webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assertTrue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasValue; });
/* unused harmony export hasNoValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return assertValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return assertBoolean; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return assertNumber; });
/* unused harmony export isString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return assertString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return assertArray; });
/* unused harmony export assertError */
// This utils help to make clear assertions about expected values
var assertTrue = function assertTrue(value, message, getError) {
    if (typeof value !== 'boolean') throw new TypeError('value parameter has to be boolean');
    if (getError && typeof getError !== 'function') throw new TypeError('getError parameter has to be a function');
    if (!value) {
        throw getError ? getError(message) : new Error(message);
    }
};
var hasValue = function hasValue(value) {
    return value !== null && value !== undefined;
};
var hasNoValue = function hasNoValue(value) {
    return !hasValue(value);
};
var assertValue = function assertValue(value, message) {
    assertTrue(hasValue(value), message);
    return value;
};
var assertBoolean = function assertBoolean(value, message) {
    assertTrue(typeof value === 'boolean', message, TypeError);
    return value;
};
var isNumber = function isNumber(value) {
    return typeof value === 'number';
};
var assertNumber = function assertNumber(value, message) {
    assertTrue(isNumber(value), message, TypeError);
    return value;
};
var isString = function isString(value) {
    return typeof value === 'string';
};
var assertString = function assertString(value, message) {
    assertTrue(isString(value), message, TypeError);
    return value;
};
var assertArray = function assertArray(value, message) {
    assertTrue(Array.isArray(value), message, TypeError);
    return value;
};
var assertError = function assertError(value, message) {
    return assertTrue(value instanceof Error, message, TypeError);
};

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routeFor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return addNewRouteFor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return editRouteFor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return homeRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return alarmRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return assignPersonRoute; });
/* unused harmony export sensorsDataRoute */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return vehicleGeoposition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return settingsRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return vehicleGroupActionsRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sensorsReadingsRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return appNavigator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_EntityType__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_assert__ = __webpack_require__(5);
var _entityRoutes;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




// Declare the relative path for each entity type
var entityRoutes = (_entityRoutes = {}, _defineProperty(_entityRoutes, __WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */].Access, '/access'), _defineProperty(_entityRoutes, __WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */].Division, '/division'), _defineProperty(_entityRoutes, __WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */].Person, '/person'), _defineProperty(_entityRoutes, __WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */].Sensor, '/sensor'), _defineProperty(_entityRoutes, __WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */].ServiceAccount, '/service-account'), _defineProperty(_entityRoutes, __WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */].Vehicle, '/vehicle'), _defineProperty(_entityRoutes, __WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */].Dashboard, '/dashboard'), _defineProperty(_entityRoutes, __WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */].Report, '/reports'), _defineProperty(_entityRoutes, __WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */].Alarm, '/alarms'), _entityRoutes);
var routeFor = function routeFor(entityType) {
    return entityRoutes[entityType];
};
var addNewRouteFor = function addNewRouteFor(entityType) {
    return routeFor(entityType) + '/addNew';
};
var editRouteFor = function editRouteFor(entityType) {
    return routeFor(entityType) + '/edit';
};
var homeRoute = '/dashboard';
var alarmRoute = '/alarms';
var assignPersonRoute = '/alarms/assign';
var sensorsDataRoute = '/sensors-data';
var vehicleGeoposition = '/vehicles-map';
var settingsRoute = '/settings';
var vehicleGroupActionsRoute = '/vehicle/group-actions';
var sensorsReadingsRoute = function sensorsReadingsRoute(refId) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_assert__["a" /* assertTrue */])(typeof refId === 'string' && refId !== '');
    return '/action/SensorsReadingsExcel?id_ref=' + refId;
};
// AppNavigator helps to navigate into different parts of our application.
// When you need to show specific tab just call AppNavigator's methods.

var AppNavigator = function AppNavigator(basename) {
    var _this = this;

    _classCallCheck(this, AppNavigator);

    this.basename = basename;
    this.goToDashboard = function () {
        return _this.history.push(homeRoute);
    };
    this.goToAlarm = function () {
        return _this.history.push(alarmRoute);
    };
    this.goToEntityTab = function (entityType) {
        return _this.history.push(routeFor(entityType));
    };
    this.goToDivisionTab = function () {
        return _this.goToEntityTab(__WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */].Division);
    };
    this.goToPersonTab = function () {
        return _this.goToEntityTab(__WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */].Person);
    };
    this.goToServiceAccountTab = function () {
        return _this.goToEntityTab(__WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */].ServiceAccount);
    };
    this.goToVehicleTab = function () {
        return _this.goToEntityTab(__WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */].Vehicle);
    };
    this.goToSensorTab = function () {
        return _this.goToEntityTab(__WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */].Sensor);
    };
    this.goToAddNewEntityTab = function (entityType) {
        return _this.history.push(addNewRouteFor(entityType));
    };
    this.goToEditEntityTab = function (entityType) {
        return _this.history.push(editRouteFor(entityType));
    };
    this.goToSensorsDataPage = function () {
        return _this.history.push(sensorsDataRoute);
    };
    this.goToVehicleGeopositionPage = function () {
        return _this.history.push(vehicleGeoposition);
    };
    this.goToAssignPersonOnIssuePage = function () {
        return _this.history.push(assignPersonRoute);
    };
    this.goToSettingsPage = function () {
        return _this.history.push(settingsRoute);
    };
    this.goToVehicleGroupActionsPage = function () {
        return _this.history.push(vehicleGroupActionsRoute);
    };
    this.closeSettings = function () {
        return _this.history.length > 0 ? _this.history.goBack() : _this.history.replace(_this.basename);
    };
    this.history = __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()({ basename: basename });
};

var appNavigator = new AppNavigator("/app/");

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Vehicle__ = __webpack_require__(164);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Vehicle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntityType__ = __webpack_require__(54);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__EntityType__["a"]; });



/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditCreateEntityActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Actions__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["a" /* createNamespace */])('EditEntity');
var names = {
    SET_EDIT_ENTITY: ns('SET_EDIT_ENTITY'),
    SET_ENTITY_PROTOTYPE: ns('SET_ENTITY_PROTOTYPE'),
    REJECT_DRAFT: ns('REJECT_DRAFT')
};
var EditCreateEntityActions = function (_Actions) {
    _inherits(EditCreateEntityActions, _Actions);

    function EditCreateEntityActions() {
        _classCallCheck(this, EditCreateEntityActions);

        var _this = _possibleConstructorReturn(this, (EditCreateEntityActions.__proto__ || Object.getPrototypeOf(EditCreateEntityActions)).apply(this, arguments));

        _this.setEntityToEdit = function (entity, entityType) {
            return _this.dispatch(names.SET_EDIT_ENTITY, entity, entityType);
        };
        _this.setEntityPrototype = function (entity, entityType) {
            return _this.dispatch(names.SET_ENTITY_PROTOTYPE, entity, entityType);
        };
        _this.rejectDraft = function (entityType) {
            return _this.dispatch(names.REJECT_DRAFT, null, entityType);
        };
        return _this;
    }

    return EditCreateEntityActions;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["b" /* Actions */]);

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VehicleBatchEditActions__ = __webpack_require__(314);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__VehicleBatchEditActions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VehicleBatchEditStore__ = __webpack_require__(562);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__VehicleBatchEditStore__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__VehicleBatchEditStore__["b"]; });



/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EntityType; });
/* unused harmony export EntityTypeNames */
/* unused harmony export EntityTypeValues */
var EntityType;
(function (EntityType) {
    EntityType[EntityType["Division"] = 1] = "Division";
    EntityType[EntityType["Person"] = 2] = "Person";
    EntityType[EntityType["Access"] = 3] = "Access";
    EntityType[EntityType["ServiceAccount"] = 4] = "ServiceAccount";
    EntityType[EntityType["Vehicle"] = 5] = "Vehicle";
    EntityType[EntityType["Sensor"] = 6] = "Sensor";
    EntityType[EntityType["SensorExcess"] = 7] = "SensorExcess";
    EntityType[EntityType["Report"] = 8] = "Report";
    EntityType[EntityType["Dashboard"] = 9] = "Dashboard";
    EntityType[EntityType["Alarm"] = 10] = "Alarm";
})(EntityType || (EntityType = {}));
var keys = Object.keys(EntityType).map(function (k) {
    return EntityType[k];
});
var EntityTypeNames = keys.filter(function (v) {
    return typeof v === 'string';
});
var EntityTypeValues = keys.filter(function (v) {
    return typeof v === 'number';
});

/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DeleteObjectsActions__ = __webpack_require__(318);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__DeleteObjectsActions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DeleteObjectsStore__ = __webpack_require__(582);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__DeleteObjectsStore__["a"]; });



/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Store__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_assert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_merge__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListActions__ = __webpack_require__(65);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// This store holds data for each table inside entity tab
var ListStore = function (_Store) {
    _inherits(ListStore, _Store);

    function ListStore(key, token) {
        _classCallCheck(this, ListStore);

        var _this = _possibleConstructorReturn(this, (ListStore.__proto__ || Object.getPrototypeOf(ListStore)).call(this));

        _this.key = key;
        _this.token = token;
        _this.getItemsCount = function () {
            return _this.state.items.length;
        };
        _this.state = { items: [] };
        // get rid of old items and set new items
        _this.register(__WEBPACK_IMPORTED_MODULE_3__ListActions__["b" /* names */].SET_ITEMS, function (e) {
            if (e.meta === _this.token) {
                var items = e.payload;
                if (e.meta == 6) {
                    window.sensors = items;
                }
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assert__["d" /* assertArray */])(items, 'array payload expected');
                return { items: items };
            }
        });
        // replace items by keys
        _this.register(__WEBPACK_IMPORTED_MODULE_3__ListActions__["b" /* names */].REPLACE_ITEMS, function (e) {
            if (e.meta === _this.token) {
                var newItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assert__["d" /* assertArray */])(e.payload);

                var _this$getState = _this.getState(),
                    oldItems = _this$getState.items;

                var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_merge__["a" /* replace */])(oldItems, newItems, _this.key);
                if (oldItems !== newItems) return { items: items };
            }
        });
        // replace items by keys and add new items
        _this.register(__WEBPACK_IMPORTED_MODULE_3__ListActions__["b" /* names */].UPSERT_ITEMS, function (e) {
            if (e.meta === _this.token) {
                var newItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assert__["d" /* assertArray */])(e.payload);

                var _this$getState2 = _this.getState(),
                    oldItems = _this$getState2.items;

                var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_merge__["b" /* merge */])(oldItems, newItems, _this.key);
                if (oldItems !== items) return { items: items };
            }
        });
        // remove items by keys
        _this.register(__WEBPACK_IMPORTED_MODULE_3__ListActions__["b" /* names */].REMOVE_ITEMS, function (e) {
            if (e.meta === _this.token) {
                var toDelete = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assert__["d" /* assertArray */])(e.payload);

                var _this$getState3 = _this.getState(),
                    oldItems = _this$getState3.items;

                var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_merge__["c" /* remove */])(oldItems, toDelete, _this.key);
                if (oldItems != items) return { items: items };
            }
        });
        return _this;
    }

    return ListStore;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Store__["a" /* Store */]);

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Container":"Container--iCozS","MainRoute":"MainRoute--1Lru-","HeaderControls":"HeaderControls--1zAaj","Version":"Version--fNvBV","StickyControlPanel":"StickyControlPanel--14Uiu","ConfirmationContainer":"ConfirmationContainer--7olos"};

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Actions__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["a" /* createNamespace */])('List');
var names = {
    SET_ITEMS: ns('SET_ITEMS'),
    REPLACE_ITEMS: ns('REPLACE_ITEMS'),
    UPSERT_ITEMS: ns('UPSERT_ITEMS'),
    REMOVE_ITEMS: ns('REMOVE_ITEMS')
};
var ListActions = function (_Actions) {
    _inherits(ListActions, _Actions);

    function ListActions() {
        _classCallCheck(this, ListActions);

        var _this = _possibleConstructorReturn(this, (ListActions.__proto__ || Object.getPrototypeOf(ListActions)).apply(this, arguments));

        _this.setItems = function (items, meta) {
            return _this.dispatch(names.SET_ITEMS, items, meta);
        };
        _this.replaceItems = function (items, meta) {
            return _this.dispatch(names.REPLACE_ITEMS, items, meta);
        };
        _this.upsertItems = function (items, meta) {
            return _this.dispatch(names.UPSERT_ITEMS, items, meta);
        };
        _this.removeItems = function (keys, meta) {
            return _this.dispatch(names.REMOVE_ITEMS, keys, meta);
        };
        return _this;
    }

    return ListActions;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["b" /* Actions */]);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectedItemsStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatcher__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Store__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectedItemsActions__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListActions__ = __webpack_require__(65);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// This Flux store is used to manage selected entities in tables
var SelectedItemsStore = function (_Store) {
    _inherits(SelectedItemsStore, _Store);

    function SelectedItemsStore(listStore, token) {
        _classCallCheck(this, SelectedItemsStore);

        var _this = _possibleConstructorReturn(this, (SelectedItemsStore.__proto__ || Object.getPrototypeOf(SelectedItemsStore)).call(this));

        _this.lastChange = null;
        _this.state = {
            selected: new Set(),
            allSelected: false,
            disabled: true
        };
        _this.register(__WEBPACK_IMPORTED_MODULE_2__SelectedItemsActions__["b" /* names */].TOGGLE_ITEM, function (e) {
            if (e.meta === token) {
                __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* dispatcher */].waitFor([listStore.dispatchToken]);
                var key = e.payload;

                var _listStore$getState = listStore.getState(),
                    items = _listStore$getState.items;

                var validKeys = new Set(items.map(listStore.key));
                if (!validKeys.has(key)) return;
                var selected = new Set(_this.state.selected);
                if (selected.has(key)) {
                    selected.delete(key);
                } else {
                    selected.add(key);
                }
                _this.lastChange = new Date();
                return { selected: selected, allSelected: selected.size === validKeys.size && validKeys.size > 0, disabled: validKeys.size === 0 };
            }
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__SelectedItemsActions__["b" /* names */].TOGGLE_ALL, function (e) {
            if (e.meta === token) {
                __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* dispatcher */].waitFor([listStore.dispatchToken]);
                var _this$state = _this.state,
                    allSelected = _this$state.allSelected,
                    disabled = _this$state.disabled;

                if (!disabled) {
                    if (allSelected) return _this.field({ allSelected: false, selected: new Set() });
                    _this.lastChange = new Date();

                    var _listStore$getState2 = listStore.getState(),
                        items = _listStore$getState2.items;

                    return _this.field({ allSelected: true, selected: new Set(items.map(listStore.key)) });
                }
            }
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__SelectedItemsActions__["b" /* names */].SELECT_ALL, function (e) {
            if (e.meta === token) {
                __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* dispatcher */].waitFor([listStore.dispatchToken]);
                var _this$state2 = _this.state,
                    allSelected = _this$state2.allSelected,
                    disabled = _this$state2.disabled;

                if (!disabled) {
                    _this.lastChange = new Date();

                    var _listStore$getState3 = listStore.getState(),
                        items = _listStore$getState3.items;

                    localStorage.setItem('groupActionVehicleIds', JSON.stringify(items.map(listStore.key)));
                    return _this.field({ allSelected: true, selected: new Set(items.map(listStore.key)) });
                }
            }
        });
        var tryReduceState = function tryReduceState(e) {
            var clear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (e.meta === listStore.token) {
                __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* dispatcher */].waitFor([listStore.dispatchToken]);
                return reduceState(clear);
            }
        };
        var reduceState = function reduceState(clear) {
            var _listStore$getState4 = listStore.getState(),
                items = _listStore$getState4.items;

            var validKeys = new Set(items.map(listStore.key));
            var selected = _this.state.selected;

            var intersection = clear ? new Set() : new Set([].concat(_toConsumableArray(validKeys)).filter(function (k) {
                return selected.has(k);
            }));
            return { selected: intersection, allSelected: intersection.size === validKeys.size && validKeys.size > 0, disabled: validKeys.size === 0 };
        };
        _this.register(__WEBPACK_IMPORTED_MODULE_3__ListActions__["b" /* names */].REPLACE_ITEMS, tryReduceState);
        _this.register(__WEBPACK_IMPORTED_MODULE_3__ListActions__["b" /* names */].SET_ITEMS, function (e) {
            return tryReduceState(e, true);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__ListActions__["b" /* names */].UPSERT_ITEMS, tryReduceState);
        _this.register(__WEBPACK_IMPORTED_MODULE_3__ListActions__["b" /* names */].REMOVE_ITEMS, tryReduceState);
        return _this;
    }

    _createClass(SelectedItemsStore, [{
        key: "toArray",
        value: function toArray() {
            return [].concat(_toConsumableArray(this.state.selected));
        }
    }]);

    return SelectedItemsStore;
}(__WEBPACK_IMPORTED_MODULE_1__flux_Store__["a" /* Store */]);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LabelStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Store__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LabelActions__ = __webpack_require__(319);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var LabelStore = function (_Store) {
    _inherits(LabelStore, _Store);

    function LabelStore() {
        _classCallCheck(this, LabelStore);

        var _this = _possibleConstructorReturn(this, (LabelStore.__proto__ || Object.getPrototypeOf(LabelStore)).call(this));

        _this.getLabel = function () {
            return _this.state.label;
        };
        _this.state = { label: null };
        _this.register(__WEBPACK_IMPORTED_MODULE_1__LabelActions__["b" /* names */].SET, function (e) {
            if (e.meta === _this.dispatchToken) return _this.field({ label: e.payload });
        });
        return _this;
    }

    return LabelStore;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Store__["a" /* Store */]);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = stringToInt;
/* unused harmony export stringToIntWithMinus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return intToString; });
function stringToInt(s) {
    var emptyToNull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (s == null || emptyToNull && s === '') return null;
    var n = parseInt(s);
    if (Number.isNaN(n)) throw '[Invalid Argument Exception] couldn\'t convert "' + s + '" to integer number';
    return n;
}
function stringToIntWithMinus(s) {
    var emptyToNull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (s == null || emptyToNull && s === '') return null;
    if (s == '-') {
        return '-';
    } else {
        var n = parseInt(s);
        if (Number.isNaN(n)) throw '[Invalid Argument Exception] couldn\'t convert "' + s + '" to integer number';
        return n;
    }
}
var intToString = function intToString(n) {
    var nullToEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return n != null ? JSON.stringify(n) : nullToEmpty ? '' : null;
};

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"StickyTable":"StickyTable--SJQ3d"};

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectedItemsActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Actions__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["a" /* createNamespace */])('SelectedActions');
var names = {
    TOGGLE_ITEM: ns('TOGGLE_ITEM'),
    TOGGLE_ALL: ns('TOGGLE_ALL'),
    SELECT_ALL: ns('SELECT_ALL')
};
var SelectedItemsActions = function (_Actions) {
    _inherits(SelectedItemsActions, _Actions);

    function SelectedItemsActions() {
        _classCallCheck(this, SelectedItemsActions);

        var _this = _possibleConstructorReturn(this, (SelectedItemsActions.__proto__ || Object.getPrototypeOf(SelectedItemsActions)).apply(this, arguments));

        _this.toggleItem = function (id, meta) {
            return _this.dispatch(names.TOGGLE_ITEM, id, meta);
        };
        _this.toggleAll = function (meta) {
            return _this.dispatch(names.TOGGLE_ALL, null, meta);
        };
        _this.selectAll = function (meta) {
            return _this.dispatch(names.SELECT_ALL, null, meta);
        };
        return _this;
    }

    return SelectedItemsActions;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["b" /* Actions */]);

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditSensorActions__ = __webpack_require__(311);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__EditSensorActions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditSensorStore__ = __webpack_require__(543);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__EditSensorStore__["a"]; });



/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TypeaheadEnterEscWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// TypeaheadEnterEscWrapper stops Enter and Esc propagation when menu is open
var TypeaheadEnterEscWrapper = function (_React$Component) {
    _inherits(TypeaheadEnterEscWrapper, _React$Component);

    function TypeaheadEnterEscWrapper() {
        _classCallCheck(this, TypeaheadEnterEscWrapper);

        return _possibleConstructorReturn(this, (TypeaheadEnterEscWrapper.__proto__ || Object.getPrototypeOf(TypeaheadEnterEscWrapper)).apply(this, arguments));
    }

    _createClass(TypeaheadEnterEscWrapper, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var children = this.props.children;
            if (Array.isArray(children)) {
                throw new Error('children of TypeaheadEnterEscWrapper has to be a Typeahead component');
            }
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { onKeyDown: function onKeyDown(e) {
                    var comp = _this2.typeahead.getInstance();
                    e.keyCode === 13 && comp.state.showMenu && e.stopPropagation(); // stop Enter/Return keyDown event propagation
                    e.keyCode === 27 && comp.state.showMenu && e.stopPropagation(); // stop Esc keyDown event propagation
                } }, __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](children, { ref: function ref(e) {
                    return _this2.typeahead = e;
                } }));
        }
    }]);

    return TypeaheadEnterEscWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StickyMediator; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StickyMediator = function StickyMediator() {
    var _this = this;

    _classCallCheck(this, StickyMediator);

    this.onToolbox = function (div) {
        _this.toolbox = div;
        _this.stickyfiy();
    };
    this.onThead = function (thead) {
        _this.thead = thead;
        _this.stickyfiy();
    };
    this.stickyfiy = function () {
        if (!_this.toolbox || !_this.thead) return;
        var clientHeight = _this.toolbox.clientHeight;

        var style = getComputedStyle(_this.toolbox);
        var dy = clientHeight + parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
        var trs = _this.thead.children;
        for (var i = 0; i < trs.length; i++) {
            var tr = trs[i];
            if (tr.nodeName !== 'TR') continue;
            var ths = tr.children;
            for (var j = 0; j < ths.length; j++) {
                var th = ths[j];
                if (th.nodeName !== 'TH') continue;
                th.style.top = dy + 'px';
            }
        }
    };
};

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataGrid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};


// DataGrid component helps to create grids on each Entity page inside our app
// Also it applies Bootstrap classes in order to style the grid
// DataGrid makes it easy to specify each grid declaratively as a set of columns 
var DataGrid = function (_React$Component) {
    _inherits(DataGrid, _React$Component);

    function DataGrid(props) {
        _classCallCheck(this, DataGrid);

        var _this = _possibleConstructorReturn(this, (DataGrid.__proto__ || Object.getPrototypeOf(DataGrid)).call(this, props));

        _this.state = _this.getStateFromProps(props);
        return _this;
    }

    _createClass(DataGrid, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            this.setState(this.getStateFromProps(nextProps));
        }
    }, {
        key: "getStateFromProps",
        value: function getStateFromProps(props) {
            return {
                data: Array.from(props.initialData)
            };
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var contexts = this.getContexts();
            var state = this.state;
            var _a = this.props,
                initialData = _a.initialData,
                className = _a.className,
                onThead = _a.onThead,
                tableProps = __rest(_a, ["initialData", "className", "onThead"]);
            // Create table element. Populate header first.
            // Iterate over each data item and build one cell at a time
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("table", Object.assign({ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('table table-striped table-bordered table-hover', className) }, tableProps), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("thead", { ref: onThead }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null, contexts.map(function (ctx, idx) {
                var _ctx$props = ctx.props,
                    header = _ctx$props.header,
                    renderHeader = _ctx$props.renderHeader,
                    headerClassName = _ctx$props.headerClassName,
                    headerBgColor = _ctx$props.headerBgColor,
                    headerTextColor = _ctx$props.headerTextColor;

                var content = header ? header : renderHeader();
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", { key: idx, style: { background: headerBgColor, color: headerTextColor }, className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('text-center', headerClassName) }, content);
            }))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody", null, state.data.map(function (datum, rowIdx) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", { key: rowIdx },
                // each Column knows how to render a cell from datum
                __WEBPACK_IMPORTED_MODULE_0_react__["Children"].toArray(_this2.props.children).filter(function (ch) {
                    return ch != null;
                }).map(function (ch) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](ch, { datum: datum, row: rowIdx });
                }));
            })));
        }
    }, {
        key: "getContexts",
        value: function getContexts() {
            var _this3 = this;

            // convert each child Column component into plain js object
            return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].toArray(this.props.children).filter(function (item) {
                return item != null;
            }).map(function (child, idx) {
                return _this3.getColumnContext(child);
            });
        }
    }, {
        key: "getColumnContext",
        value: function getColumnContext(child) {
            var elem = child;
            var column = elem.type; // is there a better way?
            return {
                column: column,
                props: elem.props
            };
        }
    }]);

    return DataGrid;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataGridTemplateColumn; });
// This column is the most generic one. It renders the template which was provided by the render prop
var DataGridTemplateColumn = function DataGridTemplateColumn(props) {
  return props.render(props);
};

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NonIsolatedPremise__ = __webpack_require__(501);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__NonIsolatedPremise__["a"]; });


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(620);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__common__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__common__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persons__ = __webpack_require__(621);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sensors__ = __webpack_require__(622);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_accounts__ = __webpack_require__(623);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__service_accounts__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vehicles__ = __webpack_require__(624);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__vehicles__["a"]; });






/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DeleteConfirmationWidget__ = __webpack_require__(496);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DeleteConfirmationWidget__["a"]; });


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return InputTextGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CheckboxGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LoadableGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LabelGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LevelGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormItemHorizontal__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pages_EditCreate_Loadable__ = __webpack_require__(513);
var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};



var InputTextGroup = function InputTextGroup(props) {
    var password = props.password,
        title = props.title,
        vertical = props.vertical,
        labelColumns = props.labelColumns,
        columns = props.columns,
        inputAttributes = __rest(props, ["password", "title", "vertical", "labelColumns", "columns"]);

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__FormItemHorizontal__["a" /* FormItemHorizontal */], { title: title, vertical: vertical, labelColumns: labelColumns, columns: columns }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", Object.assign({ className: 'form-control', type: password ? 'password' : 'text' }, inputAttributes)));
};
var CheckboxGroup = function CheckboxGroup(props) {
    var title = props.title,
        vertical = props.vertical,
        labelColumns = props.labelColumns,
        columns = props.columns,
        inputAttributes = __rest(props, ["title", "vertical", "labelColumns", "columns"]);

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__FormItemHorizontal__["a" /* FormItemHorizontal */], { vertical: vertical, labelColumns: labelColumns, columns: columns }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "checkbox" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", Object.assign({ type: "checkbox" }, inputAttributes)), " ", title)));
};
var LoadableGroup = function LoadableGroup(props) {
    var title = props.title,
        vertical = props.vertical,
        labelColumns = props.labelColumns,
        columns = props.columns,
        value = props.value,
        isLoading = props.isLoading,
        children = props.children;

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__FormItemHorizontal__["a" /* FormItemHorizontal */], { title: title, vertical: vertical, labelColumns: labelColumns, columns: columns }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Pages_EditCreate_Loadable__["a" /* Loadable */], { value: value, isLoading: isLoading }, children));
};
var LabelGroup = function LabelGroup(props) {
    var title = props.title,
        vertical = props.vertical,
        labelColumns = props.labelColumns,
        columns = props.columns,
        value = props.value;

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__FormItemHorizontal__["a" /* FormItemHorizontal */], { title: title, vertical: vertical, labelColumns: labelColumns, columns: columns }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "form-control-static" }, value));
};
var LevelGroup = function LevelGroup(props) {
    var unitName = props.unitName,
        title = props.title,
        vertical = props.vertical,
        labelColumns = props.labelColumns,
        columns = props.columns,
        inputAttributes = __rest(props, ["unitName", "title", "vertical", "labelColumns", "columns"]);

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__FormItemHorizontal__["a" /* FormItemHorizontal */], { title: title, vertical: vertical, labelColumns: labelColumns, columns: columns }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "input-group" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", Object.assign({ className: 'form-control', type: unitName == "C" ? "number" : "text" }, inputAttributes)), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "input-group-addon", style: { minWidth: 50 } }, unitName)));
};

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditCreateEntityRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal_Modal__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dialogs_TwoButtonDialog__ = __webpack_require__(212);
var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};




var EditCreateEntityRoute = function EditCreateEntityRoute(props) {
    var path = props.path,
        renderEdit = props.renderEdit,
        dialogProps = __rest(props, ["path", "renderEdit"]);

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */], { path: path, render: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_Modal_Modal__["a" /* Modal */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Dialogs_TwoButtonDialog__["a" /* TwoButtonDialog */], Object.assign({}, dialogProps), renderEdit()));
        } });
};

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Store__ = __webpack_require__(22);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var EditStore = function (_Store) {
    _inherits(EditStore, _Store);

    function EditStore() {
        _classCallCheck(this, EditStore);

        return _possibleConstructorReturn(this, (EditStore.__proto__ || Object.getPrototypeOf(EditStore)).apply(this, arguments));
    }

    _createClass(EditStore, [{
        key: "draft",

        // Each Entity edit store has a draft property inside it state
        // This helper method updates property of that draft
        // In Flux architecture state should be immutable, so we return new instance on every invocation
        value: function draft(_draft) {
            return Object.assign({}, this.state, {
                draft: this.getDraft(_draft)
            });
        }
    }, {
        key: "getDraft",
        value: function getDraft(draft) {
            var oldDraft = this.state ? this.state.draft : undefined;
            return Object.assign({}, oldDraft, draft);
        }
    }]);

    return EditStore;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Store__["a" /* Store */]);



/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteObjectsCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_DeleteObjects__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_assert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_Grid__ = __webpack_require__(110);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





// This command is executed from UI when we want to delete single or multiple entities
var DeleteObjectsCommand = function DeleteObjectsCommand(entityType, store, deleteObjects) {
    var _this = this;

    _classCallCheck(this, DeleteObjectsCommand);

    this.entityType = entityType;
    this.store = store;
    this.deleteObjects = deleteObjects;
    this.delObjActions = new __WEBPACK_IMPORTED_MODULE_1__flux_DeleteObjects__["b" /* DeleteObjectsActions */]();
    this.listStoreActions = new __WEBPACK_IMPORTED_MODULE_3__flux_Grid__["a" /* ListActions */]();
    this.execute = function () {
        var _store$getState = _this.store.getState(),
            ids = _store$getState.ids;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_assert__["d" /* assertArray */])(ids);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_assert__["a" /* assertTrue */])(ids.length > 0);
        var request = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__models__["a" /* EntityType */][_this.entityType], ids);
        _this.deleteObjects(request).then(function (res) {
            if (res.Success) {
                _this.delObjActions.setIds([], _this.entityType);
                _this.delObjActions.hideConfirmation(_this.entityType);
                _this.listStoreActions.removeItems(ids, _this.entityType);
            } else {
                _this.delObjActions.showError(new Error(res.ErrorMessage), _this.entityType);
            }
        }).catch(function (err) {
            _this.delObjActions.showError(err, _this.entityType);
        });
    };
};

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TableTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Container__ = __webpack_require__(17);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// TableTitle manages title of the table on each Entity tab
var TableTitle = function (_React$Component) {
    _inherits(TableTitle, _React$Component);

    function TableTitle() {
        _classCallCheck(this, TableTitle);

        return _possibleConstructorReturn(this, (TableTitle.__proto__ || Object.getPrototypeOf(TableTitle)).apply(this, arguments));
    }

    _createClass(TableTitle, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                labelStore = _props.labelStore,
                polyglot = _props.polyglot;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Container__["a" /* Container */], { subscribe: [labelStore], render: function render() {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", null, labelStore.getLabel() || polyglot.t('misc.nothing_searched_msg'));
                } });
        }
    }]);

    return TableTitle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListActions__ = __webpack_require__(65);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ListActions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListStore__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectedItemsActions__ = __webpack_require__(74);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__SelectedItemsActions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectedItemsStore__ = __webpack_require__(66);
/* unused harmony namespace reexport */





/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SequenceState; });
var SequenceState;
(function (SequenceState) {
    SequenceState[SequenceState["Normal"] = 0] = "Normal";
    SequenceState[SequenceState["Dimmed"] = 1] = "Dimmed";
    SequenceState[SequenceState["Highlighted"] = 2] = "Highlighted";
    SequenceState[SequenceState["Hidden"] = 3] = "Hidden";
})(SequenceState || (SequenceState = {}));

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Select; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// Select component is a wrapper around native select
// It accepts getters to query value and display of underlying data
// Also it helps to show placeholder whcih cannot be selected from the list
var Select = function (_React$Component) {
    _inherits(Select, _React$Component);

    function Select(props) {
        _classCallCheck(this, Select);

        var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

        _this.state = _this.getStateFromProps(props);
        return _this;
    }

    _createClass(Select, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps, nextContext) {
            var nextState = this.getStateFromProps(nextProps);
            // if(this.state.value !== nextState.value) {
            //     const { onChange } = nextProps;
            //     onChange(this);
            // }
            this.setState(nextState);
        }
    }, {
        key: 'getStateFromProps',
        value: function getStateFromProps(props) {
            var initialValue = props.defaultValue;
            // reset the value if it is not in item source
            if (initialValue != null) {
                var valueFn = this.getValueFn(props.valueFn);
                var found = props.items.find(function (item, idx) {
                    return valueFn(item, idx) == initialValue;
                });
                initialValue = found === undefined ? null : initialValue;
            }
            if (initialValue == null) {
                if (props.placeholder == null) throw 'Provide placeholder if defaultValue is not in itemSource';
                initialValue = '';
            }
            return {
                value: initialValue
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var valueFn = this.getValueFn(this.props.valueFn);
            var titleFn = this.getTitleFn(this.props.titleFn);
            var placeholder = this.props.placeholder;
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("select", { value: this.state.value, onChange: this.onChange.bind(this), className: this.props.className, disabled: this.props.disabled },
            // https://stackoverflow.com/questions/5805059/how-do-i-make-a-placeholder-for-a-select-box/8442831#8442831
            placeholder != null && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("option", { value: '', disabled: true, hidden: true }, placeholder), this.props.items.map(function (item, idx) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("option", { key: idx, value: valueFn(item, idx) }, titleFn(item, idx));
            }));
        }
    }, {
        key: 'getValueFn',
        value: function getValueFn(valueFn) {
            return function (item, idx) {
                var value = valueFn ? valueFn(item, idx) : idx.toString();
                if (value == null) throw 'valueFn has to return a string';
                return value;
            };
        }
    }, {
        key: 'getTitleFn',
        value: function getTitleFn(titleFn) {
            return function (item, idx) {
                return titleFn ? titleFn(item, idx) : JSON.stringify(item);
            };
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            var _this2 = this;

            this.setState({
                value: e.target.value
            }, function () {
                if (_this2.props.onChange) _this2.props.onChange(_this2);
            });
        }
    }, {
        key: 'getValue',
        value: function getValue() {
            var value = this.state.value;

            return value == '' ? null : value;
        }
    }]);

    return Select;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IdColumn__ = __webpack_require__(502);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__IdColumn__["a"]; });


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MultiselectColumn__ = __webpack_require__(503);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MultiselectColumn__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__MultiselectColumn__["b"]; });


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GenericSearchWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Container__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GenericSearch__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Actions__ = __webpack_require__(308);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var GenericSearchWidget = function (_React$Component) {
    _inherits(GenericSearchWidget, _React$Component);

    function GenericSearchWidget() {
        _classCallCheck(this, GenericSearchWidget);

        var _this = _possibleConstructorReturn(this, (GenericSearchWidget.__proto__ || Object.getPrototypeOf(GenericSearchWidget)).apply(this, arguments));

        _this.searchFormActions = new __WEBPACK_IMPORTED_MODULE_3__Actions__["a" /* SearchActions */]();
        return _this;
    }

    _createClass(GenericSearchWidget, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
            return false;
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Container__["a" /* Container */], { merge: true, stores: [[this.props.searchFormStore, function (store) {
                    return { searchParams: store.getState() };
                }], [this.props.searchInProgressStore, function (store) {
                    return { searchInProgress: store.isSet() };
                }], this.props.searchErrorStore] }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__GenericSearch__["a" /* GenericSearch */], { polyglot: this.props.polyglot, onChange: function onChange(f) {
                    return _this2.searchFormActions.updateSearchParams(f.getValue(), _this2.props.searchFormStore.dispatchToken);
                }, onSearch: function onSearch(f) {
                    return _this2.props.searchCommand.execute(f.getValue());
                } }));
        }
    }]);

    return GenericSearchWidget;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getSearchNameMiddleware */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCurrentDivisionMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SearchWithSpinnerCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchWithInitiatorCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Refresher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rest_Search__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_Error__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flux_Label__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flux_Grid__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flux_Flag__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flux_Value__ = __webpack_require__(583);
function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









var getSearchNameMiddleware = function getSearchNameMiddleware(entityType) {
    return function (params) {
        return Object.assign({}, params, { Name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__rest_Search__["b" /* getSearchName */])(entityType) });
    };
};
var getCurrentDivisionMiddleware = function getCurrentDivisionMiddleware(getDivision) {
    return function (params) {
        return Object.assign({}, params, { DivisionId: getDivision() });
    };
};
// This is a base class for a search. It is primary responsibility is to update the grid when result is available

var SearchBase = function SearchBase(polyglot, entityType, errorDispatchToken) {
    var _this = this;

    _classCallCheck(this, SearchBase);

    this.polyglot = polyglot;
    this.entityType = entityType;
    this.errorDispatchToken = errorDispatchToken;
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_3__flux_Error__["a" /* ErrorActions */]();
    this.labelActions = new __WEBPACK_IMPORTED_MODULE_4__flux_Label__["a" /* LabelActions */]();
    this.listActions = new __WEBPACK_IMPORTED_MODULE_5__flux_Grid__["a" /* ListActions */]();
    this.transformators = [];
    this.handleResult = function (res) {
        _this.listActions.setItems(res.Entries[__WEBPACK_IMPORTED_MODULE_0__models__["a" /* EntityType */][_this.entityType]], _this.entityType);
        _this.labelActions.set(res.SearchTitle || _this.polyglot.t('misc.search_results'), _this.labelDispatchToken);
        var url_parts = window.location.href.split("/");
        if (url_parts[url_parts.length - 1] != 'dashboard') {
            __WEBPACK_IMPORTED_MODULE_1__routes__["b" /* appNavigator */].goToEntityTab(_this.entityType);
        }
    };
    this.handleError = function (err) {
        return _this.errorActions.setError(err, _this.errorDispatchToken, 5 * 1000);
    };
    this.addRequestMiddleware = function (middleware) {
        _this.transformators.push(middleware);
    };
    this.applyMiddleware = function (params) {
        return _this.transformators.reduce(function (prev, transformation) {
            return transformation(prev);
        }, params);
    };
    this.addRequestMiddleware(getSearchNameMiddleware(entityType));
};
// Searches which are initiated from search box inside Entity tab are tight with a spinner
// This command shows and hiddes the spinner during the search as well as shows error message in case of search failure


var SearchWithSpinnerCommand = function (_SearchBase) {
    _inherits(SearchWithSpinnerCommand, _SearchBase);

    function SearchWithSpinnerCommand(polyglot, entityType, runSearch, refresher, inProgressDispatchToken, errorDispatchToken) {
        _classCallCheck(this, SearchWithSpinnerCommand);

        var _this2 = _possibleConstructorReturn(this, (SearchWithSpinnerCommand.__proto__ || Object.getPrototypeOf(SearchWithSpinnerCommand)).call(this, polyglot, entityType, errorDispatchToken));

        _this2.runSearch = runSearch;
        _this2.refresher = refresher;
        _this2.inProgressDispatchToken = inProgressDispatchToken;
        _this2.inProgressActions = new __WEBPACK_IMPORTED_MODULE_6__flux_Flag__["a" /* FlagActions */]();
        _this2.execute = function (params) {
            _this2.inProgressActions.set(_this2.inProgressDispatchToken);
            var targetParams = _this2.applyMiddleware(params);
            _this2.refresher.bindParameters(targetParams);
            _this2.runSearch(targetParams).then(_this2.handleResult).catch(_this2.handleError).then(function () {
                return _this2.inProgressActions.reset(_this2.inProgressDispatchToken);
            }); // finally
        };
        return _this2;
    }

    return SearchWithSpinnerCommand;
}(SearchBase);
// Searches which are initiated from grid are assosiated with the spinner in a particullar cell
// This class hepls to start/stop that spinner. Also search can be interrupted by another search from a different cell in a grid
// In this case we need to update the innitiator
var SearchWithInitiatorCommand = function (_SearchBase2) {
    _inherits(SearchWithInitiatorCommand, _SearchBase2);

    function SearchWithInitiatorCommand(polyglot, entityType, runSearch, valueDispatchToken, errorDispatchToken) {
        _classCallCheck(this, SearchWithInitiatorCommand);

        var _this3 = _possibleConstructorReturn(this, (SearchWithInitiatorCommand.__proto__ || Object.getPrototypeOf(SearchWithInitiatorCommand)).call(this, polyglot, entityType, errorDispatchToken));

        _this3.runSearch = runSearch;
        _this3.valueDispatchToken = valueDispatchToken;
        _this3.valueActions = new __WEBPACK_IMPORTED_MODULE_7__flux_Value__["a" /* ValueActions */]();
        _this3.execute = function (initiator, params) {
            _this3.initiator = initiator;
            var sameInitiator = function sameInitiator() {
                return _this3.initiator === initiator;
            };
            _this3.valueActions.set(initiator, _this3.valueDispatchToken);
            var targetParams = _this3.applyMiddleware(params);
            if (_this3.refresher) {
                _this3.refresher.bindParameters(targetParams);
            }
            _this3.runSearch(targetParams).then(function (res) {
                return sameInitiator() && _this3.handleResult(res);
            }).catch(function (err) {
                return sameInitiator() && _this3.handleError(err);
            }).then(function () {
                if (sameInitiator()) {
                    _this3.valueActions.clear(_this3.valueDispatchToken);
                    _this3.initiator = null;
                }
            });
        };
        return _this3;
    }

    return SearchWithInitiatorCommand;
}(SearchBase);
// We need to run the search on the page when current division has changed
// But we don't want to run all searches blindly, we need to run the search on the active tab only
var Refresher = function Refresher(emiter, getDivision) {
    var _this4 = this;

    _classCallCheck(this, Refresher);

    this.getDivision = getDivision;
    // remember search paramters
    this.bindParameters = function (parameters) {
        var expired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        _this4.searchParameters = parameters;
        _this4.expired = expired;
    };
    // run the search in case results marked as expired
    this.run = function () {
        if (_this4.expired) {
            // try to update implicit DivisionId param (in case search depends on it) then run new search
            _this4.searchCmd.execute(_this4.modernize(_this4.searchParameters));
        }
    };
    this.modernize = function (params) {
        if (_this4.dependsOnDivision(params)) {
            params = Object.assign({}, params, { DivisionId: _this4.getDivision() });
        }
        return params;
    };
    this.dependsOnDivision = function (params) {
        return params != null && 'DivisionId' in params;
    };
    // subscribe on division change event
    emiter.addListener('division', function () {
        // mark all search results on each tab as expired in case this result depends on current division parameter
        _this4.expired = _this4.expired || _this4.dependsOnDivision(_this4.searchParameters);
    });
};

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoResults; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Container__ = __webpack_require__(17);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var NoResults = function (_React$Component) {
    _inherits(NoResults, _React$Component);

    function NoResults() {
        _classCallCheck(this, NoResults);

        return _possibleConstructorReturn(this, (NoResults.__proto__ || Object.getPrototypeOf(NoResults)).apply(this, arguments));
    }

    _createClass(NoResults, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                polyglot = _props.polyglot,
                listStore = _props.listStore;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Container__["a" /* Container */], { subscribe: [listStore], render: function render() {
                    return listStore.getItemsCount() === 0 ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, polyglot.t('misc.no_results')) : null;
                } });
        }
    }]);

    return NoResults;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toolbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};


var styles = __webpack_require__(957);
var Toolbar = function Toolbar(props) {
    var className = props.className,
        children = props.children,
        divProps = __rest(props, ["className", "children"]);

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", Object.assign({ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(styles.Toolbar, props.className) }, divProps), children);
};

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TrashButtonWidget__ = __webpack_require__(581);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TrashButtonWidget__["a"]; });


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ValueStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Store__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ValueActions__ = __webpack_require__(219);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ValueStore = function (_Store) {
    _inherits(ValueStore, _Store);

    function ValueStore() {
        _classCallCheck(this, ValueStore);

        var _this = _possibleConstructorReturn(this, (ValueStore.__proto__ || Object.getPrototypeOf(ValueStore)).call(this));

        _this.getValue = function () {
            return _this.state.value;
        };
        _this.state = { value: null };
        _this.register(__WEBPACK_IMPORTED_MODULE_1__ValueActions__["b" /* names */].SET, function (e) {
            if (e.meta === _this.dispatchToken) return _this.field({ value: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_1__ValueActions__["b" /* names */].CLEAR, function (e) {
            if (e.meta === _this.dispatchToken) return _this.field({ value: null });
        });
        return _this;
    }

    return ValueStore;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Store__["a" /* Store */]);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabSearchConfigurator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rest_Search__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Pages_Search_Store__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Flag__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_Error__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pages_commands_EntitySearchCommand__ = __webpack_require__(124);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






// TabSearchConfigurator is a class which helps to setup searchbox on every Entity tab
// Those search boxes has implicit dependency – current division id
// Also we need to prepare new search when current division is change (even on different tab)
var TabSearchConfigurator = function TabSearchConfigurator(polyglot, entityType, getCurrentDivisionId, divisionEmitter, tableTitleDispatchToken) {
    _classCallCheck(this, TabSearchConfigurator);

    this.searchInProgressStore = new __WEBPACK_IMPORTED_MODULE_2__flux_Flag__["b" /* FlagStore */]();
    this.searchErrorStore = new __WEBPACK_IMPORTED_MODULE_3__flux_Error__["b" /* ErrorStore */]();
    var refresher = new __WEBPACK_IMPORTED_MODULE_4__components_Pages_commands_EntitySearchCommand__["b" /* Refresher */](divisionEmitter, getCurrentDivisionId);
    var refreshCommand = new __WEBPACK_IMPORTED_MODULE_4__components_Pages_commands_EntitySearchCommand__["c" /* SearchWithSpinnerCommand */](polyglot, entityType, __WEBPACK_IMPORTED_MODULE_0__rest_Search__["a" /* runSearch */], refresher, this.searchInProgressStore.dispatchToken, this.searchErrorStore.dispatchToken);
    refreshCommand.labelDispatchToken = tableTitleDispatchToken;
    refresher.searchCmd = refreshCommand;
    refresher.bindParameters({ DivisionId: null }, true);
    var searchBoxCommand = new __WEBPACK_IMPORTED_MODULE_4__components_Pages_commands_EntitySearchCommand__["c" /* SearchWithSpinnerCommand */](polyglot, entityType, __WEBPACK_IMPORTED_MODULE_0__rest_Search__["a" /* runSearch */], refresher, this.searchInProgressStore.dispatchToken, this.searchErrorStore.dispatchToken);
    searchBoxCommand.addRequestMiddleware(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__components_Pages_commands_EntitySearchCommand__["d" /* getCurrentDivisionMiddleware */])(getCurrentDivisionId));
    searchBoxCommand.labelDispatchToken = tableTitleDispatchToken;
    this.searchBoxProps = {
        searchInProgressStore: this.searchInProgressStore,
        searchErrorStore: this.searchErrorStore,
        searchFormStore: new __WEBPACK_IMPORTED_MODULE_1__components_Pages_Search_Store__["a" /* SearchFormStore */](),
        searchCommand: searchBoxCommand,
        refresher: refresher
    };
};

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = prepareSensorDraft;
/* harmony export (immutable) */ __webpack_exports__["e"] = prepareServiceAccountDraft;
/* harmony export (immutable) */ __webpack_exports__["b"] = prepareVehicleDraft;
/* harmony export (immutable) */ __webpack_exports__["c"] = perparePersonDraft;
/* harmony export (immutable) */ __webpack_exports__["d"] = prepareDivisionDraft;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_defaults__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_defaults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_defaults__);
// In order to edit some entity we have to make a deep copy of it.
// When user makes changes we reflet them into that clone which we call draft
// In case user cancels changes we just get rid of this draft, other wise we commit it
// Draft's shema can be differ from entity, so there are a few utils which help to create draft from entity

function prepareSensorDraft(sensor) {
    var draft = Object.assign({}, sensor); // sensor could be null or undefined
    if (!draft.Display) draft.Display = '';
    return __WEBPACK_IMPORTED_MODULE_0_lodash_defaults___default()(draft, {
        VehicleId: null,
        GeotabId: null,
        AbsLevelMaximumRed: null,
        AbsLevelMinimumRed: null,
        AbsLevelMaximumYellow: null,
        AbsLevelMinimumYellow: null
    });
}
function prepareServiceAccountDraft(account) {
    // ServiceAccount entity doesn't have Password field on the client side,
    // But in order to update a password on a server side we have to push ServiceAccountDraft to the server
    var draft = Object.assign({}, account, {
        // reset these fields
        Password: ''
    });
    return __WEBPACK_IMPORTED_MODULE_0_lodash_defaults___default()(draft, {
        AutoImport: !account,
        // React expects text fields to be valid strings. Falsy values are treated differently
        Username: '',
        ServerUrl: ''
    });
}
function prepareVehicleDraft(vehicle, source) {
    var draft = Object.assign({}, vehicle);
    draft.Display = draft.Display || '';
    return __WEBPACK_IMPORTED_MODULE_0_lodash_defaults___default()(draft, {
        ServiceAccountId: null,
        GeotabId: null,
        SourceId: source
    });
}
function perparePersonDraft(person) {
    // person could be null
    var draft = Object.assign({}, person, { Password: '', PasswordConfirmation: '' });
    if (!draft.Firstname) draft.Firstname = '';
    if (!draft.Lastname) draft.Lastname = '';
    if (!draft.Username) draft.Username = '';
    if (!draft.IsAdministrator) draft.IsAdministrator = false;
    return draft;
}
function prepareDivisionDraft(division) {
    var draft = Object.assign({}, division);
    draft.Name = draft.Name || '';
    draft.ParentName = draft.ParentName || '';
    return draft;
}

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataGridTextColumn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// This column displays raw text
var DataGridTextColumn = function (_React$Component) {
    _inherits(DataGridTextColumn, _React$Component);

    function DataGridTextColumn() {
        _classCallCheck(this, DataGridTextColumn);

        return _possibleConstructorReturn(this, (DataGridTextColumn.__proto__ || Object.getPrototypeOf(DataGridTextColumn)).apply(this, arguments));
    }

    _createClass(DataGridTextColumn, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                datum = _props.datum,
                getValue = _props.getValue,
                cellClassName = _props.cellClassName;

            var LastDataDateTimeReceivedOn = datum.LastDataDateTimeReceivedOn ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(datum.LastDataDateTimeReceivedOn).format('YYYY-MM-DD HH:mm') : null;
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: cellClassName }, LastDataDateTimeReceivedOn && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "tooltip-message", "data-toggle": "tooltip", "data-placement": "top", title: "Received At: " + LastDataDateTimeReceivedOn }, getValue(datum)), !LastDataDateTimeReceivedOn && getValue(datum));
        }
    }]);

    return DataGridTextColumn;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Actions__ = __webpack_require__(12);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Actions__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Actions__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Store__ = __webpack_require__(22);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__Store__["a"]; });



/***/ }),
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OneButtonDialog__ = __webpack_require__(498);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__OneButtonDialog__["a"]; });


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DivisionSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NestedTypeahead__ = __webpack_require__(609);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};


// DivisionSelector component is a wrapper around NestedTypeahead
// This component has private methods to convert plain Division list into hierarchical structure
var DivisionSelector = function (_React$Component) {
    _inherits(DivisionSelector, _React$Component);

    function DivisionSelector(props) {
        _classCallCheck(this, DivisionSelector);

        var _this = _possibleConstructorReturn(this, (DivisionSelector.__proto__ || Object.getPrototypeOf(DivisionSelector)).call(this, props));

        _this.state = { options: _this.getOptions(props.divisions) };
        return _this;
    }

    _createClass(DivisionSelector, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps, nextContext) {
            this.setState({ options: this.getOptions(nextProps.divisions) });
        }
    }, {
        key: "render",
        value: function render() {
            var _a = this.props,
                _onChange = _a.onChange,
                selectedId = _a.selectedId,
                rest = __rest(_a, ["onChange", "selectedId"]);var options = this.state.options;

            var selectedOption = options.find(function (opt) {
                return opt.option.id === selectedId;
            });
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_NestedTypeahead__["a" /* NestedTypeahead */], Object.assign({ className: this.props.className, labelKey: function labelKey(division) {
                    return division.Name;
                }, options: options, selected: selectedOption, onChange: function onChange(selected) {
                    return _onChange(selected.length > 0 ? selected[0].option : null);
                } }, rest));
        }
    }, {
        key: "getOptions",
        value: function getOptions(divisions) {
            var _this2 = this;

            var idToNode = new Map(); // space: O(n)
            divisions.forEach(function (d) {
                return idToNode.set(d.id, { value: d, children: [] });
            }); // time: O(n)
            var roots = [];
            var completed = new Set();
            divisions.forEach(function (d) {
                var cur = idToNode.get(d.id);
                while (cur) {
                    if (completed.has(cur.value.id)) break;
                    completed.add(cur.value.id);
                    var parent = idToNode.get(cur.value.ParentId);
                    if (parent) {
                        parent.children.push(cur);
                    } else {
                        roots.push(cur);
                    }
                    cur = parent;
                }
            });
            var options = [];
            roots.forEach(function (root) {
                return _this2.dfs(root, 0, options);
            });
            return options;
        }
        // Depth first search

    }, {
        key: "dfs",
        value: function dfs(node, level, result) {
            var _this3 = this;

            result.push({ level: level, option: node.value });
            node.children.forEach(function (child) {
                return _this3.dfs(child, level + 1, result);
            });
        }
    }]);

    return DivisionSelector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormItemHorizontal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_assert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FormGroup__ = __webpack_require__(213);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FormItemHorizontal = function (_React$Component) {
    _inherits(FormItemHorizontal, _React$Component);

    function FormItemHorizontal() {
        _classCallCheck(this, FormItemHorizontal);

        return _possibleConstructorReturn(this, (FormItemHorizontal.__proto__ || Object.getPrototypeOf(FormItemHorizontal)).apply(this, arguments));
    }

    _createClass(FormItemHorizontal, [{
        key: 'render',
        value: function render() {
            var _classnames2;

            var _props = this.props,
                children = _props.children,
                title = _props.title,
                columns = _props.columns,
                labelColumns = _props.labelColumns,
                vertical = _props.vertical;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_assert__["f" /* assertNumber */])(labelColumns, 'labelColumns has to be a number');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_assert__["a" /* assertTrue */])(Number.isInteger(labelColumns), 'labelColumns has to be an integer number');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_assert__["a" /* assertTrue */])(labelColumns > 0 && labelColumns <= 12, 'labelColumns has to be in the closed range [1; 12]');
            if (title) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_assert__["g" /* assertString */])(title);
            }
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__FormGroup__["a" /* FormGroup */], null, title && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('control-label text-right', _defineProperty({}, 'col-sm-' + labelColumns, !vertical)) }, title), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames2 = {}, _defineProperty(_classnames2, 'col-sm-offset-' + labelColumns, !title), _defineProperty(_classnames2, 'col-sm-' + (typeof columns === 'number' ? columns : 12 - labelColumns), !vertical), _classnames2)) }, children));
        }
    }]);

    return FormItemHorizontal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
FormItemHorizontal.defaultProps = {
    labelColumns: 4,
    vertical: false
};

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssignPersonActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Actions__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["a" /* createNamespace */])('ASSIGN');
var names = {
    SET_SENSOR_EXCESS: ns('SET_SENSOR_EXCESS'),
    SET_DURATION: ns('SET_DURATION'),
    REJECT_SENSOR_EXCESS: ns('REJECT_SENSOR_EXCESS')
};
var AssignPersonActions = function (_Actions) {
    _inherits(AssignPersonActions, _Actions);

    function AssignPersonActions() {
        _classCallCheck(this, AssignPersonActions);

        var _this = _possibleConstructorReturn(this, (AssignPersonActions.__proto__ || Object.getPrototypeOf(AssignPersonActions)).apply(this, arguments));

        _this.setSensorExcess = function (sensorExcess) {
            return _this.dispatch(names.SET_SENSOR_EXCESS, sensorExcess);
        };
        _this.setDuration = function (duration) {
            return _this.dispatch(names.SET_DURATION, duration);
        };
        _this.reject = function () {
            return _this.dispatch(names.REJECT_SENSOR_EXCESS);
        };
        return _this;
    }

    return AssignPersonActions;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["b" /* Actions */]);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShowSensorsDataCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_TimeSeries_flux_TimeSeriesActions__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charts_Data__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flux_Flag__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes__ = __webpack_require__(7);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var ShowSensorsDataCommand = function ShowSensorsDataCommand(googleMapLoader, alertDispatchToken) {
    var _this = this;

    _classCallCheck(this, ShowSensorsDataCommand);

    this.googleMapLoader = googleMapLoader;
    this.alertDispatchToken = alertDispatchToken;
    this.sensorsDataActions = new __WEBPACK_IMPORTED_MODULE_0__flux__["b" /* SensorsDataActions */]();
    this.timeseriesActions = new __WEBPACK_IMPORTED_MODULE_1__charts_TimeSeries_flux_TimeSeriesActions__["a" /* TimeSeriesActions */]();
    this.alertActions = new __WEBPACK_IMPORTED_MODULE_4__flux_Flag__["a" /* FlagActions */]();
    this.execute = function (resp) {
        var Rows = resp.Rows;

        var hasReadings = Rows.some(function (row) {
            return row.Readings.length > 0;
        });
        if (hasReadings) {
            _this.sensorsDataActions.setSensorsData(resp);
            _this.timeseriesActions.setDataSets(convertSensorData(resp.Rows, resp.Axes));
            return _this.googleMapLoader.loadMapFor(resp.Gapik).then(__WEBPACK_IMPORTED_MODULE_5__routes__["b" /* appNavigator */].goToSensorsDataPage);
        } else {
            _this.alertActions.set(_this.alertDispatchToken);
        }
    };
};
var colors = ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"];
function convertSensorData(rows, axes) {
    var map = rows.reduce(function (acc, r, idx) {
        r.order = idx;
        return acc.set(r.id, r);
    }, new Map());
    var groups = axes.map(function (axis, idx) {
        return {
            RangeMax: axis.RangeMax,
            RangeMin: axis.RangeMin,
            Rows: axis.SensorIds.map(function (id) {
                var row = map.get(id);
                map.delete(id);
                return row;
            })
        };
    });
    map.forEach(function (row, id) {
        return groups.push({ Rows: [row] });
    });
    var colorIdx = 0;
    groups.forEach(function (g) {
        return g.Rows = g.Rows.filter(function (r) {
            return r.Readings.length > 1;
        });
    });
    return groups.filter(function (g) {
        return g.Rows.length > 0;
    }).map(function (group, idx) {
        return {
            yAxisTitle: group.Rows.length === 1 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* getTitle */])(group.Rows[0]) : group.Rows[0].UnitName,
            maxValue: group.RangeMax,
            minValue: group.RangeMin || 0,
            sequences: group.Rows.map(function (r, index) {
                return {
                    id: colorIdx,
                    color: colors[colorIdx++ % colors.length],
                    title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* getTitle */])(r),
                    dotType: r.DotType,
                    order: r.order,
                    state: __WEBPACK_IMPORTED_MODULE_3__charts_Data__["a" /* SequenceState */].Normal,
                    BaselineValue: group.Rows[index].Baseline,
                    samples: r.Readings.map(function (item) {
                        return {
                            x: new Date(item.DateTime),
                            y: item.Value,
                            severity: item.POI
                        };
                    })
                };
            })
        };
    });
}

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SettingsActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Actions__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["a" /* createNamespace */])('SETTINGS');
var names = {
    SET_DIVISION: ns('SET_DIVISION'),
    SET_SETTINGS_ITEMS: ns('SET_SETTINGS_ITEMS'),
    SET_QUANTITY_UNIT: ns('SET_QUANTITY_UNIT'),
    SET_EMAILS: ns('SET_EMAILS'),
    SET_LANGUAGE: ns('SET_LANGUAGE'),
    SET_LANGUAGE_ITEMS: ns('SET_LANGUAGE_ITEMS'),
    SET_PASSWORD_FLAG: ns('SET_PASSWORD_FLAG'),
    SET_PASSWORD: ns('SET_PASSWORD'),
    SET_PASSWORD_CONFIRMATION: ns('SET_PASSWORD_CONFIRMATION'),
    SET_DONT_ALERT_LEAVING_RED: ns('SET_DONT_ALERT_LEAVING_RED'),
    SET_DONT_ALERT_ENTERING_YELLOW: ns('SET_DONT_ALERT_ENTERING_YELLOW'),
    SET_DONT_ALERT_LEAVING_YELLOW: ns('SET_DONT_ALERT_LEAVING_YELLOW'),
    REJECT: ns('REJECT')
};
// These are actions which settings UI component could emmit in order to change a state
var SettingsActions = function (_Actions) {
    _inherits(SettingsActions, _Actions);

    function SettingsActions() {
        _classCallCheck(this, SettingsActions);

        var _this = _possibleConstructorReturn(this, (SettingsActions.__proto__ || Object.getPrototypeOf(SettingsActions)).apply(this, arguments));

        _this.setDivision = function (division) {
            return _this.dispatch(names.SET_DIVISION, division);
        };
        _this.setSettingsItems = function (settings) {
            return _this.dispatch(names.SET_SETTINGS_ITEMS, settings);
        };
        _this.setQuantityUnit = function (quantityId, unitId) {
            return _this.dispatch(names.SET_QUANTITY_UNIT, { key: quantityId, value: unitId });
        };
        _this.setEmails = function (value) {
            return _this.dispatch(names.SET_EMAILS, value);
        };
        _this.setLanguage = function (lang) {
            return _this.dispatch(names.SET_LANGUAGE, lang);
        };
        _this.setLanguageItems = function (languages) {
            return _this.dispatch(names.SET_LANGUAGE_ITEMS, languages);
        };
        _this.setChangePasswordFlag = function (flag) {
            return _this.dispatch(names.SET_PASSWORD_FLAG, flag);
        };
        _this.setPassword = function (pwd) {
            return _this.dispatch(names.SET_PASSWORD, pwd);
        };
        _this.setPasswordConfirmation = function (pwd) {
            return _this.dispatch(names.SET_PASSWORD_CONFIRMATION, pwd);
        };
        _this.setDontAlertLeavingRedZone = function (value) {
            return _this.dispatch(names.SET_DONT_ALERT_LEAVING_RED, value);
        };
        _this.setDontAlertEnteringYellowZone = function (value) {
            return _this.dispatch(names.SET_DONT_ALERT_ENTERING_YELLOW, value);
        };
        _this.setDontAlertLeavingYellowZone = function (value) {
            return _this.dispatch(names.SET_DONT_ALERT_LEAVING_YELLOW, value);
        };
        _this.reject = function () {
            return _this.dispatch(names.REJECT);
        };
        return _this;
    }

    return SettingsActions;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["b" /* Actions */]);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimeSeriesActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Actions__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["a" /* createNamespace */])('TimeSeries');
var names = {
    SET_DATA_SETS: ns('SET_DATA_SETS'),
    SET_RANGE: ns('SET_RANGE'),
    SET_TOOLTIP_TIME: ns('SET_TOOLTIP_TIME'),
    TOGGLE_VISIBILITY: ns('TOGGLE_VISIBILITY'),
    HIGHLIGHT_SINGLE: ns('HIGHLIGHT_SINGLE'),
    NORMALIZE: ns('NORMALIZE')
};
var TimeSeriesActions = function (_Actions) {
    _inherits(TimeSeriesActions, _Actions);

    function TimeSeriesActions() {
        _classCallCheck(this, TimeSeriesActions);

        var _this = _possibleConstructorReturn(this, (TimeSeriesActions.__proto__ || Object.getPrototypeOf(TimeSeriesActions)).apply(this, arguments));

        _this.setDataSets = function (dataSets) {
            return _this.dispatch(names.SET_DATA_SETS, dataSets);
        };
        _this.setRange = function (range) {
            return _this.dispatch(names.SET_RANGE, range);
        };
        _this.setTooltipTime = function (t) {
            return _this.dispatch(names.SET_TOOLTIP_TIME, t);
        };
        _this.toggleVisibility = function (sequenceId) {
            return _this.dispatch(names.TOGGLE_VISIBILITY, sequenceId);
        };
        _this.highlightSingle = function (sequenceId) {
            return _this.dispatch(names.HIGHLIGHT_SINGLE, sequenceId);
        };
        _this.normalize = function () {
            return _this.dispatch(names.NORMALIZE);
        };
        return _this;
    }

    return TimeSeriesActions;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["b" /* Actions */]);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ErrorMessage__ = __webpack_require__(605);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ErrorMessage__["a"]; });


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Modal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var styles = __webpack_require__(968);
// Modal component helps to dispay content modaly
var Modal = function (_React$Component) {
    _inherits(Modal, _React$Component);

    function Modal() {
        _classCallCheck(this, Modal);

        return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
    }

    _createClass(Modal, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'show modal' }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styles.ModalBackground + " modalBackground" }, this.props.children));
        }
    }]);

    return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Source; });
var Source;
(function (Source) {
    Source[Source["Geotab"] = 1] = "Geotab";
    Source[Source["BoxId"] = 2] = "BoxId";
})(Source || (Source = {}));

/***/ }),
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MarginLeft":"MarginLeft--18Eaq"};

/***/ }),
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Store__ = __webpack_require__(547);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Store__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Store__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Actions__ = __webpack_require__(312);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Actions__["a"]; });



/***/ }),
/* 208 */,
/* 209 */,
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDashboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return takeOverSensorExcess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__(23);

var getDashboard = function getDashboard(request) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__client__["a" /* runAction */])('/action/GetDashboard', request);
};
var takeOverSensorExcess = function takeOverSensorExcess(assignment) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__client__["a" /* runAction */])('/action/TakeOverSensorExcess', assignment);
};

/***/ }),
/* 211 */,
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TwoButtonDialog__ = __webpack_require__(499);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TwoButtonDialog__["a"]; });


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};


var FormGroup = function FormGroup(props) {
    var className = props.className,
        children = props.children,
        divProps = __rest(props, ["className", "children"]);

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", Object.assign({ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(props.className, 'form-group') }, divProps), children);
};

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditCreateDivisionActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Actions__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["a" /* createNamespace */])('EditCreateDivisions');
var names = {
    SET_NAME: ns('SET_NAME'),
    SET_PARENT_DIVISION: ns('SET_PARENT_DIVISION'),
    SET_DIVISION_ITEMS: ns('SET_DIVISION_ITEMS')
};
var EditCreateDivisionActions = function (_Actions) {
    _inherits(EditCreateDivisionActions, _Actions);

    function EditCreateDivisionActions() {
        _classCallCheck(this, EditCreateDivisionActions);

        var _this = _possibleConstructorReturn(this, (EditCreateDivisionActions.__proto__ || Object.getPrototypeOf(EditCreateDivisionActions)).apply(this, arguments));

        _this.setName = function (name) {
            return _this.dispatch(names.SET_NAME, name);
        };
        _this.setParentDivision = function (divisionId) {
            return _this.dispatch(names.SET_PARENT_DIVISION, divisionId);
        };
        _this.setDivisionItems = function (divisions) {
            return _this.dispatch(names.SET_DIVISION_ITEMS, divisions);
        };
        return _this;
    }

    return EditCreateDivisionActions;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["b" /* Actions */]);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditCreatePersonActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Actions__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["a" /* createNamespace */])('EDIT_PERSON');
var names = {
    SET_DIVISION: ns('SET_DIVISION'),
    SET_DIVISION_ITEMS: ns('SET_DIVISION_ITEMS'),
    SET_FIRST_NAME: ns('SET_FIRST_NAME'),
    SET_LAST_NAME: ns('SET_LAST_NAME'),
    SET_USER_NAME: ns('SET_USER_NAME'),
    SET_PASSWORD: ns('SET_PASSWORD'),
    SET_PASSWORD_CONFIRMATION: ns('SET_PASSWORD_CONFIRMATION'),
    SET_ADMIN_FLAG: ns('SET_ADMIN_FLAG')
};
var EditCreatePersonActions = function (_Actions) {
    _inherits(EditCreatePersonActions, _Actions);

    function EditCreatePersonActions() {
        _classCallCheck(this, EditCreatePersonActions);

        var _this = _possibleConstructorReturn(this, (EditCreatePersonActions.__proto__ || Object.getPrototypeOf(EditCreatePersonActions)).apply(this, arguments));

        _this.setDivision = function (divisionId) {
            return _this.dispatch(names.SET_DIVISION, divisionId);
        };
        _this.setDivisionItems = function (divisions) {
            return _this.dispatch(names.SET_DIVISION_ITEMS, divisions);
        };
        _this.setFirstName = function (value) {
            return _this.dispatch(names.SET_FIRST_NAME, value);
        };
        _this.setLastName = function (value) {
            return _this.dispatch(names.SET_LAST_NAME, value);
        };
        _this.setUserName = function (value) {
            return _this.dispatch(names.SET_USER_NAME, value);
        };
        _this.setAdminFlag = function (value) {
            return _this.dispatch(names.SET_ADMIN_FLAG, value);
        };
        _this.setPassword = function (value) {
            return _this.dispatch(names.SET_PASSWORD, value);
        };
        _this.setPasswordConfirmation = function (value) {
            return _this.dispatch(names.SET_PASSWORD_CONFIRMATION, value);
        };
        return _this;
    }

    return EditCreatePersonActions;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["b" /* Actions */]);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditServiceAccountActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Actions__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["a" /* createNamespace */])('EDIT_SERVICE_ACCOUNT');
var names = {
    SET_DIVISION: ns('SET_DIVISION'),
    SET_DIVISION_ITEMS: ns('SET_DIVISION_ITEMS'),
    SET_LOGIN: ns('SET_LOGIN'),
    SET_PASSWORD: ns('SET_PASSWORD'),
    SET_SERVER_URL: ns('SET_SERVER_URL'),
    SET_IMPORT_VEHICLES: ns('SET_IMPORT_VEHICLES')
};
var EditServiceAccountActions = function (_Actions) {
    _inherits(EditServiceAccountActions, _Actions);

    function EditServiceAccountActions() {
        _classCallCheck(this, EditServiceAccountActions);

        var _this = _possibleConstructorReturn(this, (EditServiceAccountActions.__proto__ || Object.getPrototypeOf(EditServiceAccountActions)).apply(this, arguments));

        _this.setDivision = function (division) {
            return _this.dispatch(names.SET_DIVISION, division);
        };
        _this.setDivisionItems = function (divisions) {
            return _this.dispatch(names.SET_DIVISION_ITEMS, divisions);
        };
        _this.setLogin = function (login) {
            return _this.dispatch(names.SET_LOGIN, login);
        };
        _this.setPassword = function (password) {
            return _this.dispatch(names.SET_PASSWORD, password);
        };
        _this.setServerUrl = function (url) {
            return _this.dispatch(names.SET_SERVER_URL, url);
        };
        _this.setImportAllVehicles = function (flag) {
            return _this.dispatch(names.SET_IMPORT_VEHICLES, flag);
        };
        return _this;
    }

    return EditServiceAccountActions;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["b" /* Actions */]);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditVehicleActions__ = __webpack_require__(316);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__EditVehicleActions__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__EditVehicleActions__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditVehicleStore__ = __webpack_require__(572);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__EditVehicleStore__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VehicleGeopositionActions__ = __webpack_require__(317);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__VehicleGeopositionActions__["a"]; });




/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpsertCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Flag__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Grid__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_Error__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(7);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






// This command is executed from UI when we want to update Entity instance
var UpsertCommand = function UpsertCommand(commit, listDispatchToken, inProgressDispatchToken, errorDispatchToken) {
    var _this = this;

    _classCallCheck(this, UpsertCommand);

    this.commit = commit;
    this.listDispatchToken = listDispatchToken;
    this.inProgressDispatchToken = inProgressDispatchToken;
    this.errorDispatchToken = errorDispatchToken;
    this.inProgressActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Flag__["a" /* FlagActions */]();
    this.listActions = new __WEBPACK_IMPORTED_MODULE_2__flux_Grid__["a" /* ListActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_3__flux_Error__["a" /* ErrorActions */]();
    this.execute = function (entityDraft, entityType) {
        _this.inProgressActions.set(_this.inProgressDispatchToken);
        _this.commit({ type: entityType, entity: entityDraft }).then(function (res) {
            if (res.Success) return res[__WEBPACK_IMPORTED_MODULE_0__models__["a" /* EntityType */][entityType]];
            throw new Error(res.ErrorMessage);
        }).then(function (entity) {
            _this.listActions.upsertItems([entity], entityType);
            __WEBPACK_IMPORTED_MODULE_4__routes__["b" /* appNavigator */].goToEntityTab(entityType);
        }).catch(function (err) {
            return _this.errorActions.setError(err, _this.errorDispatchToken);
        }).then(function () {
            return _this.inProgressActions.reset(_this.inProgressDispatchToken);
        }); // finaly
    };
};

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ValueActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Actions__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["a" /* createNamespace */])('VALUE');
var names = {
    SET: ns('SET'),
    CLEAR: ns('CLEAR')
};
var ValueActions = function (_Actions) {
    _inherits(ValueActions, _Actions);

    function ValueActions() {
        _classCallCheck(this, ValueActions);

        var _this = _possibleConstructorReturn(this, (ValueActions.__proto__ || Object.getPrototypeOf(ValueActions)).apply(this, arguments));

        _this.set = function (value, dispatchToken) {
            return _this.dispatch(names.SET, value, dispatchToken);
        };
        _this.clear = function (dispatchToken) {
            return _this.dispatch(names.CLEAR, null, dispatchToken);
        };
        return _this;
    }

    return ValueActions;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["b" /* Actions */]);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return nameof; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var nameof = function nameof(descriptor) {
    if ((typeof descriptor === 'undefined' ? 'undefined' : _typeof(descriptor)) !== 'object') throw Error('descriptor has to be an object');
    return Object.getOwnPropertyNames(descriptor)[0];
};

/***/ }),
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GoogleMapLoader; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleMapLoader = function () {
    function GoogleMapLoader() {
        _classCallCheck(this, GoogleMapLoader);
    }

    _createClass(GoogleMapLoader, [{
        key: 'loadMapFor',
        value: function loadMapFor(googleApiKey) {
            if (typeof googleApiKey !== 'string') return Promise.resolve({});
            return new Promise(function (resolve) {
                if (!window['google']) {
                    var script = document.createElement('script');
                    script.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=' + googleApiKey);
                    script.async = false;
                    script.onload = resolve;
                    document.head.appendChild(script);
                } else {
                    resolve();
                }
            });
        }
    }]);

    return GoogleMapLoader;
}();

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimezoneActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Actions__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["a" /* createNamespace */])('TIMEZONE');
var names = {
    SET_TIMEZONES: ns('SET_TIMEZONES')
};
// TimezoneActions pulls list of Timezones from server
// TimezoneActions is an Action in terms of Flux
var TimezoneActions = function (_Actions) {
    _inherits(TimezoneActions, _Actions);

    function TimezoneActions(getTimezones) {
        _classCallCheck(this, TimezoneActions);

        var _this = _possibleConstructorReturn(this, (TimezoneActions.__proto__ || Object.getPrototypeOf(TimezoneActions)).call(this));

        _this.getTimezones = getTimezones;
        _this.startPullingTimezones = function (msInterval) {
            _this.pullTimezones();
            _this.timerId = setInterval(_this.pullTimezones, msInterval);
        };
        _this.stopPullingTimezones = function () {
            clearInterval(_this.timerId);
            _this.timerId = null;
        };
        _this.pullTimezones = function () {
            _this.getTimezones().then(function (tzr) {
                return _this.dispatch(names.SET_TIMEZONES, tzr.Timezones);
            });
        };
        return _this;
    }

    return TimezoneActions;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["b" /* Actions */]);

/***/ }),
/* 294 */,
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SignOutCommand; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SignOutCommand = function () {
    function SignOutCommand(signOut, removeAuthCookies, redirect) {
        var _this = this;

        _classCallCheck(this, SignOutCommand);

        this.signOut = signOut;
        this.removeAuthCookies = removeAuthCookies;
        this.redirect = redirect;
        this.execute = function () {
            _this.signOut().then(function () {
                _this.removeAuthCookies();
                _this.takeMeToLogin();
                // this.redirect();
            });
        };
    }

    _createClass(SignOutCommand, [{
        key: 'takeMeToLogin',
        value: function takeMeToLogin() {
            var uri = void 0;
            if (window.location.origin.includes('localhost')) {
                uri = window.location.origin + '/output/login/index.html';
            } else {
                uri = window.location.origin + '/login';
            }
            window.location.href = 'https://my.spartansense.com:8443/auth/realms/spartanlync/protocol/openid-connect/logout?redirect_uri=' + uri;
        }
    }]);

    return SignOutCommand;
}();

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sensors__ = __webpack_require__(614);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__sensors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vehicles__ = __webpack_require__(616);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__vehicles__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sensors_data__ = __webpack_require__(615);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__sensors_data__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__sensors_data__["b"]; });




/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__measures__ = __webpack_require__(617);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__measures__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__measures__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timezones__ = __webpack_require__(618);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__timezones__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vehicle_tags__ = __webpack_require__(619);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__vehicle_tags__["a"]; });




/***/ }),
/* 298 */,
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddTags; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_TypeAhead__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_edit_distance__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_string_alignment__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TypeaheadEnterEscWrapper__ = __webpack_require__(76);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// AddTags is a wrapper arround 3d party react-bootstrap-typeahead
// The main feature of this component is that makes fuzzy search according to Levenshtein distance https://en.wikipedia.org/wiki/Levenshtein_distance
var AddTags = function (_React$Component) {
    _inherits(AddTags, _React$Component);

    function AddTags(props) {
        _classCallCheck(this, AddTags);

        var _this = _possibleConstructorReturn(this, (AddTags.__proto__ || Object.getPrototypeOf(AddTags)).call(this, props));

        _this.state = {
            filteredOptions: _this.props.options || []
        };
        return _this;
    }

    _createClass(AddTags, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps, nextContext) {
            this.setState({ filteredOptions: nextProps.options });
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                selected = _props.selected,
                _onChange = _props.onChange,
                className = _props.className,
                placeholder = _props.placeholder,
                newSelectionPrefix = _props.newSelectionPrefix;
            var filteredOptions = this.state.filteredOptions;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__TypeaheadEnterEscWrapper__["a" /* TypeaheadEnterEscWrapper */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["Typeahead"], { key: "add-tags", className: className, placeholder: placeholder, newSelectionPrefix: newSelectionPrefix, allowNew: true, multiple: true, selected: selected || [], options: filteredOptions, filterBy: function filterBy(option, text) {
                    return filteredOptions.indexOf(option) >= 0;
                }, onChange: function onChange(opts) {
                    return _onChange(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_TypeAhead__["a" /* extactValues */])(opts));
                }, onInputChange: this.handleInputChange.bind(this) }));
        }
    }, {
        key: "handleInputChange",
        value: function handleInputChange(text) {
            var _this2 = this;

            var options = this.props.options;

            if (text == null || text === '') {
                this.setState({ filteredOptions: options });
                return;
            }
            // Get a tag and sort all tags with respect to edit distance
            // Get rid of values which a less than some threshold
            // This threshold is calculated in a hacky way but works well in practice – feel free to play with it
            var source = text.toLocaleLowerCase();
            var evaluate = function evaluate(tag) {
                return [tag, _this2.getScore(source, tag.toLocaleLowerCase())];
            };
            var items = this.props.options.map(evaluate);
            var filteredOptions = items.filter(function (item) {
                return item[1].value >= 0.5 && item[1].alignment >= Math.floor(Math.log2(item[0].length));
            }).sort(function (a, b) {
                return b[1].value - a[1].value;
            }).map(function (item) {
                return item[0];
            });
            this.setState({ filteredOptions: filteredOptions });
        }
    }, {
        key: "getScore",
        value: function getScore(source, target) {
            var alignment = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_string_alignment__["a" /* calcAlignment */])(source, target);
            var editDistance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_edit_distance__["a" /* calcEditDistance */])(source, target);
            var value = alignment / Math.sqrt(alignment + editDistance + 1);
            return { alignment: alignment, editDistance: editDistance, value: value };
        }
    }]);

    return AddTags;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CurrentDivisionActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Actions__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["a" /* createNamespace */])('CurrentDivision');
var names = {
    SET_TARGET_DIVISION: ns('SET_TARGET_DIVISION')
};
var CurrentDivisionActions = function (_Actions) {
    _inherits(CurrentDivisionActions, _Actions);

    function CurrentDivisionActions() {
        _classCallCheck(this, CurrentDivisionActions);

        var _this = _possibleConstructorReturn(this, (CurrentDivisionActions.__proto__ || Object.getPrototypeOf(CurrentDivisionActions)).apply(this, arguments));

        _this.setTarget = function (id, allDivisions) {
            return _this.dispatch(names.SET_TARGET_DIVISION, { targetDivisionId: id, allDivisions: allDivisions });
        };
        return _this;
    }

    return CurrentDivisionActions;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["b" /* Actions */]);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormItemVertical; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_assert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormGroup__ = __webpack_require__(213);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var FormItemVertical = function (_React$Component) {
    _inherits(FormItemVertical, _React$Component);

    function FormItemVertical() {
        _classCallCheck(this, FormItemVertical);

        return _possibleConstructorReturn(this, (FormItemVertical.__proto__ || Object.getPrototypeOf(FormItemVertical)).apply(this, arguments));
    }

    _createClass(FormItemVertical, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                title = _props.title;

            if (title) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assert__["g" /* assertString */])(title);
            }
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__FormGroup__["a" /* FormGroup */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "control-label text-right" }, title), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, children));
        }
    }]);

    return FormItemVertical;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Levels; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__converters_converters__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Forms_Groups__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Forms_FormItemHorizontal__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Select__ = __webpack_require__(112);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Levels = function (_React$Component) {
    _inherits(Levels, _React$Component);

    function Levels() {
        _classCallCheck(this, Levels);

        return _possibleConstructorReturn(this, (Levels.__proto__ || Object.getPrototypeOf(Levels)).apply(this, arguments));
    }

    _createClass(Levels, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                isBaselineVisible = _props.isBaselineVisible,
                unitName = _props.unitName,
                defineAlertLevels = _props.defineAlertLevels,
                setDefineAlertLevels = _props.setDefineAlertLevels,
                baseline = _props.baseline,
                setBaseline = _props.setBaseline,
                redMax = _props.redMax,
                setRedMax = _props.setRedMax,
                redMin = _props.redMin,
                setRedMin = _props.setRedMin,
                yellowMax = _props.yellowMax,
                setYellowMax = _props.setYellowMax,
                yellowMin = _props.yellowMin,
                setYellowMin = _props.setYellowMin,
                polyglot = _props.polyglot;

            var maxUnitName = isBaselineVisible ? '+%' : unitName;
            var minUnitName = isBaselineVisible ? '-%' : unitName;
            var axles = createAxleOptions(polyglot, this.props.axleCount);
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-horizontal" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Forms_FormItemHorizontal__["a" /* FormItemHorizontal */], { title: polyglot.t('levels.axles') + ':', labelColumns: 4 }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Select__["a" /* Select */], { className: 'form-control', placeholder: "---", items: axles, titleFn: function titleFn(axle) {
                    return axle.name;
                }, valueFn: function valueFn(axle) {
                    return axle.id.toString();
                }, onChange: function onChange(s) {
                    return _this2.props.setAxle(parseInt(s.getValue()));
                }, defaultValue: this.props.axle ? this.props.axle.toString() : null })), isBaselineVisible && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Forms_Groups__["d" /* LevelGroup */], { title: polyglot.t('levels.baseline') + ':', unitName: unitName, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__converters_converters__["a" /* intToString */])(baseline, true), onChange: function onChange(e) {
                    return setBaseline(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__converters_converters__["b" /* stringToInt */])(e.target.value, true));
                } }), isBaselineVisible && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Forms_Groups__["e" /* CheckboxGroup */], { title: polyglot.t('levels.define_alert_levels'), checked: this.props.defineAlertLevels, onChange: function onChange(e) {
                    return setDefineAlertLevels(e.target.checked);
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Forms_Groups__["d" /* LevelGroup */], { title: polyglot.t('levels.red_max') + ':', unitName: maxUnitName, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__converters_converters__["a" /* intToString */])(redMax, true), onChange: function onChange(e) {
                    return setRedMax(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__converters_converters__["b" /* stringToInt */])(e.target.value, true));
                }, disabled: isBaselineVisible && !defineAlertLevels }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Forms_Groups__["d" /* LevelGroup */], { title: polyglot.t('levels.yellow_max') + ':', unitName: maxUnitName, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__converters_converters__["a" /* intToString */])(yellowMax, true), onChange: function onChange(e) {
                    return setYellowMax(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__converters_converters__["b" /* stringToInt */])(e.target.value, true));
                }, disabled: isBaselineVisible && !defineAlertLevels }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Forms_Groups__["d" /* LevelGroup */], { title: polyglot.t('levels.yellow_min') + ':', unitName: minUnitName, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__converters_converters__["a" /* intToString */])(yellowMin, true), onChange: function onChange(e) {
                    return setYellowMin(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__converters_converters__["b" /* stringToInt */])(e.target.value, true));
                }, disabled: isBaselineVisible && !defineAlertLevels }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Forms_Groups__["d" /* LevelGroup */], { title: polyglot.t('levels.red_min') + ':', unitName: minUnitName, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__converters_converters__["a" /* intToString */])(redMin, true), onChange: function onChange(e) {
                    return setRedMin(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__converters_converters__["b" /* stringToInt */])(e.target.value, true));
                }, disabled: isBaselineVisible && !defineAlertLevels }));
        }
    }]);

    return Levels;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
function createAxleOptions(polyglot, axleCount) {
    var axles = [-1];
    for (var i = 1; i <= axleCount; i++) {
        axles.push(i);
    }
    return axles.map(function (id) {
        return {
            id: id,
            name: id > 0 ? polyglot.t('levels.axle_#') + " " + id : polyglot.t('levels.all_axles')
        };
    });
}

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataGridButtonColumn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Buttons__ = __webpack_require__(21);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// This column renders a button inside a cell
// Mostly it is used for Action column in a grid
var DataGridButtonColumn = function (_React$Component) {
    _inherits(DataGridButtonColumn, _React$Component);

    function DataGridButtonColumn() {
        _classCallCheck(this, DataGridButtonColumn);

        return _possibleConstructorReturn(this, (DataGridButtonColumn.__proto__ || Object.getPrototypeOf(DataGridButtonColumn)).apply(this, arguments));
    }

    _createClass(DataGridButtonColumn, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                datum = _props.datum,
                row = _props.row,
                title = _props.title,
                _onClick = _props.onClick,
                cellClassName = _props.cellClassName;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: cellClassName }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_Buttons__["a" /* Button */], { dim: "xs", type: "info", leftIcon: "pencil", onClick: function onClick(e) {
                    return _onClick(datum, row);
                } }, title));
        }
    }]);

    return DataGridButtonColumn;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssignPersonStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditCreate_EditStore__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AssignPersonActions__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_assert__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AssignPersonStore = function (_EditStore) {
    _inherits(AssignPersonStore, _EditStore);

    function AssignPersonStore() {
        _classCallCheck(this, AssignPersonStore);

        var _this = _possibleConstructorReturn(this, (AssignPersonStore.__proto__ || Object.getPrototypeOf(AssignPersonStore)).call(this));

        _this.setDuration = function (duration) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_assert__["f" /* assertNumber */])(duration, 'number payload expected');
            return _this.draft({ Duration: duration });
        };
        _this.register(__WEBPACK_IMPORTED_MODULE_1__AssignPersonActions__["b" /* names */].SET_DURATION, function (e) {
            return _this.setDuration(e.payload);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_1__AssignPersonActions__["b" /* names */].SET_SENSOR_EXCESS, function (e) {
            return _this.getDafaultState(e.payload.IncidentId);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_1__AssignPersonActions__["b" /* names */].REJECT_SENSOR_EXCESS, function (e) {
            return null;
        });
        return _this;
    }

    _createClass(AssignPersonStore, [{
        key: "getDafaultState",
        value: function getDafaultState(incidentId) {
            return {
                draft: {
                    IncidentId: incidentId,
                    Duration: 15
                },
                durations: [15, 30, 45, 60, 120]
            };
        }
    }]);

    return AssignPersonStore;
}(__WEBPACK_IMPORTED_MODULE_0__EditCreate_EditStore__["a" /* EditStore */]);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FindIncidentDataCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Value_ValueActions__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Error_ErrorActions__ = __webpack_require__(13);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var FindIncidentDataCommand = function FindIncidentDataCommand(getSensorsDataForIncident, showSensorsDataCmd, valueDispatchToken, errorDispatchToken) {
    var _this = this;

    _classCallCheck(this, FindIncidentDataCommand);

    this.getSensorsDataForIncident = getSensorsDataForIncident;
    this.showSensorsDataCmd = showSensorsDataCmd;
    this.valueDispatchToken = valueDispatchToken;
    this.errorDispatchToken = errorDispatchToken;
    this.valueActions = new __WEBPACK_IMPORTED_MODULE_0__flux_Value_ValueActions__["a" /* ValueActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Error_ErrorActions__["a" /* ErrorActions */]();
    this.execute = function (incidentId) {
        _this.token = incidentId;
        _this.valueActions.set(incidentId, _this.valueDispatchToken);
        var sameToken = function sameToken() {
            return _this.token === incidentId;
        };
        _this.getSensorsDataForIncident(incidentId).then(function (res) {
            if (sameToken()) {
                return _this.showSensorsDataCmd.execute(res);
            }
        }).catch(function (err) {
            return sameToken() && _this.errorActions.setError(err, _this.errorDispatchToken, 5 * 1000);
        }).then(function () {
            if (sameToken()) {
                _this.token = null;
                _this.valueActions.clear(_this.valueDispatchToken);
            }
        }); // finally
    };
};

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadDashboardCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Flag__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Error__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Grid__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_Label__ = __webpack_require__(320);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var LoadDashboardCommand = function LoadDashboardCommand(polyglot, getDashboard, getDivisionId, listDispatchToken, reportListDispatchToken, reportTableLabelDipatchToken, inProgressDispatchToken, errorDispatchToken) {
    var _this = this;

    _classCallCheck(this, LoadDashboardCommand);

    this.polyglot = polyglot;
    this.getDashboard = getDashboard;
    this.getDivisionId = getDivisionId;
    this.listDispatchToken = listDispatchToken;
    this.reportListDispatchToken = reportListDispatchToken;
    this.reportTableLabelDipatchToken = reportTableLabelDipatchToken;
    this.inProgressDispatchToken = inProgressDispatchToken;
    this.errorDispatchToken = errorDispatchToken;
    this.flagActions = new __WEBPACK_IMPORTED_MODULE_0__flux_Flag__["a" /* FlagActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Error__["a" /* ErrorActions */]();
    this.listActions = new __WEBPACK_IMPORTED_MODULE_2__flux_Grid__["a" /* ListActions */]();
    this.labelActions = new __WEBPACK_IMPORTED_MODULE_3__flux_Label__["a" /* LabelActions */]();
    this.execute = function () {
        var divisionId = _this.getDivisionId();
        _this.flagActions.set(_this.inProgressDispatchToken);
        _this.getDashboard({ DivisionId: divisionId }).then(function (res) {
            res.SensorsExcesses.forEach(function (se) {
                return se.date = new Date(se.DateTime);
            });
            _this.listActions.setItems(res.SensorsExcesses, _this.listDispatchToken);
            _this.labelActions.set(_this.polyglot.t('dashboard.summary_table.header', { name: res.Division }), _this.reportTableLabelDipatchToken);
            _this.listActions.setItems([res], _this.reportListDispatchToken);
        }).catch(function (err) {
            return _this.errorActions.setError(err, _this.errorDispatchToken, 5 * 1000);
        }).then(function () {
            return _this.flagActions.reset(_this.inProgressDispatchToken);
        }); // finally
    };
};

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TakeOverSensorExcessCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Flag_FlagActions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Error_ErrorActions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AssignPersonActions__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_Grid_ListActions__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(7);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var TakeOverSensorExcessCommand = function TakeOverSensorExcessCommand(takeOverSensorExcess, listDispatchToken, inProgressDispatchToken, errorDispatchToken) {
    var _this = this;

    _classCallCheck(this, TakeOverSensorExcessCommand);

    this.takeOverSensorExcess = takeOverSensorExcess;
    this.listDispatchToken = listDispatchToken;
    this.inProgressDispatchToken = inProgressDispatchToken;
    this.errorDispatchToken = errorDispatchToken;
    this.listActions = new __WEBPACK_IMPORTED_MODULE_3__flux_Grid_ListActions__["a" /* ListActions */]();
    this.inProgress = new __WEBPACK_IMPORTED_MODULE_0__flux_Flag_FlagActions__["a" /* FlagActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Error_ErrorActions__["a" /* ErrorActions */]();
    this.assignActions = new __WEBPACK_IMPORTED_MODULE_2__AssignPersonActions__["a" /* AssignPersonActions */]();
    this.execute = function (assignment) {
        _this.inProgress.set(_this.inProgressDispatchToken);
        _this.takeOverSensorExcess(assignment).then(function (res) {
            var se = res.SensorsExcess;
            se.date = new Date(se.DateTime);
            _this.listActions.upsertItems([se], _this.listDispatchToken);
            __WEBPACK_IMPORTED_MODULE_4__routes__["b" /* appNavigator */].goToAlarm();
            _this.assignActions.reject();
        }).catch(function (err) {
            return _this.errorActions.setError(err, _this.errorDispatchToken);
        }).then(function () {
            return _this.inProgress.reset(_this.inProgressDispatchToken);
        }); //finally
    };
};

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Actions__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["a" /* createNamespace */])('SEARCH');
var names = {
    SEARCH_PARAMS_UPDATED: ns('SEARCH_PARAMS_UPDATED')
};
var SearchActions = function (_Actions) {
    _inherits(SearchActions, _Actions);

    function SearchActions() {
        _classCallCheck(this, SearchActions);

        var _this = _possibleConstructorReturn(this, (SearchActions.__proto__ || Object.getPrototypeOf(SearchActions)).apply(this, arguments));

        _this.updateSearchParams = function (searchParams, dispatchToken) {
            return _this.dispatch(names.SEARCH_PARAMS_UPDATED, searchParams, dispatchToken);
        };
        return _this;
    }

    return SearchActions;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["b" /* Actions */]);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export names */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DateRangeActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateRangeStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Store__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Actions__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__flux_Actions__["a" /* createNamespace */])('DATE_RANGE');
var names = {
    SET_FROM_DATE: ns('SET_FROM_DATE'),
    SET_TO_DATE: ns('SET_TO_DATE')
};
var DateRangeActions = function (_Actions) {
    _inherits(DateRangeActions, _Actions);

    function DateRangeActions() {
        _classCallCheck(this, DateRangeActions);

        var _this = _possibleConstructorReturn(this, (DateRangeActions.__proto__ || Object.getPrototypeOf(DateRangeActions)).apply(this, arguments));

        _this.setFromDate = function (date) {
            return _this.dispatch(names.SET_FROM_DATE, date);
        };
        _this.setToDate = function (date) {
            return _this.dispatch(names.SET_TO_DATE, date);
        };
        return _this;
    }

    return DateRangeActions;
}(__WEBPACK_IMPORTED_MODULE_1__flux_Actions__["b" /* Actions */]);
var DateRangeStore = function (_Store) {
    _inherits(DateRangeStore, _Store);

    function DateRangeStore() {
        _classCallCheck(this, DateRangeStore);

        var _this2 = _possibleConstructorReturn(this, (DateRangeStore.__proto__ || Object.getPrototypeOf(DateRangeStore)).call(this));

        _this2.state = { fromDate: null, toDate: null };
        _this2.register(names.SET_FROM_DATE, function (e) {
            return _this2.field({ fromDate: e.payload });
        });
        _this2.register(names.SET_TO_DATE, function (e) {
            return _this2.field({ toDate: e.payload });
        });
        return _this2;
    }

    return DateRangeStore;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Store__["a" /* Store */]);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadSensorsDataCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Flag_FlagActions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Error_ErrorActions__ = __webpack_require__(13);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var LoadSensorsDataCommand = function LoadSensorsDataCommand(getSensorsData, getIds, showSensorsDataCmd, inProgressDispatchToken, errorDispatchToken) {
    var _this = this;

    _classCallCheck(this, LoadSensorsDataCommand);

    this.getSensorsData = getSensorsData;
    this.getIds = getIds;
    this.showSensorsDataCmd = showSensorsDataCmd;
    this.inProgressDispatchToken = inProgressDispatchToken;
    this.errorDispatchToken = errorDispatchToken;
    this.flagActions = new __WEBPACK_IMPORTED_MODULE_0__flux_Flag_FlagActions__["a" /* FlagActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Error_ErrorActions__["a" /* ErrorActions */]();
    this.execute = function (timeRange) {
        _this.flagActions.set(_this.inProgressDispatchToken);
        var task = _this.getSensorsData(_this.getIds(), timeRange).then(_this.showSensorsDataCmd.execute).catch(function (err) {
            return _this.errorActions.setError(err, _this.errorDispatchToken, 5 * 1000);
        }).then(function () {
            return _this.flagActions.reset(_this.inProgressDispatchToken);
        }); // finally
    };
};

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditSensorActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux__ = __webpack_require__(132);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flux__["a" /* createNamespace */])('EDIT_SENSOR');
var names = {
    SET_VEHICLE: ns('SET_VEHICLE'),
    SET_GEOTAB: ns('SET_GEOTAB'),
    SET_DISPLAY: ns('SET_DISPLAY'),
    SET_QUANTITY_UNIT: ns('SET_QUANTITY_UNIT'),
    SET_ABS_RED_MAX: ns('SET_ABS_RED_MAX'),
    SET_ABS_RED_MIN: ns('SET_ABS_RED_MIN'),
    SET_ABS_YELLOW_MAX: ns('SET_ABS_YELLOW_MAX'),
    SET_ABS_YELLOW_MIN: ns('SET_ABS_YELLOW_MIN'),
    SET_BASELINE: ns('SET_BASELINE'),
    SET_REL_RED_MAX: ns('SET_REL_RED_MAX'),
    SET_REL_RED_MIN: ns('SET_REL_RED_MIN'),
    SET_REL_YELLOW_MAX: ns('SET_REL_YELLOW_MAX'),
    SET_REL_YELLOW_MIN: ns('SET_REL_YELLOW_MIN'),
    SET_VEHICLES_ITEMS: ns('SET_VEHICLES_ITEMS'),
    SET_GEOTAB_SENSORS_ITEMS: ns('SET_GEOTAB_SENSORS_ITEMS'),
    SET_MEASURE_ITEMS: ns('LOAD_MEASURES')
};
var EditSensorActions = function (_Actions) {
    _inherits(EditSensorActions, _Actions);

    function EditSensorActions() {
        _classCallCheck(this, EditSensorActions);

        var _this = _possibleConstructorReturn(this, (EditSensorActions.__proto__ || Object.getPrototypeOf(EditSensorActions)).apply(this, arguments));

        _this.setVehicle = function (vehicleId) {
            return _this.dispatch(names.SET_VEHICLE, vehicleId);
        };
        _this.setVehicleItems = function (vehicles) {
            return _this.dispatch(names.SET_VEHICLES_ITEMS, vehicles);
        };
        _this.setGeotabSensor = function (sensor) {
            return _this.dispatch(names.SET_GEOTAB, sensor);
        };
        _this.setGeotabSensorsItems = function (sensors) {
            return _this.dispatch(names.SET_GEOTAB_SENSORS_ITEMS, sensors);
        };
        _this.setQuantity = function (quantityId, unitId) {
            return _this.dispatch(names.SET_QUANTITY_UNIT, { quantityId: quantityId, unitId: unitId });
        };
        _this.setMeasures = function (measures) {
            return _this.dispatch(names.SET_MEASURE_ITEMS, measures);
        };
        _this.setAbsRedMax = function (value) {
            return _this.dispatch(names.SET_ABS_RED_MAX, value);
        };
        _this.setAbsRedMin = function (value) {
            return _this.dispatch(names.SET_ABS_RED_MIN, value);
        };
        _this.setAbsYellowMax = function (value) {
            return _this.dispatch(names.SET_ABS_YELLOW_MAX, value);
        };
        _this.setAbsYellowMin = function (value) {
            return _this.dispatch(names.SET_ABS_YELLOW_MIN, value);
        };
        _this.setDisplay = function (value) {
            return _this.dispatch(names.SET_DISPLAY, value);
        };
        _this.setBaseline = function (value) {
            return _this.dispatch(names.SET_BASELINE, value);
        };
        _this.setRelRedMax = function (value) {
            return _this.dispatch(names.SET_REL_RED_MAX, value);
        };
        _this.setRelRedMin = function (value) {
            return _this.dispatch(names.SET_REL_RED_MIN, value);
        };
        _this.setRelYellowMax = function (value) {
            return _this.dispatch(names.SET_REL_YELLOW_MAX, value);
        };
        _this.setRelYellowMin = function (value) {
            return _this.dispatch(names.SET_REL_YELLOW_MIN, value);
        };
        return _this;
    }

    return EditSensorActions;
}(__WEBPACK_IMPORTED_MODULE_0__flux__["b" /* Actions */]);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SensorsDataActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Actions__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["a" /* createNamespace */])('SENSORS_DATA');
var names = {
    SET_GRAPH_VIEW: ns('SET_GRAPH_VIEW'),
    SET_TABLE_VIEW: ns('SET_TABLE_VIEW'),
    TOGGLE_MAP: ns('TOGGLE_MAP'),
    SET_COORDINATE: ns('SET_COORDINATE'),
    SET_SENSORS_DATA: ns('SET_SENSORS_DATA')
};
var SensorsDataActions = function (_Actions) {
    _inherits(SensorsDataActions, _Actions);

    function SensorsDataActions() {
        _classCallCheck(this, SensorsDataActions);

        var _this = _possibleConstructorReturn(this, (SensorsDataActions.__proto__ || Object.getPrototypeOf(SensorsDataActions)).apply(this, arguments));

        _this.setGraphView = function () {
            return _this.dispatch(names.SET_GRAPH_VIEW);
        };
        _this.setTableView = function () {
            return _this.dispatch(names.SET_TABLE_VIEW);
        };
        _this.toggleMap = function () {
            return _this.dispatch(names.TOGGLE_MAP);
        };
        _this.setCoordinate = function (lon, lat) {
            return _this.dispatch(names.SET_COORDINATE, { lon: lon, lat: lat });
        };
        _this.setSensorsData = function (data) {
            return _this.dispatch(names.SET_SENSORS_DATA, data);
        };
        return _this;
    }

    return SensorsDataActions;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["b" /* Actions */]);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTitle; });
var getTitle = function getTitle(row) {
  return row.UnitName ? row.Title + ", " + row.UnitName : row.Title;
};

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VehicleBatchEditActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Grid_ListActions__ = __webpack_require__(65);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flux__["a" /* createNamespace */])('VehicleGroupActions');
var names = {
    REJECT_DRAFT: ns('REJECT_DRAFT'),
    SET_IDS: ns('SET_IDS'),
    SET_AXLE_COUNT: ns('SET_AXLE_COUNT'),
    SET_ALL_TAGS: ns('SET_ALL_TAGS'),
    SET_AVAILABLE_TAGS_STAT: ns('SET_AVAILABLE_TAGS_STAT'),
    SELECT_ACTION: ns('SELECT_ACTION'),
    SET_SELECTED_TAGS: ns('SET_SELECTED_TAGS'),
    SET_TIMEZONE: ns('SET_TIMEZONE'),
    SET_UNIT: ns('SET_UNIT'),
    SET_AXLE: ns('SET_AXLE'),
    SET_BASELINE: ns('SET_BASELINE'),
    SET_DEFINE_ALERT_LEVELS_FLAG: ns('SET_DEFINE_ALERT_LEVELS_FLAG'),
    SET_RED_MAX: ns('SET_RED_MAX'),
    SET_RED_MIN: ns('SET_RED_MIN'),
    SET_YELLOW_MAX: ns('SET_YELLOW_MAX'),
    SET_YELLOW_MIN: ns('SET_YELLOW_MIN'),
    COMMIT_ACTION: ns('COMMIT_ACTION'),
    REMOVE_ACTION: ns('REMOVE_ACTION')
};
var VehicleBatchEditActions = function (_Actions) {
    _inherits(VehicleBatchEditActions, _Actions);

    function VehicleBatchEditActions() {
        _classCallCheck(this, VehicleBatchEditActions);

        var _this = _possibleConstructorReturn(this, (VehicleBatchEditActions.__proto__ || Object.getPrototypeOf(VehicleBatchEditActions)).apply(this, arguments));

        _this.listActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Grid_ListActions__["a" /* ListActions */]();
        _this.setIds = function (ids) {
            return _this.dispatch(names.SET_IDS, ids);
        };
        _this.setAxleCount = function (axleCount) {
            return _this.dispatch(names.SET_AXLE_COUNT, axleCount);
        };
        _this.setAllTags = function (tags) {
            return _this.dispatch(names.SET_ALL_TAGS, tags);
        };
        _this.setAvailableTagsStat = function (tagsStat) {
            return _this.dispatch(names.SET_AVAILABLE_TAGS_STAT, tagsStat);
        };
        _this.setActionType = function (type) {
            return _this.dispatch(names.SELECT_ACTION, type);
        };
        _this.setTags = function (tags) {
            return _this.dispatch(names.SET_SELECTED_TAGS, tags);
        };
        _this.setTimezone = function (tz) {
            return _this.dispatch(names.SET_TIMEZONE, tz);
        };
        _this.setAxle = function (axle) {
            return _this.dispatch(names.SET_AXLE, axle);
        };
        _this.setBaseline = function (value) {
            return _this.dispatch(names.SET_BASELINE, value);
        };
        _this.setDefineAlertLevelsFlag = function (flag) {
            return _this.dispatch(names.SET_DEFINE_ALERT_LEVELS_FLAG, flag);
        };
        _this.setRedMax = function (value) {
            return _this.dispatch(names.SET_RED_MAX, value);
        };
        _this.setYellowMax = function (value) {
            return _this.dispatch(names.SET_YELLOW_MAX, value);
        };
        _this.setYellowMin = function (value) {
            return _this.dispatch(names.SET_YELLOW_MIN, value);
        };
        _this.setRedMin = function (value) {
            return _this.dispatch(names.SET_RED_MIN, value);
        };
        _this.setUnit = function (unit) {
            return _this.dispatch(names.SET_UNIT, unit);
        };
        _this.commitAction = function () {
            return _this.dispatch(names.COMMIT_ACTION);
        };
        _this.removeAction = function (id) {
            return _this.dispatch(names.REMOVE_ACTION, id);
        };
        _this.rejectDraft = function () {
            return _this.dispatch(names.REJECT_DRAFT);
        };
        return _this;
    }

    return VehicleBatchEditActions;
}(__WEBPACK_IMPORTED_MODULE_0__flux__["b" /* Actions */]);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return groupActionsTranslationKeys; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux__ = __webpack_require__(39);

var groupActionsTranslationKeys = new Map().set(__WEBPACK_IMPORTED_MODULE_0__flux__["c" /* ActionType */].AddTags, 'vehicle.group_actions.action_title_add_tags').set(__WEBPACK_IMPORTED_MODULE_0__flux__["c" /* ActionType */].RemoveTags, 'vehicle.group_actions.action_title_remove_tags').set(__WEBPACK_IMPORTED_MODULE_0__flux__["c" /* ActionType */].SetTimezone, 'vehicle.group_actions.action_title_set_timezone').set(__WEBPACK_IMPORTED_MODULE_0__flux__["c" /* ActionType */].SetPressure, 'vehicle.group_actions.action_title_set_pressure').set(__WEBPACK_IMPORTED_MODULE_0__flux__["c" /* ActionType */].SetTemperature, 'vehicle.group_actions.action_title_set_temperature');

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EditVehicleActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpsertVehicleController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rest_Search__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_Flag_FlagActions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flux_Error_ErrorActions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_assert_index__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Forest__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_EditCreateEntityActions__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_draft_Vehicle__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routes__ = __webpack_require__(7);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__flux_Actions__["a" /* createNamespace */])('EDIT_VEHICLE');
var names = {
    COMPOUND_UPDATE: ns('SET_COMPOUND_UPDATE'),
    SET_SOURCE: ns('SET_SOURCE'),
    SET_BOX_ID: ns('SET_BOX_ID'),
    SET_DISPLAY: ns('SET_DISPLAY'),
    SET_TAGS: ns('SET_TAGS'),
    SET_TIMEZONE: ns('SET_TIMEZONE'),
    SET_ALL_TAGS: ns('SET_ALL_TAGS')
};
var EditVehicleActions = function (_Actions) {
    _inherits(EditVehicleActions, _Actions);

    function EditVehicleActions() {
        _classCallCheck(this, EditVehicleActions);

        var _this = _possibleConstructorReturn(this, (EditVehicleActions.__proto__ || Object.getPrototypeOf(EditVehicleActions)).apply(this, arguments));

        _this.update = function (update) {
            return _this.dispatch(names.COMPOUND_UPDATE, update);
        };
        _this.setSource = function (source) {
            return _this.dispatch(names.SET_SOURCE, source);
        };
        _this.setBoxId = function (boxId) {
            return _this.dispatch(names.SET_BOX_ID, boxId);
        };
        _this.setDisplay = function (value) {
            return _this.dispatch(names.SET_DISPLAY, value);
        };
        _this.setTags = function (tags) {
            return _this.dispatch(names.SET_TAGS, tags);
        };
        _this.setAllTags = function (tags) {
            return _this.dispatch(names.SET_ALL_TAGS, tags);
        };
        _this.setTimezone = function (tzId) {
            return _this.dispatch(names.SET_TIMEZONE, tzId);
        };
        return _this;
    }

    return EditVehicleActions;
}(__WEBPACK_IMPORTED_MODULE_2__flux_Actions__["b" /* Actions */]);
var createForest = function createForest(divisions) {
    return new __WEBPACK_IMPORTED_MODULE_6__utils_Forest__["a" /* Forest */](function (d) {
        return d.id;
    }, function (d) {
        return d.ParentId;
    }, divisions);
};
var UpsertVehicleController = function () {
    function UpsertVehicleController(polyglot, search, getGeotabVehicles, getVehicleTags, commitEntity, getCurrentDivisionId, store, upsertCmd, errorDispatchToken, loadDivisionsDispatchToken, loadServiceAccountsDispatchToken, loadVehiclesDispatchToken, loadTagsDispatchToken) {
        var _this2 = this;

        _classCallCheck(this, UpsertVehicleController);

        this.polyglot = polyglot;
        this.search = search;
        this.getGeotabVehicles = getGeotabVehicles;
        this.getVehicleTags = getVehicleTags;
        this.commitEntity = commitEntity;
        this.getCurrentDivisionId = getCurrentDivisionId;
        this.store = store;
        this.upsertCmd = upsertCmd;
        this.errorDispatchToken = errorDispatchToken;
        this.loadDivisionsDispatchToken = loadDivisionsDispatchToken;
        this.loadServiceAccountsDispatchToken = loadServiceAccountsDispatchToken;
        this.loadVehiclesDispatchToken = loadVehiclesDispatchToken;
        this.loadTagsDispatchToken = loadTagsDispatchToken;
        this.vehicleRequestTicket = 0;
        this.actions = new EditVehicleActions();
        this.editEntityActions = new __WEBPACK_IMPORTED_MODULE_7__actions_EditCreateEntityActions__["a" /* EditCreateEntityActions */]();
        this.errorActions = new __WEBPACK_IMPORTED_MODULE_4__flux_Error_ErrorActions__["a" /* ErrorActions */]();
        this.flagActions = new __WEBPACK_IMPORTED_MODULE_3__flux_Flag_FlagActions__["a" /* FlagActions */]();
        this.showUpsertForm = function (toEdit) {
            var createMode = toEdit == null;
            if (createMode) {
                _this2.editEntityActions.rejectDraft(__WEBPACK_IMPORTED_MODULE_1__models__["a" /* EntityType */].Vehicle);
                __WEBPACK_IMPORTED_MODULE_9__routes__["b" /* appNavigator */].goToAddNewEntityTab(__WEBPACK_IMPORTED_MODULE_1__models__["a" /* EntityType */].Vehicle);
            } else {
                _this2.editEntityActions.setEntityToEdit(toEdit, __WEBPACK_IMPORTED_MODULE_1__models__["a" /* EntityType */].Vehicle);
                __WEBPACK_IMPORTED_MODULE_9__routes__["b" /* appNavigator */].goToEditEntityTab(__WEBPACK_IMPORTED_MODULE_1__models__["a" /* EntityType */].Vehicle);
            }
            _this2.errorActions.clearError(_this2.errorDispatchToken);
        };
        this.cancel = function () {
            __WEBPACK_IMPORTED_MODULE_9__routes__["b" /* appNavigator */].goToVehicleTab();
            _this2.editEntityActions.rejectDraft(__WEBPACK_IMPORTED_MODULE_1__models__["a" /* EntityType */].Vehicle);
            _this2.errorActions.clearError(_this2.errorDispatchToken);
        };
        this.upsert = function () {
            var _store$getState = _this2.store.getState(),
                draft = _store$getState.draft;

            var setError = function setError(msg) {
                return _this2.errorActions.setError(new Error(msg), _this2.errorDispatchToken);
            };
            if (typeof draft.DivisionId !== 'number') {
                setError(_this2.polyglot.t('vehicle.validation_err.division_not_set'));
                return;
            }
            if (draft.SourceId === __WEBPACK_IMPORTED_MODULE_1__models__["b" /* Source */].BoxId) {
                if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_draft_Vehicle__["b" /* isValidBoxId */])(draft.BoxId)) {
                    setError(_this2.polyglot.t('vehicle.validation_err.invalid_box_id'));
                    return;
                }
            } else {
                if (typeof draft.ServiceAccountId !== 'number') {
                    setError(_this2.polyglot.t('vehicle.validation_err.service_account_not_set'));
                    return;
                } else if (typeof draft.GeotabId !== 'string') {
                    setError(_this2.polyglot.t('vehicle.validation_err.geotab_vehicle_not_set'));
                    return;
                }
            }
            _this2.upsertCmd.execute(draft, __WEBPACK_IMPORTED_MODULE_1__models__["a" /* EntityType */].Vehicle);
        };
        // This method is call by UI
        this.setDivision = function (division) {
            // division selection was cleared
            var update = { DivisionId: division ? division.id : null };
            if (!division) {
                _this2.actions.update(update);
                return;
            }
            var state = _this2.store.getState();
            // nothing changed
            if (division.id === state.draft.DivisionId) {
                return;
            }
            // When user choose some division. This value has to come from allDivisions.
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_assert_index__["d" /* assertArray */])(state.allDivisions, 'Program error. allDivisions has to be loaded at this point.');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_assert_index__["b" /* assertValue */])(state.divisionsForest, 'divisionsForest is not set. Make sure divisionsForest depends on allDivisions');
            var isValidDivision = state.allDivisions.some(function (d) {
                return d.id === division.id;
            });
            if (!isValidDivision) {
                throw new Error('Program error. Division value came not from source');
            }
            // New division value doesn't affect ServiceAccount and Vehicle fields in this case
            if (state.draft.SourceId === __WEBPACK_IMPORTED_MODULE_1__models__["b" /* Source */].Geotab) {
                var saState = _this2.computeServiceAccount(division.id, state.divisionsForest, state.draft.ServiceAccountId, state.allServiceAccounts);
                Object.assign(update, saState);
                var vehicleState = _this2.computeVehicleForServiceAccount(update.ServiceAccountId, state.draft.ServiceAccountId);
                Object.assign(update, vehicleState);
                var invalidVehicles = update.ServiceAccountId != null && update.ServiceAccountId !== state.draft.ServiceAccountId;
                if (invalidVehicles) {
                    _this2.fetchVehiclesFor(update.ServiceAccountId);
                }
            }
            _this2.actions.update(update);
        };
        this.setServiceAccount = function (serviceAccountId) {
            var update = { ServiceAccountId: serviceAccountId };
            var state = _this2.store.getState();
            var vehicleState = _this2.computeVehicleForServiceAccount(update.ServiceAccountId, state.draft.ServiceAccountId);
            Object.assign(update, vehicleState);
            var invalidVehicles = update.ServiceAccountId != null && update.ServiceAccountId !== state.draft.ServiceAccountId;
            if (invalidVehicles) {
                _this2.fetchVehiclesFor(update.ServiceAccountId);
            }
            _this2.actions.update(update);
        };
        this.setVehicle = function (vehicle) {
            _this2.actions.update({ GeotabId: vehicle ? vehicle.Id : null, GeotabTitle: vehicle ? vehicle.Name : null });
        };
        this.preload = function () {
            _this2.fetchDivisions();
            _this2.fetchServiceAccounts();

            var _store$getState$draft = _this2.store.getState().draft,
                SourceId = _store$getState$draft.SourceId,
                ServiceAccountId = _store$getState$draft.ServiceAccountId,
                id = _store$getState$draft.id;

            if (id == null) {
                _this2.actions.setTimezone(_this2.defaultTimezoneId);
            }
            if (SourceId === __WEBPACK_IMPORTED_MODULE_1__models__["b" /* Source */].Geotab && ServiceAccountId != null) {
                _this2.fetchVehiclesFor(ServiceAccountId);
            }
            _this2.fetchTags();
        };
    }
    // Computes Service account state for selected division


    _createClass(UpsertVehicleController, [{
        key: "computeServiceAccount",
        value: function computeServiceAccount(divisionId, forest, oldServiceAccountId, allServiceAccounts) {
            // allServiceAccounts or forest are not available => we can't compute filteredServiceAccounts and determine is current service account id valid or not
            if (divisionId == null || forest == null || allServiceAccounts == null) return {};
            var node = forest.getByKey(divisionId);
            var ids = new Set(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_Forest__["b" /* selfAndAncestors */])(node).map(function (d) {
                return d.id;
            }));
            var filteredServiceAccounts = allServiceAccounts.filter(function (sa) {
                return ids.has(sa.DivisionId);
            });
            var serviceAccountId = filteredServiceAccounts.some(function (sa) {
                return sa.id === oldServiceAccountId;
            }) ? oldServiceAccountId : null;
            if (serviceAccountId === null && filteredServiceAccounts.length === 1) {
                serviceAccountId = filteredServiceAccounts[0].id;
            }
            var update = { filteredServiceAccounts: filteredServiceAccounts };
            if (serviceAccountId !== oldServiceAccountId) {
                update = Object.assign({}, update, { ServiceAccountId: serviceAccountId });
            }
            return update;
        }
    }, {
        key: "computeVehicleForServiceAccount",
        value: function computeVehicleForServiceAccount(newServiceAccountId, oldServiceAccountId) {
            if (newServiceAccountId == null) return {};
            if (newServiceAccountId === oldServiceAccountId) return {};
            // new value for service account ALWAYS invalidates vehicle and available vehicle options
            return { GeotabId: null, GeotabTitle: null, vehicles: null };
        }
    }, {
        key: "computeVehicleForLoadedItems",
        value: function computeVehicleForLoadedItems(oldVehicleId, vehicles) {
            var update = { vehicles: vehicles };
            if (oldVehicleId === null && vehicles.length === 1) {
                update.GeotabId = vehicles[0].Id;
                update.GeotabTitle = vehicles[0].Name;
            }
            return update;
        }
    }, {
        key: "fetchDivisions",
        value: function fetchDivisions() {
            var _this3 = this;

            this.flagActions.set(this.loadDivisionsDispatchToken);
            this.search({ Name: 'Divisions' }).then(function (res) {
                var allDivisions = res.Entries.Division;
                var divisionsForest = createForest(allDivisions);
                var state = _this3.store.getState();
                var update = { allDivisions: allDivisions, divisionsForest: divisionsForest, DivisionId: state.draft.DivisionId };
                if (update.DivisionId == null) {
                    var currDivisionId = _this3.getCurrentDivisionId();
                    if (divisionsForest.getByKey(currDivisionId)) {
                        update.DivisionId = currDivisionId;
                    }
                }
                if (update.DivisionId == null && allDivisions.length === 1) {
                    update.DivisionId = allDivisions[0].id;
                }
                if (state.draft.SourceId === __WEBPACK_IMPORTED_MODULE_1__models__["b" /* Source */].Geotab) {
                    var saState = _this3.computeServiceAccount(update.DivisionId, update.divisionsForest, state.draft.ServiceAccountId, state.allServiceAccounts);
                    Object.assign(update, saState);
                    var vehicleState = _this3.computeVehicleForServiceAccount(update.ServiceAccountId, state.draft.ServiceAccountId);
                    Object.assign(update, vehicleState);
                    var invalidVehicles = update.ServiceAccountId != null && update.ServiceAccountId !== state.draft.ServiceAccountId;
                    if (invalidVehicles) {
                        _this3.fetchVehiclesFor(update.ServiceAccountId);
                    }
                }
                _this3.actions.update(update);
            }).catch(function (err) {}).then(function () {
                _this3.flagActions.reset(_this3.loadDivisionsDispatchToken);
            }); // finaly
        }
    }, {
        key: "fetchServiceAccounts",
        value: function fetchServiceAccounts() {
            var _this4 = this;

            this.flagActions.set(this.loadServiceAccountsDispatchToken);
            this.search(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__rest_Search__["d" /* requestServiceAccounts */])()).then(function (resp) {
                var state = _this4.store.getState();
                var allServiceAccounts = resp.Entries.ServiceAccount;
                var saState = _this4.computeServiceAccount(state.draft.DivisionId, state.divisionsForest, state.draft.ServiceAccountId, allServiceAccounts);
                var update = Object.assign({ allServiceAccounts: allServiceAccounts }, saState);
                _this4.actions.update(update);
                var invalidVehicles = update.ServiceAccountId != null && update.ServiceAccountId !== state.draft.ServiceAccountId;
                if (invalidVehicles) {
                    _this4.fetchVehiclesFor(update.ServiceAccountId);
                }
            }).catch(function (err) {
                _this4.errorActions.setError(err, _this4.errorDispatchToken);
            }).then(function () {
                _this4.flagActions.reset(_this4.loadServiceAccountsDispatchToken);
            }); // finaly
        }
    }, {
        key: "fetchVehiclesFor",
        value: function fetchVehiclesFor(serviceAccountId) {
            var _this5 = this;

            var ticket = ++this.vehicleRequestTicket;
            this.flagActions.set(this.loadVehiclesDispatchToken);
            this.getGeotabVehicles(serviceAccountId).then(function (res) {
                if (ticket !== _this5.vehicleRequestTicket) return;

                var GeotabId = _this5.store.getState().draft.GeotabId;

                var update = _this5.computeVehicleForLoadedItems(GeotabId, res.GeotabVehicles);
                _this5.actions.update(update);
            }).catch(function (err) {
                if (ticket !== _this5.vehicleRequestTicket) return;
                _this5.errorActions.setError(err, _this5.errorDispatchToken);
            }).then(function () {
                if (ticket !== _this5.vehicleRequestTicket) return;
                _this5.flagActions.reset(_this5.loadVehiclesDispatchToken);
            });
        }
    }, {
        key: "fetchTags",
        value: function fetchTags() {
            var _this6 = this;

            this.flagActions.set(this.loadTagsDispatchToken);
            this.getVehicleTags().then(function (res) {
                _this6.actions.setAllTags(res.Tags);
            }).catch(function (err) {
                _this6.errorActions.setError(err, _this6.errorDispatchToken);
            }).then(function () {
                _this6.flagActions.reset(_this6.loadTagsDispatchToken);
            });
        }
    }]);

    return UpsertVehicleController;
}();

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VehicleGeopositionActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_index__ = __webpack_require__(132);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flux_index__["a" /* createNamespace */])('VehicleGeoposition');
var names = {
    SET_VEHICLES: ns('SET_VEHICLES'),
    CLEAR: ns('CLEAR')
};
var VehicleGeopositionActions = function (_Actions) {
    _inherits(VehicleGeopositionActions, _Actions);

    function VehicleGeopositionActions() {
        _classCallCheck(this, VehicleGeopositionActions);

        var _this = _possibleConstructorReturn(this, (VehicleGeopositionActions.__proto__ || Object.getPrototypeOf(VehicleGeopositionActions)).apply(this, arguments));

        _this.setVehicleGeoposition = function (vehiclesLocations) {
            return _this.dispatch(names.SET_VEHICLES, vehiclesLocations);
        };
        _this.clear = function () {
            return _this.dispatch(names.CLEAR);
        };
        return _this;
    }

    return VehicleGeopositionActions;
}(__WEBPACK_IMPORTED_MODULE_0__flux_index__["b" /* Actions */]);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteObjectsActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Actions__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["a" /* createNamespace */])('DeleteObjects');
var names = {
    SET_IDS: ns('SET_IDS'),
    SHOW_CONFIRMATION: ns('SHOW_CONFIRMATION'),
    HIDE_CONFIRMATION: ns('HIDE_CONFIRMATION'),
    ERROR: ns('ERROR')
};
var DeleteObjectsActions = function (_Actions) {
    _inherits(DeleteObjectsActions, _Actions);

    function DeleteObjectsActions() {
        _classCallCheck(this, DeleteObjectsActions);

        var _this = _possibleConstructorReturn(this, (DeleteObjectsActions.__proto__ || Object.getPrototypeOf(DeleteObjectsActions)).apply(this, arguments));

        _this.setIds = function (ids, meta) {
            return _this.dispatch(names.SET_IDS, ids, meta);
        };
        _this.showConfirmation = function (meta) {
            return _this.dispatch(names.SHOW_CONFIRMATION, null, meta);
        };
        _this.hideConfirmation = function (meta) {
            return _this.dispatch(names.HIDE_CONFIRMATION, null, meta);
        };
        _this.showError = function (error, meta) {
            return _this.dispatch(names.ERROR, error, meta);
        };
        return _this;
    }

    return DeleteObjectsActions;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["b" /* Actions */]);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LabelActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Actions__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var ns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["a" /* createNamespace */])('LABEL');
var names = {
    SET: ns('SET')
};
var LabelActions = function (_Actions) {
    _inherits(LabelActions, _Actions);

    function LabelActions() {
        _classCallCheck(this, LabelActions);

        var _this = _possibleConstructorReturn(this, (LabelActions.__proto__ || Object.getPrototypeOf(LabelActions)).apply(this, arguments));

        _this.set = function (label, dispatchToken) {
            return _this.dispatch(names.SET, label, dispatchToken);
        };
        return _this;
    }

    return LabelActions;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Actions__["b" /* Actions */]);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LabelActions__ = __webpack_require__(319);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__LabelActions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LabelStore__ = __webpack_require__(67);
/* unused harmony namespace reexport */



/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isValidBoxId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVehicleDisplay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_Vehicle__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assert_index__ = __webpack_require__(5);


var isValidBoxId = function isValidBoxId(boxId) {
    if (typeof boxId !== 'string') return false;
    var match = boxId.match(/^[0-9a-zA-Z]{6}$/);
    return match !== null;
};
// We want to display some meaningfull string into Display column in the grid even Display property is not set
var getVehicleDisplay = function getVehicleDisplay(v) {
    if (v.Display != null && v.Display != '') return v.Display;
    if (v.SourceId === __WEBPACK_IMPORTED_MODULE_0__models_Vehicle__["a" /* Source */].BoxId) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assert_index__["g" /* assertString */])(v.BoxId);
        return v.BoxId;
    }
    if (v.SourceId === __WEBPACK_IMPORTED_MODULE_0__models_Vehicle__["a" /* Source */].Geotab) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assert_index__["g" /* assertString */])(v.GeotabTitle);
        return v.GeotabTitle;
    }
    throw new Error("Unexpected SourceId: " + v.SourceId);
};

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return translate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return translateX; });
/* unused harmony export translateY */
var translate = function translate(x, y) {
  return "translate(" + x + "," + y + ")";
};
var translateX = function translateX(x) {
  return translate(x, 0);
};
var translateY = function translateY(y) {
  return translate(0, y);
};

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultWheelDelta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getClip; });
/* unused harmony export mult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return scaleSelection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_utils_assert__ = __webpack_require__(5);



// https://github.com/d3/d3-zoom/blob/master/src/zoom.js#L33
var defaultWheelDelta = function defaultWheelDelta(e) {
    return e.deltaY * (e.deltaMode ? 120 : 1) / 500;
};
var getPoint = function getPoint(e, element) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__app_utils_assert__["b" /* assertValue */])(element);
    var toSVGCoordinateSystem = element.getScreenCTM().inverse();
    return mult(toSVGCoordinateSystem, { x: e.clientX, y: e.clientY });
};
var getClip = function getClip(data, x, range, interpolateAt) {
    var bisect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* bisector */])(function (d) {
        return x(d);
    });
    var l = bisect.left(data, range[0]);
    var h = bisect.right(data, range[1]);
    var result = data.slice(l, h);
    if (l > 0 && l < data.length) result.splice(0, 0, interpolateAt(data[l - 1], data[l], range[0]));
    if (h > 0 && h < data.length) result.push(interpolateAt(data[h - 1], data[h], range[1]));
    return result;
};
var mult = function mult(transform, p) {
    return {
        x: transform.a * p.x + transform.c * p.y + transform.e,
        y: transform.b * p.x + transform.d * p.y + transform.f
    };
};
var scaleSelection = function scaleSelection(dataExtent, selection, pivot, delta) {
    var iLow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolate */])(pivot, selection[0]);
    var iHight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolate */])(pivot, selection[1]);
    var k = Math.pow(2, delta);
    return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["k" /* max */])([dataExtent[0], iLow(k)]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["j" /* min */])([dataExtent[1], iHight(k)])];
};

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assertId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_utils_nameof__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_utils_assert__ = __webpack_require__(5);


var assertId = function assertId(param) {
    var name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__app_utils_nameof__["a" /* nameof */])(param);
    var value = param[name];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__app_utils_assert__["f" /* assertNumber */])(value, "parameter " + name + " has to be a number");
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__app_utils_assert__["a" /* assertTrue */])(value > 0, name + " has to be a valid id");
};

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Forest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selfAndAncestors; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Forest = function Forest(key, parentKey, items) {
    var _this = this;

    _classCallCheck(this, Forest);

    this.key = key;
    this.parentKey = parentKey;
    this.roots = [];
    this.map = new Map();
    this.getByKey = function (key) {
        return _this.map.get(key);
    };
    this.getRoots = function () {
        return _this.roots.slice(0);
    };
    items.forEach(function (item) {
        return _this.map.set(key(item), { value: item, children: [] });
    });
    var visited = new Set();
    items.forEach(function (item) {
        var cur = _this.map.get(key(item));
        while (cur) {
            if (visited.has(key(cur.value))) break;
            visited.add(key(cur.value));
            var parent = _this.map.get(parentKey(cur.value));
            cur.parent = parent;
            if (parent) parent.children.push(cur);else _this.roots.push(cur);
            cur = parent;
        }
    });
};
var selfAndAncestors = function selfAndAncestors(node) {
    var result = [];
    var cur = node;
    while (cur) {
        result.push(cur.value);
        cur = cur.parent;
    }
    return result;
};

/***/ }),
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"StickyContainer":"StickyContainer--2aWIr"};

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SourceSelectorContainer":"SourceSelectorContainer--2QoFn","NewVehicle":"NewVehicle--3fQ6V"};

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AxisGrid":"AxisGrid--2FE_a","AxisX":"AxisX--WLdsY","LockedTooltip":"LockedTooltip--39zYY","NoEvents":"NoEvents--cscvC"};

/***/ }),
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DivisionPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DivisionSelector__ = __webpack_require__(156);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var styles = __webpack_require__(943);
var AdminIcon = function AdminIcon(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", Object.assign({ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(styles.AdminIcon, 'glyphicon glyphicon-user') }, props));
};
var Mode;
(function (Mode) {
    Mode[Mode["View"] = 0] = "View";
    Mode[Mode["Change"] = 1] = "Change";
})(Mode || (Mode = {}));
// DivisionPath component renders the current division as well as it parent division
// This component is located under tabs pills
// This component has 2 modes: view and edit
var DivisionPath = function (_React$Component) {
    _inherits(DivisionPath, _React$Component);

    function DivisionPath(props) {
        _classCallCheck(this, DivisionPath);

        var _this = _possibleConstructorReturn(this, (DivisionPath.__proto__ || Object.getPrototypeOf(DivisionPath)).call(this, props));

        _this.handleChangeClick = function () {
            _this.setState({ mode: Mode.Change });
        };
        _this.handleBlur = function () {
            setTimeout(function () {
                return _this.setState({ mode: Mode.View });
            }, 300);
        };
        _this.state = { mode: Mode.View };
        return _this;
    }

    _createClass(DivisionPath, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                path = _props.path,
                _onChange = _props.onChange,
                allDivisions = _props.allDivisions,
                className = _props.className,
                polyglot = _props.polyglot;
            var mode = this.state.mode;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(styles.DivisionPath, className), onBlur: this.handleBlur }, mode === Mode.View && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, polyglot.t('division_path.working_on'), " (", __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { onClick: this.handleChangeClick }, polyglot.t('division_path.change')), "):"), mode === Mode.Change && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__DivisionSelector__["a" /* DivisionSelector */], Object.assign({ className: styles.DivisionSelector, divisions: allDivisions, selectedId: null }, { autoFocus: true }, { onChange: function onChange(division) {
                    if (division) {
                        _onChange(division);
                        _this2.setState({ mode: Mode.View });
                    }
                } })), path.map(function (division, idx) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { key: division.id, className: styles.Fragment }, idx > 0 && '/', division.IsAdmin && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AdminIcon, { title: polyglot.t('division_path.admin_of', { name: division.Name }) }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { title: polyglot.t('division_path.switch_to', { name: division.Name }), className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(_defineProperty({}, styles.Current, idx === path.length - 1)), onClick: function onClick(e) {
                        return _onChange(division);
                    } }, division.Name));
            }));
        }
    }]);

    return DivisionPath;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChangeCurrentDivisionCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_CurrentDivisionActions__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Error__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Flag__ = __webpack_require__(24);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var ChangeCurrentDivisionCommand = function ChangeCurrentDivisionCommand(runSearch, emiter, inProgressDispatchToken, errorDispatchToken) {
    var _this = this;

    _classCallCheck(this, ChangeCurrentDivisionCommand);

    this.runSearch = runSearch;
    this.emiter = emiter;
    this.inProgressDispatchToken = inProgressDispatchToken;
    this.errorDispatchToken = errorDispatchToken;
    this.actions = new __WEBPACK_IMPORTED_MODULE_0__flux_CurrentDivisionActions__["a" /* CurrentDivisionActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Error__["a" /* ErrorActions */]();
    this.inProgress = new __WEBPACK_IMPORTED_MODULE_2__flux_Flag__["a" /* FlagActions */]();
    this.execute = function (targetDivisionId) {
        _this.inProgress.set(_this.inProgressDispatchToken);
        var success = _this.runSearch({ Name: 'Divisions' }).then(function (res) {
            _this.actions.setTarget(targetDivisionId, res.Entries.Division);
            _this.emiter.emit('division', targetDivisionId);
        }).catch(function (err) {
            return _this.errorActions.setError(err, _this.errorDispatchToken, 5 * 1000);
        }).then(function () {
            return _this.inProgress.reset(_this.inProgressDispatchToken);
        }); // finally
    };
};

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CurrentDivisionStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Forest__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Store__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CurrentDivisionActions__ = __webpack_require__(300);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var createForest = function createForest(divisions) {
    return new __WEBPACK_IMPORTED_MODULE_0__utils_Forest__["a" /* Forest */](function (d) {
        return d.id;
    }, function (d) {
        return d.ParentId;
    }, divisions);
};
var CurrentDivisionStore = function (_Store) {
    _inherits(CurrentDivisionStore, _Store);

    function CurrentDivisionStore() {
        _classCallCheck(this, CurrentDivisionStore);

        var _this = _possibleConstructorReturn(this, (CurrentDivisionStore.__proto__ || Object.getPrototypeOf(CurrentDivisionStore)).call(this));

        _this.getCurrentDivision = function () {
            var path = _this.state.path;

            return path[path.length - 1];
        };
        _this.getCurrentDivisionId = function () {
            return _this.state.selectedDivisionId;
        };
        _this.state = { allDivisions: [], forest: null, path: [], selectedDivisionId: undefined };
        _this.register(__WEBPACK_IMPORTED_MODULE_2__CurrentDivisionActions__["b" /* names */].SET_TARGET_DIVISION, function (e) {
            var _e$payload = e.payload,
                targetDivisionId = _e$payload.targetDivisionId,
                _e$payload$allDivisio = _e$payload.allDivisions,
                allDivisions = _e$payload$allDivisio === undefined ? _this.state.allDivisions : _e$payload$allDivisio;
            var forestOld = _this.state.forest;

            var forestNew = createForest(allDivisions);
            var path = calcPath(targetDivisionId, forestNew, forestOld);
            var selectedDivisionId = path.length > 0 ? path[path.length - 1].id : targetDivisionId;
            localStorage.setItem('selectedDivisionId', selectedDivisionId.toString());
            return _this.field({
                allDivisions: allDivisions,
                forest: forestNew,
                path: path,
                selectedDivisionId: selectedDivisionId
            });
        });
        return _this;
    }

    return CurrentDivisionStore;
}(__WEBPACK_IMPORTED_MODULE_1__flux_Store__["a" /* Store */]);
// target division could be absent in the new version of the forest
function calcPath(targetId, forestNew, forestOld) {
    var targetNew = void 0;
    while (!targetNew && targetId != null) {
        targetNew = forestNew.getByKey(targetId);
        if (!targetNew) {
            var targetOld = forestOld.getByKey(targetId);
            targetId = targetOld && targetOld.parent && targetOld.parent.value ? targetOld.parent.value.id : null;
        }
    }
    if (targetNew) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Forest__["b" /* selfAndAncestors */])(targetNew).reverse();
    }
    var roots = forestNew.getRoots();
    return roots.length > 0 ? [roots[0].value] : [];
}

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EntityLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(7);



var EntityLink = function EntityLink(_ref) {
    var type = _ref.type,
        children = _ref.children;

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */], { to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__routes__["d" /* routeFor */])(type) }, children);
};

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Header; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rest_Login__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__login_commands_SignOutCommand__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__login_commands_configure__ = __webpack_require__(152);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






__webpack_require__(961);
var signOutCmd = new __WEBPACK_IMPORTED_MODULE_3__login_commands_SignOutCommand__["a" /* SignOutCommand */](__WEBPACK_IMPORTED_MODULE_2__rest_Login__["c" /* signOut */], __WEBPACK_IMPORTED_MODULE_4__login_commands_configure__["c" /* removeAutCookies */], __WEBPACK_IMPORTED_MODULE_4__login_commands_configure__["d" /* redirectToLogin */]);
var Header = function (_React$Component) {
    _inherits(Header, _React$Component);

    function Header(props) {
        _classCallCheck(this, Header);

        var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

        _this.state = {
            currentUser: JSON.parse(localStorage.getItem('currentUser')),
            polyglot: _this.props.polyglot
        };
        return _this;
    }

    _createClass(Header, [{
        key: 'navigateToDashboard',
        value: function navigateToDashboard() {
            this.props.history.push('/dashboard');
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                currentUser = _state.currentUser,
                polyglot = _state.polyglot,
                children = _state.children;

            var pathParts = window.location.pathname.split("/");
            var currentPath = pathParts[pathParts.length - 1];
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "navbar navbar-inverse" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "navbar-header" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { type: "button", className: "navbar-toggle collapsed", "data-toggle": "collapse", "data-target": "#bs-example-navbar-collapse-1", "aria-expanded": "false" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "sr-only" }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "icon-bar" }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "icon-bar" }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "icon-bar" })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "navbar-brand", href: "#", onClick: this.navigateToDashboard.bind(this) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: 'https://res.cloudinary.com/dcmnedyx4/image/upload/v1526430686/logo-sps.svg' }))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "collapse navbar-collapse", id: "bs-example-navbar-collapse-1" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", Object.assign({ className: 'nav navbar-nav' }, this.props), __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(this.props.children, function (child, idx) {
                var child_node = _this2.props.children[idx];
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: child_node.props.navto && child_node.props.navto.indexOf(currentPath) >= 0 ? 'active dropdown open' : 'dropdown', key: idx }, child, child_node.props.subnav);
            })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "nav navbar-nav navbar-right" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "dropdown" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "#", className: "dropdown-toggle", "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": "false" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: 'avatar-img', src: "https://res.cloudinary.com/dcmnedyx4/image/upload/v1526430882/fg-avatar-anonymous-user-retina-7a71ca9109.png" }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "caret" })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "dropdown-menu" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "#" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { style: { margin: '0px' } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", null, polyglot.t('nav.signed_in_as'))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { style: { margin: '0px' } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null, currentUser.Username)))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { role: "separator", className: "divider" }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */], { to: 'settings' }, polyglot.t('nav.settings'))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { role: "separator", className: "divider" }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { onClick: signOutCmd.execute }, polyglot.t('nav.sign_out'))))))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "navbar-footer" })));
        }
    }]);

    return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SensorsDataRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Container__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__View__ = __webpack_require__(546);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var SensorsDataRoute = function (_React$Component) {
    _inherits(SensorsDataRoute, _React$Component);

    function SensorsDataRoute() {
        _classCallCheck(this, SensorsDataRoute);

        return _possibleConstructorReturn(this, (SensorsDataRoute.__proto__ || Object.getPrototypeOf(SensorsDataRoute)).apply(this, arguments));
    }

    _createClass(SensorsDataRoute, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */], { path: '/sensors-data', render: function render() {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Container__["a" /* Container */], { store: _this2.props.store }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__View__["a" /* View */], { polyglot: _this2.props.polyglot, className: _this2.props.className, refId: null, rows: null, axes: null, view: null, hasChartData: null, hasGeoData: null, isMapVisible: null, coordinate: null, tableData: null, timeSeriesStore: _this2.props.timeSeriesStore }));
                } });
        }
    }]);

    return SensorsDataRoute;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoImportWatchActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rest_Search__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_EntityType__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Grid_ListActions__ = __webpack_require__(65);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var AutoImportWatchActions = function AutoImportWatchActions(runSearch, getItems, entityType) {
    var _this = this;

    _classCallCheck(this, AutoImportWatchActions);

    this.runSearch = runSearch;
    this.getItems = getItems;
    this.entityType = entityType;
    this.listActions = new __WEBPACK_IMPORTED_MODULE_2__flux_Grid_ListActions__["a" /* ListActions */]();
    this.startPulling = function (msInterval) {
        _this.tryPull();
        _this.timerId = setInterval(_this.tryPull, msInterval);
    };
    this.stopPulling = function () {
        clearInterval(_this.timerId);
        _this.timerId = null;
    };
    this.tryPull = function () {
        var items = _this.getItems();
        var ids = items.filter(function (item) {
            return item.OngoingAutoImport;
        }).map(function (item) {
            return item.id;
        });
        if (ids.length === 0) return;
        var request = {
            Name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__rest_Search__["b" /* getSearchName */])(_this.entityType),
            Ids: ids
        };
        _this.runSearch(request).then(function (sr) {
            return _this.listActions.replaceItems(sr.Entries[__WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */][_this.entityType]], _this.entityType);
        });
    };
};

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VehicleGeopositionStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_assert_index__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VehicleGeopositionActions__ = __webpack_require__(317);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var VehicleGeopositionStore = function (_Store) {
    _inherits(VehicleGeopositionStore, _Store);

    function VehicleGeopositionStore() {
        _classCallCheck(this, VehicleGeopositionStore);

        var _this = _possibleConstructorReturn(this, (VehicleGeopositionStore.__proto__ || Object.getPrototypeOf(VehicleGeopositionStore)).call(this));

        _this.state = _this.getDefaultState();
        _this.register(__WEBPACK_IMPORTED_MODULE_2__VehicleGeopositionActions__["b" /* names */].SET_VEHICLES, function (e) {
            return _this.field({ Vehicles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_assert_index__["d" /* assertArray */])(e.payload) });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__VehicleGeopositionActions__["b" /* names */].CLEAR, function (e) {
            return _this.getDefaultState();
        });
        return _this;
    }

    _createClass(VehicleGeopositionStore, [{
        key: "getDefaultState",
        value: function getDefaultState() {
            return { Vehicles: [] };
        }
    }]);

    return VehicleGeopositionStore;
}(__WEBPACK_IMPORTED_MODULE_1__flux__["c" /* Store */]);

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VehicleMapRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Container__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Map__ = __webpack_require__(573);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var VehicleMapRoute = function (_React$Component) {
    _inherits(VehicleMapRoute, _React$Component);

    function VehicleMapRoute() {
        _classCallCheck(this, VehicleMapRoute);

        return _possibleConstructorReturn(this, (VehicleMapRoute.__proto__ || Object.getPrototypeOf(VehicleMapRoute)).apply(this, arguments));
    }

    _createClass(VehicleMapRoute, [{
        key: "render",
        value: function render() {
            var vehicleGeopositionStore = this.props.vehicleGeopositionStore;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_3__routes__["f" /* vehicleGeoposition */], render: function render() {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { flex: 1 } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Container__["a" /* Container */], { store: vehicleGeopositionStore }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Map__["a" /* VehicleGoogleMap */], { defaultZoom: 10, Vehicles: null })));
                } });
        }
    }]);

    return VehicleMapRoute;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home__ = __webpack_require__(586);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__home__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alarms__ = __webpack_require__(584);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__alarms__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__serviceAccount__ = __webpack_require__(589);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__serviceAccount__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__division__ = __webpack_require__(585);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__division__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__person__ = __webpack_require__(587);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__person__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vehicle__ = __webpack_require__(591);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__vehicle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sensor__ = __webpack_require__(588);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__sensor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__settings__ = __webpack_require__(590);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__settings__["a"]; });









/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationCenter; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// NotificationCenter incapsulates the interaction with browser's notification API
var NotificationCenter = function () {
    function NotificationCenter(getNotifications, pullTimeoutMS) {
        var _this = this;

        _classCallCheck(this, NotificationCenter);

        this.getNotifications = getNotifications;
        this.pullTimeoutMS = pullTimeoutMS;
        this.handlers = new Map();
        this.running = false;
        this.pull = function () {
            _this.getNotifications().then(function (resp) {
                return _this.handleNotifications(resp.Notifications);
            }).catch(function (err) {
                return console.error(err);
            });
        };
        // this lambda invokes callbacks when user interacts with native notification
        this.handleNotifications = function (notifications) {
            if (notifications && notifications.length > 0) {
                var i = 0;
                // Using an interval cause some browsers are blocking notifications if there are too much in a certain time.
                // https://developer.mozilla.org/en-US/docs/Web/API/Notifications_API/Using_the_Notifications_API
                var token = setInterval(function () {
                    if (i === notifications.length) {
                        clearInterval(token);
                        return;
                    }
                    var _notifications = notifications[i++],
                        title = _notifications.Title,
                        message = _notifications.Message,
                        action = _notifications.Action;

                    var n = new Notification(title, { body: message, icon: 'http://www.valortpms.com/sites/all/themes/valor/logo.png' });
                    n.addEventListener('click', function (e) {
                        window.focus();
                        n.close();
                        var handler = _this.handlers.get(action);
                        handler && handler();
                    });
                }, 200);
            }
        };
        // TODO: wrong type defenition https://github.com/Microsoft/TypeScript/issues/14701
        this.getCurrentPermission = function () {
            return Notification.permission;
        };
    }

    _createClass(NotificationCenter, [{
        key: 'addActionHandler',
        value: function addActionHandler(key, handler) {
            this.handlers.set(key, handler);
        }
        // start to pull server about important events like undefined alert levels

    }, {
        key: 'start',
        value: function start() {
            var _this2 = this;

            if (!this.running && this.getCurrentPermission() !== 'denied') {
                Notification.requestPermission().then(function (result) {
                    if (result == 'granted') {
                        _this2.running = true;
                        _this2.pull();
                        _this2.token = setInterval(_this2.pull, _this2.pullTimeoutMS);
                    }
                });
            }
        }
    }, {
        key: 'stop',
        value: function stop() {
            if (this.running) {
                this.running = false;
                clearInterval(this.token);
            }
        }
    }]);

    return NotificationCenter;
}();

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimezoneStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Store__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TimezoneActions__ = __webpack_require__(293);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// TimezoneStore is a central storage for loaded Timezones
var TimezoneStore = function (_Store) {
    _inherits(TimezoneStore, _Store);

    function TimezoneStore() {
        _classCallCheck(this, TimezoneStore);

        var _this = _possibleConstructorReturn(this, (TimezoneStore.__proto__ || Object.getPrototypeOf(TimezoneStore)).call(this));

        _this.state = _this.field({ timezones: [] });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__TimezoneActions__["b" /* names */].SET_TIMEZONES, function (e) {
            var timezones = e.payload;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assert__["d" /* assertArray */])(timezones, 'expected array payload');
            return _this.field({ timezones: timezones });
        });
        return _this;
    }

    return TimezoneStore;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Store__["a" /* Store */]);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimeSeriesStore; });
/* unused harmony export sampleInterpolator */
/* unused harmony export getTooltipInfoAt */
/* unused harmony export getValueAt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_Store__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_utils_assert_index__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__d3chart_zoom__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TimeSeriesActions__ = __webpack_require__(161);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var _ = __webpack_require__(1185);
// This is a storage which holds data needed to render TimeSeries chart properly
var TimeSeriesStore = function (_Store) {
    _inherits(TimeSeriesStore, _Store);

    function TimeSeriesStore() {
        _classCallCheck(this, TimeSeriesStore);

        var _this = _possibleConstructorReturn(this, (TimeSeriesStore.__proto__ || Object.getPrototypeOf(TimeSeriesStore)).call(this));

        _this.getDataSets = function () {
            return _this.state.dataSets;
        };
        _this.register(__WEBPACK_IMPORTED_MODULE_6__TimeSeriesActions__["b" /* names */].SET_DATA_SETS, function (e) {
            return reduceStateFor(initialState(), e.payload, true);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_6__TimeSeriesActions__["b" /* names */].HIGHLIGHT_SINGLE, function (e) {
            var target = e.payload;
            var dataSets = _this.state.dataSets;

            var nextDataSets = dataSets.map(function (ds) {
                return Object.assign({}, ds, { sequences: ds.sequences.map(function (seq) {
                        return Object.assign({}, seq, { state: seq.id === target ? __WEBPACK_IMPORTED_MODULE_2__Data__["a" /* SequenceState */].Highlighted : seq.state === __WEBPACK_IMPORTED_MODULE_2__Data__["a" /* SequenceState */].Hidden ? __WEBPACK_IMPORTED_MODULE_2__Data__["a" /* SequenceState */].Hidden : __WEBPACK_IMPORTED_MODULE_2__Data__["a" /* SequenceState */].Dimmed });
                    }) });
            });
            return reduceStateFor(_this.state, nextDataSets);
        });
        // Bring all visible timeseries lines from dimmed state to normal
        _this.register(__WEBPACK_IMPORTED_MODULE_6__TimeSeriesActions__["b" /* names */].NORMALIZE, function (e) {
            var nextDataSets = _this.state.dataSets.map(function (ds) {
                return Object.assign({}, ds, { sequences: ds.sequences.map(function (seq) {
                        return seq.state === __WEBPACK_IMPORTED_MODULE_2__Data__["a" /* SequenceState */].Normal || seq.state === __WEBPACK_IMPORTED_MODULE_2__Data__["a" /* SequenceState */].Hidden ? seq : Object.assign({}, seq, { state: __WEBPACK_IMPORTED_MODULE_2__Data__["a" /* SequenceState */].Normal });
                    }) });
            });
            return reduceStateFor(_this.state, nextDataSets);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_6__TimeSeriesActions__["b" /* names */].TOGGLE_VISIBILITY, function (e) {
            var dataSets = _this.state.dataSets;

            var target = e.payload;
            var targetSeq = findSequence(dataSets, target);
            var targetState = targetSeq.state === __WEBPACK_IMPORTED_MODULE_2__Data__["a" /* SequenceState */].Hidden ? __WEBPACK_IMPORTED_MODULE_2__Data__["a" /* SequenceState */].Highlighted : __WEBPACK_IMPORTED_MODULE_2__Data__["a" /* SequenceState */].Hidden;
            // All states should be treated as immutable so we have to create deep copy of the dataSets array
            var nextDataSets = _this.state.dataSets.map(function (ds) {
                return Object.assign({}, ds, { sequences: ds.sequences.map(function (seq) {
                        return Object.assign({}, seq, { state: seq.id === target ? targetState : seq.state === __WEBPACK_IMPORTED_MODULE_2__Data__["a" /* SequenceState */].Hidden ? __WEBPACK_IMPORTED_MODULE_2__Data__["a" /* SequenceState */].Hidden : targetState === __WEBPACK_IMPORTED_MODULE_2__Data__["a" /* SequenceState */].Hidden ? __WEBPACK_IMPORTED_MODULE_2__Data__["a" /* SequenceState */].Normal : __WEBPACK_IMPORTED_MODULE_2__Data__["a" /* SequenceState */].Dimmed });
                    }) });
            });
            return reduceStateFor(_this.state, nextDataSets);
        });
        // When we use zoom/brush we have to clip time series data to the specified range of interest
        _this.register(__WEBPACK_IMPORTED_MODULE_6__TimeSeriesActions__["b" /* names */].SET_RANGE, function (e) {
            var range = e.payload;
            var dataSets = _this.state.dataSets;

            return _this.field({ range: range, zoomedDataSets: zoomTo(dataSets, range) });
        });
        // When we move sweep line, tooltips values are changed, so we have to update it
        _this.register(__WEBPACK_IMPORTED_MODULE_6__TimeSeriesActions__["b" /* names */].SET_TOOLTIP_TIME, function (e) {
            var dataSets = _this.state.dataSets;

            var timeOfInterest = e.payload;
            var tooltip = timeOfInterest ? getTooltipInfoAt(_this.state.dataSets, timeOfInterest) : null;
            return _this.field({ tooltip: tooltip });
        });
        return _this;
    }

    return TimeSeriesStore;
}(__WEBPACK_IMPORTED_MODULE_3__flux_Store__["a" /* Store */]);
// Creates an empty state for TimeSeriesStore. 
// Empty state means no data available at all
var initialState = function initialState() {
    return {
        dataSets: [],
        zoomedDataSets: [],
        range: null, tooltip: null
    };
};
// This reducer transforms old state with respect to received DataSet
// Basically we need to calculate tooltip's data as well as clip timeseries data to the zoomed time range
var reduceStateFor = function reduceStateFor(oldState, dataSets, prepareBaseLineData) {
    var tooltip = oldState.tooltip,
        range = oldState.range;

    var indexOfPsi = dataSets.map(function (datasets) {
        return datasets.yAxisTitle;
    }).indexOf("psi");
    if (prepareBaseLineData && indexOfPsi >= 0) {
        //when there's just 1 sensor selected
        if (indexOfPsi < 0 && dataSets[0]) {
            indexOfPsi = dataSets.map(function (datasets) {
                return datasets.yAxisTitle;
            }).indexOf(dataSets[0].yAxisTitle);
        }
        var baseLines = dataSets[indexOfPsi].sequences.map(function (sequences) {
            return sequences.BaselineValue;
        }); // (window as any).sensors.map((x) => x.Baseline).filter((x) => !!x);
        var uniqBaseLines = _.uniq(baseLines);
        var sequences = dataSets[indexOfPsi].sequences.filter(function (sequence, idx) {
            return !sequence.baseLine;
        });
        uniqBaseLines.map(function (baseLineValue) {
            var sequence = Object.assign({}, dataSets[indexOfPsi].sequences[dataSets[indexOfPsi].sequences.length - 1]);
            sequences.push(sequence);
            sequence.id = "Baseline-" + baseLineValue;
            sequence.color = "#000000";
            sequence.title = 'Baseline';
            sequence.state = __WEBPACK_IMPORTED_MODULE_2__Data__["a" /* SequenceState */].Normal;
            sequence.baseLine = true;
            sequence.dotted = uniqBaseLines.length > 1;
            sequence.samples = sequence.samples.map(function (sample) {
                return Object.assign({}, sample);
            });
            sequence.samples = sequence.samples.map(function (sample) {
                sample.y = baseLineValue;return sample;
            });
            dataSets[indexOfPsi].sequences = sequences;
            if (dataSets[indexOfPsi].maxValue < baseLineValue) {
                dataSets[indexOfPsi].maxValue = baseLineValue + 5;
            }
            if (dataSets[indexOfPsi].minValue > baseLineValue) {
                dataSets[indexOfPsi].minValue = baseLineValue - 5;
            }
        });
    }
    return {
        dataSets: dataSets,
        range: range,
        zoomedDataSets: zoomTo(dataSets, range),
        tooltip: tooltip ? getTooltipInfoAt(dataSets, tooltip.x) : null
    };
};
// Helper method to find timeseries sequence in DataSet container by Key
// It is helpful when we need to togle timeseries visibility by key
var findSequence = function findSequence(dataSets, target) {
    for (var dsIdx = 0; dsIdx < dataSets.length; dsIdx++) {
        var sequences = dataSets[dsIdx].sequences;

        for (var seqIdx = 0; seqIdx < sequences.length; seqIdx++) {
            var seq = sequences[seqIdx];
            if (seq.id === target) {
                return seq;
            }
        }
    }
};
// Clips provided DataSet to the specified time rage of interest
var zoomTo = function zoomTo(dataSets, range) {
    return range ? dataSets.map(function (ds) {
        return Object.assign({}, ds, { sequences: ds.sequences.map(function (seq) {
                return Object.assign({}, seq, { samples: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__d3chart_zoom__["d" /* getClip */])(seq.samples, function (d) {
                        return d.x;
                    }, range, sampleInterpolator) });
            }) });
    }) : dataSets;
};
// Timeseries data is sequence of data points in time
// To render a tooltip we need to interpolate value between two points in a sequence
var sampleInterpolator = function sampleInterpolator(left, right, at) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__app_utils_assert_index__["b" /* assertValue */])(left);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__app_utils_assert_index__["b" /* assertValue */])(right);
    var interpolate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolateNumber */])(left.y, right.y);
    var t = barycentric(left.x, right.x, at);
    return { x: at, y: interpolate(t) };
};
function barycentric(x1, x2, x) {
    return (+x - +x1) / (+x2 - +x1);
}
var getTooltipInfoAt = function getTooltipInfoAt(dataSets, at) {
    return {
        x: at,
        // Each DataSet could have multiple sequences.
        // For each sequence we need to find an intersection point with sweep line (at parameter)
        // Sort constructed array by order flag in a sequence
        items: dataSets.reduce(function (acc, ds, idx) {
            return ds.sequences.reduce(function (acc, seq, sIdx) {
                acc.push({
                    value: getValueAt(seq.samples, at),
                    dataSetId: idx,
                    sequence: seq
                });
                return acc;
            }, acc);
        }, []).sort(function (a, b) {
            return a.sequence.order - b.sequence.order;
        })
    };
};
var getValueAt = function getValueAt(samples, at) {
    var bisect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* bisector */])(function (d) {
        return d.x;
    });
    var idx = bisect.left(samples, at);
    // no values less than x
    if (idx === 0) return samples[0].y;
    // all values are less
    if (idx === samples.length) return samples[samples.length - 1].y;
    // samples.slice(0, idx) < x
    return sampleInterpolator(samples[idx - 1], samples[idx], at).y;
};

/***/ }),
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return commitEntity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_EntityType__ = __webpack_require__(54);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var commitEntity = function commitEntity(request) {
    var type = request.type,
        entity = request.entity;

    var key = __WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */][type];
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__client__["a" /* runAction */])('/action/CommitObject', _defineProperty({}, key, entity));
};

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteObjects; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_utils_assert__ = __webpack_require__(5);


var deleteObjects = function deleteObjects(request) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__app_utils_assert__["b" /* assertValue */])(request);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__client__["a" /* runAction */])('/action/DeleteObject', request);
};

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVehiclesGeoposition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_utils_assert__ = __webpack_require__(5);


var getVehiclesGeoposition = function getVehiclesGeoposition(request) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__app_utils_assert__["b" /* assertValue */])(request);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__client__["a" /* runAction */])('/action/GetVehiclesGeoposition', request);
};

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return groupActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__(23);

var groupActions = function groupActions(request) {
    if (request == null) throw new Error('request param has to have a value');
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__client__["a" /* runAction */])('/action/GroupAction', request);
};

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getGroupParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__(23);

var getGroupParams = function getGroupParams(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__client__["a" /* runAction */])('/action/GetGroupParams', params);
};

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNotifications; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__(23);

var getNotifications = function getNotifications() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__client__["a" /* runAction */])('/action/GetNotifications', {});
};

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return saveSettings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__(23);

var getSettings = function getSettings(divisionId) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__client__["a" /* runAction */])('/action/GetSettings', { DivisionId: divisionId });
};
var saveSettings = function saveSettings(request) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__client__["a" /* runAction */])('/action/SaveSettings', request);
};

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUserInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__(23);

var getUserInfo = function getUserInfo() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__client__["a" /* runAction */])('/action/GetUserInfo', {});
};

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteConfirmationWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Container__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dialogs_Confirmation__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_DeleteObjects__ = __webpack_require__(56);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var DeleteConfirmationWidget = function (_React$Component) {
    _inherits(DeleteConfirmationWidget, _React$Component);

    function DeleteConfirmationWidget() {
        _classCallCheck(this, DeleteConfirmationWidget);

        var _this = _possibleConstructorReturn(this, (DeleteConfirmationWidget.__proto__ || Object.getPrototypeOf(DeleteConfirmationWidget)).apply(this, arguments));

        _this.deleteObjectsActions = new __WEBPACK_IMPORTED_MODULE_3__flux_DeleteObjects__["b" /* DeleteObjectsActions */]();
        return _this;
    }

    _createClass(DeleteConfirmationWidget, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                polyglot = _props.polyglot,
                entityType = _props.entityType,
                deleteObjectsStore = _props.deleteObjectsStore,
                title = _props.title;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Container__["a" /* Container */], { store: deleteObjectsStore }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Dialogs_Confirmation__["a" /* Confirmation */], { title: title, okTitle: polyglot.t('button.delete'), cancelTitle: polyglot.t('button.cancel'), cancel: function cancel() {
                    return _this2.deleteObjectsActions.hideConfirmation(entityType);
                }, ok: this.props.deleteObjectsCommand.execute }, this.props.children));
        }
    }]);

    return DeleteConfirmationWidget;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Confirmation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal_Modal__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dialogs_TwoButtonDialog__ = __webpack_require__(212);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};



var Confirmation = function (_React$Component) {
    _inherits(Confirmation, _React$Component);

    function Confirmation() {
        _classCallCheck(this, Confirmation);

        return _possibleConstructorReturn(this, (Confirmation.__proto__ || Object.getPrototypeOf(Confirmation)).apply(this, arguments));
    }

    _createClass(Confirmation, [{
        key: "render",
        value: function render() {
            var _a = this.props,
                isConfirmationDialogShown = _a.isConfirmationDialogShown,
                errorMessage = _a.errorMessage,
                children = _a.children,
                ok = _a.ok,
                cancel = _a.cancel,
                title = _a.title,
                okTitle = _a.okTitle,
                cancelTitle = _a.cancelTitle,
                rest = __rest(_a, ["isConfirmationDialogShown", "errorMessage", "children", "ok", "cancel", "title", "okTitle", "cancelTitle"]);
            if (!isConfirmationDialogShown) return null;
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_Modal_Modal__["a" /* Modal */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Dialogs_TwoButtonDialog__["a" /* TwoButtonDialog */], Object.assign({ okTitle: okTitle, cancelTitle: cancelTitle, title: title, errorMessage: errorMessage, cancel: cancel, ok: ok }, rest), children));
        }
    }]);

    return Confirmation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OneButtonDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Container__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Buttons__ = __webpack_require__(21);





var style = __webpack_require__(941);
var OneButtonDialog = function OneButtonDialog(props) {
    var title = props.title,
        ok = props.ok,
        okTitle = props.okTitle;

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Container__["a" /* Container */], { stores: [props.visibilityStore], render: function render() {
            return props.visibilityStore.isSet() && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_Modal__["a" /* Modal */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: style.Dialog }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "text-center" }, title), props.children, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(style.ButtomToolbar, 'btn-toolbar pull-right') }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Buttons__["a" /* Button */], { type: "success", onClick: ok, autoFocus: true }, okTitle))));
        } });
};

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TwoButtonDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var style = __webpack_require__(942);
var TwoButtonDialog = function (_React$Component) {
    _inherits(TwoButtonDialog, _React$Component);

    function TwoButtonDialog() {
        _classCallCheck(this, TwoButtonDialog);

        var _this = _possibleConstructorReturn(this, (TwoButtonDialog.__proto__ || Object.getPrototypeOf(TwoButtonDialog)).apply(this, arguments));

        _this.onKeyDown = function (e) {
            var _this$props = _this.props,
                disabled = _this$props.disabled,
                okDisabled = _this$props.okDisabled,
                cancelDisabled = _this$props.cancelDisabled,
                ok = _this$props.ok,
                cancel = _this$props.cancel;

            e.keyCode === 13 && !disabled && !okDisabled && ok && ok();
            e.keyCode === 27 && !disabled && !cancelDisabled && cancel && cancel();
        };
        return _this;
    }

    _createClass(TwoButtonDialog, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                ok = _props.ok,
                cancel = _props.cancel,
                okTitle = _props.okTitle,
                cancelTitle = _props.cancelTitle,
                errorMessage = _props.errorMessage,
                _props$disabled = _props.disabled,
                disabled = _props$disabled === undefined ? false : _props$disabled,
                _props$okDisabled = _props.okDisabled,
                okDisabled = _props$okDisabled === undefined ? false : _props$okDisabled,
                _props$cancelDisabled = _props.cancelDisabled,
                cancelDisabled = _props$cancelDisabled === undefined ? false : _props$cancelDisabled,
                children = _props.children;

            var okClasses = __WEBPACK_IMPORTED_MODULE_1_classnames___default()("btn btn-success", { disabled: disabled || okDisabled });
            var cancelClasses = __WEBPACK_IMPORTED_MODULE_1_classnames___default()("btn btn-default", { disabled: disabled || cancelDisabled });
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: style.TwoButtonDialog, onKeyDown: this.onKeyDown }, title && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "text-center" }, title), children, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(style.ButtomToolbar, 'has-error') }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(style.Info, "control-label") }, errorMessage), cancelTitle && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { onClick: disabled || cancelDisabled ? null : cancel, className: cancelClasses, autoFocus: true }, cancelTitle), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { onClick: disabled || okDisabled ? null : ok, className: okClasses }, okTitle)));
        }
    }]);

    return TwoButtonDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormCheckboxItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// TODO: get rid of this class. Use CheckboxGroup instead
var FormCheckboxItem = function (_React$Component) {
    _inherits(FormCheckboxItem, _React$Component);

    function FormCheckboxItem() {
        _classCallCheck(this, FormCheckboxItem);

        return _possibleConstructorReturn(this, (FormCheckboxItem.__proto__ || Object.getPrototypeOf(FormCheckboxItem)).apply(this, arguments));
    }

    _createClass(FormCheckboxItem, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                offsetColumns = _props.offsetColumns,
                className = _props.className,
                disabled = _props.disabled;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("form-group", className) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-sm-offset-" + offsetColumns + " col-sm-" + (12 - offsetColumns) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "checkbox" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { disabled: disabled, type: "checkbox", checked: this.props.checked, onChange: this.props.onChange }), " ", this.props.label))));
        }
    }]);

    return FormCheckboxItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
FormCheckboxItem.defaultProps = {
    offsetColumns: 4
};

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NonIsolatedPremise; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Flag__ = __webpack_require__(607);


var NonIsolatedPremise = function NonIsolatedPremise(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_Flag__["a" /* Flag */], { name: "nonIsolatedPremise" }, props.children);
};

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IdColumn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var styles = __webpack_require__(962);
var getterId = function getterId(p) {
    return p.id;
};
// This column displays the id of a particular entity
// Basically this is a TextColumn with hardcoded text extractor
var IdColumn = function (_React$Component) {
    _inherits(IdColumn, _React$Component);

    function IdColumn() {
        _classCallCheck(this, IdColumn);

        return _possibleConstructorReturn(this, (IdColumn.__proto__ || Object.getPrototypeOf(IdColumn)).apply(this, arguments));
    }

    _createClass(IdColumn, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                datum = _props.datum,
                getValue = _props.getValue,
                cellClassName = _props.cellClassName;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(cellClassName) }, getValue(datum));
        }
    }]);

    return IdColumn;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
IdColumn.defaultProps = {
    headerClassName: styles.IdColumn,
    getValue: getterId
};

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return multiselectPropsFrom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MultiselectColumn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var styles = __webpack_require__(963);
var multiselectPropsFrom = function multiselectPropsFrom(props) {
    return Object.assign({ renderHeader: function renderHeader() {
            var divRef = void 0;
            return props.disabled ? null : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { onClick: function onClick(e) {
                    return divRef === e.target && props.toggleAll();
                }, ref: function ref(e) {
                    return divRef = e;
                }, className: styles.HeaderCell }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "checkbox", checked: props.allSelected, onChange: function onChange() {
                    return props.toggleAll();
                } }));
        }, headerClassName: styles.MultiselectColumn }, props);
};
// This columns renders seleciton checkbox
var MultiselectColumn = function (_React$Component) {
    _inherits(MultiselectColumn, _React$Component);

    function MultiselectColumn() {
        _classCallCheck(this, MultiselectColumn);

        return _possibleConstructorReturn(this, (MultiselectColumn.__proto__ || Object.getPrototypeOf(MultiselectColumn)).apply(this, arguments));
    }

    _createClass(MultiselectColumn, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                datum = _props.datum,
                row = _props.row,
                selected = _props.selected,
                toggle = _props.toggle,
                datumKey = _props.datumKey;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "text-center", onClick: function onClick(e) {
                    return e.target === _this2.tdRef && toggle(datum, row);
                }, ref: function ref(e) {
                    return _this2.tdRef = e;
                } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "checkbox", checked: selected.has(datumKey ? datumKey(datum) : datum.id), onChange: function onChange(e) {
                    return toggle(datum, row);
                } }));
        }
    }]);

    return MultiselectColumn;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DivisionGrid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGrid__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Columns_IdColumn__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataGrid_DataGridTemplateColumn__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Buttons__ = __webpack_require__(21);






var styles = __webpack_require__(944);
var getName = function getName(v) {
    return v.Name;
};
var AdminIcon = function AdminIcon(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", Object.assign({ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(styles.AdminIcon, 'glyphicon glyphicon-user') }, props));
};
var NameCell = function NameCell(props) {
    var datum = props.datum,
        row = props.row,
        getValue = props.getValue,
        switchTo = props.switchTo;

    var division = datum;
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: styles.NameCell }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, division.IsAdmin && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AdminIcon, { title: props.polyglot.t('division.msg_admin_for', { name: division.Name }) }), getValue(datum)), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_Buttons__["a" /* Button */], { dim: "xs", type: "info", leftIcon: "transfer", onClick: function onClick(e) {
            return switchTo(datum, row);
        } }, props.polyglot.t('division.btn_switch')));
};
// This is a grid component which is displayed on Division tab
var DivisionGrid = function DivisionGrid(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGrid__["a" /* DataGrid */], { initialData: props.items, className: props.className, onThead: props.onThead }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Columns_IdColumn__["a" /* IdColumn */], { header: props.polyglot.t('column.id') }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_DataGrid_DataGridTemplateColumn__["a" /* DataGridTemplateColumn */], { header: props.polyglot.t('division.name_label'), getValue: getName, render: function render(colProps) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](NameCell, Object.assign({ switchTo: props.switchTo, polyglot: props.polyglot }, colProps));
        } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_DataGrid_DataGridTemplateColumn__["a" /* DataGridTemplateColumn */], { header: props.polyglot.t('column.action'), render: function render(p) {
            var datum = p.datum,
                row = p.row;

            var isReadonly = typeof datum.ParentId !== 'number' || !datum.IsAdmin;
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: 'btn-toolbar' }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_Buttons__["a" /* Button */], { dim: "xs", leftIcon: "pencil", type: "info", onClick: function onClick(e) {
                    return props.onEdit(datum, row);
                }, disabled: isReadonly }, props.polyglot.t('button.edit_short')));
        } }));
};

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DivisionRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Container__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_EditCreateEntityActions__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EditCreate_EditCreateEntityRoute__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EditCreateDivision__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EditCreateDivisionActions__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DivisionGrid__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_configure_store__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Table_NoResults__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Table_TableTitle__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_StickyMediator__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Search_GenericSearchWidget__ = __webpack_require__(123);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var appStyles = __webpack_require__(64);
var tableStyles = __webpack_require__(73);
var DivisionRoute = function (_React$Component) {
    _inherits(DivisionRoute, _React$Component);

    function DivisionRoute() {
        _classCallCheck(this, DivisionRoute);

        var _this = _possibleConstructorReturn(this, (DivisionRoute.__proto__ || Object.getPrototypeOf(DivisionRoute)).apply(this, arguments));

        _this.stickyMediator = new __WEBPACK_IMPORTED_MODULE_12__utils_StickyMediator__["a" /* StickyMediator */]();
        return _this;
    }

    _createClass(DivisionRoute, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.props.refresher.run();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var entityType = __WEBPACK_IMPORTED_MODULE_1__models__["a" /* EntityType */].Division;
            var polyglot = this.props.polyglot;

            var createForm = function createForm(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Container__["a" /* Container */], { merge: true, stores: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_configure_store__["b" /* twoButtonDialogConfig */])(_this2.props.upsertInProgressStore, _this2.props.upsertErrorStore) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__EditCreate_EditCreateEntityRoute__["a" /* EditCreateEntityRoute */], { path: props.path, title: props.title, okTitle: props.okTitle, cancelTitle: polyglot.t('button.cancel'), renderEdit: function renderEdit() {
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Container__["a" /* Container */], { merge: true, stores: [_this2.props.editStore, [_this2.props.divisionsLoadInProgress, function (store) {
                                return { loadingDivisions: store.isSet() };
                            }]], actions: new __WEBPACK_IMPORTED_MODULE_7__EditCreateDivisionActions__["a" /* EditCreateDivisionActions */](), onMount: _this2.props.initUpsertCommand.execute }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__EditCreateDivision__["a" /* EditCreateDivision */], { polyglot: polyglot, loadingDivisions: false, draft: null, divisions: null }));
                    }, cancel: function cancel() {
                        new __WEBPACK_IMPORTED_MODULE_4__actions_EditCreateEntityActions__["a" /* EditCreateEntityActions */]().rejectDraft(entityType);
                        __WEBPACK_IMPORTED_MODULE_2__routes__["b" /* appNavigator */].goToDivisionTab();
                    }, ok: function ok() {
                        return _this2.props.upsertCommand.execute(_this2.props.editStore.getState().draft);
                    } }));
            };
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, createForm({ title: polyglot.t('division.create_title'), okTitle: polyglot.t('button.create'), path: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__routes__["h" /* addNewRouteFor */])(entityType) }), createForm({ title: polyglot.t('division.edit_title'), okTitle: polyglot.t('button.save'), path: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__routes__["i" /* editRouteFor */])(entityType) }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Search_GenericSearchWidget__["a" /* GenericSearchWidget */], Object.assign({}, this.props)), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: appStyles.StickyControlPanel, ref: this.stickyMediator.onToolbox }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Table_TableTitle__["a" /* TableTitle */], { polyglot: polyglot, labelStore: this.props.tableTitleStore })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Container__["a" /* Container */], { store: this.props.listStore }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__DivisionGrid__["a" /* DivisionGrid */], { className: tableStyles.StickyTable, polyglot: polyglot, items: null, onEdit: function onEdit(datum, row) {
                    return _this2.props.showEditDivisionCommand.execute(datum);
                }, switchTo: function switchTo(datum, row) {
                    return _this2.props.switchCommand.execute(datum.id);
                }, onThead: this.stickyMediator.onThead })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Table_NoResults__["a" /* NoResults */], { polyglot: polyglot, listStore: this.props.listStore }));
        }
    }]);

    return DivisionRoute;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditCreateDivision; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DivisionSelector__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Forms_Groups__ = __webpack_require__(105);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var styles = __webpack_require__(945);
// This is an edit form for Divisioin entity
var EditCreateDivision = function (_React$Component) {
    _inherits(EditCreateDivision, _React$Component);

    function EditCreateDivision() {
        _classCallCheck(this, EditCreateDivision);

        return _possibleConstructorReturn(this, (EditCreateDivision.__proto__ || Object.getPrototypeOf(EditCreateDivision)).apply(this, arguments));
    }

    _createClass(EditCreateDivision, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                draft = _props.draft,
                polyglot = _props.polyglot;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("form-horizontal", styles.EditCreateDivision) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Forms_Groups__["b" /* LoadableGroup */], { title: polyglot.t('division.parent_label') + ":", value: draft.ParentName, isLoading: this.props.loadingDivisions }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__DivisionSelector__["a" /* DivisionSelector */], { divisions: this.props.divisions, onChange: function onChange(d) {
                    return _this2.props.setParentDivision(d ? d.id : null);
                }, selectedId: draft.ParentId })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Forms_Groups__["c" /* InputTextGroup */], { title: polyglot.t('division.name_label') + ":", value: draft.Name, disabled: true }));
        }
    }]);

    return EditCreateDivision;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EditCreateDivisionStoreState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditCreateDivisionStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditCreate_EditStore__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditCreateDivisionActions__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_EditCreateEntityActions__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_EntityType__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_draft__ = __webpack_require__(130);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var EditCreateDivisionStoreState = function EditCreateDivisionStoreState() {
    _classCallCheck(this, EditCreateDivisionStoreState);
};
// This Flux store holds a draft of the changes as well as possible values for division selector
var EditCreateDivisionStore = function (_EditStore) {
    _inherits(EditCreateDivisionStore, _EditStore);

    function EditCreateDivisionStore() {
        _classCallCheck(this, EditCreateDivisionStore);

        var _this = _possibleConstructorReturn(this, (EditCreateDivisionStore.__proto__ || Object.getPrototypeOf(EditCreateDivisionStore)).call(this));

        _this.state = _this.getDefaultStateFor(null);
        _this.register(__WEBPACK_IMPORTED_MODULE_1__EditCreateDivisionActions__["b" /* names */].SET_NAME, function (e) {
            return _this.draft({ Name: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_1__EditCreateDivisionActions__["b" /* names */].SET_PARENT_DIVISION, function (e) {
            return _this.draft({ ParentId: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_1__EditCreateDivisionActions__["b" /* names */].SET_DIVISION_ITEMS, function (e) {
            return _this.field({ divisions: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__actions_EditCreateEntityActions__["b" /* names */].REJECT_DRAFT, function (e) {
            if (e.meta === __WEBPACK_IMPORTED_MODULE_3__models_EntityType__["a" /* EntityType */].Division) return _this.getDefaultStateFor(null);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__actions_EditCreateEntityActions__["b" /* names */].SET_EDIT_ENTITY, function (e) {
            if (e.meta === __WEBPACK_IMPORTED_MODULE_3__models_EntityType__["a" /* EntityType */].Division) return _this.getDefaultStateFor(e.payload);
        });
        return _this;
    }

    _createClass(EditCreateDivisionStore, [{
        key: "getDefaultStateFor",
        value: function getDefaultStateFor(division) {
            return {
                draft: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_draft__["d" /* prepareDivisionDraft */])(division),
                divisions: []
            };
        }
    }]);

    return EditCreateDivisionStore;
}(__WEBPACK_IMPORTED_MODULE_0__EditCreate_EditStore__["a" /* EditStore */]);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InitUpsertDivisionCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Error_ErrorActions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Flag_FlagActions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditCreateDivisionActions__ = __webpack_require__(214);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var InitUpsertDivisionCommand = function InitUpsertDivisionCommand(runSearch, store, getDidivionId, inProgressDispatchToken, errorDispatchToken) {
    var _this = this;

    _classCallCheck(this, InitUpsertDivisionCommand);

    this.runSearch = runSearch;
    this.store = store;
    this.getDidivionId = getDidivionId;
    this.inProgressDispatchToken = inProgressDispatchToken;
    this.errorDispatchToken = errorDispatchToken;
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_0__flux_Error_ErrorActions__["a" /* ErrorActions */]();
    this.inProgressActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Flag_FlagActions__["a" /* FlagActions */]();
    this.editActions = new __WEBPACK_IMPORTED_MODULE_2__EditCreateDivisionActions__["a" /* EditCreateDivisionActions */]();
    this.execute = function () {
        _this.errorActions.clearError(_this.errorDispatchToken); // reset error from previous edit session
        _this.inProgressActions.set(_this.inProgressDispatchToken);
        _this.runSearch({ Name: 'Divisions' }).then(function (res) {
            var divisions = res.Entries.Division;

            var _store$getState$draft = _this.store.getState().draft,
                ParentId = _store$getState$draft.ParentId,
                id = _store$getState$draft.id;

            if (ParentId == null && id == null) {
                var currDivisionId = _this.getDidivionId();
                var division = divisions.find(function (d) {
                    return d.id === currDivisionId;
                });
                if (division) {
                    _this.editActions.setParentDivision(division.id);
                }
            }
            _this.editActions.setDivisionItems(divisions);
        }).catch(function (err) {
            return _this.errorActions.setError(err, _this.errorDispatchToken);
        }).then(function () {
            return _this.inProgressActions.reset(_this.inProgressDispatchToken);
        }); // finaly
    };
};

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShowCreateDivisionCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_EditCreateEntityActions__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Error_ErrorActions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes__ = __webpack_require__(7);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var ShowCreateDivisionCommand = function ShowCreateDivisionCommand(upsertErrorDispatchToken) {
    var _this = this;

    _classCallCheck(this, ShowCreateDivisionCommand);

    this.upsertErrorDispatchToken = upsertErrorDispatchToken;
    this.editActions = new __WEBPACK_IMPORTED_MODULE_1__actions_EditCreateEntityActions__["a" /* EditCreateEntityActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_2__flux_Error_ErrorActions__["a" /* ErrorActions */]();
    this.execute = function () {
        _this.editActions.rejectDraft(__WEBPACK_IMPORTED_MODULE_0__models__["a" /* EntityType */].Division);
        _this.errorActions.clearError(_this.upsertErrorDispatchToken);
        __WEBPACK_IMPORTED_MODULE_3__routes__["b" /* appNavigator */].goToAddNewEntityTab(__WEBPACK_IMPORTED_MODULE_0__models__["a" /* EntityType */].Division);
    };
};

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShowEditDivisionCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_EditCreateEntityActions__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Error_ErrorActions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_assert_index__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(7);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var ShowEditDivisionCommand = function ShowEditDivisionCommand(upsertErrorDispatchToken) {
    var _this = this;

    _classCallCheck(this, ShowEditDivisionCommand);

    this.upsertErrorDispatchToken = upsertErrorDispatchToken;
    this.editActions = new __WEBPACK_IMPORTED_MODULE_1__actions_EditCreateEntityActions__["a" /* EditCreateEntityActions */]();
    this.upsertErrorActions = new __WEBPACK_IMPORTED_MODULE_2__flux_Error_ErrorActions__["a" /* ErrorActions */]();
    this.execute = function (toEdit) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_assert_index__["b" /* assertValue */])(toEdit, 'division to edit couldn\'t be empty');
        _this.editActions.setEntityToEdit(toEdit, __WEBPACK_IMPORTED_MODULE_0__models__["a" /* EntityType */].Division);
        _this.upsertErrorActions.clearError(_this.upsertErrorDispatchToken);
        __WEBPACK_IMPORTED_MODULE_4__routes__["b" /* appNavigator */].goToEditEntityTab(__WEBPACK_IMPORTED_MODULE_0__models__["a" /* EntityType */].Division);
    };
};

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpsertDivisionCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Flag_FlagActions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Error_ErrorActions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Grid_ListActions__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(7);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var UpsertDivisionCommand = function UpsertDivisionCommand(polyglot, commit, changeCurrentDivisionCommand, getCurrentDivisionId, listDispatchToken, inProgressDispatchToken, errorDispatchToken) {
    var _this = this;

    _classCallCheck(this, UpsertDivisionCommand);

    this.polyglot = polyglot;
    this.commit = commit;
    this.changeCurrentDivisionCommand = changeCurrentDivisionCommand;
    this.getCurrentDivisionId = getCurrentDivisionId;
    this.listDispatchToken = listDispatchToken;
    this.inProgressDispatchToken = inProgressDispatchToken;
    this.errorDispatchToken = errorDispatchToken;
    this.inProgressActions = new __WEBPACK_IMPORTED_MODULE_0__flux_Flag_FlagActions__["a" /* FlagActions */]();
    this.listActions = new __WEBPACK_IMPORTED_MODULE_2__flux_Grid_ListActions__["a" /* ListActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Error_ErrorActions__["a" /* ErrorActions */]();
    this.execute = function (entityDraft) {
        if (!entityDraft) throw new Error('Program error. draft has to have value');
        var Name = entityDraft.Name,
            ParentId = entityDraft.ParentId;

        var setError = function setError(msg) {
            return _this.errorActions.setError(new Error(msg), _this.errorDispatchToken);
        };
        if (typeof ParentId !== 'number') {
            setError(_this.polyglot.t('division.validation_err.parent_not_set'));
            return;
        }
        if (typeof Name !== 'string' || Name.trim() === '') {
            setError(_this.polyglot.t('division.validation_err.empty_name'));
            return;
        }
        var entityType = __WEBPACK_IMPORTED_MODULE_3__models__["a" /* EntityType */].Division;
        _this.inProgressActions.set(_this.inProgressDispatchToken);
        _this.commit({ type: entityType, entity: entityDraft }).then(function (res) {
            if (res.Success) return res[__WEBPACK_IMPORTED_MODULE_3__models__["a" /* EntityType */][entityType]];
            throw new Error(res.ErrorMessage);
        }).then(function (entity) {
            _this.listActions.upsertItems([entity], entityType);
            _this.changeCurrentDivisionCommand.execute(_this.getCurrentDivisionId());
            __WEBPACK_IMPORTED_MODULE_4__routes__["b" /* appNavigator */].goToDivisionTab();
        }).catch(function (err) {
            return _this.errorActions.setError(err, _this.errorDispatchToken);
        }).then(function () {
            return _this.inProgressActions.reset(_this.inProgressDispatchToken);
        }); // finaly
    };
};

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShowCreateDivisionCommand__ = __webpack_require__(509);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__ShowCreateDivisionCommand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShowEditDivisionCommand__ = __webpack_require__(510);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__ShowEditDivisionCommand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UpsertDivisionCommand__ = __webpack_require__(511);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__UpsertDivisionCommand__["a"]; });




/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Loadable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(113);


var helperStyles = __webpack_require__(186);
var Loadable = function Loadable(props) {
    return props.isLoading ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-control", style: { pointerEvents: "none" } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_Spinner__["a" /* Spinner */], null), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: helperStyles.MarginLeft }, props.value)) : props.children;
};

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssignPerson; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Select__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__converters_converters__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_assert__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var AssignPerson = function (_React$Component) {
    _inherits(AssignPerson, _React$Component);

    function AssignPerson() {
        _classCallCheck(this, AssignPerson);

        var _this = _possibleConstructorReturn(this, (AssignPerson.__proto__ || Object.getPrototypeOf(AssignPerson)).apply(this, arguments));

        _this.getTitle = function (duration) {
            var minUnit = _this.props.polyglot.t('units.min');
            if (duration < 60) return duration + " " + minUnit;
            var hours = Math.floor(duration / 60);
            var mins = duration % 60;
            var hourUnit = _this.props.polyglot.t('units.hours', { smart_count: hours });
            if (mins === 0) return hours + " " + hourUnit;
            return hours + " " + hourUnit + " " + mins + " min";
        };
        _this.getValue = function () {
            return Object.assign({}, _this.props.draft);
        };
        return _this;
    }

    _createClass(AssignPerson, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                draft = _props.draft,
                durations = _props.durations,
                setDuration = _props.setDuration;
            var Duration = draft.Duration;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-horizontal", style: { width: 510, padding: 15 } }, this.props.polyglot.t('dashboard.excess_assignment.message'), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'form-group' }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'col-sm-4' }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_Select__["a" /* Select */], { className: 'form-control', placeholder: '---', items: durations, defaultValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__converters_converters__["a" /* intToString */])(Duration), valueFn: function valueFn(n) {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__converters_converters__["a" /* intToString */])(n);
                }, titleFn: this.getTitle, onChange: function onChange(s) {
                    var duration = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__converters_converters__["b" /* stringToInt */])(s.getValue());
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_assert__["f" /* assertNumber */])(duration, 'duration has to be a number');
                    setDuration(duration);
                } }))));
        }
    }]);

    return AssignPerson;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dashboard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AssignPersonActions__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AssignPersonStore__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Container__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditCreate_EditCreateEntityRoute__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AssignPerson__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SensorsExcessesGrid__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_configure_store__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flux_Error_ErrorActions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ErrorMessage__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_StickyMediator__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Dialogs_OneButtonDialog_index__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__flux_Flag_FlagActions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__flux_Grid_SelectedItemsActions__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TrashButtonWidget__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DeleteConfirmationWidget__ = __webpack_require__(104);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var styles = __webpack_require__(406);
var appStyles = __webpack_require__(64);
var Dashboard = function (_React$Component) {
    _inherits(Dashboard, _React$Component);

    function Dashboard() {
        _classCallCheck(this, Dashboard);

        var _this = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).apply(this, arguments));

        _this.assignPersonActions = new __WEBPACK_IMPORTED_MODULE_1__AssignPersonActions__["a" /* AssignPersonActions */]();
        _this.assignPersonStore = new __WEBPACK_IMPORTED_MODULE_2__AssignPersonStore__["a" /* AssignPersonStore */]();
        _this.errorActions = new __WEBPACK_IMPORTED_MODULE_9__flux_Error_ErrorActions__["a" /* ErrorActions */]();
        _this.stickyMediator = new __WEBPACK_IMPORTED_MODULE_12__utils_StickyMediator__["a" /* StickyMediator */]();
        return _this;
    }

    _createClass(Dashboard, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            var _this2 = this;

            this.props.loadDashboardCmd.execute();
            this.intervalToken = setInterval(function () {
                var selectedItemsStore = _this2.props.selectedItemsStore;
                // skip refresh if some items are selected and N seconds have not elapsed
                if (!!selectedItemsStore.lastChange && selectedItemsStore.getState().selected.size > 0 && new Date() - selectedItemsStore.lastChange < 120 * 1000) {
                    return;
                }
                _this2.props.loadDashboardCmd.execute();
            }, 10 * 1000);
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            clearInterval(this.intervalToken);
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var polyglot = this.props.polyglot;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__DeleteConfirmationWidget__["a" /* DeleteConfirmationWidget */], Object.assign({}, this.props, { entityType: __WEBPACK_IMPORTED_MODULE_10__models__["a" /* EntityType */].SensorExcess, title: polyglot.t('dashboard.excess_table.del_confirmation_title') }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: appStyles.ConfirmationContainer }, polyglot.t('dashboard.excess_table.del_confirmation_msg'))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Container__["a" /* Container */], { merge: true, stores: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_configure_store__["b" /* twoButtonDialogConfig */])(this.props.assignmentInProgressStore, this.props.assignmentErrorStore) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__EditCreate_EditCreateEntityRoute__["a" /* EditCreateEntityRoute */], { path: __WEBPACK_IMPORTED_MODULE_6__routes__["k" /* assignPersonRoute */], title: polyglot.t('dashboard.excess_assignment.title'), okTitle: polyglot.t('button.commit'), cancelTitle: polyglot.t('button.cancel'), renderEdit: function renderEdit() {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Container__["a" /* Container */], { store: _this3.assignPersonStore, actions: _this3.assignPersonActions }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__AssignPerson__["a" /* AssignPerson */], { polyglot: polyglot, ref: function ref(e) {
                            return _this3.formRef = e;
                        }, draft: null, durations: [] }));
                }, ok: function ok() {
                    return _this3.props.assignCmd.execute(_this3.assignPersonStore.getState().draft);
                }, cancel: function cancel() {
                    _this3.assignPersonActions.reject();
                    __WEBPACK_IMPORTED_MODULE_6__routes__["b" /* appNavigator */].goToAlarm();
                } })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Dialogs_OneButtonDialog_index__["a" /* OneButtonDialog */], { visibilityStore: this.props.alertStore, title: polyglot.t('misc.info'), okTitle: polyglot.t('button.ok'), ok: function ok() {
                    return new __WEBPACK_IMPORTED_MODULE_14__flux_Flag_FlagActions__["a" /* FlagActions */]().reset(_this3.props.alertStore.dispatchToken);
                } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, polyglot.t('sensor.no_data_msg'))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: this.stickyMediator.onToolbox, className: styles.StickyContainer }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Container__["a" /* Container */], { store: this.props.excessTableErrorStore }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_ErrorMessage__["a" /* ErrorMessage */], { errorMessage: null }))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__TrashButtonWidget__["a" /* TrashButtonWidget */], Object.assign({ entityType: __WEBPACK_IMPORTED_MODULE_10__models__["a" /* EntityType */].SensorExcess }, this.props)), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Container__["a" /* Container */], { merge: true, stores: [this.props.sensorsExcessesListStore, this.props.selectedItemsStore, [this.props.sensorsDataSearchInitiatorStore, function (store) {
                    return { sensorsDataSearchInitiator: store.getValue() };
                }], [this.props.sensorsSearchInitiatorStore, function (store) {
                    return { sensorsSearchInitiator: store.getValue() };
                }], [this.props.vehicleSearchInitiatorStore, function (store) {
                    return { vehicleSearchInitiator: store.getValue() };
                }]] }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__SensorsExcessesGrid__["a" /* SensorsExcessesGrid */], { polyglot: polyglot, sensorsSearchInitiator: null, vehicleSearchInitiator: null, sensorsDataSearchInitiator: null, items: [], onVehicle: function onVehicle(datum, row) {
                    return _this3.props.vehicleSearchCmd.execute(datum.IncidentId, { IncidentId: datum.IncidentId });
                }, onSensor: function onSensor(datum, row) {
                    return _this3.props.sensorSearchCmd.execute(datum.IncidentId, { IncidentId: datum.IncidentId });
                }, onData: function onData(datum, row) {
                    return _this3.props.incidentDataSearchCmd.execute(datum.IncidentId);
                }, onAssign: function onAssign(datum, row) {
                    _this3.assignPersonActions.setSensorExcess(datum);
                    _this3.errorActions.clearError(_this3.props.assignmentErrorStore.dispatchToken);
                    __WEBPACK_IMPORTED_MODULE_6__routes__["b" /* appNavigator */].goToAssignPersonOnIssuePage();
                }, onThead: this.stickyMediator.onThead, toggle: function toggle(datum, row) {
                    return new __WEBPACK_IMPORTED_MODULE_15__flux_Grid_SelectedItemsActions__["a" /* SelectedItemsActions */]().toggleItem(datum.IncidentId, __WEBPACK_IMPORTED_MODULE_10__models__["a" /* EntityType */].SensorExcess);
                }, toggleAll: function toggleAll() {
                    return new __WEBPACK_IMPORTED_MODULE_15__flux_Grid_SelectedItemsActions__["a" /* SelectedItemsActions */]().toggleAll(__WEBPACK_IMPORTED_MODULE_10__models__["a" /* EntityType */].SensorExcess);
                } })));
        }
    }]);

    return Dashboard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dashboard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AssignPersonActions__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AssignPersonStore__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Container__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Table_TableTitle__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ReportGrid__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flux_Error_ErrorActions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StickyMediator__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Dialogs_OneButtonDialog_index__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__flux_Flag_FlagActions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DeleteConfirmationWidget__ = __webpack_require__(104);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var styles = __webpack_require__(406);
var appStyles = __webpack_require__(64);
var Dashboard = function (_React$Component) {
    _inherits(Dashboard, _React$Component);

    function Dashboard() {
        _classCallCheck(this, Dashboard);

        var _this = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).apply(this, arguments));

        _this.assignPersonActions = new __WEBPACK_IMPORTED_MODULE_1__AssignPersonActions__["a" /* AssignPersonActions */]();
        _this.assignPersonStore = new __WEBPACK_IMPORTED_MODULE_2__AssignPersonStore__["a" /* AssignPersonStore */]();
        _this.errorActions = new __WEBPACK_IMPORTED_MODULE_7__flux_Error_ErrorActions__["a" /* ErrorActions */]();
        _this.stickyMediator = new __WEBPACK_IMPORTED_MODULE_9__utils_StickyMediator__["a" /* StickyMediator */]();
        return _this;
    }

    _createClass(Dashboard, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            var _this2 = this;

            this.props.loadDashboardCmd.execute();
            this.intervalToken = setInterval(function () {
                var selectedItemsStore = _this2.props.selectedItemsStore;
                // skip refresh if some items are selected and N seconds have not elapsed
                if (!!selectedItemsStore.lastChange && selectedItemsStore.getState().selected.size > 0 && new Date() - selectedItemsStore.lastChange < 120 * 1000) {
                    return;
                }
                _this2.props.loadDashboardCmd.execute();
            }, 10 * 1000);
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            clearInterval(this.intervalToken);
        }
    }, {
        key: "searchByCategory",
        value: function searchByCategory(category) {
            this.props.searchVehiclesByCategory.execute(category, { SummaryCategory: category });
            __WEBPACK_IMPORTED_MODULE_4__routes__["b" /* appNavigator */].goToVehicleTab();
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var polyglot = this.props.polyglot;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__DeleteConfirmationWidget__["a" /* DeleteConfirmationWidget */], Object.assign({}, this.props, { entityType: __WEBPACK_IMPORTED_MODULE_8__models__["a" /* EntityType */].SensorExcess, title: polyglot.t('dashboard.excess_table.del_confirmation_title') }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: appStyles.ConfirmationContainer }, polyglot.t('dashboard.excess_table.del_confirmation_msg'))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Dialogs_OneButtonDialog_index__["a" /* OneButtonDialog */], { visibilityStore: this.props.alertStore, title: polyglot.t('misc.info'), okTitle: polyglot.t('button.ok'), ok: function ok() {
                    return new __WEBPACK_IMPORTED_MODULE_11__flux_Flag_FlagActions__["a" /* FlagActions */]().reset(_this3.props.alertStore.dispatchToken);
                } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, polyglot.t('sensor.no_data_msg'))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Table_TableTitle__["a" /* TableTitle */], { polyglot: polyglot, labelStore: this.props.reportTableTitleStore }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Container__["a" /* Container */], { merge: true, stores: [this.props.reportListStore, [this.props.searchVehiclesByCategoryInitiator, function (store) {
                    return { searchInitiator: store.getValue() };
                }]] }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ReportGrid__["a" /* ReportGrid */], { items: [], searchInitiator: null, polyglot: polyglot, onClick: function onClick(category) {
                    return _this3.searchByCategory(category);
                } })));
        }
    }]);

    return Dashboard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportGrid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataGrid_DataGrid__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGridTemplateColumn__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_index__ = __webpack_require__(113);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var styles = __webpack_require__(946);
var tableStyles = __webpack_require__(73);
var getTotal = function getTotal(r) {
    return r.VehiclesTotal;
};
var getLive = function getLive(r) {
    return r.VehiclesLive;
};
var getDead = function getDead(r) {
    return r.VehiclesDead;
};
var getGreen = function getGreen(r) {
    return r.VehiclesGreenZone;
};
var getYellow = function getYellow(r) {
    return r.VehiclesYellowZone;
};
var getRed = function getRed(r) {
    return r.VehiclesRedZone;
};
var getUndef = function getUndef(r) {
    return r.VehiclesUndefinedAlertLevels;
};
var getRenderFor = function getRenderFor(category, handler) {
    return function (_ref, className) {
        var datum = _ref.datum,
            getValue = _ref.getValue;

        var value = getValue(datum);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, value ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: className, onClick: function onClick(e) {
                return handler(category);
            } }, value) : null);
    };
};
;
var Cell = function Cell(props) {
    var value = props.getValue(props.datum);
    var category = props.category;

    var isLoading = category === props.searchInitiator;
    if (value == null || value === 0 && props.hideZero) return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null));
    if (!category || category === '') return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, value);
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, isLoading && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_Spinner_index__["a" /* Spinner */], null), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: props.className, style: { pointerEvents: isLoading ? "none" : "initial" }, onClick: function onClick(e) {
            return props.onClick(props.category);
        } }, value));
};
var ReportGrid = function (_React$Component) {
    _inherits(ReportGrid, _React$Component);

    function ReportGrid() {
        _classCallCheck(this, ReportGrid);

        return _possibleConstructorReturn(this, (ReportGrid.__proto__ || Object.getPrototypeOf(ReportGrid)).apply(this, arguments));
    }

    _createClass(ReportGrid, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var polyglot = this.props.polyglot;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_DataGrid_DataGrid__["a" /* DataGrid */], { initialData: this.props.items, className: styles.ReportTable }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGridTemplateColumn__["a" /* DataGridTemplateColumn */], { getValue: getTotal, headerBgColor: "#2f3c43", headerTextColor: "#FFF", header: polyglot.t('dashboard.summary_table.column_header.total'), render: function render(colProps) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Cell, Object.assign({}, colProps, _this2.props, { category: "Total" }));
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGridTemplateColumn__["a" /* DataGridTemplateColumn */], { getValue: getLive, headerBgColor: "#FFF", headerTextColor: "#2f3c43", header: polyglot.t('dashboard.summary_table.column_header.live'), render: function render(colProps) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Cell, Object.assign({}, colProps, _this2.props, { category: "Live" }));
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGridTemplateColumn__["a" /* DataGridTemplateColumn */], { getValue: getDead, headerBgColor: "#FFF", headerTextColor: "#2f3c43", header: polyglot.t('dashboard.summary_table.column_header.dead'), render: function render(colProps) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Cell, Object.assign({}, colProps, _this2.props, { category: "Dead" }));
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGridTemplateColumn__["a" /* DataGridTemplateColumn */], { getValue: getGreen, headerBgColor: "#92c740", headerTextColor: "#FFF", header: polyglot.t('dashboard.summary_table.column_header.green_zone'), render: function render(colProps) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Cell, Object.assign({}, colProps, _this2.props, { category: "Green", hideZero: true }));
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGridTemplateColumn__["a" /* DataGridTemplateColumn */], { getValue: getYellow, headerBgColor: "#ecab21", headerTextColor: "#fff", header: polyglot.t('dashboard.summary_table.column_header.yellow_zone'), render: function render(colProps) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Cell, Object.assign({}, colProps, _this2.props, { category: "Yellow", hideZero: true, className: styles.SeverityYellow }));
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGridTemplateColumn__["a" /* DataGridTemplateColumn */], { getValue: getRed, headerBgColor: "#bd2728", headerTextColor: "#fff", header: polyglot.t('dashboard.summary_table.column_header.red_zone'), render: function render(colProps) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Cell, Object.assign({}, colProps, _this2.props, { category: "Red", hideZero: true, className: styles.SeverityRed }));
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGridTemplateColumn__["a" /* DataGridTemplateColumn */], { getValue: getUndef, headerBgColor: "#bd2728", headerTextColor: "#fff", header: polyglot.t('dashboard.summary_table.column_header.no_levels'), render: function render(colProps) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Cell, Object.assign({}, colProps, _this2.props, { category: "VehiclesUndefinedAlertLevels", hideZero: true, className: styles.SeverityRed }));
                } }));
        }
    }]);

    return ReportGrid;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SensorsExcessesGrid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataGrid_DataGrid__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGridTextColumn__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTemplateColumn__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Buttons__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Columns_MultiselectColumn__ = __webpack_require__(122);






var helperStyles = __webpack_require__(186);
var tableStyles = __webpack_require__(73);
var styles = __webpack_require__(947);
var getDate = function getDate(se) {
    return se.date.toLocaleString();
};
var getVehicle = function getVehicle(se) {
    return se.VehicleName;
};
var getSensor = function getSensor(se) {
    return se.SensorName;
};
var getQuantity = function getQuantity(se) {
    return se.QuantityName;
};
var getValue = function getValue(se) {
    return se.Reading;
};
var getSeverityClass = function getSeverityClass(se) {
    return se.Severity === 'red' ? styles.SeverityRed : styles.SeverityYellow;
};
var getAssignee = function getAssignee(se) {
    return se.TakenByUserName;
};
var SensorsExcessesGrid = function SensorsExcessesGrid(props) {
    var items = props.items,
        onVehicle = props.onVehicle,
        onSensor = props.onSensor,
        onData = props.onData,
        onAssign = props.onAssign,
        polyglot = props.polyglot;

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_DataGrid_DataGrid__["a" /* DataGrid */], { initialData: items, className: tableStyles.StickyTable, onThead: props.onThead }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Columns_MultiselectColumn__["a" /* MultiselectColumn */], Object.assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Columns_MultiselectColumn__["b" /* multiselectPropsFrom */])(props), { datumKey: function datumKey(se) {
            return se.IncidentId;
        } })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGridTextColumn__["a" /* DataGridTextColumn */], { getValue: getDate, header: polyglot.t('dashboard.excess_table.column_header.time') }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTemplateColumn__["a" /* DataGridTemplateColumn */], { getValue: getVehicle, header: polyglot.t('dashboard.excess_table.column_header.vehicle'), render: function render(colProps) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Cell, Object.assign({ btnTitle: polyglot.t('dashboard.excess_table.buttons.vehicle'), btnType: 'black', handler: onVehicle, inProgress: colProps.datum.IncidentId === props.vehicleSearchInitiator }, colProps));
        } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTemplateColumn__["a" /* DataGridTemplateColumn */], { getValue: getSensor, header: polyglot.t('dashboard.excess_table.column_header.sensor'), render: function render(colProps) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Cell, Object.assign({ btnType: 'danger', btnTitle: polyglot.t('dashboard.excess_table.buttons.sensor'), handler: onSensor, inProgress: colProps.datum.IncidentId === props.sensorsSearchInitiator }, colProps));
        } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGridTextColumn__["a" /* DataGridTextColumn */], { getValue: getQuantity, header: polyglot.t('dashboard.excess_table.column_header.quantity') }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTemplateColumn__["a" /* DataGridTemplateColumn */], { getValue: getValue, header: polyglot.t('dashboard.excess_table.column_header.value'), render: function render(colProps) {
            var datum = colProps.datum,
                row = colProps.row;

            var excess = datum;
            var unitName = excess.UnitName;
            var inProgress = props.sensorsDataSearchInitiator === excess.IncidentId;
            var value = getValue(datum);
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styles.Cell }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: getSeverityClass(datum) }, unitName ? value + " " + unitName : value)), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Buttons__["a" /* Button */], { dim: "xs", type: "black", onClick: function onClick(e) {
                    return onData(datum, row);
                }, spinner: inProgress, disabled: inProgress }, polyglot.t('dashboard.excess_table.buttons.data'))));
        } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTemplateColumn__["a" /* DataGridTemplateColumn */], { header: polyglot.t('dashboard.excess_table.column_header.assignee'), render: function render(colProps) {
            var datum = colProps.datum,
                row = colProps.row;

            var assignee = getAssignee(datum);
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, assignee ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, assignee) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Buttons__["a" /* Button */], { type: "success", leftIcon: "pushpin", dim: "xs", onClick: function onClick(e) {
                    return onAssign(datum, row);
                } }, polyglot.t('dashboard.excess_table.buttons.iamonit')));
        } }));
};
var Cell = function Cell(props) {
    var datum = props.datum,
        row = props.row,
        getValue = props.getValue,
        handler = props.handler,
        btnTitle = props.btnTitle,
        inProgress = props.inProgress,
        btnType = props.btnType;

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styles.Cell }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, getValue(datum)), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Buttons__["a" /* Button */], { dim: "xs", type: btnType, leftIcon: "search", spinner: inProgress, disabled: inProgress, onClick: function onClick(e) {
            return handler(datum, row);
        } }, btnTitle)));
};

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditCreatePerson; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Forms_Groups__ = __webpack_require__(105);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var styles = __webpack_require__(948);
var EditCreatePerson = function (_React$Component) {
    _inherits(EditCreatePerson, _React$Component);

    function EditCreatePerson() {
        _classCallCheck(this, EditCreatePerson);

        return _possibleConstructorReturn(this, (EditCreatePerson.__proto__ || Object.getPrototypeOf(EditCreatePerson)).apply(this, arguments));
    }

    _createClass(EditCreatePerson, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                draft = _props.draft,
                setFirstName = _props.setFirstName,
                setLastName = _props.setLastName,
                setUserName = _props.setUserName,
                setAdminFlag = _props.setAdminFlag,
                setPassword = _props.setPassword,
                setPasswordConfirmation = _props.setPasswordConfirmation,
                polyglot = _props.polyglot;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("form-horizontal", styles.EditCreatePerson) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Forms_Groups__["c" /* InputTextGroup */], { readOnly: true, title: polyglot.t('person.label_division') + ':', value: draft.DivisionReg }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Forms_Groups__["c" /* InputTextGroup */], { readOnly: true, title: polyglot.t('person.label_first_name') + ':', value: draft.Firstname, onChange: function onChange(e) {
                    return setFirstName(e.target.value);
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Forms_Groups__["c" /* InputTextGroup */], { readOnly: true, title: polyglot.t('person.label_last_name') + ':', value: draft.Lastname, onChange: function onChange(e) {
                    return setLastName(e.target.value);
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Forms_Groups__["c" /* InputTextGroup */], { readOnly: true, title: polyglot.t('person.label_username') + ':', value: draft.Username, onChange: function onChange(e) {
                    return setUserName(e.target.value);
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Forms_Groups__["e" /* CheckboxGroup */], { readOnly: true, title: polyglot.t('person.label_is_administrator'), checked: draft.IsAdministrator, onChange: function onChange(e) {
                    return setAdminFlag(e.target.checked);
                }, disabled: true }));
        }
    }, {
        key: "getValue",
        value: function getValue() {
            return Object.assign({}, this.props.draft);
        }
    }]);

    return EditCreatePerson;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditCreatePersonStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_draft__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditCreate_EditStore__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditCreatePersonActions__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_nameof__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_EditCreateEntityActions__ = __webpack_require__(33);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var EditCreatePersonStore = function (_EditStore) {
    _inherits(EditCreatePersonStore, _EditStore);

    function EditCreatePersonStore() {
        _classCallCheck(this, EditCreatePersonStore);

        var _this = _possibleConstructorReturn(this, (EditCreatePersonStore.__proto__ || Object.getPrototypeOf(EditCreatePersonStore)).call(this));

        _this.setFirstName = function (firstName) {
            assertString(firstName, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_nameof__["a" /* nameof */])({ firstName: firstName }));
            return _this.draft({ Firstname: firstName });
        };
        _this.setLastName = function (lastName) {
            assertString(lastName, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_nameof__["a" /* nameof */])({ lastName: lastName }));
            return _this.draft({ Lastname: lastName });
        };
        _this.setUserName = function (userName) {
            assertString(userName, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_nameof__["a" /* nameof */])({ userName: userName }));
            return _this.draft({ Username: userName });
        };
        _this.setAdminFlag = function (isAdmin) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["h" /* assertBoolean */])(isAdmin, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_nameof__["a" /* nameof */])({ isAdmin: isAdmin }) + " has to be a boolean value");
            return _this.draft({ IsAdministrator: isAdmin });
        };
        _this.setPassword = function (password) {
            assertString(password, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_nameof__["a" /* nameof */])({ password: password }));
            return _this.draft({ Password: password });
        };
        _this.setPasswordConfirmation = function (passwordConfirmation) {
            assertString(passwordConfirmation, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_nameof__["a" /* nameof */])({ passwordConfirmation: passwordConfirmation }));
            return _this.draft({ PasswordConfirmation: passwordConfirmation });
        };
        _this.register(__WEBPACK_IMPORTED_MODULE_4__EditCreatePersonActions__["b" /* names */].SET_DIVISION, function (e) {
            return _this.draft({ DivisionRegId: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_4__EditCreatePersonActions__["b" /* names */].SET_DIVISION_ITEMS, function (e) {
            return _this.field({ divisions: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_4__EditCreatePersonActions__["b" /* names */].SET_FIRST_NAME, function (e) {
            return _this.setFirstName(e.payload);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_4__EditCreatePersonActions__["b" /* names */].SET_LAST_NAME, function (e) {
            return _this.setLastName(e.payload);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_4__EditCreatePersonActions__["b" /* names */].SET_USER_NAME, function (e) {
            return _this.setUserName(e.payload);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_4__EditCreatePersonActions__["b" /* names */].SET_ADMIN_FLAG, function (e) {
            return _this.setAdminFlag(e.payload);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_4__EditCreatePersonActions__["b" /* names */].SET_PASSWORD, function (e) {
            return _this.setPassword(e.payload);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_4__EditCreatePersonActions__["b" /* names */].SET_PASSWORD_CONFIRMATION, function (e) {
            return _this.setPasswordConfirmation(e.payload);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_6__actions_EditCreateEntityActions__["b" /* names */].REJECT_DRAFT, function (e) {
            if (e.meta === __WEBPACK_IMPORTED_MODULE_1__models__["a" /* EntityType */].Person) return _this.getDefaultStateFor(null);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_6__actions_EditCreateEntityActions__["b" /* names */].SET_EDIT_ENTITY, function (e) {
            if (e.meta === __WEBPACK_IMPORTED_MODULE_1__models__["a" /* EntityType */].Person) return _this.getDefaultStateFor(e.payload);
        });
        return _this;
    }

    _createClass(EditCreatePersonStore, [{
        key: "getDefaultStateFor",
        value: function getDefaultStateFor(person) {
            return {
                draft: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_draft__["c" /* perparePersonDraft */])(person),
                divisions: []
            };
        }
    }]);

    return EditCreatePersonStore;
}(__WEBPACK_IMPORTED_MODULE_3__EditCreate_EditStore__["a" /* EditStore */]);
function assertString(value, paramName) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" /* assertTrue */])(typeof value === 'string', paramName + " has to be non null string");
    return value;
}

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PersonGrid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataGrid_DataGrid__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGridFlagValueColumn__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTextColumn__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataGrid_DataGridTemplateColumn__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Columns_IdColumn__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Columns_MultiselectColumn__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Buttons__ = __webpack_require__(21);








var getterFirstName = function getterFirstName(p) {
    return p.Firstname;
};
var getterLastName = function getterLastName(p) {
    return p.Lastname;
};
var getterUserName = function getterUserName(p) {
    return p.Username;
};
var getterAdmin = function getterAdmin(p) {
    return p.IsAdministrator;
};
var PersonGrid = function PersonGrid(props) {
    var _props$items = props.items,
        items = _props$items === undefined ? [] : _props$items,
        isAdmin = props.isAdmin,
        onEdit = props.onEdit,
        polyglot = props.polyglot;

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_DataGrid_DataGrid__["a" /* DataGrid */], { initialData: items, className: props.className, onThead: props.onThead }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Columns_MultiselectColumn__["a" /* MultiselectColumn */], Object.assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__Columns_MultiselectColumn__["b" /* multiselectPropsFrom */])(props))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Columns_IdColumn__["a" /* IdColumn */], { header: polyglot.t('column.id') }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTextColumn__["a" /* DataGridTextColumn */], { header: polyglot.t('person.label_first_name'), getValue: getterFirstName }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTextColumn__["a" /* DataGridTextColumn */], { header: polyglot.t('person.label_last_name'), getValue: getterLastName }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTextColumn__["a" /* DataGridTextColumn */], { header: polyglot.t('person.label_username'), getValue: getterUserName }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGridFlagValueColumn__["a" /* DataGridFlagValueColumn */], { getValue: getterAdmin, header: polyglot.t('person.label_level'), trueTitle: polyglot.t('person.label_level_administrator'), falseTitle: polyglot.t('person.label_level_user') }), isAdmin && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_DataGrid_DataGridTemplateColumn__["a" /* DataGridTemplateColumn */], { header: props.polyglot.t('column.action'), render: function render(p) {
            var datum = p.datum,
                row = p.row;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: 'btn-toolbar' }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_Buttons__["a" /* Button */], { dim: "xs", leftIcon: "eye-open", type: "info", onClick: function onClick(e) {
                    return props.onEdit(datum, row);
                } }, props.polyglot.t('button.view')));
        } }));
};

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PersonRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Container__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PersonGrid__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EditCreatePersonActions__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EditCreate_EditCreateEntityRoute__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EditCreatePerson__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_EditCreateEntityActions__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flux_Grid__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Toolbar__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__flux_Error_ErrorActions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_configure_store__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Table_NoResults__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Table_TableTitle__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Search_GenericSearchWidget__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_StickyMediator__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__TrashButtonWidget__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DeleteConfirmationWidget__ = __webpack_require__(104);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var appStyles = __webpack_require__(64);
var tableStyles = __webpack_require__(73);
var PersonRoute = function (_React$Component) {
    _inherits(PersonRoute, _React$Component);

    function PersonRoute() {
        _classCallCheck(this, PersonRoute);

        var _this = _possibleConstructorReturn(this, (PersonRoute.__proto__ || Object.getPrototypeOf(PersonRoute)).apply(this, arguments));

        _this.errorActions = new __WEBPACK_IMPORTED_MODULE_11__flux_Error_ErrorActions__["a" /* ErrorActions */]();
        _this.editActions = new __WEBPACK_IMPORTED_MODULE_5__EditCreatePersonActions__["a" /* EditCreatePersonActions */]();
        _this.editCreateEntityActions = new __WEBPACK_IMPORTED_MODULE_8__actions_EditCreateEntityActions__["a" /* EditCreateEntityActions */]();
        _this.selectedItemsActions = new __WEBPACK_IMPORTED_MODULE_9__flux_Grid__["b" /* SelectedItemsActions */]();
        _this.stickyMediator = new __WEBPACK_IMPORTED_MODULE_16__utils_StickyMediator__["a" /* StickyMediator */]();
        return _this;
    }

    _createClass(PersonRoute, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.props.refresher.run();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                isAdmin = _props.isAdmin,
                polyglot = _props.polyglot;

            var createForm = function createForm(_ref) {
                var title = _ref.title,
                    okTitle = _ref.okTitle,
                    path = _ref.path;
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Container__["a" /* Container */], { merge: true, stores: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_configure_store__["b" /* twoButtonDialogConfig */])(_this2.props.upsertInProgressStore, _this2.props.upsertErrorStore) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__EditCreate_EditCreateEntityRoute__["a" /* EditCreateEntityRoute */], { title: title, okTitle: okTitle, path: path, renderEdit: function renderEdit() {
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Container__["a" /* Container */], { merge: true, stores: [_this2.props.editStore, [_this2.props.divisionsLoadInProgress, function (store) {
                                return { loadingDivisions: store.isSet() };
                            }]], actions: _this2.editActions, onMount: _this2.props.initUpsertCommand.execute }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__EditCreatePerson__["a" /* EditCreatePerson */], { polyglot: polyglot, loadingDivisions: false }));
                    }, cancel: function cancel() {}, ok: function ok() {
                        __WEBPACK_IMPORTED_MODULE_2__routes__["b" /* appNavigator */].goToEntityTab(entityType);
                        _this2.editCreateEntityActions.rejectDraft(entityType);
                    } }));
            };
            var entityType = __WEBPACK_IMPORTED_MODULE_4__models__["a" /* EntityType */].Person;
            var disableInject = {
                disabled: function disabled() {
                    return _this2.props.selectedItemsStore.getState().selected.size === 0;
                }
            };
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, isAdmin && createForm({ title: polyglot.t('person.create_title'), okTitle: polyglot.t('button.close'), path: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__routes__["h" /* addNewRouteFor */])(entityType) }), isAdmin && createForm({ title: polyglot.t('person.edit_title'), okTitle: polyglot.t('button.close'), path: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__routes__["i" /* editRouteFor */])(entityType) }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__DeleteConfirmationWidget__["a" /* DeleteConfirmationWidget */], Object.assign({}, this.props, { entityType: entityType, title: polyglot.t('person.del_confirmation_title') }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: appStyles.ConfirmationContainer }, polyglot.t('person.del_confirmation_msg'))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__Search_GenericSearchWidget__["a" /* GenericSearchWidget */], Object.assign({}, this.props)), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: appStyles.StickyControlPanel, ref: this.stickyMediator.onToolbox }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Toolbar__["a" /* Toolbar */], null, isAdmin && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__TrashButtonWidget__["a" /* TrashButtonWidget */], Object.assign({ entityType: __WEBPACK_IMPORTED_MODULE_4__models__["a" /* EntityType */].Person }, this.props))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Table_TableTitle__["a" /* TableTitle */], { polyglot: polyglot, labelStore: this.props.tableTitleStore })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Container__["a" /* Container */], { merge: true, stores: [this.props.listStore, this.props.selectedItemsStore] }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__PersonGrid__["a" /* PersonGrid */], { className: tableStyles.StickyTable, isAdmin: isAdmin, polyglot: polyglot, selected: null, allSelected: null, onEdit: function onEdit(datum, row) {
                    _this2.editCreateEntityActions.setEntityToEdit(datum, entityType);
                    _this2.errorActions.clearError(_this2.props.upsertErrorStore.dispatchToken);
                    __WEBPACK_IMPORTED_MODULE_2__routes__["b" /* appNavigator */].goToEditEntityTab(entityType);
                }, toggle: function toggle(datum, row) {
                    return _this2.selectedItemsActions.toggleItem(datum.id, entityType);
                }, toggleAll: function toggleAll() {
                    return _this2.selectedItemsActions.toggleAll(entityType);
                }, onThead: this.stickyMediator.onThead })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Table_NoResults__["a" /* NoResults */], { polyglot: polyglot, listStore: this.props.listStore })));
        }
    }]);

    return PersonRoute;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InitUpsertPersonCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Error__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Flag__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditCreatePersonActions__ = __webpack_require__(215);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var InitUpsertPersonCommand = function InitUpsertPersonCommand(runSearch, store, getDidivionId, inProgressDispatchToken, errorDispatchToken) {
    var _this = this;

    _classCallCheck(this, InitUpsertPersonCommand);

    this.runSearch = runSearch;
    this.store = store;
    this.getDidivionId = getDidivionId;
    this.inProgressDispatchToken = inProgressDispatchToken;
    this.errorDispatchToken = errorDispatchToken;
    this.editActions = new __WEBPACK_IMPORTED_MODULE_2__EditCreatePersonActions__["a" /* EditCreatePersonActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_0__flux_Error__["a" /* ErrorActions */]();
    this.inProgressActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Flag__["a" /* FlagActions */]();
    this.execute = function () {
        _this.errorActions.clearError(_this.errorDispatchToken); // reset error from previous edit session
        _this.inProgressActions.set(_this.inProgressDispatchToken);
        _this.runSearch({ Name: 'Divisions' }).then(function (res) {
            var divisions = res.Entries.Division;

            var _store$getState$draft = _this.store.getState().draft,
                DivisionRegId = _store$getState$draft.DivisionRegId,
                id = _store$getState$draft.id;

            if (DivisionRegId == null && id == null) {
                var currDivisionId = _this.getDidivionId();
                var division = divisions.find(function (d) {
                    return d.id === currDivisionId;
                });
                if (division) {
                    _this.editActions.setDivision(division.id);
                }
            }
            _this.editActions.setDivisionItems(divisions);
        }).catch(function (err) {
            return _this.errorActions.setError(err, _this.errorDispatchToken);
        }).then(function () {
            return _this.inProgressActions.reset(_this.inProgressDispatchToken);
        }); // finaly
    };
};

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpsertPersonCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Flag_FlagActions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Error_ErrorActions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Grid_ListActions__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(7);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var UpsertPersonCommand = function UpsertPersonCommand(polyglot, commit, listDispatchToken, inProgressDispatchToken, errorDispatchToken) {
    var _this = this;

    _classCallCheck(this, UpsertPersonCommand);

    this.polyglot = polyglot;
    this.commit = commit;
    this.listDispatchToken = listDispatchToken;
    this.inProgressDispatchToken = inProgressDispatchToken;
    this.errorDispatchToken = errorDispatchToken;
    this.inProgressActions = new __WEBPACK_IMPORTED_MODULE_0__flux_Flag_FlagActions__["a" /* FlagActions */]();
    this.listActions = new __WEBPACK_IMPORTED_MODULE_2__flux_Grid_ListActions__["a" /* ListActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Error_ErrorActions__["a" /* ErrorActions */]();
    this.execute = function (draft) {
        if (!draft) throw new Error('Program error. draft has to have value');
        var DivisionRegId = draft.DivisionRegId,
            Firstname = draft.Firstname,
            Username = draft.Username,
            Password = draft.Password,
            PasswordConfirmation = draft.PasswordConfirmation;

        var setError = function setError(msg) {
            return _this.errorActions.setError(new Error(msg), _this.errorDispatchToken);
        };
        if (typeof DivisionRegId !== 'number') {
            setError(_this.polyglot.t('person.validation_err.division_not_set'));
            return;
        }
        if (typeof Firstname !== 'string' || Firstname === '') {
            setError(_this.polyglot.t('person.validation_err.empty_first_name'));
            return;
        }
        if (typeof Username !== 'string' || Username === '') {
            setError(_this.polyglot.t('person.validation_err.empty_username'));
            return;
        }
        if (Password !== PasswordConfirmation) {
            setError(_this.polyglot.t('person.validation_err.password_mismatch'));
            return;
        }
        delete draft.PasswordConfirmation;
        if (Password === '') {
            delete draft.Password;
        }
        var entityType = __WEBPACK_IMPORTED_MODULE_3__models__["a" /* EntityType */].Person;
        _this.inProgressActions.set(_this.inProgressDispatchToken);
        _this.commit({ type: entityType, entity: draft }).then(function (res) {
            if (res.Success) return res[__WEBPACK_IMPORTED_MODULE_3__models__["a" /* EntityType */][entityType]];
            throw new Error(res.ErrorMessage);
        }).then(function (entity) {
            _this.listActions.upsertItems([entity], entityType);
            __WEBPACK_IMPORTED_MODULE_4__routes__["b" /* appNavigator */].goToPersonTab();
        }).catch(function (err) {
            return _this.errorActions.setError(err, _this.errorDispatchToken);
        }).then(function () {
            return _this.inProgressActions.reset(_this.inProgressDispatchToken);
        }); // finaly
    };
};

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GenericSearch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Search_Search__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Buttons__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Search_SearchTextField__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_index__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ErrorMessage_index__ = __webpack_require__(162);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var styles = __webpack_require__(949);
var helperStyles = __webpack_require__(186);
var GenericSearch = function (_SearchForm) {
    _inherits(GenericSearch, _SearchForm);

    function GenericSearch() {
        _classCallCheck(this, GenericSearch);

        return _possibleConstructorReturn(this, (GenericSearch.__proto__ || Object.getPrototypeOf(GenericSearch)).apply(this, arguments));
    }

    _createClass(GenericSearch, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                searchParams = _props.searchParams,
                searchInProgress = _props.searchInProgress,
                errorMessage = _props.errorMessage;
            var _searchParams$UserInp = searchParams.UserInput,
                UserInput = _searchParams$UserInp === undefined ? '' : _searchParams$UserInp;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("form", { className: 'form-inline', onSubmit: this.onSubmit.bind(this), onChange: this.onChange.bind(this) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Search_SearchTextField__["a" /* SearchTextField */], { title: this.props.polyglot.t('search.title') + ':', value: UserInput, ref: function ref(e) {
                    return _this2.refUserInput = e;
                }, className: styles.UserInput }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_Buttons__["a" /* Button */], { disabled: searchInProgress, leftIcon: "search" }, this.props.polyglot.t('button.find')), searchInProgress && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Spinner_index__["a" /* Spinner */], { className: helperStyles.MarginLeft }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_ErrorMessage_index__["a" /* ErrorMessage */], { errorMessage: errorMessage, className: helperStyles.MarginLeft }));
        }
    }, {
        key: 'getValue',
        value: function getValue() {
            return {
                UserInput: this.refUserInput.getValue()
            };
        }
    }]);

    return GenericSearch;
}(__WEBPACK_IMPORTED_MODULE_1__Search_Search__["a" /* SearchForm */]);

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var SearchForm = function (_React$Component) {
    _inherits(SearchForm, _React$Component);

    function SearchForm() {
        _classCallCheck(this, SearchForm);

        return _possibleConstructorReturn(this, (SearchForm.__proto__ || Object.getPrototypeOf(SearchForm)).apply(this, arguments));
    }

    _createClass(SearchForm, [{
        key: "onSubmit",
        value: function onSubmit(e) {
            e.preventDefault();
            var onSearch = this.props.onSearch;

            if (onSearch) {
                onSearch(this);
            }
        }
    }, {
        key: "onChange",
        value: function onChange() {
            var onChange = this.props.onChange;

            if (onChange) {
                onChange(this);
            }
        }
    }]);

    return SearchForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchTextField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var SearchTextField = function (_React$Component) {
    _inherits(SearchTextField, _React$Component);

    function SearchTextField() {
        _classCallCheck(this, SearchTextField);

        return _possibleConstructorReturn(this, (SearchTextField.__proto__ || Object.getPrototypeOf(SearchTextField)).apply(this, arguments));
    }

    _createClass(SearchTextField, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                title = _props.title,
                value = _props.value,
                className = _props.className;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('form-group', className) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", null, title), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "text", className: 'form-control', ref: function ref(e) {
                    return _this2.inputRef = e;
                }, value: value, onChange: function onChange(e) {} }));
        }
    }, {
        key: "getValue",
        value: function getValue() {
            return this.inputRef.value;
        }
    }]);

    return SearchTextField;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchFormStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Actions__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Store__ = __webpack_require__(22);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var SearchFormStore = function (_Store) {
    _inherits(SearchFormStore, _Store);

    function SearchFormStore() {
        _classCallCheck(this, SearchFormStore);

        var _this = _possibleConstructorReturn(this, (SearchFormStore.__proto__ || Object.getPrototypeOf(SearchFormStore)).call(this));

        _this.state = {};
        _this.register(__WEBPACK_IMPORTED_MODULE_0__Actions__["b" /* names */].SEARCH_PARAMS_UPDATED, function (e) {
            if (e.meta === _this.dispatchToken) {
                return Object.assign({}, e.payload);
            }
        });
        return _this;
    }

    return SearchFormStore;
}(__WEBPACK_IMPORTED_MODULE_1__flux_Store__["a" /* Store */]);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NativeSensorSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TypeaheadEnterEscWrapper__ = __webpack_require__(76);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var getNativeSensorDisplay = function getNativeSensorDisplay(s) {
    return s.Name;
};
var NativeSensorSelector = function (_React$Component) {
    _inherits(NativeSensorSelector, _React$Component);

    function NativeSensorSelector() {
        _classCallCheck(this, NativeSensorSelector);

        return _possibleConstructorReturn(this, (NativeSensorSelector.__proto__ || Object.getPrototypeOf(NativeSensorSelector)).apply(this, arguments));
    }

    _createClass(NativeSensorSelector, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                polyglot = _props.polyglot,
                nativeSensorId = _props.nativeSensorId,
                nativeSensors = _props.nativeSensors,
                setNativeSensor = _props.setNativeSensor;

            var geotab = nativeSensors.find(function (item) {
                return item.Id === nativeSensorId;
            });
            var selectedGeotab = geotab ? [geotab] : [];
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__TypeaheadEnterEscWrapper__["a" /* TypeaheadEnterEscWrapper */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["Typeahead"], { ref: function ref(e) {
                    return _this2.typeahead = e;
                }, disabled: this.props.disabled, placeholder: polyglot.t('sensor.placeholder_sensor'), labelKey: getNativeSensorDisplay, options: nativeSensors, selected: selectedGeotab, onChange: function onChange(values) {
                    return setNativeSensor(values[0]);
                } }));
        }
    }]);

    return NativeSensorSelector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuantitySelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Select__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__converters_converters__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_assert_index__ = __webpack_require__(5);




var getDisplay = function getDisplay(quantity) {
        return quantity.Name;
};
var getKey = function getKey(quantity) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__converters_converters__["a" /* intToString */])(quantity.Id);
};
var QuantitySelector = function QuantitySelector(props) {
        var quantityId = props.quantityId,
            quantities = props.quantities;

        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_Select__["a" /* Select */], { className: 'form-control', disabled: props.disabled, placeholder: '---', items: quantities, defaultValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__converters_converters__["a" /* intToString */])(quantityId), valueFn: getKey, titleFn: getDisplay, onChange: function onChange(s) {
                        var quantities = props.quantities,
                            setQuantity = props.setQuantity;

                        var quantityId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__converters_converters__["b" /* stringToInt */])(s.getValue());
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_assert_index__["f" /* assertNumber */])(quantityId, 'quantityId has to be a number');
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_assert_index__["a" /* assertTrue */])(quantities.length > 0, 'at this point quantities have to be loaded');
                        var quantity = quantities.find(function (item) {
                                return item.Id === quantityId;
                        });
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_assert_index__["a" /* assertTrue */])(quantity != null, "quantity with id " + quantityId + " is not present in loaded values");
                        setQuantity(quantityId, quantity.Units[0]);
                } });
};

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VehicleSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_draft_Vehicle__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TypeaheadEnterEscWrapper__ = __webpack_require__(76);




var VehicleSelector = function VehicleSelector(props) {
    var polyglot = props.polyglot,
        vehicleId = props.vehicleId,
        vehicles = props.vehicles,
        setVehicle = props.setVehicle;

    var vehicle = vehicles.find(function (item) {
        return item.id === vehicleId;
    });
    var selectedVehicle = vehicle ? [vehicle] : [];
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__TypeaheadEnterEscWrapper__["a" /* TypeaheadEnterEscWrapper */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["Typeahead"], { placeholder: polyglot.t('sensor.placeholder_vehicle'), labelKey: __WEBPACK_IMPORTED_MODULE_2__utils_draft_Vehicle__["a" /* getVehicleDisplay */], options: vehicles, selected: selectedVehicle, onChange: function onChange(values) {
            var id = values && values.length > 0 ? values[0].id : null;
            setVehicle(id);
        } }));
};

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewSensor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__converters_converters__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditCreateSensor_QuantitySelector__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditCreateSensor_VehicleSelector__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EditCreateSensor_NativeSensorSelector__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Forms_Groups__ = __webpack_require__(105);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var styles = __webpack_require__(950);
var NewSensor = function (_React$Component) {
    _inherits(NewSensor, _React$Component);

    function NewSensor() {
        _classCallCheck(this, NewSensor);

        var _this = _possibleConstructorReturn(this, (NewSensor.__proto__ || Object.getPrototypeOf(NewSensor)).apply(this, arguments));

        _this.getServiceAccountValue = function (account) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__converters_converters__["a" /* intToString */])(account.id);
        };
        _this.getServiceAccoutDisplay = function (account) {
            return account.Username;
        };
        _this.getVehicleValue = function (v) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__converters_converters__["a" /* intToString */])(v.id);
        };
        _this.getPairValue = function (pair) {
            return pair.Id;
        };
        return _this;
    }

    _createClass(NewSensor, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                polyglot = _props.polyglot,
                draft = _props.draft,
                vehicles = _props.vehicles,
                geotabSensors = _props.geotabSensors,
                quantities = _props.quantities,
                units = _props.units;

            var geotab = geotabSensors ? geotabSensors.find(function (item) {
                return item.Id === draft.GeotabId;
            }) : undefined;
            var selectedGeotab = geotab ? [geotab] : [];
            var quantity = quantities.find(function (item) {
                return item.Id === draft.QuantityId;
            });
            var isRelative = quantity && quantity.RelativeLevels;
            var unit = units.find(function (item) {
                return item.Id === draft.UnitId;
            });
            var unitName = unit ? unit.Name : "";
            var CanOnlyEditLevels = draft.CanOnlyEditLevels;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("form-horizontal", styles.NewSensor) }, CanOnlyEditLevels && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Forms_Groups__["a" /* LabelGroup */], { title: polyglot.t('sensor.label_vehicle') + ':', value: draft.Vehicle }), !CanOnlyEditLevels && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Forms_Groups__["b" /* LoadableGroup */], { title: polyglot.t('sensor.label_vehicle') + ':', value: draft.Vehicle, isLoading: this.props.loadingVehicles }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__EditCreateSensor_VehicleSelector__["a" /* VehicleSelector */], { polyglot: polyglot, vehicleId: draft.VehicleId, vehicles: vehicles, setVehicle: this.props.setVehicleCmd.execute })), CanOnlyEditLevels && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Forms_Groups__["a" /* LabelGroup */], { title: polyglot.t('sensor.label_sensor') + ':', value: draft.GeotabTitle }), !CanOnlyEditLevels && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Forms_Groups__["b" /* LoadableGroup */], { title: polyglot.t('sensor.label_sensor') + ':', value: draft.GeotabTitle, isLoading: this.props.loadingGeotabSensors }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__EditCreateSensor_NativeSensorSelector__["a" /* NativeSensorSelector */], { polyglot: polyglot, disabled: this.props.draft.VehicleId == null, nativeSensorId: draft.GeotabId, nativeSensors: geotabSensors, setNativeSensor: this.props.setGeotabSensorCmd.execute })), CanOnlyEditLevels && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Forms_Groups__["a" /* LabelGroup */], { title: polyglot.t('sensor.label_display') + ':', value: draft.Display }), !CanOnlyEditLevels && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Forms_Groups__["c" /* InputTextGroup */], { title: polyglot.t('sensor.label_display') + ':', value: draft.Display, onChange: function onChange(e) {
                    return _this2.props.setDisplay(e.target.value);
                } }), CanOnlyEditLevels && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Forms_Groups__["a" /* LabelGroup */], { title: polyglot.t('sensor.label_quantity') + ':', value: getQuantityName(quantities, draft.QuantityId) }), !CanOnlyEditLevels && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Forms_Groups__["b" /* LoadableGroup */], { title: polyglot.t('sensor.label_quantity') + ':', value: getQuantityName(quantities, draft.QuantityId), isLoading: this.props.loadingQuantities }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__EditCreateSensor_QuantitySelector__["a" /* QuantitySelector */], { disabled: this.props.draft.GeotabId == null, quantities: quantities, quantityId: draft.QuantityId, setQuantity: this.props.setQuantity })), isRelative && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Forms_Groups__["d" /* LevelGroup */], { title: polyglot.t('levels.baseline') + ':', unitName: unitName, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__converters_converters__["a" /* intToString */])(draft.Baseline, true), onChange: function onChange(e) {
                    return _this2.props.setBaseline(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__converters_converters__["b" /* stringToInt */])(e.target.value, true));
                } }), !isRelative && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'form-group', style: { height: 34 } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Forms_Groups__["d" /* LevelGroup */], { title: polyglot.t('levels.red_max') + ':', unitName: isRelative ? '+%' : unitName, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__converters_converters__["a" /* intToString */])(isRelative ? draft.RelLevelMaximumRed : draft.AbsLevelMaximumRed, true), onChange: function onChange(e) {
                    var _props2 = _this2.props,
                        setRelRedMax = _props2.setRelRedMax,
                        setAbsRedMax = _props2.setAbsRedMax;

                    var handler = isRelative ? setRelRedMax : setAbsRedMax;
                    handler(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__converters_converters__["b" /* stringToInt */])(e.target.value, true));
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Forms_Groups__["d" /* LevelGroup */], { title: polyglot.t('levels.yellow_max') + ':', unitName: isRelative ? '+%' : unitName, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__converters_converters__["a" /* intToString */])(isRelative ? draft.RelLevelMaximumYellow : draft.AbsLevelMaximumYellow, true), onChange: function onChange(e) {
                    var _props3 = _this2.props,
                        setAbsYellowMax = _props3.setAbsYellowMax,
                        setRelYellowMax = _props3.setRelYellowMax;

                    var handler = isRelative ? setRelYellowMax : setAbsYellowMax;
                    handler(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__converters_converters__["b" /* stringToInt */])(e.target.value, true));
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Forms_Groups__["d" /* LevelGroup */], { title: polyglot.t('levels.yellow_min') + ':', unitName: isRelative ? '-%' : unitName, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__converters_converters__["a" /* intToString */])(isRelative ? draft.RelLevelMinimumYellow : draft.AbsLevelMinimumYellow, true), onChange: function onChange(e) {
                    var _props4 = _this2.props,
                        setAbsYellowMin = _props4.setAbsYellowMin,
                        setRelYellowMin = _props4.setRelYellowMin;

                    var handler = isRelative ? setRelYellowMin : setAbsYellowMin;
                    handler(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__converters_converters__["b" /* stringToInt */])(e.target.value, true));
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Forms_Groups__["d" /* LevelGroup */], { title: polyglot.t('levels.red_min') + ':', unitName: isRelative ? '-%' : unitName, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__converters_converters__["a" /* intToString */])(isRelative ? draft.RelLevelMinimumRed : draft.AbsLevelMinimumRed, true), onChange: function onChange(e) {
                    var _props5 = _this2.props,
                        setAbsRedMin = _props5.setAbsRedMin,
                        setRelRedMin = _props5.setRelRedMin;

                    var handler = isRelative ? setRelRedMin : setAbsRedMin;
                    handler(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__converters_converters__["b" /* stringToInt */])(e.target.value, true));
                } }));
        }
    }, {
        key: 'getValue',
        value: function getValue() {
            return Object.assign({}, this.props.draft);
        }
    }]);

    return NewSensor;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
var getQuantityName = function getQuantityName(quantities, id) {
    var quantity = quantities.find(function (q) {
        return q.Id === id;
    });
    return quantity ? quantity.Name : '';
};

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SensorGrid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataGrid_DataGrid__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGridTemplateColumn__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTextColumn__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Columns_DataGridButtonColumn__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Buttons__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Columns_IdColumn__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Columns_MultiselectColumn__ = __webpack_require__(122);








var styles = __webpack_require__(951);
var getterVehicle = function getterVehicle(s) {
    return s.Vehicle;
};
var getterGeotab = function getterGeotab(s) {
    return s.GeotabTitle;
};
var getterDisplay = function getterDisplay(s) {
    return s.Display;
};
var getterLifetime = function getterLifetime(s) {
    return s.Lifetime;
};
var VehicleCell = function VehicleCell(props) {
    var polyglot = props.polyglot,
        datum = props.datum,
        row = props.row,
        getValue = props.getValue,
        onClone = props.onClone,
        isAdmin = props.isAdmin,
        inProgress = props.inProgress;

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: styles.VehicleCell }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, getValue(datum)), isAdmin && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_Buttons__["a" /* Button */], { dim: "xs", leftIcon: "duplicate", type: "info", onClick: function onClick(e) {
            return onClone(datum, row);
        } }, polyglot.t('button.clone')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_Buttons__["a" /* Button */], { dim: "xs", type: "info", leftIcon: "search", spinner: inProgress, disabled: inProgress, onClick: function onClick(e) {
            return props.onVehicle(datum, row);
        } }, polyglot.t('sensor.label_vehicle')));
};
var SensorGrid = function SensorGrid(props) {
    var polyglot = props.polyglot;

    var withUnit = function withUnit(value, s) {
        return value ? value + ' ' + s.UnitName : value;
    };
    var withFrac = function withFrac(value) {
        return value ? value + ' %' : value;
    };
    var getterBaseline = function getterBaseline(s) {
        return withUnit(s.Baseline, s);
    };
    var getterRedMax = function getterRedMax(s) {
        return withUnit(s.AbsLevelMaximumRed, s) || withFrac(s.RelLevelMaximumRed);
    };
    var getterYellowMax = function getterYellowMax(s) {
        return withUnit(s.AbsLevelMaximumYellow, s) || withFrac(s.RelLevelMaximumYellow);
    };
    var getterYellowMin = function getterYellowMin(s) {
        return withUnit(s.AbsLevelMinimumYellow, s) || withFrac(s.RelLevelMinimumYellow);
    };
    var getterRedMin = function getterRedMin(s) {
        return withUnit(s.AbsLevelMinimumRed, s) || withFrac(s.RelLevelMinimumRed);
    };
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_DataGrid_DataGrid__["a" /* DataGrid */], { initialData: props.items || [], className: props.className, onThead: props.onThead }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Columns_MultiselectColumn__["a" /* MultiselectColumn */], Object.assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__Columns_MultiselectColumn__["b" /* multiselectPropsFrom */])(props))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Columns_IdColumn__["a" /* IdColumn */], { header: polyglot.t('column.id') }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGridTemplateColumn__["a" /* DataGridTemplateColumn */], { header: polyglot.t('sensor.label_vehicle'), getValue: getterVehicle, render: function render(colProps) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](VehicleCell, Object.assign({ polyglot: polyglot, isAdmin: props.isAdmin, onClone: props.onClone, onVehicle: props.onVehicle, inProgress: props.vehicleSearchInitiator === colProps.datum.id }, colProps));
        } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTextColumn__["a" /* DataGridTextColumn */], { header: polyglot.t('sensor.label_native_title'), getValue: getterGeotab }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTextColumn__["a" /* DataGridTextColumn */], { header: polyglot.t('levels.baseline'), getValue: getterBaseline }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTextColumn__["a" /* DataGridTextColumn */], { header: polyglot.t('levels.red_max'), getValue: getterRedMax }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTextColumn__["a" /* DataGridTextColumn */], { header: polyglot.t('levels.yellow_max'), getValue: getterYellowMax }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTextColumn__["a" /* DataGridTextColumn */], { header: polyglot.t('levels.yellow_min'), getValue: getterYellowMin }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTextColumn__["a" /* DataGridTextColumn */], { header: polyglot.t('levels.red_min'), getValue: getterRedMin }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTextColumn__["a" /* DataGridTextColumn */], { header: polyglot.t('sensor.label_display'), getValue: getterDisplay }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTextColumn__["a" /* DataGridTextColumn */], { header: polyglot.t('sensor.label_lifetime'), getValue: getterLifetime }), props.isAdmin && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Columns_DataGridButtonColumn__["a" /* DataGridButtonColumn */], { header: polyglot.t('column.action'), title: polyglot.t('button.edit_short'), onClick: props.onEdit }));
};

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SensorGrid__ = __webpack_require__(533);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SensorGrid__["a"]; });


/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SensorTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Container__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditCreate_EditCreateEntityRoute__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flux__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NewSensor__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SensorGrid__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Buttons__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DateRange__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DateRangeStore__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Dialogs_OneButtonDialog__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_EditCreateEntityActions__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__flux_Error_ErrorActions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__flux_Grid_SelectedItemsActions__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_configure_store__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Toolbar__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Table_NoResults__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Table_TableTitle__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Spinner__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_ErrorMessage__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_StickyMediator__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__flux_Flag_FlagActions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Search_GenericSearchWidget__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__TrashButtonWidget__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__DeleteConfirmationWidget__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_render_html__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_render_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_react_render_html__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




























var appStyles = __webpack_require__(64);
var tableStyles = __webpack_require__(73);
var SensorTab = function (_React$Component) {
    _inherits(SensorTab, _React$Component);

    function SensorTab() {
        _classCallCheck(this, SensorTab);

        var _this = _possibleConstructorReturn(this, (SensorTab.__proto__ || Object.getPrototypeOf(SensorTab)).apply(this, arguments));

        _this.errorActions = new __WEBPACK_IMPORTED_MODULE_13__flux_Error_ErrorActions__["a" /* ErrorActions */]();
        _this.dateRangeActions = new __WEBPACK_IMPORTED_MODULE_10__DateRangeStore__["b" /* DateRangeActions */]();
        _this.editCreateEntityActions = new __WEBPACK_IMPORTED_MODULE_12__actions_EditCreateEntityActions__["a" /* EditCreateEntityActions */]();
        _this.selectedItemsActions = new __WEBPACK_IMPORTED_MODULE_14__flux_Grid_SelectedItemsActions__["a" /* SelectedItemsActions */]();
        _this.stickyMediator = new __WEBPACK_IMPORTED_MODULE_21__utils_StickyMediator__["a" /* StickyMediator */]();
        _this.state = {
            allowDeletionOfSensors: JSON.parse(localStorage.getItem("allowDeletionOfSensors"))
        };
        return _this;
    }

    _createClass(SensorTab, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            // this.props.refresher.run();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                dateRangeStore = _props.dateRangeStore,
                selectedItemsStore = _props.selectedItemsStore,
                isAdmin = _props.isAdmin,
                polyglot = _props.polyglot;

            var entityType = __WEBPACK_IMPORTED_MODULE_1__models__["a" /* EntityType */].Sensor;
            var createForm = function createForm(_ref) {
                var title = _ref.title,
                    okTitle = _ref.okTitle,
                    path = _ref.path;
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Container__["a" /* Container */], { merge: true, stores: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_configure_store__["b" /* twoButtonDialogConfig */])(_this2.props.upsertInProgressStore, _this2.props.upsertErrorStore) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__EditCreate_EditCreateEntityRoute__["a" /* EditCreateEntityRoute */], { title: title, okTitle: okTitle, path: path, cancelTitle: polyglot.t('button.cancel'), renderEdit: function renderEdit() {
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Container__["a" /* Container */], { merge: true, stores: [_this2.props.editStore, [_this2.props.loadingVehicles, function (store) {
                                return { loadingVehicles: store.isSet() };
                            }], [_this2.props.loadingGeotabSensors, function (store) {
                                return { loadingGeotabSensors: store.isSet() };
                            }], [_this2.props.loadingQuantities, function (store) {
                                return { loadingQuantities: store.isSet() };
                            }]], actions: new __WEBPACK_IMPORTED_MODULE_5__flux__["b" /* EditSensorActions */](), onMount: function onMount() {
                                var VehicleId = _this2.props.editStore.getState().draft.VehicleId;

                                _this2.props.upsertInitCmd.execute(VehicleId);
                            } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__NewSensor__["a" /* NewSensor */], { polyglot: polyglot, loadingVehicles: null, loadingGeotabSensors: null, loadingQuantities: null, setVehicleCmd: _this2.props.upsertSetVehicle, setGeotabSensorCmd: _this2.props.upsertSetGeotabSensor }));
                    }, cancel: function cancel() {
                        return __WEBPACK_IMPORTED_MODULE_3__routes__["b" /* appNavigator */].goToEntityTab(entityType);
                    }, ok: function ok() {
                        return _this2.props.upsertCommand.execute(_this2.props.editStore.getState().draft);
                    } }));
            };
            var disableInject = {
                disabled: function disabled() {
                    return selectedItemsStore.getState().selected.size === 0;
                }
            };
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Dialogs_OneButtonDialog__["a" /* OneButtonDialog */], { visibilityStore: this.props.alertVisibilityStore, title: polyglot.t('misc.info'), okTitle: polyglot.t('button.ok'), ok: function ok() {
                    return new __WEBPACK_IMPORTED_MODULE_22__flux_Flag_FlagActions__["a" /* FlagActions */]().reset(_this2.props.alertVisibilityStore.dispatchToken);
                } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, polyglot.t('sensor.no_data_msg'))), isAdmin && createForm({ title: polyglot.t('sensor.create_title'), okTitle: polyglot.t('button.create'), path: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__routes__["h" /* addNewRouteFor */])(entityType) }), isAdmin && createForm({ title: polyglot.t('sensor.edit_title'), okTitle: polyglot.t('button.save'), path: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__routes__["i" /* editRouteFor */])(entityType) }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25__DeleteConfirmationWidget__["a" /* DeleteConfirmationWidget */], Object.assign({}, this.props, { entityType: entityType, title: polyglot.t('sensor.del_confirmation_title') }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: appStyles.ConfirmationContainer }, __WEBPACK_IMPORTED_MODULE_26_react_render_html___default()(polyglot.t('sensor.del_confirmation_msg')))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23__Search_GenericSearchWidget__["a" /* GenericSearchWidget */], Object.assign({}, this.props)), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: appStyles.StickyControlPanel, ref: this.stickyMediator.onToolbox }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Toolbar__["a" /* Toolbar */], null, isAdmin && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_Buttons__["a" /* Button */], { type: "success", leftIcon: "plus", onClick: function onClick() {
                    _this2.editCreateEntityActions.rejectDraft(entityType);
                    _this2.errorActions.clearError(_this2.props.upsertErrorStore.dispatchToken);
                    __WEBPACK_IMPORTED_MODULE_3__routes__["b" /* appNavigator */].goToAddNewEntityTab(entityType);
                } }, this.props.polyglot.t('button.new')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Container__["a" /* Container */], { inject: disableInject, stores: [selectedItemsStore] }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_Buttons__["a" /* Button */], { onClick: function onClick() {
                    return _this2.props.loadSensorsDataCmd.execute('last24h');
                } }, polyglot.t('sensor.btn_last_24h'))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Container__["a" /* Container */], { inject: disableInject, stores: [selectedItemsStore] }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_Buttons__["a" /* Button */], { onClick: function onClick() {
                    return _this2.props.loadSensorsDataCmd.execute('yesterday');
                } }, polyglot.t('sensor.btn_yesterday'))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Container__["a" /* Container */], { stores: {
                    disabled: function disabled() {
                        return { value: selectedItemsStore.getState().selected.size === 0, store: selectedItemsStore };
                    },
                    fromDate: function fromDate() {
                        return { value: dateRangeStore.getState().fromDate, store: dateRangeStore };
                    },
                    toDate: function toDate() {
                        return { value: dateRangeStore.getState().toDate, store: dateRangeStore };
                    }
                } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_DateRange__["a" /* DateRange */], { locale: polyglot.locale(), fromTitle: polyglot.t('sensor.placeholder_from'), toTitle: polyglot.t('sensor.placeholder_to'), buttonTitle: polyglot.t('sensor.btn_go'), disabled: null, fromDate: null, toDate: null, setFromDate: function setFromDate(date) {
                    return _this2.dateRangeActions.setFromDate(date);
                }, setToDate: function setToDate(date) {
                    return _this2.dateRangeActions.setToDate(date);
                }, onClick: function onClick(e) {
                    return _this2.props.loadSensorsDataCmd.execute(_this2.getDateRange());
                } })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Container__["a" /* Container */], { subscribe: [this.props.loadSensorsDataInProgressStore], render: function render() {
                    return _this2.props.loadSensorsDataInProgressStore.isSet() && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__components_Spinner__["a" /* Spinner */], null);
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Container__["a" /* Container */], { store: this.props.toolbarErrorStore }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__components_ErrorMessage__["a" /* ErrorMessage */], null)), isAdmin && this.state.allowDeletionOfSensors && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24__TrashButtonWidget__["a" /* TrashButtonWidget */], Object.assign({ entityType: __WEBPACK_IMPORTED_MODULE_1__models__["a" /* EntityType */].Sensor }, this.props))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__Table_TableTitle__["a" /* TableTitle */], { polyglot: polyglot, labelStore: this.props.tableTitleStore })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Container__["a" /* Container */], { merge: true, stores: [this.props.listStore, selectedItemsStore, [this.props.vehicleSearchInitiatorStore, function (store) {
                    return { vehicleSearchInitiator: store.getValue() };
                }]] }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__SensorGrid__["a" /* SensorGrid */], { className: tableStyles.StickyTable, polyglot: polyglot, isAdmin: isAdmin, vehicleSearchInitiator: null, items: null, selected: null, allSelected: null, onClone: function onClone(datum, row) {
                    _this2.editCreateEntityActions.setEntityPrototype(datum, entityType);
                    _this2.errorActions.clearError(_this2.props.upsertErrorStore.dispatchToken);
                    __WEBPACK_IMPORTED_MODULE_3__routes__["b" /* appNavigator */].goToAddNewEntityTab(entityType);
                }, onEdit: function onEdit(datum, row) {
                    _this2.editCreateEntityActions.setEntityToEdit(datum, entityType);
                    _this2.errorActions.clearError(_this2.props.upsertErrorStore.dispatchToken);
                    __WEBPACK_IMPORTED_MODULE_3__routes__["b" /* appNavigator */].goToEditEntityTab(entityType);
                }, onVehicle: function onVehicle(datum, row) {
                    return _this2.props.vehicleSearchCmd.execute(datum.id, { SensorId: datum.id });
                }, toggle: function toggle(datum, row) {
                    return _this2.selectedItemsActions.toggleItem(datum.id, entityType);
                }, toggleAll: function toggleAll() {
                    return _this2.selectedItemsActions.toggleAll(entityType);
                }, onThead: this.stickyMediator.onThead })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__Table_NoResults__["a" /* NoResults */], { polyglot: polyglot, listStore: this.props.listStore }));
        }
    }, {
        key: "getDateRange",
        value: function getDateRange() {
            var format = 'YYYY-MM-DD';

            var _props$dateRangeStore = this.props.dateRangeStore.getState(),
                fromDate = _props$dateRangeStore.fromDate,
                toDate = _props$dateRangeStore.toDate;

            window.fromDate = fromDate;
            window.toDate = toDate;
            return fromDate && toDate ? fromDate.format(format) + " - " + toDate.format(format) : (fromDate || toDate).format(format);
        }
    }]);

    return SensorTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InitUpsertSensorCommand; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InitUpsertSensorCommand = function InitUpsertSensorCommand(loadVehiclesCmd, loadMeasuresCmd, loadGeotabSensors) {
    var _this = this;

    _classCallCheck(this, InitUpsertSensorCommand);

    this.loadVehiclesCmd = loadVehiclesCmd;
    this.loadMeasuresCmd = loadMeasuresCmd;
    this.loadGeotabSensors = loadGeotabSensors;
    this.execute = function (vehicleId) {
        _this.loadVehiclesCmd.execute();
        _this.loadMeasuresCmd.execute();
        if (vehicleId != null) {
            _this.loadGeotabSensors.execute(vehicleId);
        }
    };
};

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadMeasuresCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Flag__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_assert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_Error__ = __webpack_require__(20);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var LoadMeasuresCommand = function LoadMeasuresCommand(getMeasures, getState, getCurrentDivisionId, loadMeasuresInProgress, loadMeasuresError) {
    var _this = this;

    _classCallCheck(this, LoadMeasuresCommand);

    this.getMeasures = getMeasures;
    this.getState = getState;
    this.getCurrentDivisionId = getCurrentDivisionId;
    this.loadMeasuresInProgress = loadMeasuresInProgress;
    this.loadMeasuresError = loadMeasuresError;
    this.flagActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Flag__["a" /* FlagActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_3__flux_Error__["a" /* ErrorActions */]();
    this.editActions = new __WEBPACK_IMPORTED_MODULE_0__flux__["b" /* EditSensorActions */]();
    this.execute = function () {
        var _getState = _this.getState(),
            editSession = _getState.editSession,
            draft = _getState.draft;

        var sameSession = function sameSession() {
            return editSession === _this.getState().editSession;
        };
        _this.flagActions.set(_this.loadMeasuresInProgress);
        (draft.id ? _this.getMeasures({ SensorId: draft.id }) : _this.getMeasures({ DivisionId: _this.getCurrentDivisionId() })).then(function (resp) {
            if (sameSession()) {
                var Quantities = resp.Quantities;

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_assert__["a" /* assertTrue */])(Quantities.length > 0, 'Quantities could not be empty');
                _this.editActions.setMeasures(resp);
                var state = _this.getState();
                var _state$draft = state.draft,
                    QuantityId = _state$draft.QuantityId,
                    UnitId = _state$draft.UnitId;

                if (QuantityId && !UnitId) {
                    var quantity = Quantities.find(function (item) {
                        return item.Id === QuantityId;
                    });
                    _this.editActions.setQuantity(QuantityId, quantity.Units[0]);
                }
            }
        }).catch(function (err) {
            return sameSession() && _this.errorActions.setError(err, _this.loadMeasuresError);
        }).then(function () {
            return sameSession() && _this.flagActions.reset(_this.loadMeasuresInProgress);
        }); // finally
    };
};

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadGeotabSensorsCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Flag__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Error__ = __webpack_require__(20);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var LoadGeotabSensorsCommand = function LoadGeotabSensorsCommand(getGeotabSensors, getState, setGeotabSensorCmd, inProgressToken, errorToken) {
    var _this = this;

    _classCallCheck(this, LoadGeotabSensorsCommand);

    this.getGeotabSensors = getGeotabSensors;
    this.getState = getState;
    this.setGeotabSensorCmd = setGeotabSensorCmd;
    this.inProgressToken = inProgressToken;
    this.errorToken = errorToken;
    this.flagActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Flag__["a" /* FlagActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_2__flux_Error__["a" /* ErrorActions */]();
    this.editActions = new __WEBPACK_IMPORTED_MODULE_0__flux__["b" /* EditSensorActions */]();
    this.execute = function (vehicleId) {
        var _getState = _this.getState(),
            editSession = _getState.editSession;

        var sameSession = function sameSession() {
            return editSession === _this.getState().editSession;
        };
        _this.flagActions.set(_this.inProgressToken);
        _this.getGeotabSensors(vehicleId).then(function (resp) {
            if (sameSession()) {
                var _getState2 = _this.getState(),
                    draft = _getState2.draft;

                var GeotabSensors = resp.GeotabSensors;
                // workaround #173

                if (!GeotabSensors) return;
                _this.editActions.setGeotabSensorsItems(GeotabSensors);
                if (draft.GeotabId == null && GeotabSensors.length === 1) {
                    _this.setGeotabSensorCmd.execute(GeotabSensors[0]);
                }
            }
        }).catch(function (err) {
            return sameSession() && _this.errorActions.setError(err, _this.errorToken);
        }).then(function () {
            return _this.flagActions.reset(_this.inProgressToken);
        }); // finally
    };
};

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SetGeotabSensorCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux__ = __webpack_require__(75);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var SetGeotabSensorCommand = function SetGeotabSensorCommand(getState) {
    var _this = this;

    _classCallCheck(this, SetGeotabSensorCommand);

    this.getState = getState;
    this.editActions = new __WEBPACK_IMPORTED_MODULE_0__flux__["b" /* EditSensorActions */]();
    this.execute = function (geotabSensor) {
        _this.editActions.setGeotabSensor(geotabSensor);
        if (geotabSensor == null) {
            _this.editActions.setQuantity(null, null);
        } else {
            var _getState = _this.getState(),
                quantities = _getState.quantities;

            var quantity = quantities.find(function (item) {
                return item.Id === geotabSensor.QuantityId;
            });
            var uId = quantity ? quantity.Units[0] : null;
            _this.editActions.setQuantity(geotabSensor.QuantityId, uId);
        }
    };
};

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpsertSensorCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Error__ = __webpack_require__(20);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var UpsertSensorCommand = function UpsertSensorCommand(polyglot, errorDispatchToken, upsert) {
    var _this = this;

    _classCallCheck(this, UpsertSensorCommand);

    this.polyglot = polyglot;
    this.errorDispatchToken = errorDispatchToken;
    this.upsert = upsert;
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Error__["a" /* ErrorActions */]();
    this.execute = function (draft) {
        var VehicleId = draft.VehicleId,
            GeotabId = draft.GeotabId,
            SensorId = draft.SensorId,
            QuantityId = draft.QuantityId;

        var setError = function setError(msg) {
            return _this.errorActions.setError(new Error(msg), _this.errorDispatchToken);
        };
        if (typeof VehicleId !== 'number') {
            setError(_this.polyglot.t('sensor.validation_err.vehicle_not_set'));
            return;
        }
        if (typeof GeotabId !== 'string' && typeof SensorId !== 'string') {
            setError(_this.polyglot.t('sensor.validation_err.sensor_not_set'));
            return;
        }
        if (typeof QuantityId !== 'number') {
            setError(_this.polyglot.t('sensor.validation_err.quantity_not_set'));
            return;
        }
        _this.upsert.execute(draft, __WEBPACK_IMPORTED_MODULE_0__models__["a" /* EntityType */].Sensor);
    };
};

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadVehiclesCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rest_Search__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Flag__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Error__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux__ = __webpack_require__(75);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var LoadVehiclesCommand = function LoadVehiclesCommand(search, getState, setVehicleCmd, inProgressToken, errorToken) {
    var _this = this;

    _classCallCheck(this, LoadVehiclesCommand);

    this.search = search;
    this.getState = getState;
    this.setVehicleCmd = setVehicleCmd;
    this.inProgressToken = inProgressToken;
    this.errorToken = errorToken;
    this.flagActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Flag__["a" /* FlagActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_2__flux_Error__["a" /* ErrorActions */]();
    this.editActions = new __WEBPACK_IMPORTED_MODULE_3__flux__["b" /* EditSensorActions */]();
    this.execute = function () {
        var _getState = _this.getState(),
            editSession = _getState.editSession;

        var sameSession = function sameSession() {
            return editSession === _this.getState().editSession;
        };
        _this.flagActions.set(_this.inProgressToken);
        _this.search(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__rest_Search__["c" /* requestVehicles */])()).then(function (resp) {
            if (sameSession()) {
                var vehicles = resp.Entries.Vehicle;

                _this.editActions.setVehicleItems(vehicles);

                var _getState2 = _this.getState(),
                    draft = _getState2.draft;

                if (draft.VehicleId == null && vehicles.length === 1) {
                    _this.setVehicleCmd.execute(vehicles[0].id);
                }
            }
        }).catch(function (err) {
            return sameSession() && _this.errorActions.setError(err, _this.errorToken);
        }).then(function () {
            return sameSession() && _this.flagActions.reset(_this.inProgressToken);
        }); // finally
    };
};

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SetVehicleCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux__ = __webpack_require__(75);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var SetVehicleCommand = function SetVehicleCommand(loadGeotabSensorsCmd, setGeotabSensorCmd) {
    var _this = this;

    _classCallCheck(this, SetVehicleCommand);

    this.loadGeotabSensorsCmd = loadGeotabSensorsCmd;
    this.setGeotabSensorCmd = setGeotabSensorCmd;
    this.editActions = new __WEBPACK_IMPORTED_MODULE_0__flux__["b" /* EditSensorActions */]();
    this.execute = function (vehicleId) {
        _this.editActions.setVehicle(vehicleId);
        _this.setGeotabSensorCmd.execute(null);
        _this.editActions.setGeotabSensorsItems([]);
        if (vehicleId != null) {
            _this.loadGeotabSensorsCmd.execute(vehicleId);
        }
    };
};

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditSensorStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_draft__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_assert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditCreate_EditStore__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditSensorActions__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_EditCreateEntityActions__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_EntityType__ = __webpack_require__(54);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var session = 0;
var EditSensorStore = function (_EditStore) {
    _inherits(EditSensorStore, _EditStore);

    function EditSensorStore() {
        _classCallCheck(this, EditSensorStore);

        var _this = _possibleConstructorReturn(this, (EditSensorStore.__proto__ || Object.getPrototypeOf(EditSensorStore)).call(this));

        _this.setBaseline = function (baseline) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assert__["a" /* assertTrue */])(baseline === null || typeof baseline === 'number', 'number payload expected');
            return _this.draft({ Baseline: baseline });
        };
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditSensorActions__["b" /* names */].SET_VEHICLE, function (e) {
            return _this.draft({ VehicleId: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditSensorActions__["b" /* names */].SET_GEOTAB, function (e) {
            var idName = e.payload || { Id: null, Name: null, QuantityId: null };
            return _this.draft({ GeotabId: idName.Id, GeotabTitle: idName.Name });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditSensorActions__["b" /* names */].SET_ABS_RED_MAX, function (e) {
            return _this.draft({ AbsLevelMaximumRed: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditSensorActions__["b" /* names */].SET_ABS_RED_MIN, function (e) {
            return _this.draft({ AbsLevelMinimumRed: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditSensorActions__["b" /* names */].SET_ABS_YELLOW_MAX, function (e) {
            return _this.draft({ AbsLevelMaximumYellow: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditSensorActions__["b" /* names */].SET_ABS_YELLOW_MIN, function (e) {
            return _this.draft({ AbsLevelMinimumYellow: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditSensorActions__["b" /* names */].SET_REL_RED_MAX, function (e) {
            return _this.draft({ RelLevelMaximumRed: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditSensorActions__["b" /* names */].SET_REL_RED_MIN, function (e) {
            return _this.draft({ RelLevelMinimumRed: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditSensorActions__["b" /* names */].SET_REL_YELLOW_MAX, function (e) {
            return _this.draft({ RelLevelMaximumYellow: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditSensorActions__["b" /* names */].SET_REL_YELLOW_MIN, function (e) {
            return _this.draft({ RelLevelMinimumYellow: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditSensorActions__["b" /* names */].SET_DISPLAY, function (e) {
            return _this.draft({ Display: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditSensorActions__["b" /* names */].SET_QUANTITY_UNIT, function (e) {
            return _this.draft({ QuantityId: e.payload.quantityId, UnitId: e.payload.unitId });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditSensorActions__["b" /* names */].SET_BASELINE, function (e) {
            return _this.setBaseline(e.payload);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditSensorActions__["b" /* names */].SET_VEHICLES_ITEMS, function (e) {
            return _this.field({ vehicles: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditSensorActions__["b" /* names */].SET_GEOTAB_SENSORS_ITEMS, function (e) {
            return _this.field({ geotabSensors: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditSensorActions__["b" /* names */].SET_MEASURE_ITEMS, function (e) {
            return _this.field({
                quantities: e.payload.Quantities,
                units: e.payload.Units
            });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_4__actions_EditCreateEntityActions__["b" /* names */].SET_ENTITY_PROTOTYPE, function (e) {
            if (e.meta === __WEBPACK_IMPORTED_MODULE_5__models_EntityType__["a" /* EntityType */].Sensor) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assert__["b" /* assertValue */])(e.payload, 'sensor payload has to have a value');
                var sensor = Object.assign({}, e.payload, { id: null, ServiceAccountId: null, ServiceAccount: null, GeotabId: null, GeotabTitle: null, Display: null, CanOnlyEditLevels: null });
                return _this.getDefaultStateFor(sensor);
            }
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_4__actions_EditCreateEntityActions__["b" /* names */].SET_EDIT_ENTITY, function (e) {
            if (e.meta === __WEBPACK_IMPORTED_MODULE_5__models_EntityType__["a" /* EntityType */].Sensor) return _this.getDefaultStateFor(e.payload);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_4__actions_EditCreateEntityActions__["b" /* names */].REJECT_DRAFT, function (e) {
            if (e.meta === __WEBPACK_IMPORTED_MODULE_5__models_EntityType__["a" /* EntityType */].Sensor) return _this.getDefaultStateFor(null);
        });
        return _this;
    }

    _createClass(EditSensorStore, [{
        key: "getDefaultStateFor",
        value: function getDefaultStateFor(sensor) {
            return {
                draft: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_draft__["a" /* prepareSensorDraft */])(sensor),
                vehicles: [],
                geotabSensors: [],
                quantities: [],
                units: [],
                editSession: session++
            };
        }
    }]);

    return EditSensorStore;
}(__WEBPACK_IMPORTED_MODULE_2__EditCreate_EditStore__["a" /* EditStore */]);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GoogleMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var styles = __webpack_require__(964);
var GoogleMap = function (_React$Component) {
    _inherits(GoogleMap, _React$Component);

    function GoogleMap() {
        _classCallCheck(this, GoogleMap);

        return _possibleConstructorReturn(this, (GoogleMap.__proto__ || Object.getPrototypeOf(GoogleMap)).apply(this, arguments));
    }

    _createClass(GoogleMap, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            if (!window['google']) {
                throw new Error('you have to add/inject <script src="https://maps.googleapis.com/maps/api/js?key=...></script>');
            }
            this.tryUpdateMap();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            this.tryUpdateMap();
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, styles.GoogleMap), ref: function ref(e) {
                    _this2.mapRef = e;
                    _this2.tryUpdateMap();
                } });
        }
    }, {
        key: "tryUpdateMap",
        value: function tryUpdateMap() {
            if (!this.mapRef) return;
            var _props = this.props,
                position = _props.position,
                defaultZoom = _props.defaultZoom;

            if (!this.isValid(position)) {
                if (this.marker) {
                    this.marker.setVisible(false);
                }
                return;
            }
            var latLng = { lat: position.lat, lng: position.lon };
            if (!this.map) {
                this.map = new google.maps.Map(this.mapRef, {
                    center: latLng,
                    zoom: defaultZoom
                });
            } else {
                var bounds = this.map.getBounds();
                if (!bounds || !bounds.contains(latLng)) {
                    this.map.setCenter(latLng);
                }
            }
            if (!this.marker) {
                this.marker = new google.maps.Marker({
                    position: latLng,
                    map: this.map
                });
            } else {
                this.marker.setPosition(latLng);
                this.marker.setVisible(true);
            }
        }
    }, {
        key: "isValid",
        value: function isValid(position) {
            return position && typeof position.lat === 'number' && typeof position.lon === 'number';
        }
    }]);

    return GoogleMap;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TableView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NonIsolatedPremise__ = __webpack_require__(102);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var styles = __webpack_require__(953);
var tableStyles = __webpack_require__(73);
var dotTypeClass = {
    square: styles.SquareIcon,
    circle: styles.CircleIcon
};
var severityClass = {
    red: styles.Red,
    yellow: styles.Yellow
};
var TableView = function (_React$Component) {
    _inherits(TableView, _React$Component);

    function TableView() {
        _classCallCheck(this, TableView);

        return _possibleConstructorReturn(this, (TableView.__proto__ || Object.getPrototypeOf(TableView)).apply(this, arguments));
    }

    _createClass(TableView, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                polyglot = _props.polyglot,
                data = _props.data,
                onHeader = _props.onHeader;
            var headers = data.headers,
                rows = data.rows;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("table", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('table table-striped table-bordered table-hover', tableStyles.StickyTable, this.props.className) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("thead", { ref: function ref(e) {
                    return onHeader && onHeader(e);
                } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", null, polyglot.t('sensors_data.label_time'), ":"), headers.map(function (header, idx) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", { key: idx, className: 'text-center' }, header);
            }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__NonIsolatedPremise__["a" /* NonIsolatedPremise */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", null, polyglot.t('sensors_data.btn_map'))))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody", { onClick: function onClick(e) {
                    return _this2.onRowClicked(_this2.getRowIdx(e), rows);
                } }, rows.map(function (row, rowIdx) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", { key: rowIdx, "data-row": rowIdx }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, __WEBPACK_IMPORTED_MODULE_2_moment___default()(row.dateTimeReceivedOn).year() > 2017 && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "tooltip-message", "data-toggle": "tooltip", "data-placement": "top", title: "Received At: " + __WEBPACK_IMPORTED_MODULE_2_moment___default()(row.dateTimeReceivedOn).format('YYYY-MM-DD HH:mm:ss') }, __WEBPACK_IMPORTED_MODULE_2_moment___default()(row.date).format('YYYY-MM-DD HH:mm:ss')), __WEBPACK_IMPORTED_MODULE_2_moment___default()(row.dateTimeReceivedOn).year() < 2017 && __WEBPACK_IMPORTED_MODULE_2_moment___default()(row.date).format('YYYY-MM-DD HH:mm:ss')), row.values.map(function (v, i) {
                    return v ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { key: i, className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(dotTypeClass[v.dotType], severityClass[v.severity]) }, v.value, " ", __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null)) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { key: i });
                }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__NonIsolatedPremise__["a" /* NonIsolatedPremise */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, row.lat && row.lat ? '+' : '-')));
            })));
        }
    }, {
        key: "getRowIdx",
        value: function getRowIdx(e) {
            var td = e.target;
            var tr = td.parentElement;
            return parseInt(tr.dataset.row, 10);
        }
    }, {
        key: "onRowClicked",
        value: function onRowClicked(rowIdx, tableRows) {
            var onClick = this.props.onClick;

            if (onClick) {
                onClick(tableRows[rowIdx]);
            }
        }
    }]);

    return TableView;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return View; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rest_Geotab__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Buttons__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flux_Grid_ListStore__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flux_Flag_FlagStore__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flux_Error_ErrorStore__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__flux_Grid_SelectedItemsStore__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Pages_Sensor_commands_LoadSensorsDataCommand__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Pages_SensorsData_commands_ShowSensorsDataCommand__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_GoogleMapLoader__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__flux__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Table__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__GoogleMap__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Container__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__charts_TimeSeries_index__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Toolbar_index__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__NonIsolatedPremise__ = __webpack_require__(102);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var styles = __webpack_require__(952);
var View = function (_React$Component) {
    _inherits(View, _React$Component);

    function View(props) {
        _classCallCheck(this, View);

        var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));

        _this.listStore = new __WEBPACK_IMPORTED_MODULE_5__flux_Grid_ListStore__["a" /* ListStore */](function (s) {
            return s.id;
        }, __WEBPACK_IMPORTED_MODULE_9__models__["a" /* EntityType */].Sensor);
        _this.selectedItemsStore = new __WEBPACK_IMPORTED_MODULE_8__flux_Grid_SelectedItemsStore__["a" /* SelectedItemsStore */](_this.listStore, __WEBPACK_IMPORTED_MODULE_9__models__["a" /* EntityType */].Sensor);
        _this.sensorsDataActions = new __WEBPACK_IMPORTED_MODULE_13__flux__["b" /* SensorsDataActions */]();
        _this.loadSensorsDataInProgressStore = new __WEBPACK_IMPORTED_MODULE_6__flux_Flag_FlagStore__["a" /* FlagStore */]();
        _this.toolbarErrorStore = new __WEBPACK_IMPORTED_MODULE_7__flux_Error_ErrorStore__["a" /* ErrorStore */]();
        _this.alertStore = new __WEBPACK_IMPORTED_MODULE_6__flux_Flag_FlagStore__["a" /* FlagStore */]();
        _this.sensorDataFilter = {
            Ids: [],
            TimeRange: 'last24h'
        };
        _this.sensorDataFilter = JSON.parse(localStorage.getItem('sensorDataFilter'));
        var googleMapLoader = new __WEBPACK_IMPORTED_MODULE_12__utils_GoogleMapLoader__["a" /* GoogleMapLoader */]();
        _this.sensorsDataShowCmd = new __WEBPACK_IMPORTED_MODULE_11__components_Pages_SensorsData_commands_ShowSensorsDataCommand__["a" /* ShowSensorsDataCommand */](googleMapLoader, _this.alertStore.dispatchToken);
        _this.loadSensrosDataCmd = new __WEBPACK_IMPORTED_MODULE_10__components_Pages_Sensor_commands_LoadSensorsDataCommand__["a" /* LoadSensorsDataCommand */](__WEBPACK_IMPORTED_MODULE_2__rest_Geotab__["c" /* getSensorsData */], function () {
            return _this.sensorDataFilter.Ids;
        }, _this.sensorsDataShowCmd, _this.loadSensorsDataInProgressStore.dispatchToken, _this.toolbarErrorStore.dispatchToken);
        return _this;
    }

    _createClass(View, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                refId = _props.refId,
                rows = _props.rows,
                axes = _props.axes,
                tableData = _props.tableData,
                view = _props.view,
                hasGeoData = _props.hasGeoData,
                isMapVisible = _props.isMapVisible,
                polyglot = _props.polyglot;
            var coordinate = this.props.coordinate;

            var isGraph = view === __WEBPACK_IMPORTED_MODULE_13__flux__["c" /* ViewType */].Graph;
            var isTable = view === __WEBPACK_IMPORTED_MODULE_13__flux__["c" /* ViewType */].TableAndMap;
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, styles.SensorsData) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__Toolbar_index__["a" /* Toolbar */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_Buttons__["b" /* LinkButton */], { leftIcon: "download", href: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__routes__["g" /* sensorsReadingsRoute */])(refId), download: true }, polyglot.t('sensors_data.btn_excel')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_Buttons__["a" /* Button */], { leftIcon: "refresh", onClick: function onClick() {
                    return _this2.loadSensrosDataCmd.execute(_this2.sensorDataFilter.TimeRange);
                } }, polyglot.t('sensors_data.btn_refresh')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "btn-group" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_Buttons__["a" /* Button */], { leftIcon: "signal", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()({ active: isGraph }), onClick: this.sensorsDataActions.setGraphView, disabled: !this.props.hasChartData }, polyglot.t('sensors_data.btn_graph')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_Buttons__["a" /* Button */], { leftIcon: "list", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()({ active: isTable }), onClick: this.sensorsDataActions.setTableView }, polyglot.t('sensors_data.btn_table')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__NonIsolatedPremise__["a" /* NonIsolatedPremise */], null, isTable && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_Buttons__["a" /* Button */], { leftIcon: "map-marker", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()({ active: isMapVisible }), onClick: this.sensorsDataActions.toggleMap, disabled: !hasGeoData }, polyglot.t('sensors_data.btn_map'))))), isGraph && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Container__["a" /* Container */], { store: this.props.timeSeriesStore }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__charts_TimeSeries_index__["a" /* Chart */], { polyglot: polyglot, dataSets: null, tooltip: null, zoomedDataSets: null, isRangeOk: isRangeOk })), isTable && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styles.Container }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { height: '100%' } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { overflowY: 'scroll', height: '100%' } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Table__["a" /* TableView */], { polyglot: polyglot, data: tableData, onClick: function onClick(row) {
                    var lon = row.lon,
                        lat = row.lat;

                    _this2.sensorsDataActions.setCoordinate(lon, lat);
                } }))), isMapVisible && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__GoogleMap__["a" /* GoogleMap */], { position: coordinate, defaultZoom: 10 })));
        }
    }]);

    return View;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
function isRangeOk(range) {
    var dt = +range[1] - +range[0];
    return dt >= 60 * 1000;
}

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ViewType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SensorsDataStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Store__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_assert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Actions__ = __webpack_require__(312);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ViewType;
(function (ViewType) {
    ViewType[ViewType["Graph"] = 0] = "Graph";
    ViewType[ViewType["TableAndMap"] = 1] = "TableAndMap";
})(ViewType || (ViewType = {}));
var SensorsDataStore = function (_Store) {
    _inherits(SensorsDataStore, _Store);

    function SensorsDataStore() {
        _classCallCheck(this, SensorsDataStore);

        var _this = _possibleConstructorReturn(this, (SensorsDataStore.__proto__ || Object.getPrototypeOf(SensorsDataStore)).call(this));

        _this.setSensorsData = function (_ref) {
            var Rows = _ref.Rows,
                Axes = _ref.Axes,
                RefId = _ref.RefId;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assert__["d" /* assertArray */])(Rows, 'ChartInfo payload expected');
            fixDate(Rows);
            var tableData = buildTable(Rows);
            var coordinate = getLatestCoordinates(tableData);
            var hasChartData = Rows.some(function (row) {
                return row.Readings.length > 1;
            });
            return _this.field({
                refId: RefId,
                rows: Rows,
                axes: Axes,
                tableData: tableData,
                view: hasChartData ? ViewType.Graph : ViewType.TableAndMap,
                coordinate: coordinate,
                hasGeoData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assert__["e" /* hasValue */])(coordinate),
                hasChartData: hasChartData
            });
        };
        _this.getDefaultState = function () {
            return {
                view: ViewType.Graph,
                refId: null,
                rows: [],
                axes: [],
                tableData: {
                    headers: [],
                    rows: []
                },
                hasGeoData: false,
                hasChartData: false,
                isMapVisible: false,
                coordinate: null
            };
        };
        _this.state = _this.getDefaultState();
        _this.register(__WEBPACK_IMPORTED_MODULE_3__Actions__["b" /* names */].SET_SENSORS_DATA, function (e) {
            return _this.setSensorsData(e.payload);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__Actions__["b" /* names */].SET_GRAPH_VIEW, function (e) {
            return _this.field({ view: ViewType.Graph });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__Actions__["b" /* names */].SET_TABLE_VIEW, function (e) {
            return _this.field({ view: ViewType.TableAndMap });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__Actions__["b" /* names */].TOGGLE_MAP, function (e) {
            return _this.field({ isMapVisible: _this.state.hasGeoData && !_this.state.isMapVisible });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__Actions__["b" /* names */].SET_COORDINATE, function (e) {
            return _this.field({ coordinate: e.payload });
        });
        return _this;
    }

    return SensorsDataStore;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Store__["a" /* Store */]);
function fixDate(rows) {
    rows.forEach(function (r) {
        return r.Readings.forEach(function (v) {
            v.date = new Date(v.DateTime);
            v.dateTimeReceivedOn = new Date(v.ReceivedOn);
        });
    });
}
var MAX_DATE = new Date(8640000000000000);
function buildTable(rows) {
    var res = {
        headers: rows.map(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* getTitle */]),
        rows: []
    };
    var hasReadings = rows.some(function (row) {
        return row.Readings && row.Readings.length > 0;
    });
    if (!hasReadings) return res;
    rows.forEach(function (r) {
        r.Readings.sort(function (l, r) {
            return l.date.valueOf() - r.date.valueOf();
        });
    });
    var cnt = 0;
    var idxs = rows.map(function (r) {
        return 0;
    });

    var _loop = function _loop() {
        var minDate = MAX_DATE;
        rows.forEach(function (r, i) {
            if (idxs[i] >= r.Readings.length) return;
            var date = r.Readings[idxs[i]].date;
            if (date < minDate) minDate = date;
        });
        var curRow = { date: minDate, values: [] };
        res.rows.push(curRow);
        rows.forEach(function (r, i) {
            var reading = r.Readings[idxs[i]];
            if (reading && reading.date.valueOf() === minDate.valueOf()) {
                curRow.values.push({ value: reading.Value, dotType: r.DotType, severity: reading.Severity });
                curRow.dateTimeReceivedOn = reading.dateTimeReceivedOn;
                curRow.lon = curRow.lon || reading.Longitude;
                curRow.lat = curRow.lat || reading.Latitude;
                idxs[i] += 1;
            } else {
                curRow.values.push(undefined);
            }
        });
        if (idxs.every(function (idx, i) {
            return idx >= rows[i].Readings.length;
        })) return "break";
    };

    while (true) {
        var _ret = _loop();

        if (_ret === "break") break;
    }
    return res;
}
function getLatestCoordinates(tableData) {
    for (var i = tableData.rows.length - 1; i >= 0; i--) {
        var _tableData$rows$i = tableData.rows[i],
            lon = _tableData$rows$i.lon,
            lat = _tableData$rows$i.lat;

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assert__["c" /* isNumber */])(lon) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assert__["c" /* isNumber */])(lat)) {
            return { lon: lon, lat: lat };
        }
    }
    return null;
}

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditServiceAccountStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditCreate_EditStore__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_draft__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditServiceAccountActions__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_EditCreateEntityActions__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_assert_index__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_EntityType__ = __webpack_require__(54);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var EditServiceAccountStore = function (_EditStore) {
    _inherits(EditServiceAccountStore, _EditStore);

    function EditServiceAccountStore() {
        _classCallCheck(this, EditServiceAccountStore);

        var _this = _possibleConstructorReturn(this, (EditServiceAccountStore.__proto__ || Object.getPrototypeOf(EditServiceAccountStore)).call(this));

        _this.setUserName = function (userName) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_assert_index__["a" /* assertTrue */])(userName === null || typeof userName === 'string');
            return _this.draft({ Username: userName });
        };
        _this.setPassword = function (password) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_assert_index__["a" /* assertTrue */])(password === null || typeof password === 'string');
            return _this.draft({ Password: password });
        };
        _this.state = _this.getDefaultStateFor(null);
        _this.register(__WEBPACK_IMPORTED_MODULE_2__EditServiceAccountActions__["b" /* names */].SET_DIVISION, function (e) {
            return _this.draft({ DivisionId: e.payload ? e.payload.id : null });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__EditServiceAccountActions__["b" /* names */].SET_DIVISION_ITEMS, function (e) {
            return _this.field({ divisions: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__EditServiceAccountActions__["b" /* names */].SET_LOGIN, function (e) {
            return _this.setUserName(e.payload);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__EditServiceAccountActions__["b" /* names */].SET_PASSWORD, function (e) {
            return _this.setPassword(e.payload);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__EditServiceAccountActions__["b" /* names */].SET_SERVER_URL, function (e) {
            return _this.draft({ ServerUrl: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__EditServiceAccountActions__["b" /* names */].SET_IMPORT_VEHICLES, function (e) {
            return _this.draft({ AutoImport: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__actions_EditCreateEntityActions__["b" /* names */].REJECT_DRAFT, function (e) {
            if (e.meta === __WEBPACK_IMPORTED_MODULE_5__models_EntityType__["a" /* EntityType */].ServiceAccount) return _this.getDefaultStateFor(null);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__actions_EditCreateEntityActions__["b" /* names */].SET_EDIT_ENTITY, function (e) {
            if (e.meta === __WEBPACK_IMPORTED_MODULE_5__models_EntityType__["a" /* EntityType */].ServiceAccount) return _this.getDefaultStateFor(e.payload);
        });
        return _this;
    }

    _createClass(EditServiceAccountStore, [{
        key: "getDefaultStateFor",
        value: function getDefaultStateFor(serviceAccount) {
            return {
                draft: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_draft__["e" /* prepareServiceAccountDraft */])(serviceAccount),
                divisions: []
            };
        }
    }]);

    return EditServiceAccountStore;
}(__WEBPACK_IMPORTED_MODULE_0__EditCreate_EditStore__["a" /* EditStore */]);

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewServiceAccount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DivisionSelector__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Forms_Groups__ = __webpack_require__(105);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var styles = __webpack_require__(954);
var NewServiceAccount = function (_React$Component) {
    _inherits(NewServiceAccount, _React$Component);

    function NewServiceAccount() {
        _classCallCheck(this, NewServiceAccount);

        return _possibleConstructorReturn(this, (NewServiceAccount.__proto__ || Object.getPrototypeOf(NewServiceAccount)).apply(this, arguments));
    }

    _createClass(NewServiceAccount, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                draft = _props.draft,
                loadDivisionsInProgress = _props.loadDivisionsInProgress,
                divisions = _props.divisions,
                setDivision = _props.setDivision,
                polyglot = _props.polyglot;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("form-horizontal", styles.NewServiceAccount) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Forms_Groups__["b" /* LoadableGroup */], { title: polyglot.t('service_account.label_division') + ':', isLoading: loadDivisionsInProgress, value: draft.Division }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__DivisionSelector__["a" /* DivisionSelector */], { divisions: divisions, onChange: setDivision, selectedId: draft.DivisionId })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Forms_Groups__["c" /* InputTextGroup */], { title: polyglot.t('service_account.label_server_url') + ':', value: draft.ServerUrl || '', onChange: function onChange(e) {
                    return _this2.props.setServerUrl(e.target.value);
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Forms_Groups__["c" /* InputTextGroup */], { title: polyglot.t('service_account.label_username') + ':', value: draft.Username || '', onChange: function onChange(e) {
                    return _this2.props.setLogin(e.target.value);
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Forms_Groups__["c" /* InputTextGroup */], { title: polyglot.t('service_account.label_password') + ':', value: draft.Password || '', onChange: function onChange(e) {
                    return _this2.props.setPassword(e.target.value);
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Forms_Groups__["e" /* CheckboxGroup */], { title: polyglot.t('service_account.label_import_vehicles'), checked: draft.AutoImport, onChange: function onChange(e) {
                    return _this2.props.setImportAllVehicles(e.target.checked);
                } }));
        }
    }]);

    return NewServiceAccount;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServiceAccountGrid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataGrid_DataGrid__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGridTextColumn__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Columns_DataGridButtonColumn__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataGrid_DataGridTemplateColumn__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Columns_IdColumn__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Columns_MultiselectColumn__ = __webpack_require__(122);







var getterLogin = function getterLogin(sa) {
    return sa.Username;
};
var getDivisionName = function getDivisionName(sa) {
    return sa.Division;
};
var importIcon = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "glyphicon glyphicon-cloud-download", style: { verticalAlign: 'text-bottom' }, title: "Import in progress. It can take a few minutes." });
var ServiceAccountGrid = function ServiceAccountGrid(props) {
    var polyglot = props.polyglot;

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_DataGrid_DataGrid__["a" /* DataGrid */], { initialData: props.items, className: props.className, onThead: props.onThead }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Columns_MultiselectColumn__["a" /* MultiselectColumn */], Object.assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__Columns_MultiselectColumn__["b" /* multiselectPropsFrom */])(props))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Columns_IdColumn__["a" /* IdColumn */], { header: polyglot.t('column.id') }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_DataGrid_DataGridTemplateColumn__["a" /* DataGridTemplateColumn */], { getValue: getterLogin, header: polyglot.t('service_account.label_username'), render: function render(colProps) {
            var sa = colProps.datum;
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, sa.OngoingAutoImport ? importIcon : null, " ", getterLogin(sa));
        } }), props.isDivisionAware && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGridTextColumn__["a" /* DataGridTextColumn */], { header: polyglot.t('service_account.label_division'), getValue: getDivisionName }), props.isAdmin && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Columns_DataGridButtonColumn__["a" /* DataGridButtonColumn */], { header: polyglot.t('column.action'), title: polyglot.t('button.edit_short'), onClick: props.onEdit }));
};

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServiceAccountRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Container__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditCreate_EditCreateEntityRoute__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NewServiceAccount__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ServiceAccountGrid__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EditServiceAccountActions__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_EditCreateEntityActions__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flux_Grid_SelectedItemsActions__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Buttons__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Toolbar__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__flux_Error_ErrorActions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_configure_store__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Table_NoResults__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Table_TableTitle__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_StickyMediator__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Search_GenericSearchWidget__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__TrashButtonWidget__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DeleteConfirmationWidget__ = __webpack_require__(104);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var appStyles = __webpack_require__(64);
var tableStyles = __webpack_require__(73);
var ServiceAccountRoute = function (_React$Component) {
    _inherits(ServiceAccountRoute, _React$Component);

    function ServiceAccountRoute() {
        _classCallCheck(this, ServiceAccountRoute);

        var _this = _possibleConstructorReturn(this, (ServiceAccountRoute.__proto__ || Object.getPrototypeOf(ServiceAccountRoute)).apply(this, arguments));

        _this.errorActions = new __WEBPACK_IMPORTED_MODULE_12__flux_Error_ErrorActions__["a" /* ErrorActions */]();
        _this.editActions = new __WEBPACK_IMPORTED_MODULE_7__EditServiceAccountActions__["a" /* EditServiceAccountActions */]();
        _this.editCreateEntityActions = new __WEBPACK_IMPORTED_MODULE_8__actions_EditCreateEntityActions__["a" /* EditCreateEntityActions */]();
        _this.selectedItemsActions = new __WEBPACK_IMPORTED_MODULE_9__flux_Grid_SelectedItemsActions__["a" /* SelectedItemsActions */]();
        _this.stickyMediator = new __WEBPACK_IMPORTED_MODULE_16__utils_StickyMediator__["a" /* StickyMediator */]();
        return _this;
    }

    _createClass(ServiceAccountRoute, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.props.refresher.run();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                isAdmin = _props.isAdmin,
                polyglot = _props.polyglot;

            var createForm = function createForm(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Container__["a" /* Container */], { merge: true, stores: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_configure_store__["b" /* twoButtonDialogConfig */])(_this2.props.upsertInProgressStore, _this2.props.upsertErrorStore) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__EditCreate_EditCreateEntityRoute__["a" /* EditCreateEntityRoute */], { title: props.title, okTitle: props.okTitle, path: props.path, cancelTitle: "Cancel", renderEdit: function renderEdit() {
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Container__["a" /* Container */], { merge: true, stores: [_this2.props.editStore, [_this2.props.loadDivisionInProgress, function (store) {
                                return { loadDivisionsInProgress: store.isSet() };
                            }]], actions: _this2.editActions, onMount: _this2.props.initUpsert.execute }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__NewServiceAccount__["a" /* NewServiceAccount */], { polyglot: polyglot, loadDivisionsInProgress: null }));
                    }, cancel: function cancel() {
                        __WEBPACK_IMPORTED_MODULE_3__routes__["b" /* appNavigator */].goToEntityTab(entityType);
                        _this2.editCreateEntityActions.rejectDraft(entityType);
                    }, ok: function ok() {
                        return _this2.props.upsertCommand.execute(_this2.props.editStore.getState().draft);
                    } }));
            };
            var entityType = __WEBPACK_IMPORTED_MODULE_1__models__["a" /* EntityType */].ServiceAccount;
            var disableInject = {
                disabled: function disabled() {
                    return _this2.props.selectedItemsStore.getState().selected.size === 0;
                }
            };
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, isAdmin && createForm({ title: polyglot.t('service_account.create_title'), okTitle: polyglot.t('button.create'), path: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__routes__["h" /* addNewRouteFor */])(entityType) }), isAdmin && createForm({ title: polyglot.t('service_account.edit_title'), okTitle: polyglot.t('button.save'), path: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__routes__["i" /* editRouteFor */])(entityType) }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__DeleteConfirmationWidget__["a" /* DeleteConfirmationWidget */], Object.assign({}, this.props, { entityType: entityType, title: polyglot.t('service_account.del_confirmation_title') }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: appStyles.ConfirmationContainer }, polyglot.t('service_account.del_confirmation_msg'))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__Search_GenericSearchWidget__["a" /* GenericSearchWidget */], Object.assign({}, this.props)), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: appStyles.StickyControlPanel, ref: this.stickyMediator.onToolbox }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Toolbar__["a" /* Toolbar */], null, isAdmin && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_Buttons__["a" /* Button */], { type: "success", leftIcon: "plus", onClick: function onClick() {
                    _this2.editCreateEntityActions.rejectDraft(entityType);
                    _this2.errorActions.clearError(_this2.props.upsertErrorStore.dispatchToken);
                    __WEBPACK_IMPORTED_MODULE_3__routes__["b" /* appNavigator */].goToAddNewEntityTab(entityType);
                } }, polyglot.t('button.new')), isAdmin && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__TrashButtonWidget__["a" /* TrashButtonWidget */], Object.assign({ entityType: __WEBPACK_IMPORTED_MODULE_1__models__["a" /* EntityType */].ServiceAccount }, this.props))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__Table_TableTitle__["a" /* TableTitle */], { polyglot: polyglot, labelStore: this.props.tableTitleStore })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Container__["a" /* Container */], { merge: true, stores: [this.props.listStore, this.props.selectedItemsStore] }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ServiceAccountGrid__["a" /* ServiceAccountGrid */], { className: tableStyles.StickyTable, polyglot: polyglot, isAdmin: isAdmin, isDivisionAware: this.props.isDivisionAware, items: null, selected: null, allSelected: null, onEdit: function onEdit(datum, row) {
                    _this2.editCreateEntityActions.setEntityToEdit(datum, entityType);
                    _this2.errorActions.clearError(_this2.props.upsertErrorStore.dispatchToken);
                    __WEBPACK_IMPORTED_MODULE_3__routes__["b" /* appNavigator */].goToEditEntityTab(entityType);
                }, toggle: function toggle(datum, row) {
                    return _this2.selectedItemsActions.toggleItem(datum.id, entityType);
                }, toggleAll: function toggleAll() {
                    return _this2.selectedItemsActions.toggleAll(entityType);
                }, onThead: this.stickyMediator.onThead })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Table_NoResults__["a" /* NoResults */], { polyglot: polyglot, listStore: this.props.listStore })));
        }
    }]);

    return ServiceAccountRoute;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InitUpsertServiceAccountCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Error_ErrorActions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Flag_FlagActions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditServiceAccountActions__ = __webpack_require__(216);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var InitUpsertServiceAccountCommand = function InitUpsertServiceAccountCommand(runSearch, store, getDidivionId, errorDispatchToken, inProgressDispatchToken) {
    var _this = this;

    _classCallCheck(this, InitUpsertServiceAccountCommand);

    this.runSearch = runSearch;
    this.store = store;
    this.getDidivionId = getDidivionId;
    this.errorDispatchToken = errorDispatchToken;
    this.inProgressDispatchToken = inProgressDispatchToken;
    this.editServiceAccountActions = new __WEBPACK_IMPORTED_MODULE_2__EditServiceAccountActions__["a" /* EditServiceAccountActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_0__flux_Error_ErrorActions__["a" /* ErrorActions */]();
    this.inProgressActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Flag_FlagActions__["a" /* FlagActions */]();
    this.execute = function () {
        _this.errorActions.clearError(_this.errorDispatchToken); // reset error from previous edit session
        _this.inProgressActions.set(_this.inProgressDispatchToken);
        _this.runSearch({ Name: 'Divisions' }).then(function (res) {
            var divisions = res.Entries.Division;

            var _store$getState$draft = _this.store.getState().draft,
                DivisionId = _store$getState$draft.DivisionId,
                id = _store$getState$draft.id;

            if (DivisionId == null && id == null) {
                var currDivisionId = _this.getDidivionId();
                var division = divisions.find(function (d) {
                    return d.id === currDivisionId;
                });
                if (division) {
                    _this.editServiceAccountActions.setDivision(division);
                }
            }
            _this.editServiceAccountActions.setDivisionItems(divisions);
        }).catch(function (err) {
            return _this.errorActions.setError(err, _this.errorDispatchToken);
        }).then(function () {
            return _this.inProgressActions.reset(_this.inProgressDispatchToken);
        }); // finaly
    };
};

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpsertServiceAccountCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Error_ErrorActions__ = __webpack_require__(13);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var UpsertServiceAccountCommand = function UpsertServiceAccountCommand(polyglot, errorDispatchToken, upsert) {
    var _this = this;

    _classCallCheck(this, UpsertServiceAccountCommand);

    this.polyglot = polyglot;
    this.errorDispatchToken = errorDispatchToken;
    this.upsert = upsert;
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Error_ErrorActions__["a" /* ErrorActions */]();
    this.execute = function (draft) {
        var DivisionId = draft.DivisionId,
            ServerUrl = draft.ServerUrl;

        var setError = function setError(msg) {
            return _this.errorActions.setError(new Error(msg), _this.errorDispatchToken);
        };
        if (typeof DivisionId !== 'number') {
            setError(_this.polyglot.t('service_account.validation_err.division_not_set'));
            return;
        }
        if (typeof ServerUrl !== 'string' || ServerUrl === '') {
            setError(_this.polyglot.t('service_account.validation_err.invalid_server_url'));
            return;
        }
        _this.upsert.execute(draft, __WEBPACK_IMPORTED_MODULE_0__models__["a" /* EntityType */].ServiceAccount);
    };
};

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InitUpsertServiceAccountCommand__ = __webpack_require__(552);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InitUpsertServiceAccountCommand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UpsertServiceAccountCommand__ = __webpack_require__(553);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__UpsertServiceAccountCommand__["a"]; });



/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddGroupAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Forms_FormItemVertical__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Select__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Buttons__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__converters_converters__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__groupEditNames__ = __webpack_require__(315);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var AddGroupAction = function (_React$Component) {
    _inherits(AddGroupAction, _React$Component);

    function AddGroupAction(props, context) {
        _classCallCheck(this, AddGroupAction);

        var _this = _possibleConstructorReturn(this, (AddGroupAction.__proto__ || Object.getPrototypeOf(AddGroupAction)).call(this, props, context));

        _this.state = { selectedActionType: null };
        return _this;
    }

    _createClass(AddGroupAction, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                polyglot = _props.polyglot,
                isValid = _props.isValid,
                selectedActionType = _props.selectedActionType,
                onGroupActionChanged = _props.onGroupActionChanged,
                commitAction = _props.commitAction;

            var children = __WEBPACK_IMPORTED_MODULE_0_react__["Children"].toArray(this.props.children).filter(function (child) {
                return typeof child !== 'string' && typeof child !== 'number';
            });
            var types = children.map(function (child, idx) {
                return child.props.type;
            });
            var selectedGroupAction = children.find(function (child) {
                return child.props.type === selectedActionType;
            });
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 col-xs-12" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Forms_FormItemVertical__["a" /* FormItemVertical */], { title: polyglot.t('vehicle.group_actions.title_select_action') + ':' }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_Select__["a" /* Select */], { className: 'form-control', placeholder: '---', defaultValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__converters_converters__["a" /* intToString */])(selectedActionType), items: types, valueFn: function valueFn(actionType) {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__converters_converters__["a" /* intToString */])(actionType);
                }, titleFn: function titleFn(actionType) {
                    return polyglot.t(__WEBPACK_IMPORTED_MODULE_5__groupEditNames__["a" /* groupActionsTranslationKeys */].get(actionType));
                }, onChange: function onChange(s) {
                    return onGroupActionChanged(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__converters_converters__["b" /* stringToInt */])(s.getValue()));
                } })), selectedGroupAction, selectedGroupAction != null && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_Buttons__["a" /* Button */], { type: 'success', onClick: commitAction, disabled: !isValid }, polyglot.t('button.add')));
        }
    }]);

    return AddGroupAction;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VehicleBatchEdit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Buttons__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddTags__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__groupEditNames__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddGroupAction__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GroupActions__ = __webpack_require__(561);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var styles = __webpack_require__(965);
var VehicleBatchEdit = function (_React$Component) {
    _inherits(VehicleBatchEdit, _React$Component);

    function VehicleBatchEdit() {
        _classCallCheck(this, VehicleBatchEdit);

        return _possibleConstructorReturn(this, (VehicleBatchEdit.__proto__ || Object.getPrototypeOf(VehicleBatchEdit)).apply(this, arguments));
    }

    _createClass(VehicleBatchEdit, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                polyglot = _props.polyglot,
                selectedAction = _props.selectedAction,
                selectGroupAction = _props.selectGroupAction,
                isGroupActionValid = _props.isGroupActionValid,
                addedActions = _props.addedActions,
                commitAction = _props.commitAction,
                availableTags = _props.availableTags,
                suggestedTags = _props.suggestedTags,
                allTags = _props.allTags,
                actionValue = _props.actionValue,
                setTags = _props.setTags,
                timezones = _props.timezones,
                setTimezone = _props.setTimezone,
                setAxle = _props.setAxle,
                setBaseline = _props.setBaseline,
                setRedMax = _props.setRedMax,
                setYellowMax = _props.setYellowMax,
                setYellowMin = _props.setYellowMin,
                setRedMin = _props.setRedMin,
                unit = _props.unit;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styles.VehicleBatchEdit + " VehicleBatchEdit" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__AddGroupAction__["a" /* AddGroupAction */], { polyglot: polyglot, isValid: true, selectedActionType: selectedAction, onGroupActionChanged: selectGroupAction, commitAction: commitAction }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__AddTags__["a" /* AddTags */], Object.assign({}, { type: __WEBPACK_IMPORTED_MODULE_2__flux__["c" /* ActionType */].AddTags }, { className: styles.EditTags, options: allTags, selected: actionValue, onChange: setTags })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__GroupActions__["a" /* RemoveTagsGroupAction */], { suggestions: suggestedTags, className: styles.EditTags, options: availableTags, selectedTags: actionValue, onChange: setTags }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__GroupActions__["b" /* TimezoneGroupAction */], { polyglot: polyglot, selectedTimezone: actionValue, options: timezones, onChange: setTimezone }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__GroupActions__["c" /* PressureGroupAction */], { polyglot: polyglot, levels: actionValue, axleCount: this.props.axleCount, setAxle: setAxle, setBaseline: setBaseline, setRedMax: setRedMax, setRedMin: setRedMin, setYellowMax: setYellowMax, setYellowMin: setYellowMin, unit: unit, setDefineAlertLevels: this.props.setDefineAlertLevelsFlag }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__GroupActions__["d" /* TemperatureGroupAction */], { polyglot: polyglot, levels: actionValue, axleCount: this.props.axleCount, setAxle: setAxle, setRedMax: setRedMax, setRedMin: setRedMin, setYellowMax: setYellowMax, setYellowMin: setYellowMin, unit: unit })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, this.actionsListMarkup(addedActions)));
        }
    }, {
        key: "actionsListMarkup",
        value: function actionsListMarkup(actions) {
            var _this2 = this;

            var _props2 = this.props,
                removeAction = _props2.removeAction,
                polyglot = _props2.polyglot;

            return actions && actions.length > 0 ? [__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", { key: "1", style: { textAlign: 'center' } }, polyglot.t('vehicle.group_actions.added_actions_title')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { key: "2", className: styles.List }, actions.map(function (item, idx) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: idx }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styles.Item }, _this2.actionMarkup(item), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_Buttons__["a" /* Button */], { leftIcon: "remove", dim: "xs", onClick: function onClick() {
                        return removeAction(item.id);
                    } })));
            }))] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styles.EmptyLabel }, polyglot.t('vehicle.group_actions.no_actions_placeholder'));
        }
    }, {
        key: "actionMarkup",
        value: function actionMarkup(action) {
            var polyglot = this.props.polyglot;

            var val = action.value;
            switch (action.type) {
                case __WEBPACK_IMPORTED_MODULE_2__flux__["c" /* ActionType */].AddTags:
                case __WEBPACK_IMPORTED_MODULE_2__flux__["c" /* ActionType */].RemoveTags:
                    val = (action.value || []).join(', ');
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__flux__["c" /* ActionType */].SetTimezone:
                    val = action.value.Display;
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__flux__["c" /* ActionType */].SetTemperature:
                    var tLevels = action.value;
                    val = joinTemperatureLevels(polyglot, tLevels, action.meta);
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__flux__["c" /* ActionType */].SetPressure:
                    var pLevels = action.value;
                    val = joinPressureLevels(polyglot, pLevels, action.meta);
                    break;
                default:
                    throw new Error("there is no implementation for " + action.type);
            }
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null, polyglot.t(__WEBPACK_IMPORTED_MODULE_4__groupEditNames__["a" /* groupActionsTranslationKeys */].get(action.type)), ": "), val);
        }
    }]);

    return VehicleBatchEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
function joinPressureLevels(polyglot, levels, unitName) {
    var values = [];
    if (levels.Axle != null) values.push(polyglot.t('levels.axles') + "=" + (levels.Axle > 0 ? levels.Axle : polyglot.t('levels.all_axles')));
    if (levels.Baseline != null) values.push(polyglot.t('levels.baseline') + "=" + levels.Baseline + " " + unitName);
    if (levels.RelLevelMaximumRed != null) values.push(polyglot.t('levels.red_max') + "=+" + levels.RelLevelMaximumRed + "%");
    if (levels.RelLevelMaximumYellow != null) values.push(polyglot.t('levels.yellow_max') + "=+" + levels.RelLevelMaximumYellow + "%");
    if (levels.RelLevelMinimumYellow != null) values.push(polyglot.t('levels.yellow_min') + "=-" + levels.RelLevelMinimumYellow + "%");
    if (levels.RelLevelMinimumRed != null) values.push(polyglot.t('levels.red_min') + "=-" + levels.RelLevelMinimumRed + "%");
    return values.join(', ');
}
function joinTemperatureLevels(polyglot, levels, unitName) {
    var values = [];
    if (levels.Axle != null) values.push(polyglot.t('levels.axles') + "=" + (levels.Axle > 0 ? levels.Axle : polyglot.t('levels.all_axles')));
    if (levels.AbsLevelMaximumRed != null) values.push(polyglot.t('levels.red_max') + "=" + levels.AbsLevelMaximumRed + " " + unitName);
    if (levels.AbsLevelMaximumYellow != null) values.push(polyglot.t('levels.yellow_max') + "=" + levels.AbsLevelMaximumYellow + " " + unitName);
    if (levels.AbsLevelMinimumYellow != null) values.push(polyglot.t('levels.yellow_min') + "=" + levels.AbsLevelMinimumYellow + " " + unitName);
    if (levels.AbsLevelMinimumRed != null) values.push(polyglot.t('levels.red_min') + "=" + levels.AbsLevelMinimumRed + " " + unitName);
    return values.join(', ');
}

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PressureGroupAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Levels_Levels__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux__ = __webpack_require__(39);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var PressureGroupAction = function (_React$Component) {
    _inherits(PressureGroupAction, _React$Component);

    function PressureGroupAction() {
        _classCallCheck(this, PressureGroupAction);

        return _possibleConstructorReturn(this, (PressureGroupAction.__proto__ || Object.getPrototypeOf(PressureGroupAction)).apply(this, arguments));
    }

    _createClass(PressureGroupAction, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                polyglot = _props.polyglot,
                unit = _props.unit,
                levels = _props.levels,
                setBaseline = _props.setBaseline,
                setRedMax = _props.setRedMax,
                setYellowMax = _props.setYellowMax,
                setYellowMin = _props.setYellowMin,
                setRedMin = _props.setRedMin;
            var Axle = levels.Axle,
                RelLevelMaximumRed = levels.RelLevelMaximumRed,
                RelLevelMaximumYellow = levels.RelLevelMaximumYellow,
                RelLevelMinimumYellow = levels.RelLevelMinimumYellow,
                RelLevelMinimumRed = levels.RelLevelMinimumRed;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Levels_Levels__["a" /* Levels */], { isBaselineVisible: true, polyglot: polyglot, unitName: unit ? unit.Name : '', axleCount: this.props.axleCount, axle: Axle, setAxle: this.props.setAxle, baseline: levels.Baseline, setBaseline: setBaseline, defineAlertLevels: this.props.levels.DefineAlertLevels, setDefineAlertLevels: this.props.setDefineAlertLevels, redMax: RelLevelMaximumRed, setRedMax: setRedMax, yellowMax: RelLevelMaximumYellow, setYellowMax: setYellowMax, yellowMin: RelLevelMinimumYellow, setYellowMin: setYellowMin, redMin: RelLevelMinimumRed, setRedMin: setRedMin });
        }
    }]);

    return PressureGroupAction;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
PressureGroupAction.defaultProps = {
    type: __WEBPACK_IMPORTED_MODULE_2__flux__["c" /* ActionType */].SetPressure
};

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RemoveTagsGroupAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SuggestList_SuggestList__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TypeaheadEnterEscWrapper__ = __webpack_require__(76);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var RemoveTagsGroupAction = function (_React$Component) {
    _inherits(RemoveTagsGroupAction, _React$Component);

    function RemoveTagsGroupAction() {
        _classCallCheck(this, RemoveTagsGroupAction);

        return _possibleConstructorReturn(this, (RemoveTagsGroupAction.__proto__ || Object.getPrototypeOf(RemoveTagsGroupAction)).apply(this, arguments));
    }

    _createClass(RemoveTagsGroupAction, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                className = _props.className,
                options = _props.options,
                selectedTags = _props.selectedTags,
                suggestions = _props.suggestions,
                onChange = _props.onChange;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: className }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__TypeaheadEnterEscWrapper__["a" /* TypeaheadEnterEscWrapper */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["Typeahead"], { key: "remove-tags", multiple: true, placeholder: "Enter a tag", selected: selectedTags, options: options, onChange: onChange })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__SuggestList_SuggestList__["a" /* SuggestList */], { items: suggestions, onClick: function onClick(tag, idx) {
                    return onChange([].concat(_toConsumableArray(selectedTags), [tag]));
                } }));
        }
    }]);

    return RemoveTagsGroupAction;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
RemoveTagsGroupAction.defaultProps = {
    type: __WEBPACK_IMPORTED_MODULE_3__flux__["c" /* ActionType */].RemoveTags
};

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TemperatureGroupAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Levels_Levels__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux__ = __webpack_require__(39);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var TemperatureGroupAction = function (_React$Component) {
    _inherits(TemperatureGroupAction, _React$Component);

    function TemperatureGroupAction() {
        _classCallCheck(this, TemperatureGroupAction);

        return _possibleConstructorReturn(this, (TemperatureGroupAction.__proto__ || Object.getPrototypeOf(TemperatureGroupAction)).apply(this, arguments));
    }

    _createClass(TemperatureGroupAction, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                polyglot = _props.polyglot,
                unit = _props.unit,
                levels = _props.levels,
                setRedMax = _props.setRedMax,
                setYellowMax = _props.setYellowMax,
                setYellowMin = _props.setYellowMin,
                setRedMin = _props.setRedMin;
            var Axle = levels.Axle,
                AbsLevelMaximumRed = levels.AbsLevelMaximumRed,
                AbsLevelMaximumYellow = levels.AbsLevelMaximumYellow,
                AbsLevelMinimumYellow = levels.AbsLevelMinimumYellow,
                AbsLevelMinimumRed = levels.AbsLevelMinimumRed;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Levels_Levels__["a" /* Levels */], { polyglot: polyglot, unitName: unit ? unit.Name : '', axleCount: this.props.axleCount, axle: Axle, setAxle: this.props.setAxle, redMax: AbsLevelMaximumRed, setRedMax: setRedMax, yellowMax: AbsLevelMaximumYellow, setYellowMax: setYellowMax, yellowMin: AbsLevelMinimumYellow, setYellowMin: setYellowMin, redMin: AbsLevelMinimumRed, setRedMin: setRedMin });
        }
    }]);

    return TemperatureGroupAction;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
TemperatureGroupAction.defaultProps = {
    type: __WEBPACK_IMPORTED_MODULE_2__flux__["c" /* ActionType */].SetTemperature
};

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimezoneGroupAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Forms_FormItemVertical__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TypeaheadEnterEscWrapper__ = __webpack_require__(76);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var TimezoneGroupAction = function (_React$Component) {
    _inherits(TimezoneGroupAction, _React$Component);

    function TimezoneGroupAction() {
        _classCallCheck(this, TimezoneGroupAction);

        return _possibleConstructorReturn(this, (TimezoneGroupAction.__proto__ || Object.getPrototypeOf(TimezoneGroupAction)).apply(this, arguments));
    }

    _createClass(TimezoneGroupAction, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                polyglot = _props.polyglot,
                options = _props.options,
                selectedTimezone = _props.selectedTimezone,
                _onChange = _props.onChange;

            var selected = selectedTimezone ? [selectedTimezone] : [];
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Forms_FormItemVertical__["a" /* FormItemVertical */], { title: polyglot.t('vehicle.label_timezone') + ':' }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__TypeaheadEnterEscWrapper__["a" /* TypeaheadEnterEscWrapper */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["Typeahead"], { key: "timezones", labelKey: function labelKey(tz) {
                    return tz.Display;
                }, options: options, selected: selected, onChange: function onChange(tz) {
                    return _onChange(Array.isArray(tz) && tz.length > 0 ? tz[0] : null);
                }, placeholder: polyglot.t('vehicle.placeholder_timezone') })));
        }
    }]);

    return TimezoneGroupAction;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
TimezoneGroupAction.defaultProps = {
    type: __WEBPACK_IMPORTED_MODULE_3__flux__["c" /* ActionType */].SetTimezone
};

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PressureGroupAction__ = __webpack_require__(557);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__PressureGroupAction__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TemperatureGroupAction__ = __webpack_require__(559);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__TemperatureGroupAction__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TimezoneGroupAction__ = __webpack_require__(560);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__TimezoneGroupAction__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemoveTagsGroupAction__ = __webpack_require__(558);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__RemoveTagsGroupAction__["a"]; });





/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VehicleBatchEditStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueid__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_assert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VehicleBatchEditActions__ = __webpack_require__(314);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ActionType;
(function (ActionType) {
    ActionType[ActionType["AddTags"] = 0] = "AddTags";
    ActionType[ActionType["RemoveTags"] = 1] = "RemoveTags";
    ActionType[ActionType["SetTimezone"] = 2] = "SetTimezone";
    ActionType[ActionType["SetPressure"] = 3] = "SetPressure";
    ActionType[ActionType["SetTemperature"] = 4] = "SetTemperature";
})(ActionType || (ActionType = {}));
var VehicleBatchEditStore = function (_Store) {
    _inherits(VehicleBatchEditStore, _Store);

    function VehicleBatchEditStore() {
        _classCallCheck(this, VehicleBatchEditStore);

        var _this = _possibleConstructorReturn(this, (VehicleBatchEditStore.__proto__ || Object.getPrototypeOf(VehicleBatchEditStore)).call(this));

        _this.state = _this.getDefaultState();
        _this.register(__WEBPACK_IMPORTED_MODULE_3__VehicleBatchEditActions__["b" /* names */].SET_IDS, function (e) {
            var _this$getState = _this.getState(),
                _this$getState$addedA = _this$getState.addedActions,
                addedActions = _this$getState$addedA === undefined ? [] : _this$getState$addedA;

            return _this.field({
                ids: e.payload,
                availableTags: [],
                suggestedTags: []
            });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__VehicleBatchEditActions__["b" /* names */].SET_AXLE_COUNT, function (e) {
            return _this.field({ axleCount: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__VehicleBatchEditActions__["b" /* names */].SET_AVAILABLE_TAGS_STAT, function (e) {
            var tagsStat = e.payload;
            var tags = calcTags(tagsStat);
            return _this.field({ tagsStat: tagsStat, availableTags: tags.available, suggestedTags: tags.suggested });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__VehicleBatchEditActions__["b" /* names */].SET_ALL_TAGS, function (e) {
            return _this.field({ allTags: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__VehicleBatchEditActions__["b" /* names */].SELECT_ACTION, function (e) {
            return _this.field({
                selectedAction: e.payload,
                actionValue: _this.getDefaultActionValue(e.payload),
                isGroupActionValid: false,
                unit: null
            });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__VehicleBatchEditActions__["b" /* names */].SET_SELECTED_TAGS, function (e) {
            if (_this.state.selectedAction === ActionType.RemoveTags) {
                var selectedTags = e.payload;
                var tagsSet = new Set(selectedTags);
                var tagsStat = new Map([].concat(_toConsumableArray(_this.state.tagsStat)).filter(function (kv) {
                    return !tagsSet.has(kv[0]);
                }));
                var tags = calcTags(tagsStat);
                return _this.field({ actionValue: selectedTags, availableTags: tags.available, suggestedTags: tags.suggested, isGroupActionValid: Array.isArray(selectedTags) && selectedTags.length > 0 });
            } else if (_this.state.selectedAction === ActionType.AddTags) {
                var _tags = e.payload;
                return _this.field({ actionValue: _tags, isGroupActionValid: Array.isArray(_tags) && _tags.length > 0 });
            }
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__VehicleBatchEditActions__["b" /* names */].SET_TIMEZONE, function (e) {
            return _this.field({ actionValue: e.payload, isGroupActionValid: e.payload != null });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__VehicleBatchEditActions__["b" /* names */].SET_UNIT, function (e) {
            return _this.field({ unit: e.payload });
        });
        var isRel = function isRel() {
            return _this.state.selectedAction === ActionType.SetPressure;
        };
        _this.register(__WEBPACK_IMPORTED_MODULE_3__VehicleBatchEditActions__["b" /* names */].SET_AXLE, function (e) {
            var actionValue = Object.assign({}, _this.state.actionValue, { Axle: e.payload });
            return _this.field({
                actionValue: actionValue,
                isGroupActionValid: isRel() ? isPressureLevelsValid(actionValue) : isTemperatureLevelsValid(actionValue)
            });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__VehicleBatchEditActions__["b" /* names */].SET_BASELINE, function (e) {
            return _this.pressureLevels({ Baseline: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__VehicleBatchEditActions__["b" /* names */].SET_DEFINE_ALERT_LEVELS_FLAG, function (e) {
            return _this.pressureLevels({ DefineAlertLevels: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__VehicleBatchEditActions__["b" /* names */].SET_RED_MAX, function (e) {
            return isRel() ? _this.pressureLevels({ RelLevelMaximumRed: e.payload }) : _this.temperatureLevels({ AbsLevelMaximumRed: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__VehicleBatchEditActions__["b" /* names */].SET_YELLOW_MAX, function (e) {
            return isRel() ? _this.pressureLevels({ RelLevelMaximumYellow: e.payload }) : _this.temperatureLevels({ AbsLevelMaximumYellow: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__VehicleBatchEditActions__["b" /* names */].SET_YELLOW_MIN, function (e) {
            return isRel() ? _this.pressureLevels({ RelLevelMinimumYellow: e.payload }) : _this.temperatureLevels({ AbsLevelMinimumYellow: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__VehicleBatchEditActions__["b" /* names */].SET_RED_MIN, function (e) {
            return isRel() ? _this.pressureLevels({ RelLevelMinimumRed: e.payload }) : _this.temperatureLevels({ AbsLevelMinimumRed: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__VehicleBatchEditActions__["b" /* names */].COMMIT_ACTION, function (e) {
            var _this$getState2 = _this.getState(),
                _this$getState2$ids = _this$getState2.ids,
                ids = _this$getState2$ids === undefined ? [] : _this$getState2$ids,
                _this$getState2$added = _this$getState2.addedActions,
                actions = _this$getState2$added === undefined ? [] : _this$getState2$added,
                type = _this$getState2.selectedAction,
                value = _this$getState2.actionValue,
                tagsStat = _this$getState2.tagsStat,
                unit = _this$getState2.unit;

            var newActions = actions;
            var newSelectedAction = type;
            var newActionValue = value;
            var meta = null;
            if (type === ActionType.SetPressure || type === ActionType.SetTemperature) {
                value.UnitId = unit.Id;
                meta = unit.Name;
                if (type === ActionType.SetTemperature) {
                    if (value.AbsLevelMinimumRed < value.AbsLevelMinimumYellow && value.AbsLevelMinimumYellow < value.AbsLevelMaximumYellow && value.AbsLevelMaximumYellow < value.AbsLevelMaximumRed) {
                        newActions = [].concat(_toConsumableArray(actions), [{ type: type, value: value, id: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueid___default()(), meta: meta }]);
                        newActionValue = null;
                        newSelectedAction = null;
                    } else {
                        alert('Inconsitent values - Red levels must be higher than Yellow levels');
                    }
                } else if (type === ActionType.SetPressure) {
                    if (value.DefineAlertLevels == true && value.RelLevelMaximumRed > value.RelLevelMaximumYellow && value.RelLevelMinimumRed > value.RelLevelMinimumYellow) {
                        newActions = [].concat(_toConsumableArray(actions), [{ type: type, value: value, id: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueid___default()(), meta: meta }]);
                        newActionValue = null;
                        newSelectedAction = null;
                    } else if (value.DefineAlertLevels == false) {
                        newActions = [].concat(_toConsumableArray(actions), [{ type: type, value: value, id: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueid___default()(), meta: meta }]);
                        newActionValue = null;
                        newSelectedAction = null;
                    } else {
                        alert('Inconsitent values - Red levels must be higher than Yellow levels');
                    }
                }
            } else {
                newActions = [].concat(_toConsumableArray(actions), [{ type: type, value: value, id: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueid___default()(), meta: meta }]);
                newActionValue = null;
                newSelectedAction = null;
            }
            var tags = calcTags(tagsStat);
            return _this.field({
                addedActions: newActions,
                selectedAction: newSelectedAction,
                actionValue: newActionValue,
                availableTags: tags.available,
                suggestedTags: tags.suggested
            });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__VehicleBatchEditActions__["b" /* names */].REMOVE_ACTION, function (e) {
            var actionId = e.payload;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_assert__["g" /* assertString */])(actionId);

            var _this$getState3 = _this.getState(),
                _this$getState3$ids = _this$getState3.ids,
                ids = _this$getState3$ids === undefined ? [] : _this$getState3$ids,
                _this$getState3$added = _this$getState3.addedActions,
                actions = _this$getState3$added === undefined ? [] : _this$getState3$added;

            var idx = actions.findIndex(function (a) {
                return a.id === actionId;
            });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_assert__["a" /* assertTrue */])(idx >= 0);
            var addedActions = [].concat(_toConsumableArray(actions.slice(0, idx)), _toConsumableArray(actions.slice(idx + 1)));
            return _this.field({ addedActions: addedActions });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__VehicleBatchEditActions__["b" /* names */].REJECT_DRAFT, function (e) {
            return _this.getDefaultState();
        });
        return _this;
    }

    _createClass(VehicleBatchEditStore, [{
        key: "pressureLevels",
        value: function pressureLevels(levels) {
            var newLevels = Object.assign({}, this.state.actionValue, levels);
            return this.field({ actionValue: newLevels, isGroupActionValid: isPressureLevelsValid(newLevels) });
        }
    }, {
        key: "temperatureLevels",
        value: function temperatureLevels(levels) {
            var newLevels = Object.assign({}, this.state.actionValue, levels);
            return this.field({ actionValue: newLevels, isGroupActionValid: isTemperatureLevelsValid(newLevels) });
        }
    }, {
        key: "getDefaultActionValue",
        value: function getDefaultActionValue(type) {
            switch (type) {
                case ActionType.SetPressure:
                    return {
                        DefineAlertLevels: false
                    };
                case ActionType.SetTemperature:
                    return {};
                case ActionType.AddTags:
                case ActionType.RemoveTags:
                    return [];
                default:
                    return null;
            }
        }
    }, {
        key: "getDefaultState",
        value: function getDefaultState() {
            return {
                ids: [],
                allTags: [],
                tagsStat: new Map(),
                availableTags: [],
                suggestedTags: [],
                addedActions: [],
                unit: null,
                selectedAction: null,
                actionValue: null,
                axleCount: 0,
                isGroupActionValid: false
            };
        }
    }, {
        key: "isValid",
        value: function isValid() {
            var _state = this.state,
                ids = _state.ids,
                addedActions = _state.addedActions;

            if (ids.length == 0) {
                ids = JSON.parse(localStorage.getItem('groupActionVehicleIds'));
            }
            return Array.isArray(ids) && ids.length > 0 && Array.isArray(addedActions) && addedActions.length > 0;
        }
    }]);

    return VehicleBatchEditStore;
}(__WEBPACK_IMPORTED_MODULE_1__flux__["c" /* Store */]);
function isPressureLevelsValid(levels) {
    var Axle = levels.Axle,
        Baseline = levels.Baseline;

    return Baseline > 0;
}
function isTemperatureLevelsValid(levels) {
    var Axle = levels.Axle,
        AbsLevelMaximumRed = levels.AbsLevelMaximumRed,
        AbsLevelMaximumYellow = levels.AbsLevelMaximumYellow,
        AbsLevelMinimumRed = levels.AbsLevelMinimumRed,
        AbsLevelMinimumYellow = levels.AbsLevelMinimumYellow;

    return typeof Axle === 'number'; // && (isNumber(AbsLevelMaximumRed) || isNumber(AbsLevelMaximumYellow) || isNumber(AbsLevelMinimumRed) || isNumber(AbsLevelMinimumYellow));
}
function calcTags(stat) {
    var available = [].concat(_toConsumableArray(stat)).sort(function (a, b) {
        return b[1] - a[1];
    }).map(function (kv) {
        return kv[0];
    });
    var suggested = available.slice(0, 5);
    return { available: available, suggested: suggested };
}

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SourceSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Buttons__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Forms_FormGroup__ = __webpack_require__(213);



var styles = __webpack_require__(407);
var SourceSelector = function SourceSelector(_ref) {
    var onGeotabClicked = _ref.onGeotabClicked,
        onBoxIdClicked = _ref.onBoxIdClicked,
        active = _ref.active,
        polyglot = _ref.polyglot;
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Forms_FormGroup__["a" /* FormGroup */], { className: styles.SourceSelectorContainer }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "btn-group", role: "group", "aria-label": "select a data source" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_Buttons__["a" /* Button */], { onClick: onBoxIdClicked, className: getClassName(active, 1) }, polyglot.t('vehicle.label_box_id_source'))));
};
function getClassName(active, index) {
    return active === index ? 'active' : null;
}

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewVehicle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_typeahead__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Select__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__converters_converters__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Forms_FormItemHorizontal__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SourceSelector__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Vehicle__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AddTags__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DivisionSelector__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Forms_Groups__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NonIsolatedPremise__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TypeaheadEnterEscWrapper__ = __webpack_require__(76);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




__webpack_require__(970);
var styles = __webpack_require__(407);










var getServiceAccountValue = function getServiceAccountValue(account) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__converters_converters__["a" /* intToString */])(account.id);
};
var getServiceAccoutDisplay = function getServiceAccoutDisplay(account) {
    return account.Username;
};
var getGeotabValue = function getGeotabValue(pair) {
    return pair.Id;
};
var getGeotabDisplay = function getGeotabDisplay(pair) {
    return pair.Name;
};
var getTimezoneDisplay = function getTimezoneDisplay(tz) {
    return tz.Display;
};
var NewVehicle = function (_React$Component) {
    _inherits(NewVehicle, _React$Component);

    function NewVehicle() {
        _classCallCheck(this, NewVehicle);

        return _possibleConstructorReturn(this, (NewVehicle.__proto__ || Object.getPrototypeOf(NewVehicle)).apply(this, arguments));
    }

    _createClass(NewVehicle, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                polyglot = _props.polyglot,
                draft = _props.draft,
                mode = _props.mode,
                setSource = _props.setSource,
                setBoxId = _props.setBoxId,
                setDisplay = _props.setDisplay,
                setTags = _props.setTags,
                setTimezone = _props.setTimezone;

            var selectedGeotab = getSelectedValue(this.props.vehicles || [], draft.GeotabId);
            var selectedTz = getSelectedValue(this.props.timezones || [], draft.TimezoneId);
            var selectedTzTitle = selectedTz.length ? selectedTz[0].Display : '';
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("form-horizontal", styles.NewVehicle) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__NonIsolatedPremise__["a" /* NonIsolatedPremise */], null, mode === 'create' && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__SourceSelector__["a" /* SourceSelector */], { polyglot: polyglot, active: draft.SourceId - 1, onGeotabClicked: function onGeotabClicked() {
                    return setSource(__WEBPACK_IMPORTED_MODULE_7__models_Vehicle__["a" /* Source */].Geotab);
                }, onBoxIdClicked: function onBoxIdClicked() {
                    return setSource(__WEBPACK_IMPORTED_MODULE_7__models_Vehicle__["a" /* Source */].BoxId);
                } })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__NonIsolatedPremise__["a" /* NonIsolatedPremise */], null, mode === 'edit' && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Forms_Groups__["a" /* LabelGroup */], { title: polyglot.t('vehicle.label_source') + ':', value: draft.SourceId === __WEBPACK_IMPORTED_MODULE_7__models_Vehicle__["a" /* Source */].Geotab ? 'Geotab' : 'Box ID' })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Forms_Groups__["b" /* LoadableGroup */], { title: polyglot.t('vehicle.label_division') + ':', value: draft.Division, isLoading: this.props.loadingDivisions }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__DivisionSelector__["a" /* DivisionSelector */], { divisions: this.props.allDivisions || [], onChange: this.props.onDivisionChanged, selectedId: draft.DivisionId })), draft.SourceId === __WEBPACK_IMPORTED_MODULE_7__models_Vehicle__["a" /* Source */].BoxId && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Forms_Groups__["c" /* InputTextGroup */], { title: polyglot.t('vehicle.label_box_id') + ':', value: draft.BoxId || '', onChange: function onChange(e) {
                    return setBoxId(e.target.value);
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__NonIsolatedPremise__["a" /* NonIsolatedPremise */], null, draft.SourceId == __WEBPACK_IMPORTED_MODULE_7__models_Vehicle__["a" /* Source */].BoxId && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'form-group', style: { height: 34 } })), draft.SourceId === __WEBPACK_IMPORTED_MODULE_7__models_Vehicle__["a" /* Source */].Geotab && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Forms_Groups__["b" /* LoadableGroup */], { title: polyglot.t('vehicle.label_service_account') + ':', value: draft.ServiceAccount, isLoading: this.props.loadingServiceAccounts }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_Select__["a" /* Select */], { className: 'form-control', placeholder: '---', items: this.props.filteredServiceAccounts || [], defaultValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__converters_converters__["a" /* intToString */])(draft.ServiceAccountId), valueFn: getServiceAccountValue, titleFn: getServiceAccoutDisplay, onChange: function onChange(s) {
                    var service_account = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__converters_converters__["b" /* stringToInt */])(s.getValue());
                    _this2.props.onServiceAccountChanged(service_account);
                } })), draft.SourceId === __WEBPACK_IMPORTED_MODULE_7__models_Vehicle__["a" /* Source */].Geotab && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Forms_Groups__["b" /* LoadableGroup */], { title: polyglot.t('vehicle.label_vehicle') + ':', value: draft.GeotabTitle, isLoading: this.props.loadingVehicles }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__TypeaheadEnterEscWrapper__["a" /* TypeaheadEnterEscWrapper */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_typeahead__["Typeahead"], { labelKey: getGeotabDisplay, options: this.props.vehicles || [], selected: selectedGeotab, onChange: function onChange(values) {
                    return _this2.props.onVehicleChanged(values && values.length > 0 ? values[0] : null);
                }, placeholder: polyglot.t('vehicle.placeholder_vehicle') }))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Forms_Groups__["b" /* LoadableGroup */], { title: polyglot.t('vehicle.label_timezone') + ':', value: selectedTzTitle, isLoading: false }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__TypeaheadEnterEscWrapper__["a" /* TypeaheadEnterEscWrapper */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_typeahead__["Typeahead"], { labelKey: getTimezoneDisplay, options: this.props.timezones, selected: selectedTz, onChange: function onChange(tz) {
                    return setTimezone(tz && tz.length ? tz[0].Id : null);
                }, placeholder: polyglot.t('vehicle.placeholder_timezone') }))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Forms_Groups__["c" /* InputTextGroup */], { title: polyglot.t('vehicle.label_display') + ':', value: draft.Display, onChange: function onChange(e) {
                    return setDisplay(e.target.value);
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Forms_FormItemHorizontal__["a" /* FormItemHorizontal */], { title: polyglot.t('vehicle.label_tags') + ':', labelColumns: 4 }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__AddTags__["a" /* AddTags */], { placeholder: polyglot.t('vehicle.placeholder_tags'), newSelectionPrefix: polyglot.t('vehicle.prefix_for_tags') + ': ', selected: draft.Tags, options: this.props.allTags, onChange: setTags }))));
        }
    }]);

    return NewVehicle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
function getSelectedValue(items, id) {
    var found = items.find(function (item) {
        return item.Id === id;
    });
    return found === undefined ? [] : [found];
}

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VehicleGrid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGrid__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTextColumn__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_Vehicle__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DataGrid_DataGridTemplateColumn__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Buttons__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Columns_IdColumn__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Columns_MultiselectColumn__ = __webpack_require__(122);









var getterServiceAccount = function getterServiceAccount(sa) {
    return sa.ServiceAccount;
};
var getterDivision = function getterDivision(v) {
    return v.Division;
};
var getterNativeTitle = function getterNativeTitle(v) {
    return v.SourceId === __WEBPACK_IMPORTED_MODULE_4__models_Vehicle__["a" /* Source */].BoxId ? v.BoxId : v.GeotabTitle;
};
var getterDisplay = function getterDisplay(v) {
    return v.Display;
};
var getterTags = function getterTags(v) {
    return v.Tags.join(', ');
};
var getterLastData = function getterLastData(v) {
    return v.LastDataDateTime ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(v.LastDataDateTime).format('YYYY-MM-DD HH:mm') : '';
};
var importIcon = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "glyphicon glyphicon-cloud-download", style: { verticalAlign: 'text-bottom' } });
var VehicleGrid = function VehicleGrid(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_DataGrid_DataGrid__["a" /* DataGrid */], { initialData: props.items, className: props.className, onThead: props.onThead }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Columns_MultiselectColumn__["a" /* MultiselectColumn */], Object.assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__Columns_MultiselectColumn__["b" /* multiselectPropsFrom */])(props))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Columns_IdColumn__["a" /* IdColumn */], { header: props.polyglot.t('column.id') }), !props.isIsolatedPremise && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTextColumn__["a" /* DataGridTextColumn */], { header: props.polyglot.t('vehicle.label_service_account'), getValue: getterServiceAccount }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTextColumn__["a" /* DataGridTextColumn */], { header: props.polyglot.t('vehicle.label_division'), getValue: getterDivision }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_DataGrid_DataGridTemplateColumn__["a" /* DataGridTemplateColumn */], { header: props.polyglot.t('vehicle.label_native_title'), getValue: getterNativeTitle, render: function render(colProps) {
            var vehicle = colProps.datum;
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, vehicle.OngoingAutoImport ? __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](importIcon, { title: props.polyglot.t('vehicle.msg_import_in_progress') }) : null, " ", getterNativeTitle(vehicle));
        } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTextColumn__["a" /* DataGridTextColumn */], { header: props.polyglot.t('vehicle.label_display'), getValue: getterDisplay }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTextColumn__["a" /* DataGridTextColumn */], { header: props.polyglot.t('vehicle.label_tags'), getValue: getterTags }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DataGrid_DataGridTextColumn__["a" /* DataGridTextColumn */], { header: props.polyglot.t('vehicle.label_last_data'), getValue: getterLastData }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_DataGrid_DataGridTemplateColumn__["a" /* DataGridTemplateColumn */], { header: props.polyglot.t('column.action'), render: function render(p) {
            var datum = p.datum,
                row = p.row;

            var inProgress = datum.id === props.sensorsSearchInitiator;
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: 'btn-toolbar' }, props.isAdmin && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_Buttons__["a" /* Button */], { dim: "xs", leftIcon: "pencil", type: "info", onClick: function onClick(e) {
                    return props.onEdit(datum, row);
                } }, props.polyglot.t('button.edit_short')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_Buttons__["a" /* Button */], { dim: "xs", type: "info", leftIcon: "search", spinner: inProgress, disabled: inProgress, onClick: function onClick(e) {
                    return props.onSensors(datum, row);
                } }, props.polyglot.t('vehicle.btn_sensors')));
        } }));
};

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VehicleRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_broadcast__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Container__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EditCreate_EditCreateEntityRoute__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flux_Grid_SelectedItemsActions__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NewVehicle__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__VehicleGrid__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flux__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BatchEdit_BatchEdit__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BatchEdit_flux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Buttons__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Toolbar__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Dialogs_OneButtonDialog__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__flux_Flag_FlagActions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_configure_store__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ErrorMessage__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Table_NoResults__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Table_TableTitle__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_StickyMediator__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Search_GenericSearchWidget__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__TrashButtonWidget__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__DeleteConfirmationWidget__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__NonIsolatedPremise__ = __webpack_require__(102);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


























var appStyles = __webpack_require__(64);
var tableStyles = __webpack_require__(73);
var VehicleRoute = function (_React$Component) {
    _inherits(VehicleRoute, _React$Component);

    function VehicleRoute() {
        _classCallCheck(this, VehicleRoute);

        var _this = _possibleConstructorReturn(this, (VehicleRoute.__proto__ || Object.getPrototypeOf(VehicleRoute)).apply(this, arguments));

        _this.editActions = new __WEBPACK_IMPORTED_MODULE_9__flux__["c" /* EditVehicleActions */]();
        _this.vehicleBatchEditActions = new __WEBPACK_IMPORTED_MODULE_11__BatchEdit_flux__["b" /* VehicleBatchEditActions */]();
        _this.selectedItemsActions = new __WEBPACK_IMPORTED_MODULE_6__flux_Grid_SelectedItemsActions__["a" /* SelectedItemsActions */]();
        _this.alertActions = new __WEBPACK_IMPORTED_MODULE_15__flux_Flag_FlagActions__["a" /* FlagActions */]();
        _this.stickyMediator = new __WEBPACK_IMPORTED_MODULE_20__utils_StickyMediator__["a" /* StickyMediator */]();
        return _this;
    }

    _createClass(VehicleRoute, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.props.refresher.run();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                searchFormStore = _props.searchFormStore,
                timezoneStore = _props.timezoneStore,
                listStore = _props.listStore,
                selectedItemsStore = _props.selectedItemsStore,
                showVehicleGeopositionCommand = _props.showVehicleGeopositionCommand,
                mapInProgressStore = _props.mapInProgressStore,
                alertVisibilityStore = _props.alertVisibilityStore,
                isAdmin = _props.isAdmin,
                polyglot = _props.polyglot;

            var loadingDivisions = [this.props.loadingDivisions, function (store) {
                return { loadingDivisions: store.isSet() };
            }];
            var loadServiceAccounts = [this.props.loadingServiceAccounts, function (store) {
                return { loadingServiceAccounts: store.isSet() };
            }];
            var loadGeotabVehicles = [this.props.loadingGeotabVehicles, function (store) {
                return { loadingVehicles: store.isSet() };
            }];
            var createForm = function createForm(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Container__["a" /* Container */], { merge: true, stores: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_configure_store__["b" /* twoButtonDialogConfig */])(_this2.props.upsertInProgress, _this2.props.upsertErrorStore) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__EditCreate_EditCreateEntityRoute__["a" /* EditCreateEntityRoute */], { title: props.title, okTitle: props.okTitle, path: props.path, cancelTitle: polyglot.t('button.cancel'), renderEdit: function renderEdit() {
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Container__["a" /* Container */], { merge: true, stores: [_this2.props.editStore, timezoneStore, loadingDivisions, loadServiceAccounts, loadGeotabVehicles], actions: _this2.editActions, onMount: _this2.props.upsertController.preload }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__NewVehicle__["a" /* NewVehicle */], { polyglot: polyglot, loadingDivisions: null, loadingVehicles: null, loadingServiceAccounts: null, onDivisionChanged: _this2.props.upsertController.setDivision, onServiceAccountChanged: _this2.props.upsertController.setServiceAccount, onVehicleChanged: _this2.props.upsertController.setVehicle }));
                    }, cancel: _this2.props.upsertController.cancel, ok: _this2.props.upsertController.upsert }));
            };
            var entityType = __WEBPACK_IMPORTED_MODULE_2__models__["a" /* EntityType */].Vehicle;
            var notSelected = function notSelected() {
                return selectedItemsStore.getState().selected.size === 0;
            };
            var selectionDisableInject = { disabled: notSelected };
            var mapDisableInject = { disabled: function disabled() {
                    return notSelected() || mapInProgressStore.isSet();
                } };
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, isAdmin && createForm({ title: polyglot.t('vehicle.create_title'), okTitle: polyglot.t('button.create'), path: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__routes__["h" /* addNewRouteFor */])(entityType) }), isAdmin && createForm({ title: polyglot.t('vehicle.edit_title'), okTitle: polyglot.t('button.save'), path: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__routes__["i" /* editRouteFor */])(entityType) }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23__DeleteConfirmationWidget__["a" /* DeleteConfirmationWidget */], Object.assign({}, this.props, { entityType: entityType, title: polyglot.t('vehicle.del_confirmation_title') }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: appStyles.ConfirmationContainer }, polyglot.t('vehicle.del_confirmation_msg'))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Container__["a" /* Container */], { merge: true, stores: [this.props.groupEditStore, this.props.applyErrorStore], subscribe: [this.props.applyInProgressStore], inject: {
                    okDisabled: function okDisabled() {
                        return !_this2.props.groupEditStore.isValid() || _this2.props.applyInProgressStore.isSet();
                    }
                } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__EditCreate_EditCreateEntityRoute__["a" /* EditCreateEntityRoute */], { path: __WEBPACK_IMPORTED_MODULE_4__routes__["j" /* vehicleGroupActionsRoute */], title: polyglot.t('vehicle.group_actions'), okTitle: polyglot.t('button.apply'), cancelTitle: polyglot.t('button.cancel'), ok: this.props.applyGroupActionCommand.execute, cancel: function cancel() {
                    _this2.vehicleBatchEditActions.rejectDraft();
                    __WEBPACK_IMPORTED_MODULE_4__routes__["b" /* appNavigator */].goToVehicleTab();
                }, renderEdit: function renderEdit() {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Container__["a" /* Container */], { merge: true, stores: [_this2.props.groupEditStore, timezoneStore], actions: _this2.vehicleBatchEditActions }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__BatchEdit_BatchEdit__["a" /* VehicleBatchEdit */], { polyglot: polyglot, addedActions: null, timezones: null, unit: null, availableTags: [], suggestedTags: [], allTags: [], isGroupActionValid: null, axleCount: 0, selectGroupAction: function selectGroupAction(type) {
                            return _this2.props.selectGroupActionCommand.execute(type);
                        } }));
                } })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Dialogs_OneButtonDialog__["a" /* OneButtonDialog */], { visibilityStore: alertVisibilityStore, title: polyglot.t('misc.info'), okTitle: polyglot.t('button.ok'), ok: function ok() {
                    return _this2.alertActions.reset(alertVisibilityStore.dispatchToken);
                } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, polyglot.t('vehicle.no_data_msg'))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21__Search_GenericSearchWidget__["a" /* GenericSearchWidget */], Object.assign({}, this.props)), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: appStyles.StickyControlPanel, ref: this.stickyMediator.onToolbox }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Toolbar__["a" /* Toolbar */], null, isAdmin && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__components_Buttons__["a" /* Button */], { type: "success", leftIcon: "plus", onClick: function onClick() {
                    return _this2.props.upsertController.showUpsertForm();
                } }, this.props.polyglot.t('button.new')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Container__["a" /* Container */], { inject: selectionDisableInject, stores: [selectedItemsStore] }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__components_Buttons__["a" /* Button */], { leftIcon: "pencil", onClick: this.props.showVehicleGroupActionsCommand.execute }, polyglot.t('vehicle.group_actions'))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24__NonIsolatedPremise__["a" /* NonIsolatedPremise */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Container__["a" /* Container */], { inject: mapDisableInject, stores: [selectedItemsStore, mapInProgressStore] }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__components_Buttons__["a" /* Button */], { leftIcon: "map-marker", title: polyglot.t('vehicle.btn_show_on_map'), onClick: showVehicleGeopositionCommand.execute }))), isAdmin && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22__TrashButtonWidget__["a" /* TrashButtonWidget */], Object.assign({ entityType: __WEBPACK_IMPORTED_MODULE_2__models__["a" /* EntityType */].Vehicle }, this.props)), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Container__["a" /* Container */], { store: this.props.toolbarErrorStore }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__components_ErrorMessage__["a" /* ErrorMessage */], null))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__Table_TableTitle__["a" /* TableTitle */], { polyglot: polyglot, labelStore: this.props.tableTitleStore })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_broadcast__["b" /* Subscriber */], { channel: "nonIsolatedPremise" }, function (nonIsolatedPremise) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Container__["a" /* Container */], { merge: true, stores: [listStore, selectedItemsStore, [_this2.props.sensorsSearchInitiatorStore, function (store) {
                        return { sensorsSearchInitiator: store.getValue() };
                    }]] }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__VehicleGrid__["a" /* VehicleGrid */], { className: tableStyles.StickyTable, polyglot: polyglot, isAdmin: isAdmin, isIsolatedPremise: !nonIsolatedPremise, sensorsSearchInitiator: null, items: null, onEdit: function onEdit(datum, row) {
                        return _this2.props.upsertController.showUpsertForm(datum);
                    }, onSensors: function onSensors(datum, row) {
                        return _this2.props.sensorsSearchCmd.execute(datum.id, { VehicleId: datum.id });
                    }, toggle: function toggle(datum, row) {
                        return _this2.selectedItemsActions.toggleItem(datum.id, entityType);
                    }, toggleAll: function toggleAll() {
                        return _this2.selectedItemsActions.toggleAll(entityType);
                    }, onThead: _this2.stickyMediator.onThead }));
            }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__Table_NoResults__["a" /* NoResults */], { polyglot: polyglot, listStore: listStore })));
        }
    }]);

    return VehicleRoute;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplyVehicleGroupActionsCommand; });
/* unused harmony export extractActionPayload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Grid__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Error__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_Flag__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BatchEdit_flux__ = __webpack_require__(39);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var ApplyVehicleGroupActionsCommand = function ApplyVehicleGroupActionsCommand(getState, groupActions, errorStoreToken, inProgressToken) {
    var _this = this;

    _classCallCheck(this, ApplyVehicleGroupActionsCommand);

    this.getState = getState;
    this.groupActions = groupActions;
    this.errorStoreToken = errorStoreToken;
    this.inProgressToken = inProgressToken;
    this.listActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Grid__["a" /* ListActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_2__flux_Error__["a" /* ErrorActions */]();
    this.inProgressActions = new __WEBPACK_IMPORTED_MODULE_3__flux_Flag__["a" /* FlagActions */]();
    this.vehicleBatchEditActions = new __WEBPACK_IMPORTED_MODULE_5__BatchEdit_flux__["b" /* VehicleBatchEditActions */]();
    this.execute = function () {
        var _getState = _this.getState(),
            addedActions = _getState.addedActions,
            ids = _getState.ids;

        if (!addedActions || addedActions.length === 0) throw new Error('no group actions to apply');
        if (!ids || ids.length === 0) {
            ids = JSON.parse(localStorage.getItem('groupActionVehicleIds'));
            // throw new Error('no ids selected to apply group actions');
        }
        _this.inProgressActions.set(_this.inProgressToken);
        _this.groupActions({
            Vehicle: {
                Ids: ids,
                Actions: addedActions.map(extractActionPayload)
            }
        }).then(function (res) {
            if (!res.Success) {
                throw new Error(res.ErrorMessage);
            }
            _this.listActions.replaceItems(res.Entries.Vehicle, __WEBPACK_IMPORTED_MODULE_0__models__["a" /* EntityType */].Vehicle);
            __WEBPACK_IMPORTED_MODULE_4__routes__["b" /* appNavigator */].goToVehicleTab();
            _this.vehicleBatchEditActions.rejectDraft();
        }).catch(function (err) {
            return _this.errorActions.setError(err, _this.errorStoreToken);
        }).then(function () {
            return _this.inProgressActions.reset(_this.inProgressToken);
        }); // finaly
    };
};
function extractActionPayload(batchAction) {
    switch (batchAction.type) {
        case __WEBPACK_IMPORTED_MODULE_5__BatchEdit_flux__["c" /* ActionType */].AddTags:
            return { ApplyTags: batchAction.value };
        case __WEBPACK_IMPORTED_MODULE_5__BatchEdit_flux__["c" /* ActionType */].RemoveTags:
            return { RemoveTags: batchAction.value };
        case __WEBPACK_IMPORTED_MODULE_5__BatchEdit_flux__["c" /* ActionType */].SetTimezone:
            return { MoveToTimezone: batchAction.value.Id };
        case __WEBPACK_IMPORTED_MODULE_5__BatchEdit_flux__["c" /* ActionType */].SetPressure:
            return { SetPressureLevels: batchAction.value };
        case __WEBPACK_IMPORTED_MODULE_5__BatchEdit_flux__["c" /* ActionType */].SetTemperature:
            return { SetTemperatureLevels: batchAction.value };
        default:
            throw new Error("unexpected ActionType: batchAction.type");
    }
}

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectGroupActionCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rest_Misc__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BatchEdit_flux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_assert__ = __webpack_require__(5);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var SelectGroupActionCommand = function SelectGroupActionCommand(getState, getMeasures, getGroupParams, getVehicleTags) {
    var _this = this;

    _classCallCheck(this, SelectGroupActionCommand);

    this.getState = getState;
    this.getMeasures = getMeasures;
    this.getGroupParams = getGroupParams;
    this.getVehicleTags = getVehicleTags;
    this.groupEditActions = new __WEBPACK_IMPORTED_MODULE_1__BatchEdit_flux__["b" /* VehicleBatchEditActions */]();
    this.execute = function (type) {
        _this.groupEditActions.setActionType(type);
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_1__BatchEdit_flux__["c" /* ActionType */].SetPressure:
            case __WEBPACK_IMPORTED_MODULE_1__BatchEdit_flux__["c" /* ActionType */].SetTemperature:
                var _getState = _this.getState(),
                    ids = _getState.ids;

                _this.getMeasures({ VehicleId: ids[0] }).then(function (measures) {
                    if (_this.getState().selectedAction !== type) return;
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_assert__["b" /* assertValue */])(measures);
                    var quantities = measures.Quantities,
                        units = measures.Units;

                    var qId = type === __WEBPACK_IMPORTED_MODULE_1__BatchEdit_flux__["c" /* ActionType */].SetPressure ? __WEBPACK_IMPORTED_MODULE_0__rest_Misc__["d" /* Quantities */].Pressure : __WEBPACK_IMPORTED_MODULE_0__rest_Misc__["d" /* Quantities */].Temperature;
                    var quantity = quantities.find(function (q) {
                        return q.Id === qId;
                    });
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_assert__["b" /* assertValue */])(quantity);
                    var unit = units.find(function (u) {
                        return u.Id === quantity.Units[0];
                    });
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_assert__["b" /* assertValue */])(unit);
                    _this.groupEditActions.setUnit(unit);
                });
                _this.getGroupParams({ Name: 'Vehicles', Ids: ids }).then(function (resp) {
                    _this.groupEditActions.setAxleCount(resp.AxlesCount);
                });
                break;
            case __WEBPACK_IMPORTED_MODULE_1__BatchEdit_flux__["c" /* ActionType */].AddTags:
                _this.getVehicleTags().then(function (res) {
                    if (_this.getState().selectedAction !== type) return;
                    _this.groupEditActions.setAllTags(res.Tags);
                });
                break;
        }
    };
};

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShowVehicleGeopositionCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Flag__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_Error__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(7);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var ShowVehicleGeopositionCommand = function ShowVehicleGeopositionCommand(getIds, getVehiclesGeoposition, googleMapLoader, errorToken, inProgressToken, alertStoreToken) {
    var _this = this;

    _classCallCheck(this, ShowVehicleGeopositionCommand);

    this.getIds = getIds;
    this.getVehiclesGeoposition = getVehiclesGeoposition;
    this.googleMapLoader = googleMapLoader;
    this.errorToken = errorToken;
    this.inProgressToken = inProgressToken;
    this.alertStoreToken = alertStoreToken;
    this.vehicleGeopositionActions = new __WEBPACK_IMPORTED_MODULE_1__flux__["d" /* VehicleGeopositionActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_3__flux_Error__["a" /* ErrorActions */]();
    this.inProgressActions = new __WEBPACK_IMPORTED_MODULE_2__flux_Flag__["a" /* FlagActions */]();
    this.alertActions = new __WEBPACK_IMPORTED_MODULE_2__flux_Flag__["a" /* FlagActions */]();
    this.execute = function () {
        var ids = _this.getIds();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["d" /* assertArray */])(ids);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" /* assertTrue */])(ids.length > 0);
        var vehicleGeopositions = void 0;
        _this.inProgressActions.set(_this.inProgressToken);
        _this.getVehiclesGeoposition({ Vehicle: ids }).then(function (res) {
            vehicleGeopositions = res.Vehicle;
            return _this.googleMapLoader.loadMapFor(res.Gapik);
        }).then(function () {
            _this.inProgressActions.reset(_this.inProgressToken);
            var hasGeoData = vehicleGeopositions.some(function (v) {
                return Array.isArray(v.Geoposition) && v.Geoposition.length > 0;
            });
            if (!hasGeoData) {
                _this.alertActions.set(_this.alertStoreToken);
            } else {
                _this.vehicleGeopositionActions.setVehicleGeoposition(vehicleGeopositions);
                __WEBPACK_IMPORTED_MODULE_4__routes__["b" /* appNavigator */].goToVehicleGeopositionPage();
            }
        }).catch(function (err) {
            _this.inProgressActions.reset(_this.inProgressToken);
            _this.errorActions.setError(err, _this.errorToken, 5 * 1000);
        });
    };
};

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShowVehicleGroupActionsCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BatchEdit_flux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Error__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_StatBuilder__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes__ = __webpack_require__(7);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var ShowVehicleGroupActionsCommand = function ShowVehicleGroupActionsCommand(listStore, selectedItemsStore, errorDispatchToken) {
    var _this = this;

    _classCallCheck(this, ShowVehicleGroupActionsCommand);

    this.listStore = listStore;
    this.selectedItemsStore = selectedItemsStore;
    this.errorDispatchToken = errorDispatchToken;
    this.groupEditActions = new __WEBPACK_IMPORTED_MODULE_0__BatchEdit_flux__["b" /* VehicleBatchEditActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Error__["a" /* ErrorActions */]();
    this.execute = function () {
        var vehicleIds = _this.selectedItemsStore.toArray();
        var selected = new Set(vehicleIds);
        var statBuilder = new __WEBPACK_IMPORTED_MODULE_2__utils_StatBuilder__["a" /* StatBuilder */]();
        _this.listStore.getState().items.filter(function (item) {
            return selected.has(item.id);
        }).forEach(function (item) {
            return statBuilder.inc.apply(statBuilder, _toConsumableArray(item.Tags));
        });
        _this.groupEditActions.setIds(vehicleIds);
        _this.groupEditActions.setAvailableTagsStat(statBuilder.stat);
        _this.errorActions.clearError(_this.errorDispatchToken);
        __WEBPACK_IMPORTED_MODULE_3__routes__["b" /* appNavigator */].goToVehicleGroupActionsPage();
    };
};

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ApplyVehicleGroupActionsCommand__ = __webpack_require__(567);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__ApplyVehicleGroupActionsCommand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SelectGroupActionCommand__ = __webpack_require__(568);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__SelectGroupActionCommand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShowVehicleGeopositionCommand__ = __webpack_require__(569);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__ShowVehicleGeopositionCommand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShowVehicleGroupActionsCommand__ = __webpack_require__(570);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__ShowVehicleGroupActionsCommand__["a"]; });





/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditVehicleStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_draft__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditCreate_EditStore__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditVehicleActions__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_assert_index__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_EditCreateEntityActions__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_removeUndefined__ = __webpack_require__(628);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};







var session = 0;
var EditVehicleStore = function (_EditStore) {
    _inherits(EditVehicleStore, _EditStore);

    function EditVehicleStore() {
        _classCallCheck(this, EditVehicleStore);

        var _this = _possibleConstructorReturn(this, (EditVehicleStore.__proto__ || Object.getPrototypeOf(EditVehicleStore)).call(this));

        _this.setDisplay = function (display) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_assert_index__["a" /* assertTrue */])(display === null || typeof display === 'string');
            return _this.draft({ Display: display });
        };
        _this.setTags = function (tags) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_assert_index__["d" /* assertArray */])(tags, 'expect Array of string payload');
            tags.forEach(function (tag) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_assert_index__["g" /* assertString */])(tag);
            });
            return _this.draft({ Tags: tags });
        };
        _this.state = _this.getDefaultStateFor(null);
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditVehicleActions__["c" /* names */].COMPOUND_UPDATE, function (e) {
            var update = e.payload;

            var DivisionId = update.DivisionId,
                ServiceAccountId = update.ServiceAccountId,
                GeotabId = update.GeotabId,
                GeotabTitle = update.GeotabTitle,
                rest = __rest(update, ["DivisionId", "ServiceAccountId", "GeotabId", "GeotabTitle"]);

            return Object.assign({}, _this.state, rest, { draft: _this.getDraft(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_removeUndefined__["a" /* removeUndefined */])({ DivisionId: DivisionId, ServiceAccountId: ServiceAccountId, GeotabId: GeotabId, GeotabTitle: GeotabTitle })) });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditVehicleActions__["c" /* names */].SET_SOURCE, function (e) {
            return _this.draft({ SourceId: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditVehicleActions__["c" /* names */].SET_BOX_ID, function (e) {
            return _this.draft({ BoxId: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditVehicleActions__["c" /* names */].SET_ALL_TAGS, function (e) {
            return _this.field({ allTags: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditVehicleActions__["c" /* names */].SET_TIMEZONE, function (e) {
            return _this.draft({ TimezoneId: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditVehicleActions__["c" /* names */].SET_DISPLAY, function (e) {
            return _this.setDisplay(e.payload);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_3__EditVehicleActions__["c" /* names */].SET_TAGS, function (e) {
            return _this.setTags(e.payload);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_5__actions_EditCreateEntityActions__["b" /* names */].REJECT_DRAFT, function (e) {
            if (e.meta === __WEBPACK_IMPORTED_MODULE_0__models__["a" /* EntityType */].Vehicle) {
                return _this.getDefaultStateFor(null);
                ;
            }
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_5__actions_EditCreateEntityActions__["b" /* names */].SET_EDIT_ENTITY, function (e) {
            if (e.meta === __WEBPACK_IMPORTED_MODULE_0__models__["a" /* EntityType */].Vehicle) {
                return _this.getDefaultStateFor(e.payload);
            }
        });
        return _this;
    }

    _createClass(EditVehicleStore, [{
        key: "getDefaultStateFor",
        value: function getDefaultStateFor(vehicle) {
            return {
                draft: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_draft__["b" /* prepareVehicleDraft */])(vehicle, this.isIsolatedPremise ? __WEBPACK_IMPORTED_MODULE_0__models__["b" /* Source */].BoxId : __WEBPACK_IMPORTED_MODULE_0__models__["b" /* Source */].BoxId),
                // Pay attention to null. Empty array will break UpsertVehicleController
                allServiceAccounts: null,
                filteredServiceAccounts: null,
                allDivisions: null,
                divisionsForest: null,
                vehicles: [],
                allTags: [],
                mode: vehicle ? 'edit' : 'create'
            };
        }
    }]);

    return EditVehicleStore;
}(__WEBPACK_IMPORTED_MODULE_2__EditCreate_EditStore__["a" /* EditStore */]);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VehicleGoogleMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_assert__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var VehicleGoogleMap = function (_React$Component) {
    _inherits(VehicleGoogleMap, _React$Component);

    function VehicleGoogleMap() {
        _classCallCheck(this, VehicleGoogleMap);

        return _possibleConstructorReturn(this, (VehicleGoogleMap.__proto__ || Object.getPrototypeOf(VehicleGoogleMap)).apply(this, arguments));
    }

    _createClass(VehicleGoogleMap, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            assertGoogleScriptTag();
            this.updateMap();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { minHeight: '400px' }, className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className), ref: function ref(e) {
                    return _this2.mapRef = e;
                } });
        }
    }, {
        key: "updateMap",
        value: function updateMap() {
            var _this3 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_assert__["b" /* assertValue */])(this.mapRef);
            var _props = this.props,
                defaultZoom = _props.defaultZoom,
                Vehicles = _props.Vehicles;

            var center = void 0;
            var bounds = void 0;
            var vehicleGeopositions = Vehicles.filter(function (v) {
                return Array.isArray(v.Geoposition) && v.Geoposition.length > 0;
            });
            var locations = vehicleGeopositions.map(function (v) {
                return v.Geoposition[v.Geoposition.length - 1];
            });
            if (locations.length > 1) {
                bounds = new google.maps.LatLngBounds();
                locations.map(getLatLngFrom).forEach(function (ll) {
                    return bounds.extend(ll);
                });
                center = bounds.getCenter();
            } else if (locations.length === 1) {
                center = getLatLngFrom(locations[0]);
            } else {
                throw new Error('no data to display');
            }
            this.map = new google.maps.Map(this.mapRef, {
                center: center,
                zoom: defaultZoom
            });
            if (bounds) {
                this.map.fitBounds(bounds);
            }
            vehicleGeopositions.forEach(function (vg) {
                var lastPosition = vg.Geoposition[vg.Geoposition.length - 1];
                var timestamp = __WEBPACK_IMPORTED_MODULE_2_moment___default()(lastPosition.DateTime).format('YYYY-MM-DD HH:mm:ss');
                new google.maps.Marker({
                    position: getLatLngFrom(lastPosition),
                    map: _this3.map,
                    title: vg.Display + "\n" + timestamp
                });
            });
        }
    }]);

    return VehicleGoogleMap;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
function getLatLngFrom(geo) {
    return new google.maps.LatLng(geo.Latitude, geo.Longitude);
}
function assertGoogleScriptTag() {
    if (!window['google']) throw new Error('you have to add/inject <script src="https://maps.googleapis.com/maps/api/js?key=...></script>');
}

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Settings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal_Modal__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dialogs_TwoButtonDialog__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SettingsView__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Container__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SettingsActions__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_configure_store__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routes__ = __webpack_require__(7);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Settings components is container arround SettingsView with Save Cancel buttons
var Settings = function (_React$Component) {
    _inherits(Settings, _React$Component);

    function Settings() {
        _classCallCheck(this, Settings);

        var _this = _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).apply(this, arguments));

        _this.actions = new __WEBPACK_IMPORTED_MODULE_5__SettingsActions__["a" /* SettingsActions */]();
        return _this;
    }

    _createClass(Settings, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var division = this.props.currentDivisionStore.getCurrentDivision();
            var isAdmin = this.props.isAdmin;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_Modal_Modal__["a" /* Modal */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Container__["a" /* Container */], { merge: true, stores: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_configure_store__["b" /* twoButtonDialogConfig */])(this.props.inProgressStore, this.props.errorStore) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Dialogs_TwoButtonDialog__["a" /* TwoButtonDialog */], { okTitle: this.props.polyglot.t('button.save'), cancelTitle: this.props.polyglot.t('button.cancel'), ok: this.props.saveSettingsCommand.execute, cancel: __WEBPACK_IMPORTED_MODULE_7__routes__["b" /* appNavigator */].closeSettings }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Container__["a" /* Container */], { actions: this.actions, store: this.props.settingsStore, onMount: function onMount() {
                    return _this2.props.initSettingsCommand.execute();
                } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__SettingsView__["a" /* SettingsView */], { polyglot: this.props.polyglot, division: null, setDivision: null, quantities: null, quantitySettings: null, setQuantityUnit: null, emails: null, setEmails: null, languages: null, selectedLanguage: null, setLanguage: null, passwordFlag: false, setChangePasswordFlag: null, password: '', setPassword: null, passwordConfirmation: '', setPasswordConfirmation: null, isEmailNotificationEnabled: this.props.isEmailNotificationEnabled, dontAlertLeavingRedZone: null, setDontAlertLeavingRedZone: null, dontAlertEnteringYellowZone: null, setDontAlertEnteringYellowZone: null, dontAlertLeavingYellowZone: null, setDontAlertLeavingYellowZone: null, isAdmin: isAdmin })))));
        }
    }]);

    return Settings;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SettingsStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_assert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Store__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SettingsActions__ = __webpack_require__(160);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// This is a storage of settings data
// It receives actions and transfors the state accordingly
// This is a Store in temrs of Flux architecture
var SettingsStore = function (_Store) {
    _inherits(SettingsStore, _Store);

    function SettingsStore() {
        _classCallCheck(this, SettingsStore);

        var _this = _possibleConstructorReturn(this, (SettingsStore.__proto__ || Object.getPrototypeOf(SettingsStore)).call(this));

        _this.getDefaultState = function () {
            return {
                division: null,
                quantities: [],
                quantitySettings: {},
                emails: '',
                languages: [],
                selectedLanguage: null,
                passwordFlag: false,
                password: '',
                passwordConfirmation: '',
                dontAlertLeavingRedZone: false,
                dontAlertEnteringYellowZone: false,
                dontAlertLeavingYellowZone: false
            };
        };
        _this.state = _this.getDefaultState();
        _this.register(__WEBPACK_IMPORTED_MODULE_2__SettingsActions__["b" /* names */].SET_DIVISION, function (e) {
            return _this.field({ division: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__SettingsActions__["b" /* names */].SET_SETTINGS_ITEMS, function (e) {
            return _this.setSettingsItems(e.payload);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__SettingsActions__["b" /* names */].SET_QUANTITY_UNIT, function (e) {
            return _this.setQuantity(e.payload);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__SettingsActions__["b" /* names */].SET_EMAILS, function (e) {
            return _this.setEmails(e.payload);
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__SettingsActions__["b" /* names */].SET_LANGUAGE_ITEMS, function (e) {
            return _this.field({ languages: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__SettingsActions__["b" /* names */].SET_LANGUAGE, function (e) {
            return _this.field({ selectedLanguage: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__SettingsActions__["b" /* names */].SET_PASSWORD_FLAG, function (e) {
            return _this.field({ passwordFlag: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__SettingsActions__["b" /* names */].SET_PASSWORD, function (e) {
            return _this.field({ password: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__SettingsActions__["b" /* names */].SET_PASSWORD_CONFIRMATION, function (e) {
            return _this.field({ passwordConfirmation: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__SettingsActions__["b" /* names */].SET_DONT_ALERT_LEAVING_RED, function (e) {
            return _this.field({ dontAlertLeavingRedZone: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__SettingsActions__["b" /* names */].SET_DONT_ALERT_ENTERING_YELLOW, function (e) {
            return _this.field({ dontAlertEnteringYellowZone: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__SettingsActions__["b" /* names */].SET_DONT_ALERT_LEAVING_YELLOW, function (e) {
            return _this.field({ dontAlertLeavingYellowZone: e.payload });
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_2__SettingsActions__["b" /* names */].REJECT, function (e) {
            return _this.getDefaultState();
        });
        return _this;
    }

    _createClass(SettingsStore, [{
        key: "setSettingsItems",
        value: function setSettingsItems(settings) {
            var quantities = populateUnits(settings.Measures);
            var quantitySettings = quantities.reduce(function (obj, q) {
                obj[q.Id] = q.SelectedUnitId;
                return obj;
            }, {});
            return this.field({ quantities: quantities, quantitySettings: quantitySettings, emails: settings.EmailAddresses, dontAlertLeavingRedZone: settings.DontAlertLeavingRed, dontAlertEnteringYellowZone: settings.DontAlertEnteringYellow, dontAlertLeavingYellowZone: settings.DontAlertLeavingYellow });
        }
    }, {
        key: "setQuantity",
        value: function setQuantity(pair) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["f" /* assertNumber */])(pair.key, 'key has to be a number');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["a" /* assertTrue */])(pair.value === null || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_assert__["c" /* isNumber */])(pair.value), 'value has to be a number');
            var qSettings = this.state.quantitySettings;
            return this.field({ quantitySettings: Object.assign({}, qSettings, _defineProperty({}, pair.key, pair.value)) });
        }
    }, {
        key: "setEmails",
        value: function setEmails(emails) {
            return this.field({ emails: emails });
        }
    }]);

    return SettingsStore;
}(__WEBPACK_IMPORTED_MODULE_1__flux_Store__["a" /* Store */]);
function populateUnits(measures) {
    var quantities = measures.Quantities;
    var units = measures.Units;
    var map = units.reduce(function (obj, u) {
        obj[u.Id] = u;
        return obj;
    }, {});
    var result = quantities.map(function (q) {
        return Object.assign({}, q, { Units: q.Units.map(function (u) {
                return map[u];
            }) });
    });
    return result;
}

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SettingsView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Select__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__converters_converters__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_assert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Forms_FormItemHorizontal__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Forms_FormCheckboxItem__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NonIsolatedPremise__ = __webpack_require__(102);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var styles = __webpack_require__(955);
// SettingsView component renders the state from SettingsStore and emmits SettingsActions on user interactions
var SettingsView = function (_React$Component) {
    _inherits(SettingsView, _React$Component);

    function SettingsView() {
        _classCallCheck(this, SettingsView);

        var _this = _possibleConstructorReturn(this, (SettingsView.__proto__ || Object.getPrototypeOf(SettingsView)).apply(this, arguments));

        _this.state = {
            allowDeletionOfSensors: JSON.parse(localStorage.getItem("allowDeletionOfSensors")),
            dontNotifyLeavingRedZone: JSON.parse(localStorage.getItem("dontNotifyLeavingRedZone")),
            dontNotifyEnteringYellowZone: JSON.parse(localStorage.getItem("dontNotifyEnteringYellowZone")),
            dontNotifyLeavingYellowZone: JSON.parse(localStorage.getItem("dontNotifyLeavingYellowZone"))
        };
        return _this;
    }

    _createClass(SettingsView, [{
        key: "allowDeletionOfSensors",
        value: function allowDeletionOfSensors(val) {
            localStorage.setItem("allowDeletionOfSensors", val);
            this.setState({
                allowDeletionOfSensors: val
            });
        }
    }, {
        key: "dontNotifyLeavingRedZone",
        value: function dontNotifyLeavingRedZone(val) {
            localStorage.setItem("dontNotifyLeavingRedZone", val);
            this.setState({
                dontNotifyLeavingRedZone: val
            });
        }
    }, {
        key: "dontNotifyEnteringYellowZone",
        value: function dontNotifyEnteringYellowZone(val) {
            localStorage.setItem("dontNotifyEnteringYellowZone", val);
            this.setState({
                dontNotifyEnteringYellowZone: val
            });
        }
    }, {
        key: "dontNotifyLeavingYellowZone",
        value: function dontNotifyLeavingYellowZone(val) {
            localStorage.setItem("dontNotifyLeavingYellowZone", val);
            this.setState({
                dontNotifyLeavingYellowZone: val
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                polyglot = _props.polyglot,
                division = _props.division,
                isAdmin = _props.isAdmin;

            if (!division) return null;
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("form-horizontal", styles.SettingsView) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "text-center" }, polyglot.t('settings.title_for', { name: division.Name })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", { className: "text-center" }, polyglot.t('settings.title_measure_units')), this.props.quantities.filter(function (qw) {
                return qw.IsUnitEditable;
            }).map(function (qw) {
                var units = division.MustSpecifySettings ? qw.Units : [{ Id: null, Name: '---' }].concat(_toConsumableArray(qw.Units));
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Forms_FormItemHorizontal__["a" /* FormItemHorizontal */], { title: qw.Name, key: qw.Id, labelColumns: 4, columns: 4 }, units.length > 1 ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_Select__["a" /* Select */], { className: 'form-control', placeholder: division.MustSpecifySettings ? '---' : null, items: units, disabled: !isAdmin, defaultValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__converters_converters__["a" /* intToString */])(_this2.props.quantitySettings[qw.Id], true), valueFn: function valueFn(u) {
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__converters_converters__["a" /* intToString */])(u.Id, true);
                    }, titleFn: function titleFn(u) {
                        return u.Name;
                    }, onChange: function onChange(s) {
                        var unitId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__converters_converters__["b" /* stringToInt */])(s.getValue(), true);
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_assert__["a" /* assertTrue */])(unitId === null || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_assert__["c" /* isNumber */])(unitId), 'unitId has to be null or number');
                        _this2.props.setQuantityUnit(qw.Id, unitId);
                    } }) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-control" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, qw.Name)));
            }), this.props.isEmailNotificationEnabled && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Forms_FormItemHorizontal__["a" /* FormItemHorizontal */], { title: polyglot.t('settings.title_emails'), labelColumns: 4 }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("textarea", { className: "form-control", rows: 3, value: this.props.emails, disabled: !isAdmin, onChange: function onChange(ta) {
                    return _this2.props.setEmails(ta.target.value);
                }, onKeyDown: function onKeyDown(e) {
                    if (e.keyCode === 13) {
                        e.stopPropagation(); // prevent form submition
                    }
                } })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group", style: { marginBottom: '0px' } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-sm-offset-4 col-sm-8" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { style: { color: '#a31518', 'fontWeight': 'bold', margin: '0px' } }, "The settings below only apply to vehicles within this division"))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Forms_FormCheckboxItem__["a" /* FormCheckboxItem */], { disabled: !isAdmin, checked: this.props.dontAlertLeavingRedZone, onChange: function onChange(e) {
                    return _this2.props.setDontAlertLeavingRedZone(e.target.checked);
                }, label: "Do not notify on LEAVING RED zone (To YELLOW / GREEN)" }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Forms_FormCheckboxItem__["a" /* FormCheckboxItem */], { disabled: !isAdmin, checked: this.props.dontAlertEnteringYellowZone, onChange: function onChange(e) {
                    return _this2.props.setDontAlertEnteringYellowZone(e.target.checked);
                }, label: "Do not notify on ENTERING YELLOW zone (From GREEN)" }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Forms_FormCheckboxItem__["a" /* FormCheckboxItem */], { disabled: !isAdmin, checked: this.props.dontAlertLeavingYellowZone, onChange: function onChange(e) {
                    return _this2.props.setDontAlertLeavingYellowZone(e.target.checked);
                }, label: "Do not notify on LEAVING YELLOW zone (To GREEN)" }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", null), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "text-center" }, polyglot.t('settings.title_personal_settings')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__NonIsolatedPremise__["a" /* NonIsolatedPremise */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Forms_FormItemHorizontal__["a" /* FormItemHorizontal */], { title: polyglot.t('settings.title_language'), labelColumns: 4 }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_Select__["a" /* Select */], { className: 'form-control', placeholder: "---", items: this.props.languages, titleFn: function titleFn(lang) {
                    return lang.display;
                }, valueFn: function valueFn(lang) {
                    return lang.code;
                }, onChange: function onChange(s) {
                    return _this2.props.setLanguage(_this2.props.languages.find(function (opt) {
                        return opt.code === s.getValue();
                    }));
                }, defaultValue: this.props.selectedLanguage ? this.props.selectedLanguage.code : null }))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-sm-offset-4 col-sm-12" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { target: "_blank", href: 'https://my.spartansense.com:8443/auth/realms/spartanlync/account/password' }, polyglot.t('settings.title_change_password')))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Forms_FormCheckboxItem__["a" /* FormCheckboxItem */], { disabled: !isAdmin, checked: this.state.allowDeletionOfSensors, onChange: function onChange(e) {
                    return _this2.allowDeletionOfSensors(e.target.checked);
                }, label: "Allow Deletion of Sensors" }));
        }
    }]);

    return SettingsView;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InitSettingsCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SettingsActions__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Flag_FlagActions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Error_ErrorActions__ = __webpack_require__(13);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




// InitSettingsCommand is executed on initial render of the Settings UI component
var InitSettingsCommand = function InitSettingsCommand(getSettings, getCurrentDivision, getLanguageOptions, getCurrentLanguage, inProgressDispatchToken, errorDispatchToken) {
    var _this = this;

    _classCallCheck(this, InitSettingsCommand);

    this.getSettings = getSettings;
    this.getCurrentDivision = getCurrentDivision;
    this.getLanguageOptions = getLanguageOptions;
    this.getCurrentLanguage = getCurrentLanguage;
    this.inProgressDispatchToken = inProgressDispatchToken;
    this.errorDispatchToken = errorDispatchToken;
    this.settingsActions = new __WEBPACK_IMPORTED_MODULE_0__SettingsActions__["a" /* SettingsActions */]();
    this.flagActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Flag_FlagActions__["a" /* FlagActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_2__flux_Error_ErrorActions__["a" /* ErrorActions */]();
    this.execute = function () {
        var division = _this.getCurrentDivision();
        _this.settingsActions.setDivision(division);
        var languages = _this.getLanguageOptions();
        _this.settingsActions.setLanguageItems(languages);
        var curLanguage = _this.getCurrentLanguage();
        _this.settingsActions.setLanguage(curLanguage);
        _this.flagActions.set(_this.inProgressDispatchToken);
        _this.getSettings(division.id).then(function (res) {
            return _this.settingsActions.setSettingsItems(res);
        }).catch(function (err) {
            return _this.errorActions.setError(err, _this.errorDispatchToken);
        }).then(function () {
            return _this.flagActions.reset(_this.inProgressDispatchToken);
        }); // finaly
    };
};

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SaveSettingsCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Flag_FlagActions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Error_ErrorActions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__converters_converters__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes__ = __webpack_require__(7);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





// Settings UI component exec SaveSettingsCommand on Save click
var SaveSettingsCommand = function SaveSettingsCommand(polyglot, languages, rerender, saveSettings, getCurrentDivisionId, settingsStore, inProgressDispatchToken, errorDispatchToken) {
    var _this = this;

    _classCallCheck(this, SaveSettingsCommand);

    this.polyglot = polyglot;
    this.languages = languages;
    this.rerender = rerender;
    this.saveSettings = saveSettings;
    this.getCurrentDivisionId = getCurrentDivisionId;
    this.settingsStore = settingsStore;
    this.inProgressDispatchToken = inProgressDispatchToken;
    this.errorDispatchToken = errorDispatchToken;
    this.flagActions = new __WEBPACK_IMPORTED_MODULE_0__flux_Flag_FlagActions__["a" /* FlagActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_1__flux_Error_ErrorActions__["a" /* ErrorActions */]();
    this.execute = function () {
        var state = _this.settingsStore.getState();
        var passwordFlag = state.passwordFlag,
            password = state.password,
            passwordConfirmation = state.passwordConfirmation,
            selectedLanguage = state.selectedLanguage,
            quantitySettings = state.quantitySettings;

        var setError = function setError(msg) {
            return _this.errorActions.setError(new Error(msg), _this.errorDispatchToken);
        };
        if (passwordFlag) {
            if (password !== passwordConfirmation) {
                setError(_this.polyglot.t('settings.validation_err.password_mismatch'));
                return;
            }
            if (password === null || password === '') {
                setError(_this.polyglot.t('settings.validation_err.password_not_set'));
                return;
            }
        }
        var prefUnits = getPreferredUnits(quantitySettings);
        _this.flagActions.set(_this.inProgressDispatchToken);
        _this.saveSettings({
            DivisionId: _this.getCurrentDivisionId(),
            PreferredUnits: prefUnits,
            EmailAddresses: _this.settingsStore.getState().emails,
            Locale: selectedLanguage.code,
            NewPassword: passwordFlag ? password : null,
            DontAlertLeavingRed: _this.settingsStore.getState().dontAlertLeavingRedZone,
            DontAlertEnteringYellow: _this.settingsStore.getState().dontAlertEnteringYellowZone,
            DontAlertLeavingYellow: _this.settingsStore.getState().dontAlertLeavingYellowZone
        }).then(function () {
            _this.polyglot.locale(selectedLanguage.code);
            _this.polyglot.replace(_this.languages.get(selectedLanguage.code));
            __WEBPACK_IMPORTED_MODULE_3__routes__["b" /* appNavigator */].closeSettings();
            _this.rerender();
        }).catch(function (err) {
            return _this.errorActions.setError(err, _this.errorDispatchToken);
        }).then(function () {
            return _this.flagActions.reset(_this.inProgressDispatchToken);
        }); // finaly
    };
};
var getPreferredUnits = function getPreferredUnits(settings) {
    return Object.keys(settings).map(function (k) {
        return {
            QuantityId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__converters_converters__["b" /* stringToInt */])(k),
            UnitId: settings[k]
        };
    });
};

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShowSettingsCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Error_ErrorActions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SettingsActions__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(7);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




// ShowSettingsCommand is executed when app needs to show Settings UI component
// Settings UI can be show multiple times during session, so we need to reset previous state (if any)
var ShowSettingsCommand = function ShowSettingsCommand(errorDispatchToken) {
    var _this = this;

    _classCallCheck(this, ShowSettingsCommand);

    this.errorDispatchToken = errorDispatchToken;
    this.settingsActions = new __WEBPACK_IMPORTED_MODULE_1__SettingsActions__["a" /* SettingsActions */]();
    this.errorActions = new __WEBPACK_IMPORTED_MODULE_0__flux_Error_ErrorActions__["a" /* ErrorActions */]();
    this.execute = function () {
        _this.settingsActions.reject();
        _this.errorActions.clearError(_this.errorDispatchToken);
        __WEBPACK_IMPORTED_MODULE_2__routes__["b" /* appNavigator */].goToSettingsPage();
    };
};

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SuggestList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var styles = __webpack_require__(956);
// SuggestList is used to make it easier to attach popular tags to entities
var SuggestList = function (_React$Component) {
    _inherits(SuggestList, _React$Component);

    function SuggestList() {
        _classCallCheck(this, SuggestList);

        return _possibleConstructorReturn(this, (SuggestList.__proto__ || Object.getPrototypeOf(SuggestList)).apply(this, arguments));
    }

    _createClass(SuggestList, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                items = _props.items,
                _onClick = _props.onClick,
                className = _props.className;

            if (!items || items.length === 0) return null;
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, styles.SuggestList) }, items.map(function (item, idx) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: idx, onClick: function onClick(e) {
                        return _onClick(item, idx);
                    } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", null, item));
            }));
        }
    }]);

    return SuggestList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrashButtonWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Container__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Buttons__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_DeleteObjects__ = __webpack_require__(56);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// TrashButtonWidget is a styled button which is shown on every entity page which could be removed
// It is disabled if there are no selected entities
var TrashButtonWidget = function (_React$Component) {
    _inherits(TrashButtonWidget, _React$Component);

    function TrashButtonWidget() {
        _classCallCheck(this, TrashButtonWidget);

        var _this = _possibleConstructorReturn(this, (TrashButtonWidget.__proto__ || Object.getPrototypeOf(TrashButtonWidget)).apply(this, arguments));

        _this.deleteObjectsActions = new __WEBPACK_IMPORTED_MODULE_3__flux_DeleteObjects__["b" /* DeleteObjectsActions */]();
        return _this;
    }

    _createClass(TrashButtonWidget, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
            return false;
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Container__["a" /* Container */], { merge: true, stores: [[this.props.selectedItemsStore, function (store) {
                    return { disabled: store.getState().selected.size === 0 };
                }]] }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_Buttons__["a" /* Button */], { leftIcon: "trash", type: "danger", className: "pull-right", title: this.props.polyglot.t('misc.btn_trash_title'), onClick: function onClick() {
                    var toDelete = [].concat(_toConsumableArray(_this2.props.selectedItemsStore.getState().selected));
                    _this2.deleteObjectsActions.setIds(toDelete, _this2.props.entityType);
                    _this2.deleteObjectsActions.showConfirmation(_this2.props.entityType);
                } }));
        }
    }]);

    return TrashButtonWidget;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteObjectsStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flux_Store__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DeleteObjectsActions__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_assert__ = __webpack_require__(5);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DeleteObjectsStore = function (_Store) {
    _inherits(DeleteObjectsStore, _Store);

    function DeleteObjectsStore(entityType) {
        _classCallCheck(this, DeleteObjectsStore);

        var _this = _possibleConstructorReturn(this, (DeleteObjectsStore.__proto__ || Object.getPrototypeOf(DeleteObjectsStore)).call(this));

        _this.entityType = entityType;
        _this.state = {
            isConfirmationDialogShown: false,
            ids: []
        };
        _this.register(__WEBPACK_IMPORTED_MODULE_1__DeleteObjectsActions__["b" /* names */].SET_IDS, function (e) {
            if (e.meta === _this.entityType) {
                var ids = e.payload;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_assert__["d" /* assertArray */])(ids, 'expected Array payload');
                return _this.field({ ids: ids });
            }
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_1__DeleteObjectsActions__["b" /* names */].SHOW_CONFIRMATION, function (e) {
            if (e.meta === _this.entityType) {
                return _this.field({ isConfirmationDialogShown: true, errorMessage: null });
            }
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_1__DeleteObjectsActions__["b" /* names */].HIDE_CONFIRMATION, function (e) {
            if (e.meta === _this.entityType) {
                return _this.field({ isConfirmationDialogShown: false, errorMessage: null });
            }
        });
        _this.register(__WEBPACK_IMPORTED_MODULE_1__DeleteObjectsActions__["b" /* names */].ERROR, function (e) {
            if (e.meta === _this.entityType) {
                return _this.field({ errorMessage: e.payload.message });
            }
        });
        return _this;
    }

    return DeleteObjectsStore;
}(__WEBPACK_IMPORTED_MODULE_0__flux_Store__["a" /* Store */]);

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ValueActions__ = __webpack_require__(219);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ValueActions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ValueStore__ = __webpack_require__(128);
/* unused harmony namespace reexport */



/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlarmTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Label_LabelStore__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Grid_ListStore__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_Flag_FlagStore__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flux_Error_ErrorStore__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flux_Value_ValueStore__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Pages_Home_commands_LoadDashboardCommand__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Pages_Home_commands_TakeOverSensorExcessCommand__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Pages_SensorsData_commands_ShowSensorsDataCommand__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Pages_Home_commands_FindIncidentDataCommand__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Pages_Home_Home__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Pages_commands_EntitySearchCommand__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__flux_Grid_SelectedItemsStore__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__flux_DeleteObjects__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Pages_commands_DeleteObjects__ = __webpack_require__(108);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

















// This class is a configuration for Dashboard tab
// Constructor receives and/or creates dependencies and injects them
var AlarmTab = function AlarmTab(polyglot, runSearch, getDashboard, takeOverSensorExcess, getSensorsDataForIncident, getCurrentDivisionId, googleMapLoader, deleteObjects) {
    _classCallCheck(this, AlarmTab);

    this.homeReportTableTitleStore = new __WEBPACK_IMPORTED_MODULE_1__flux_Label_LabelStore__["a" /* LabelStore */]();
    this.homeReportListStore = new __WEBPACK_IMPORTED_MODULE_2__flux_Grid_ListStore__["a" /* ListStore */](function (r) {
        return null;
    }, "ReportExcessToken");
    this.homeSensorsExcessesListStore = new __WEBPACK_IMPORTED_MODULE_2__flux_Grid_ListStore__["a" /* ListStore */](function (se) {
        return se.IncidentId;
    }, __WEBPACK_IMPORTED_MODULE_10__models__["a" /* EntityType */].SensorExcess);
    this.homeTakeOverSensorExcessInProgressStore = new __WEBPACK_IMPORTED_MODULE_3__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.homeTakeOverSensorExcessErrorStore = new __WEBPACK_IMPORTED_MODULE_4__flux_Error_ErrorStore__["a" /* ErrorStore */]();
    this.homeExcessTableErrorStore = new __WEBPACK_IMPORTED_MODULE_4__flux_Error_ErrorStore__["a" /* ErrorStore */]();
    this.homeAlertStore = new __WEBPACK_IMPORTED_MODULE_3__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.homeVehicleSearchInitiator = new __WEBPACK_IMPORTED_MODULE_5__flux_Value_ValueStore__["a" /* ValueStore */]();
    this.homeSensorsSearchInitiator = new __WEBPACK_IMPORTED_MODULE_5__flux_Value_ValueStore__["a" /* ValueStore */]();
    this.homeSensorsDataValueStore = new __WEBPACK_IMPORTED_MODULE_5__flux_Value_ValueStore__["a" /* ValueStore */]();
    this.categorySearchInitiator = new __WEBPACK_IMPORTED_MODULE_5__flux_Value_ValueStore__["a" /* ValueStore */]();
    this.selectedItemsStore = new __WEBPACK_IMPORTED_MODULE_13__flux_Grid_SelectedItemsStore__["a" /* SelectedItemsStore */](this.homeSensorsExcessesListStore, __WEBPACK_IMPORTED_MODULE_10__models__["a" /* EntityType */].SensorExcess);
    this.toDeleteItemsStore = new __WEBPACK_IMPORTED_MODULE_14__flux_DeleteObjects__["a" /* DeleteObjectsStore */](__WEBPACK_IMPORTED_MODULE_10__models__["a" /* EntityType */].SensorExcess);
    this.homeLoadDashboardCmd = new __WEBPACK_IMPORTED_MODULE_6__components_Pages_Home_commands_LoadDashboardCommand__["a" /* LoadDashboardCommand */](polyglot, getDashboard, getCurrentDivisionId, this.homeSensorsExcessesListStore.token, this.homeReportListStore.token, this.homeReportTableTitleStore.dispatchToken, null, null);
    var homeTakeOverSensorExcessCmd = new __WEBPACK_IMPORTED_MODULE_7__components_Pages_Home_commands_TakeOverSensorExcessCommand__["a" /* TakeOverSensorExcessCommand */](takeOverSensorExcess, this.homeSensorsExcessesListStore.token, this.homeTakeOverSensorExcessInProgressStore.dispatchToken, this.homeTakeOverSensorExcessErrorStore.dispatchToken);
    var homeShowSensorsDataCmd = new __WEBPACK_IMPORTED_MODULE_8__components_Pages_SensorsData_commands_ShowSensorsDataCommand__["a" /* ShowSensorsDataCommand */](googleMapLoader, this.homeAlertStore.dispatchToken);
    this.homeSearchVehicleCmd = new __WEBPACK_IMPORTED_MODULE_12__components_Pages_commands_EntitySearchCommand__["a" /* SearchWithInitiatorCommand */](polyglot, __WEBPACK_IMPORTED_MODULE_10__models__["a" /* EntityType */].Vehicle, runSearch, this.homeVehicleSearchInitiator.dispatchToken, this.homeExcessTableErrorStore.dispatchToken);
    this.homeSearchSensorsCmd = new __WEBPACK_IMPORTED_MODULE_12__components_Pages_commands_EntitySearchCommand__["a" /* SearchWithInitiatorCommand */](polyglot, __WEBPACK_IMPORTED_MODULE_10__models__["a" /* EntityType */].Sensor, runSearch, this.homeSensorsSearchInitiator.dispatchToken, this.homeExcessTableErrorStore.dispatchToken);
    var homeFindIncidentDataCmd = new __WEBPACK_IMPORTED_MODULE_9__components_Pages_Home_commands_FindIncidentDataCommand__["a" /* FindIncidentDataCommand */](getSensorsDataForIncident, homeShowSensorsDataCmd, this.homeSensorsDataValueStore.dispatchToken, this.homeExcessTableErrorStore.dispatchToken);
    this.vehicleCategorySearch = new __WEBPACK_IMPORTED_MODULE_12__components_Pages_commands_EntitySearchCommand__["a" /* SearchWithInitiatorCommand */](polyglot, __WEBPACK_IMPORTED_MODULE_10__models__["a" /* EntityType */].Vehicle, runSearch, this.categorySearchInitiator.dispatchToken, this.homeExcessTableErrorStore.dispatchToken);
    this.vehicleCategorySearch.addRequestMiddleware(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__components_Pages_commands_EntitySearchCommand__["d" /* getCurrentDivisionMiddleware */])(getCurrentDivisionId));
    var discardSensorExcessCommand = new __WEBPACK_IMPORTED_MODULE_15__components_Pages_commands_DeleteObjects__["a" /* DeleteObjectsCommand */](__WEBPACK_IMPORTED_MODULE_10__models__["a" /* EntityType */].SensorExcess, this.toDeleteItemsStore, deleteObjects);
    this.markup = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_Pages_Home_Home__["a" /* Dashboard */], { polyglot: polyglot, assignCmd: homeTakeOverSensorExcessCmd, assignmentInProgressStore: this.homeTakeOverSensorExcessInProgressStore, assignmentErrorStore: this.homeTakeOverSensorExcessErrorStore, sensorsExcessesListStore: this.homeSensorsExcessesListStore, selectedItemsStore: this.selectedItemsStore, loadDashboardCmd: this.homeLoadDashboardCmd, reportTableTitleStore: this.homeReportTableTitleStore, reportListStore: this.homeReportListStore, sensorSearchCmd: this.homeSearchSensorsCmd, vehicleSearchCmd: this.homeSearchVehicleCmd, incidentDataSearchCmd: homeFindIncidentDataCmd, excessTableErrorStore: this.homeExcessTableErrorStore, alertStore: this.homeAlertStore, sensorsDataSearchInitiatorStore: this.homeSensorsDataValueStore, sensorsSearchInitiatorStore: this.homeSensorsSearchInitiator, vehicleSearchInitiatorStore: this.homeVehicleSearchInitiator, searchVehiclesByCategoryInitiator: this.categorySearchInitiator, searchVehiclesByCategory: this.vehicleCategorySearch, deleteObjectsStore: this.toDeleteItemsStore, deleteObjectsCommand: discardSensorExcessCommand });
};

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DivisionTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Label_LabelStore__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_Grid_ListStore__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flux_Flag_FlagStore__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flux_Error_ErrorStore__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Pages_Division_EditCreateDivisionStore__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Pages_Division_commands_index__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Pages_Division_commands_InitUpsertDivisionCommand__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Pages_Division_DivisionRoute__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__routes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__configureSearchBox__ = __webpack_require__(129);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }














// This class is a configuration for Division tab
// Constructor receives and/or creates dependencies and injects them
var DivisionTab = function DivisionTab(polyglot, runSearch, commitEntity, getCurrentDivisionId, divisionEmitter, changeCurrentDivisionCmd) {
    var _this = this;

    _classCallCheck(this, DivisionTab);

    this.tableTitleStore = new __WEBPACK_IMPORTED_MODULE_2__flux_Label_LabelStore__["a" /* LabelStore */]();
    this.listStore = new __WEBPACK_IMPORTED_MODULE_3__flux_Grid_ListStore__["a" /* ListStore */](function (division) {
        return division.id;
    }, __WEBPACK_IMPORTED_MODULE_7__models__["a" /* EntityType */].Division);
    this.commitInProgressStore = new __WEBPACK_IMPORTED_MODULE_4__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.upsertErrorStore = new __WEBPACK_IMPORTED_MODULE_5__flux_Error_ErrorStore__["a" /* ErrorStore */]();
    this.upsertStore = new __WEBPACK_IMPORTED_MODULE_6__components_Pages_Division_EditCreateDivisionStore__["a" /* EditCreateDivisionStore */]();
    this.divisionLoadInProgress = new __WEBPACK_IMPORTED_MODULE_4__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.searchConfig = new __WEBPACK_IMPORTED_MODULE_12__configureSearchBox__["a" /* TabSearchConfigurator */](polyglot, __WEBPACK_IMPORTED_MODULE_7__models__["a" /* EntityType */].Division, getCurrentDivisionId, divisionEmitter, this.tableTitleStore.dispatchToken);
    var divisionUpsertCmd = new __WEBPACK_IMPORTED_MODULE_8__components_Pages_Division_commands_index__["a" /* UpsertDivisionCommand */](polyglot, commitEntity, changeCurrentDivisionCmd, getCurrentDivisionId, this.listStore.dispatchToken, this.commitInProgressStore.dispatchToken, this.upsertErrorStore.dispatchToken);
    var divisionInitUpsertCmd = new __WEBPACK_IMPORTED_MODULE_9__components_Pages_Division_commands_InitUpsertDivisionCommand__["a" /* InitUpsertDivisionCommand */](runSearch, this.upsertStore, getCurrentDivisionId, this.divisionLoadInProgress.dispatchToken, this.upsertErrorStore.dispatchToken);
    var showCreateDivisionCommand = new __WEBPACK_IMPORTED_MODULE_8__components_Pages_Division_commands_index__["b" /* ShowCreateDivisionCommand */](this.upsertErrorStore.dispatchToken);
    var showEditDivisionCmd = new __WEBPACK_IMPORTED_MODULE_8__components_Pages_Division_commands_index__["c" /* ShowEditDivisionCommand */](this.upsertErrorStore.dispatchToken);
    this.markup = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */], { path: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__routes__["d" /* routeFor */])(__WEBPACK_IMPORTED_MODULE_7__models__["a" /* EntityType */].Division), render: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_Pages_Division_DivisionRoute__["a" /* DivisionRoute */], Object.assign({ polyglot: polyglot, tableTitleStore: _this.tableTitleStore, listStore: _this.listStore }, _this.searchConfig.searchBoxProps, { editStore: _this.upsertStore, divisionsLoadInProgress: _this.divisionLoadInProgress, upsertInProgressStore: _this.commitInProgressStore, upsertErrorStore: _this.upsertErrorStore, upsertCommand: divisionUpsertCmd, initUpsertCommand: divisionInitUpsertCmd, showCreateDivisionCommand: showCreateDivisionCommand, showEditDivisionCommand: showEditDivisionCmd, switchCommand: changeCurrentDivisionCmd }));
        } });
};

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HomeTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Label_LabelStore__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Grid_ListStore__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_Flag_FlagStore__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flux_Error_ErrorStore__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flux_Value_ValueStore__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Pages_Home_commands_LoadDashboardCommand__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Pages_Home_commands_TakeOverSensorExcessCommand__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Pages_SensorsData_commands_ShowSensorsDataCommand__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Pages_Home_commands_FindIncidentDataCommand__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Pages_Home_Home2__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Pages_commands_EntitySearchCommand__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__flux_Grid_SelectedItemsStore__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__flux_DeleteObjects__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Pages_commands_DeleteObjects__ = __webpack_require__(108);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

















// This class is a configuration for Dashboard tab
// Constructor receives and/or creates dependencies and injects them
var HomeTab = function HomeTab(polyglot, runSearch, getDashboard, takeOverSensorExcess, getSensorsDataForIncident, getCurrentDivisionId, googleMapLoader, deleteObjects) {
    _classCallCheck(this, HomeTab);

    this.homeReportTableTitleStore = new __WEBPACK_IMPORTED_MODULE_1__flux_Label_LabelStore__["a" /* LabelStore */]();
    this.homeReportListStore = new __WEBPACK_IMPORTED_MODULE_2__flux_Grid_ListStore__["a" /* ListStore */](function (r) {
        return null;
    }, "ReportExcessToken");
    this.homeSensorsExcessesListStore = new __WEBPACK_IMPORTED_MODULE_2__flux_Grid_ListStore__["a" /* ListStore */](function (se) {
        return se.IncidentId;
    }, __WEBPACK_IMPORTED_MODULE_10__models__["a" /* EntityType */].SensorExcess);
    this.homeTakeOverSensorExcessInProgressStore = new __WEBPACK_IMPORTED_MODULE_3__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.homeTakeOverSensorExcessErrorStore = new __WEBPACK_IMPORTED_MODULE_4__flux_Error_ErrorStore__["a" /* ErrorStore */]();
    this.homeExcessTableErrorStore = new __WEBPACK_IMPORTED_MODULE_4__flux_Error_ErrorStore__["a" /* ErrorStore */]();
    this.homeAlertStore = new __WEBPACK_IMPORTED_MODULE_3__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.homeVehicleSearchInitiator = new __WEBPACK_IMPORTED_MODULE_5__flux_Value_ValueStore__["a" /* ValueStore */]();
    this.homeSensorsSearchInitiator = new __WEBPACK_IMPORTED_MODULE_5__flux_Value_ValueStore__["a" /* ValueStore */]();
    this.homeSensorsDataValueStore = new __WEBPACK_IMPORTED_MODULE_5__flux_Value_ValueStore__["a" /* ValueStore */]();
    this.categorySearchInitiator = new __WEBPACK_IMPORTED_MODULE_5__flux_Value_ValueStore__["a" /* ValueStore */]();
    this.selectedItemsStore = new __WEBPACK_IMPORTED_MODULE_13__flux_Grid_SelectedItemsStore__["a" /* SelectedItemsStore */](this.homeSensorsExcessesListStore, __WEBPACK_IMPORTED_MODULE_10__models__["a" /* EntityType */].SensorExcess);
    this.toDeleteItemsStore = new __WEBPACK_IMPORTED_MODULE_14__flux_DeleteObjects__["a" /* DeleteObjectsStore */](__WEBPACK_IMPORTED_MODULE_10__models__["a" /* EntityType */].SensorExcess);
    this.homeLoadDashboardCmd = new __WEBPACK_IMPORTED_MODULE_6__components_Pages_Home_commands_LoadDashboardCommand__["a" /* LoadDashboardCommand */](polyglot, getDashboard, getCurrentDivisionId, this.homeSensorsExcessesListStore.token, this.homeReportListStore.token, this.homeReportTableTitleStore.dispatchToken, null, null);
    var homeTakeOverSensorExcessCmd = new __WEBPACK_IMPORTED_MODULE_7__components_Pages_Home_commands_TakeOverSensorExcessCommand__["a" /* TakeOverSensorExcessCommand */](takeOverSensorExcess, this.homeSensorsExcessesListStore.token, this.homeTakeOverSensorExcessInProgressStore.dispatchToken, this.homeTakeOverSensorExcessErrorStore.dispatchToken);
    var homeShowSensorsDataCmd = new __WEBPACK_IMPORTED_MODULE_8__components_Pages_SensorsData_commands_ShowSensorsDataCommand__["a" /* ShowSensorsDataCommand */](googleMapLoader, this.homeAlertStore.dispatchToken);
    this.homeSearchVehicleCmd = new __WEBPACK_IMPORTED_MODULE_12__components_Pages_commands_EntitySearchCommand__["a" /* SearchWithInitiatorCommand */](polyglot, __WEBPACK_IMPORTED_MODULE_10__models__["a" /* EntityType */].Vehicle, runSearch, this.homeVehicleSearchInitiator.dispatchToken, this.homeExcessTableErrorStore.dispatchToken);
    this.homeSearchSensorsCmd = new __WEBPACK_IMPORTED_MODULE_12__components_Pages_commands_EntitySearchCommand__["a" /* SearchWithInitiatorCommand */](polyglot, __WEBPACK_IMPORTED_MODULE_10__models__["a" /* EntityType */].Sensor, runSearch, this.homeSensorsSearchInitiator.dispatchToken, this.homeExcessTableErrorStore.dispatchToken);
    var homeFindIncidentDataCmd = new __WEBPACK_IMPORTED_MODULE_9__components_Pages_Home_commands_FindIncidentDataCommand__["a" /* FindIncidentDataCommand */](getSensorsDataForIncident, homeShowSensorsDataCmd, this.homeSensorsDataValueStore.dispatchToken, this.homeExcessTableErrorStore.dispatchToken);
    this.vehicleCategorySearch = new __WEBPACK_IMPORTED_MODULE_12__components_Pages_commands_EntitySearchCommand__["a" /* SearchWithInitiatorCommand */](polyglot, __WEBPACK_IMPORTED_MODULE_10__models__["a" /* EntityType */].Vehicle, runSearch, this.categorySearchInitiator.dispatchToken, this.homeExcessTableErrorStore.dispatchToken);
    this.vehicleCategorySearch.addRequestMiddleware(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__components_Pages_commands_EntitySearchCommand__["d" /* getCurrentDivisionMiddleware */])(getCurrentDivisionId));
    var discardSensorExcessCommand = new __WEBPACK_IMPORTED_MODULE_15__components_Pages_commands_DeleteObjects__["a" /* DeleteObjectsCommand */](__WEBPACK_IMPORTED_MODULE_10__models__["a" /* EntityType */].SensorExcess, this.toDeleteItemsStore, deleteObjects);
    this.markup = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_Pages_Home_Home2__["a" /* Dashboard */], { polyglot: polyglot, assignCmd: homeTakeOverSensorExcessCmd, assignmentInProgressStore: this.homeTakeOverSensorExcessInProgressStore, assignmentErrorStore: this.homeTakeOverSensorExcessErrorStore, sensorsExcessesListStore: this.homeSensorsExcessesListStore, selectedItemsStore: this.selectedItemsStore, loadDashboardCmd: this.homeLoadDashboardCmd, reportTableTitleStore: this.homeReportTableTitleStore, reportListStore: this.homeReportListStore, sensorSearchCmd: this.homeSearchSensorsCmd, vehicleSearchCmd: this.homeSearchVehicleCmd, incidentDataSearchCmd: homeFindIncidentDataCmd, excessTableErrorStore: this.homeExcessTableErrorStore, alertStore: this.homeAlertStore, sensorsDataSearchInitiatorStore: this.homeSensorsDataValueStore, sensorsSearchInitiatorStore: this.homeSensorsSearchInitiator, vehicleSearchInitiatorStore: this.homeVehicleSearchInitiator, searchVehiclesByCategoryInitiator: this.categorySearchInitiator, searchVehiclesByCategory: this.vehicleCategorySearch, deleteObjectsStore: this.toDeleteItemsStore, deleteObjectsCommand: discardSensorExcessCommand });
};

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PersonTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Label_LabelStore__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_Grid_ListStore__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flux_Grid_SelectedItemsStore__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flux_Flag_FlagStore__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flux_Error_ErrorStore__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flux_DeleteObjects__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Pages_Person_EditCreatePersonStore__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Pages_commands_DeleteObjects__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Pages_Person_commands_UpsertPersonCommand__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Pages_Person_commands_InitUpsertPersonCommand__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Pages_Person_PersonRoute__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__routes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__configureSearchBox__ = __webpack_require__(129);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

















// This class is a configuration for Person tab
// Constructor receives and/or creates dependencies and injects them
var PersonTab = function PersonTab(polyglot, runSearch, commitEntity, deleteObjects, getCurrentDivisionId, divisionEmitter, IsAdmin) {
    var _this = this;

    _classCallCheck(this, PersonTab);

    this.tableTitleStore = new __WEBPACK_IMPORTED_MODULE_2__flux_Label_LabelStore__["a" /* LabelStore */]();
    this.listStore = new __WEBPACK_IMPORTED_MODULE_3__flux_Grid_ListStore__["a" /* ListStore */](function (person) {
        return person.id;
    }, __WEBPACK_IMPORTED_MODULE_12__models__["a" /* EntityType */].Person);
    this.selectedItemsStore = new __WEBPACK_IMPORTED_MODULE_4__flux_Grid_SelectedItemsStore__["a" /* SelectedItemsStore */](this.listStore, __WEBPACK_IMPORTED_MODULE_12__models__["a" /* EntityType */].Person);
    this.deleteItemsStore = new __WEBPACK_IMPORTED_MODULE_7__flux_DeleteObjects__["a" /* DeleteObjectsStore */](__WEBPACK_IMPORTED_MODULE_12__models__["a" /* EntityType */].Person);
    this.commitInProgressStore = new __WEBPACK_IMPORTED_MODULE_5__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.commitErrorStore = new __WEBPACK_IMPORTED_MODULE_6__flux_Error_ErrorStore__["a" /* ErrorStore */]();
    this.upserStore = new __WEBPACK_IMPORTED_MODULE_8__components_Pages_Person_EditCreatePersonStore__["a" /* EditCreatePersonStore */]();
    this.divisionsLoadInProgress = new __WEBPACK_IMPORTED_MODULE_5__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.searchConfig = new __WEBPACK_IMPORTED_MODULE_15__configureSearchBox__["a" /* TabSearchConfigurator */](polyglot, __WEBPACK_IMPORTED_MODULE_12__models__["a" /* EntityType */].Person, getCurrentDivisionId, divisionEmitter, this.tableTitleStore.dispatchToken);
    var deletePersonCommand = new __WEBPACK_IMPORTED_MODULE_9__components_Pages_commands_DeleteObjects__["a" /* DeleteObjectsCommand */](__WEBPACK_IMPORTED_MODULE_12__models__["a" /* EntityType */].Person, this.deleteItemsStore, deleteObjects);
    var personUpsertCmd = new __WEBPACK_IMPORTED_MODULE_10__components_Pages_Person_commands_UpsertPersonCommand__["a" /* UpsertPersonCommand */](polyglot, commitEntity, this.listStore.dispatchToken, this.commitInProgressStore.dispatchToken, this.commitErrorStore.dispatchToken);
    var personInitUpsertCmd = new __WEBPACK_IMPORTED_MODULE_11__components_Pages_Person_commands_InitUpsertPersonCommand__["a" /* InitUpsertPersonCommand */](runSearch, this.upserStore, getCurrentDivisionId, this.divisionsLoadInProgress.dispatchToken, this.commitErrorStore.dispatchToken);
    this.markup = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */], { path: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__routes__["d" /* routeFor */])(__WEBPACK_IMPORTED_MODULE_12__models__["a" /* EntityType */].Person), render: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_Pages_Person_PersonRoute__["a" /* PersonRoute */], Object.assign({ polyglot: polyglot, isAdmin: IsAdmin, tableTitleStore: _this.tableTitleStore, listStore: _this.listStore, selectedItemsStore: _this.selectedItemsStore, deleteObjectsStore: _this.deleteItemsStore, deleteObjectsCommand: deletePersonCommand }, _this.searchConfig.searchBoxProps, { upsertCommand: personUpsertCmd, upsertInProgressStore: _this.commitInProgressStore, upsertErrorStore: _this.commitErrorStore, initUpsertCommand: personInitUpsertCmd, editStore: _this.upserStore, divisionsLoadInProgress: _this.divisionsLoadInProgress }));
        } });
};

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SensorTabConfigurator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_Label_LabelStore__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flux_Flag_FlagStore__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flux_Error_ErrorStore__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flux_Grid_ListStore__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flux_Grid_SelectedItemsStore__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__flux_DeleteObjects__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Pages_Sensor_DateRangeStore__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__flux_Value_ValueStore__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Pages_commands_EntitySearchCommand__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Pages_commands_DeleteObjects__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Pages_commands_UpsertCommand__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Pages_Sensor_commands_UpsertSensorCommand__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Pages_SensorsData_commands_ShowSensorsDataCommand__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Pages_Sensor_commands_LoadSensorsDataCommand__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Pages_Sensor_flux__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Pages_Sensor_SensorRoute__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Pages_Sensor_commands_Vehicle_SetVehicleCommand__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Pages_Sensor_commands_Sensor_LoadGeotabSensorsCommand__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Pages_Sensor_commands_Sensor_SetGeotabSensorCommand__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Pages_Sensor_commands_InitUpsertSensorCommand__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Pages_Sensor_commands_Vehicle_LoadVehiclesCommand__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Pages_Sensor_commands_LoadMeasuresCommand__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__routes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__configureSearchBox__ = __webpack_require__(129);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




























// This class is a configuration for Sensors tab
// Constructor receives and/or creates dependencies and injects them
var SensorTabConfigurator = function SensorTabConfigurator(polyglot, runSearch, commitEntity, deleteObjects, getSensorsData, getGeotabSensors, getMeasures, getCurrentDivisionId, divisionEmitter, googleMapLoader) {
    var _this = this;

    _classCallCheck(this, SensorTabConfigurator);

    this.polyglot = polyglot;
    this.runSearch = runSearch;
    this.editStore = new __WEBPACK_IMPORTED_MODULE_17__components_Pages_Sensor_flux__["a" /* EditSensorStore */]();
    this.listStore = new __WEBPACK_IMPORTED_MODULE_6__flux_Grid_ListStore__["a" /* ListStore */](function (s) {
        return s.id;
    }, __WEBPACK_IMPORTED_MODULE_2__models__["a" /* EntityType */].Sensor);
    this.selectedItemsStore = new __WEBPACK_IMPORTED_MODULE_7__flux_Grid_SelectedItemsStore__["a" /* SelectedItemsStore */](this.listStore, __WEBPACK_IMPORTED_MODULE_2__models__["a" /* EntityType */].Sensor);
    this.toDeleteItemsStore = new __WEBPACK_IMPORTED_MODULE_8__flux_DeleteObjects__["a" /* DeleteObjectsStore */](__WEBPACK_IMPORTED_MODULE_2__models__["a" /* EntityType */].Sensor);
    this.loadingVehicles = new __WEBPACK_IMPORTED_MODULE_4__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.loadingGeotabSensors = new __WEBPACK_IMPORTED_MODULE_4__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.loadingQuantities = new __WEBPACK_IMPORTED_MODULE_4__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.upsertInProgressStore = new __WEBPACK_IMPORTED_MODULE_4__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.upsertErrorStore = new __WEBPACK_IMPORTED_MODULE_5__flux_Error_ErrorStore__["a" /* ErrorStore */]();
    this.toolbarErrorStore = new __WEBPACK_IMPORTED_MODULE_5__flux_Error_ErrorStore__["a" /* ErrorStore */]();
    this.dateRangeStore = new __WEBPACK_IMPORTED_MODULE_9__components_Pages_Sensor_DateRangeStore__["a" /* DateRangeStore */]();
    this.loadSensorsDataInProgressStore = new __WEBPACK_IMPORTED_MODULE_4__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.alertStore = new __WEBPACK_IMPORTED_MODULE_4__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.vehicleSearchInitiatorStore = new __WEBPACK_IMPORTED_MODULE_10__flux_Value_ValueStore__["a" /* ValueStore */]();
    this.tableTitleStore = new __WEBPACK_IMPORTED_MODULE_3__flux_Label_LabelStore__["a" /* LabelStore */]();
    this.searchConfig = new __WEBPACK_IMPORTED_MODULE_26__configureSearchBox__["a" /* TabSearchConfigurator */](polyglot, __WEBPACK_IMPORTED_MODULE_2__models__["a" /* EntityType */].Sensor, getCurrentDivisionId, divisionEmitter, this.tableTitleStore.dispatchToken);
    this.deleteCmd = new __WEBPACK_IMPORTED_MODULE_12__components_Pages_commands_DeleteObjects__["a" /* DeleteObjectsCommand */](__WEBPACK_IMPORTED_MODULE_2__models__["a" /* EntityType */].Sensor, this.toDeleteItemsStore, deleteObjects);
    this.internalUpsertCmd = new __WEBPACK_IMPORTED_MODULE_13__components_Pages_commands_UpsertCommand__["a" /* UpsertCommand */](commitEntity, this.listStore.dispatchToken, this.upsertInProgressStore.dispatchToken, this.upsertErrorStore.dispatchToken);
    this.upsertCmd = new __WEBPACK_IMPORTED_MODULE_14__components_Pages_Sensor_commands_UpsertSensorCommand__["a" /* UpsertSensorCommand */](polyglot, this.upsertErrorStore.dispatchToken, this.internalUpsertCmd);
    this.sensorsDataShowCmd = new __WEBPACK_IMPORTED_MODULE_15__components_Pages_SensorsData_commands_ShowSensorsDataCommand__["a" /* ShowSensorsDataCommand */](googleMapLoader, this.alertStore.dispatchToken);
    this.loadSensrosDataCmd = new __WEBPACK_IMPORTED_MODULE_16__components_Pages_Sensor_commands_LoadSensorsDataCommand__["a" /* LoadSensorsDataCommand */](getSensorsData, function () {
        return [].concat(_toConsumableArray(_this.selectedItemsStore.getState().selected));
    }, this.sensorsDataShowCmd, this.loadSensorsDataInProgressStore.dispatchToken, this.toolbarErrorStore.dispatchToken);
    this.searchVehicleCmd = new __WEBPACK_IMPORTED_MODULE_11__components_Pages_commands_EntitySearchCommand__["a" /* SearchWithInitiatorCommand */](polyglot, __WEBPACK_IMPORTED_MODULE_2__models__["a" /* EntityType */].Vehicle, runSearch, this.vehicleSearchInitiatorStore.dispatchToken, this.toolbarErrorStore.dispatchToken);
    this.setGeotabSensorCmd = new __WEBPACK_IMPORTED_MODULE_21__components_Pages_Sensor_commands_Sensor_SetGeotabSensorCommand__["a" /* SetGeotabSensorCommand */](this.editStore.getState);
    this.loadGeotabSensorsCmd = new __WEBPACK_IMPORTED_MODULE_20__components_Pages_Sensor_commands_Sensor_LoadGeotabSensorsCommand__["a" /* LoadGeotabSensorsCommand */](getGeotabSensors, this.editStore.getState, this.setGeotabSensorCmd, this.loadingGeotabSensors.dispatchToken, this.upsertErrorStore.dispatchToken);
    this.setVehicleCmd = new __WEBPACK_IMPORTED_MODULE_19__components_Pages_Sensor_commands_Vehicle_SetVehicleCommand__["a" /* SetVehicleCommand */](this.loadGeotabSensorsCmd, this.setGeotabSensorCmd);
    this.loadVehiclesCmd = new __WEBPACK_IMPORTED_MODULE_23__components_Pages_Sensor_commands_Vehicle_LoadVehiclesCommand__["a" /* LoadVehiclesCommand */](runSearch, this.editStore.getState, this.setVehicleCmd, this.loadingVehicles.dispatchToken, this.upsertErrorStore.dispatchToken);
    this.loadMeasuresCmd = new __WEBPACK_IMPORTED_MODULE_24__components_Pages_Sensor_commands_LoadMeasuresCommand__["a" /* LoadMeasuresCommand */](getMeasures, this.editStore.getState, getCurrentDivisionId, this.loadingQuantities.dispatchToken, this.upsertErrorStore.dispatchToken);
    this.initUpsertSensorCmd = new __WEBPACK_IMPORTED_MODULE_22__components_Pages_Sensor_commands_InitUpsertSensorCommand__["a" /* InitUpsertSensorCommand */](this.loadVehiclesCmd, this.loadMeasuresCmd, this.loadGeotabSensorsCmd);
    this.markup = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */], { path: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__routes__["d" /* routeFor */])(__WEBPACK_IMPORTED_MODULE_2__models__["a" /* EntityType */].Sensor), render: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__components_Pages_Sensor_SensorRoute__["a" /* SensorTab */], Object.assign({ polyglot: _this.polyglot, isAdmin: true, tableTitleStore: _this.tableTitleStore, listStore: _this.listStore, selectedItemsStore: _this.selectedItemsStore, deleteObjectsStore: _this.toDeleteItemsStore, deleteObjectsCommand: _this.deleteCmd }, _this.searchConfig.searchBoxProps, { loadingVehicles: _this.loadingVehicles, loadingGeotabSensors: _this.loadingGeotabSensors, loadingQuantities: _this.loadingQuantities, upsertInProgressStore: _this.upsertInProgressStore, upsertErrorStore: _this.upsertErrorStore, upsertCommand: _this.upsertCmd, vehicleSearchCmd: _this.searchVehicleCmd, vehicleSearchInitiatorStore: _this.vehicleSearchInitiatorStore, alertVisibilityStore: _this.alertStore, toolbarErrorStore: _this.toolbarErrorStore, loadSensorsDataCmd: _this.loadSensrosDataCmd, loadSensorsDataInProgressStore: _this.loadSensorsDataInProgressStore, dateRangeStore: _this.dateRangeStore, editStore: _this.editStore, upsertInitCmd: _this.initUpsertSensorCmd, upsertSetVehicle: _this.setVehicleCmd, upsertSetGeotabSensor: _this.setGeotabSensorCmd }));
        } });
};

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServiceAccountTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Label_LabelStore__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_Grid_ListStore__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flux_Grid_SelectedItemsStore__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flux_DeleteObjects__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flux_Flag_FlagStore__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flux_Error_ErrorStore__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Pages_ServiceAccount_EditServiceAccountStore__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Pages_commands_DeleteObjects__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Pages_commands_UpsertCommand__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Pages_ServiceAccount_commands__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Pages_ServiceAccount_ServiceAccountRoute__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__configureSearchBox__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__routes__ = __webpack_require__(7);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

















// This class is a configuration for Service account tab
// Constructor receives and/or creates dependencies and injects them
var ServiceAccountTab = function ServiceAccountTab(polyglot, runSearch, commitEntity, deleteObjects, getCurrentDivisionId, divisionEmitter, isDivisionAware) {
    var _this = this;

    _classCallCheck(this, ServiceAccountTab);

    this.listStore = new __WEBPACK_IMPORTED_MODULE_3__flux_Grid_ListStore__["a" /* ListStore */](function (sa) {
        return sa.id;
    }, __WEBPACK_IMPORTED_MODULE_12__models__["a" /* EntityType */].ServiceAccount);
    this.tableTitleStore = new __WEBPACK_IMPORTED_MODULE_2__flux_Label_LabelStore__["a" /* LabelStore */]();
    this.selectedItemsStore = new __WEBPACK_IMPORTED_MODULE_4__flux_Grid_SelectedItemsStore__["a" /* SelectedItemsStore */](this.listStore, __WEBPACK_IMPORTED_MODULE_12__models__["a" /* EntityType */].ServiceAccount);
    this.toDeleteItemsStore = new __WEBPACK_IMPORTED_MODULE_5__flux_DeleteObjects__["a" /* DeleteObjectsStore */](__WEBPACK_IMPORTED_MODULE_12__models__["a" /* EntityType */].ServiceAccount);
    this.upsertDivisionLoadInProgress = new __WEBPACK_IMPORTED_MODULE_6__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.upsertInProgressStore = new __WEBPACK_IMPORTED_MODULE_6__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.upsertErrorStore = new __WEBPACK_IMPORTED_MODULE_7__flux_Error_ErrorStore__["a" /* ErrorStore */]();
    this.editStore = new __WEBPACK_IMPORTED_MODULE_8__components_Pages_ServiceAccount_EditServiceAccountStore__["a" /* EditServiceAccountStore */]();
    this.searchConfig = new __WEBPACK_IMPORTED_MODULE_14__configureSearchBox__["a" /* TabSearchConfigurator */](polyglot, __WEBPACK_IMPORTED_MODULE_12__models__["a" /* EntityType */].ServiceAccount, getCurrentDivisionId, divisionEmitter, this.tableTitleStore.dispatchToken);
    var deleteServiceAccountCommand = new __WEBPACK_IMPORTED_MODULE_9__components_Pages_commands_DeleteObjects__["a" /* DeleteObjectsCommand */](__WEBPACK_IMPORTED_MODULE_12__models__["a" /* EntityType */].ServiceAccount, this.toDeleteItemsStore, deleteObjects);
    var preloadEditCreateServiceAccountCmd = new __WEBPACK_IMPORTED_MODULE_11__components_Pages_ServiceAccount_commands__["a" /* InitUpsertServiceAccountCommand */](runSearch, this.editStore, getCurrentDivisionId, this.upsertErrorStore.dispatchToken, this.upsertDivisionLoadInProgress.dispatchToken);
    var internalUpsertServiceAccountCmd = new __WEBPACK_IMPORTED_MODULE_10__components_Pages_commands_UpsertCommand__["a" /* UpsertCommand */](commitEntity, this.listStore.dispatchToken, this.upsertInProgressStore.dispatchToken, this.upsertErrorStore.dispatchToken);
    var upsertServiceAccountCmd = new __WEBPACK_IMPORTED_MODULE_11__components_Pages_ServiceAccount_commands__["b" /* UpsertServiceAccountCommand */](polyglot, this.upsertErrorStore.dispatchToken, internalUpsertServiceAccountCmd);
    this.markup = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */], { path: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__routes__["d" /* routeFor */])(__WEBPACK_IMPORTED_MODULE_12__models__["a" /* EntityType */].ServiceAccount), render: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_Pages_ServiceAccount_ServiceAccountRoute__["a" /* ServiceAccountRoute */], Object.assign({ polyglot: polyglot, isAdmin: true, isDivisionAware: isDivisionAware, tableTitleStore: _this.tableTitleStore, listStore: _this.listStore, selectedItemsStore: _this.selectedItemsStore, deleteObjectsStore: _this.toDeleteItemsStore, deleteObjectsCommand: deleteServiceAccountCommand }, _this.searchConfig.searchBoxProps, { loadDivisionInProgress: _this.upsertDivisionLoadInProgress, initUpsert: preloadEditCreateServiceAccountCmd, upsertInProgressStore: _this.upsertInProgressStore, upsertErrorStore: _this.upsertErrorStore, upsertCommand: upsertServiceAccountCmd, editStore: _this.editStore }));
        } });
};

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SettingsTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flux_Flag__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Error__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Settings_SettingsStore__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Settings_commands_InitSettingsCommand__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Settings_commands_SaveSettingsCommand__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Settings_commands_ShowSettingsCommand__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__polyglot_languagePacks__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Settings_Settings__ = __webpack_require__(574);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }










// This class is a configuration for Settings
// Constructor receives and/or creates dependencies and injects them
var SettingsTab = function SettingsTab(polyglot, languagePacks, getSettings, saveSettings, currentDivisionStore, getCurrentDivision, getCurrentDivisionId, render, isEmailNotificationEnabled, isAdmin) {
    _classCallCheck(this, SettingsTab);

    this.settingsSaveInProgressStore = new __WEBPACK_IMPORTED_MODULE_1__flux_Flag__["b" /* FlagStore */]();
    this.settingsErrorStore = new __WEBPACK_IMPORTED_MODULE_2__flux_Error__["b" /* ErrorStore */]();
    this.settingsStore = new __WEBPACK_IMPORTED_MODULE_3__components_Settings_SettingsStore__["a" /* SettingsStore */]();
    var getCurrentLanguageOption = function getCurrentLanguageOption() {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__polyglot_languagePacks__["c" /* getLanguageOptions */])().find(function (opt) {
            return opt.code === polyglot.locale();
        });
    };
    var settingsInitCommand = new __WEBPACK_IMPORTED_MODULE_4__components_Settings_commands_InitSettingsCommand__["a" /* InitSettingsCommand */](getSettings, getCurrentDivision, __WEBPACK_IMPORTED_MODULE_7__polyglot_languagePacks__["c" /* getLanguageOptions */], getCurrentLanguageOption, this.settingsSaveInProgressStore.dispatchToken, this.settingsErrorStore.dispatchToken);
    var settingsSaveCommand = new __WEBPACK_IMPORTED_MODULE_5__components_Settings_commands_SaveSettingsCommand__["a" /* SaveSettingsCommand */](polyglot, languagePacks, render, saveSettings, getCurrentDivisionId, this.settingsStore, this.settingsSaveInProgressStore.dispatchToken, this.settingsErrorStore.dispatchToken);
    this.settingsShowCommand = new __WEBPACK_IMPORTED_MODULE_6__components_Settings_commands_ShowSettingsCommand__["a" /* ShowSettingsCommand */](this.settingsErrorStore.dispatchToken);
    this.markup = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_Settings_Settings__["a" /* Settings */], { polyglot: polyglot, currentDivisionStore: currentDivisionStore, initSettingsCommand: settingsInitCommand, settingsStore: this.settingsStore, saveSettingsCommand: settingsSaveCommand, inProgressStore: this.settingsSaveInProgressStore, errorStore: this.settingsErrorStore, isEmailNotificationEnabled: isEmailNotificationEnabled, isAdmin: isAdmin });
};

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VehicleTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flux_Label_LabelStore__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_Flag_FlagStore__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flux_Error_ErrorStore__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flux_Grid_ListStore__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flux_Grid_SelectedItemsStore__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__flux_DeleteObjects__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Pages_Vehicle_BatchEdit_flux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__flux_Value_ValueStore__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Pages_commands_EntitySearchCommand__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Pages_commands_DeleteObjects__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Pages_commands_UpsertCommand__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Pages_Vehicle_VehicleRoute__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__configureSearchBox__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__routes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Pages_Vehicle_flux__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Pages_Vehicle_commands__ = __webpack_require__(571);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




















// This class is a configuration for Vehicle tab
// Constructor receives and/or creates dependencies and injects them
var VehicleTab = function VehicleTab(polyglot, timezoneStore, defaultTimezoneId, runSearch, commitEntity, deleteObjects, getMeasures, getGroupParams, getVehiclesGeoposition, getVehicleTags, getGeotabVehicles, groupActions, getCurrentDivisionId, divisionEmitter, googleMapLoader) {
    var _this = this;

    _classCallCheck(this, VehicleTab);

    this.tableTitleStore = new __WEBPACK_IMPORTED_MODULE_2__flux_Label_LabelStore__["a" /* LabelStore */]();
    this.listStore = new __WEBPACK_IMPORTED_MODULE_5__flux_Grid_ListStore__["a" /* ListStore */](function (v) {
        return v.id;
    }, __WEBPACK_IMPORTED_MODULE_6__models__["a" /* EntityType */].Vehicle);
    this.editStore = new __WEBPACK_IMPORTED_MODULE_17__components_Pages_Vehicle_flux__["a" /* EditVehicleStore */]();
    this.selectedItemsStore = new __WEBPACK_IMPORTED_MODULE_7__flux_Grid_SelectedItemsStore__["a" /* SelectedItemsStore */](this.listStore, __WEBPACK_IMPORTED_MODULE_6__models__["a" /* EntityType */].Vehicle);
    this.toDeleteItemsStore = new __WEBPACK_IMPORTED_MODULE_8__flux_DeleteObjects__["a" /* DeleteObjectsStore */](__WEBPACK_IMPORTED_MODULE_6__models__["a" /* EntityType */].Vehicle);
    this.toolbarErrorStore = new __WEBPACK_IMPORTED_MODULE_4__flux_Error_ErrorStore__["a" /* ErrorStore */]();
    this.mapInProgressStore = new __WEBPACK_IMPORTED_MODULE_3__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.alertStore = new __WEBPACK_IMPORTED_MODULE_3__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.groupActionsErrorStore = new __WEBPACK_IMPORTED_MODULE_4__flux_Error_ErrorStore__["a" /* ErrorStore */]();
    this.applyGroupActionsInProgressStore = new __WEBPACK_IMPORTED_MODULE_3__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.groupEditStore = new __WEBPACK_IMPORTED_MODULE_9__components_Pages_Vehicle_BatchEdit_flux__["a" /* VehicleBatchEditStore */]();
    this.upsertErrorStore = new __WEBPACK_IMPORTED_MODULE_4__flux_Error_ErrorStore__["a" /* ErrorStore */]();
    this.upsertLoadDivisionInProgressStore = new __WEBPACK_IMPORTED_MODULE_3__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.upsertLoadServiceAccountsInProgressStore = new __WEBPACK_IMPORTED_MODULE_3__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.upsertLoadGeotabVehiclesInProgressStore = new __WEBPACK_IMPORTED_MODULE_3__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.upsertLoadTagsInProgressStore = new __WEBPACK_IMPORTED_MODULE_3__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.upsertInProgressStore = new __WEBPACK_IMPORTED_MODULE_3__flux_Flag_FlagStore__["a" /* FlagStore */]();
    this.sensorsSearchInitiator = new __WEBPACK_IMPORTED_MODULE_10__flux_Value_ValueStore__["a" /* ValueStore */]();
    this.searchConfig = new __WEBPACK_IMPORTED_MODULE_15__configureSearchBox__["a" /* TabSearchConfigurator */](polyglot, __WEBPACK_IMPORTED_MODULE_6__models__["a" /* EntityType */].Vehicle, getCurrentDivisionId, divisionEmitter, this.tableTitleStore.dispatchToken);
    this.searchUndefinedLevelsCmd = new __WEBPACK_IMPORTED_MODULE_11__components_Pages_commands_EntitySearchCommand__["c" /* SearchWithSpinnerCommand */](polyglot, __WEBPACK_IMPORTED_MODULE_6__models__["a" /* EntityType */].Vehicle, runSearch, this.searchConfig.searchBoxProps.refresher, this.searchConfig.searchInProgressStore.dispatchToken, this.searchConfig.searchErrorStore.dispatchToken);
    this.searchUndefinedLevelsCmd.labelDispatchToken = this.tableTitleStore.dispatchToken;
    var deleteVehicleCommand = new __WEBPACK_IMPORTED_MODULE_12__components_Pages_commands_DeleteObjects__["a" /* DeleteObjectsCommand */](__WEBPACK_IMPORTED_MODULE_6__models__["a" /* EntityType */].Vehicle, this.toDeleteItemsStore, deleteObjects);
    var showVehicleGeopositionCmd = new __WEBPACK_IMPORTED_MODULE_18__components_Pages_Vehicle_commands__["a" /* ShowVehicleGeopositionCommand */](function () {
        return _this.selectedItemsStore.toArray();
    }, getVehiclesGeoposition, googleMapLoader, this.toolbarErrorStore.dispatchToken, this.mapInProgressStore.dispatchToken, this.alertStore.dispatchToken);
    var showVehicleGroupActionsCommand = new __WEBPACK_IMPORTED_MODULE_18__components_Pages_Vehicle_commands__["b" /* ShowVehicleGroupActionsCommand */](this.listStore, this.selectedItemsStore, this.groupActionsErrorStore.dispatchToken);
    var selectGroupActionCommand = new __WEBPACK_IMPORTED_MODULE_18__components_Pages_Vehicle_commands__["c" /* SelectGroupActionCommand */](this.groupEditStore.getState, getMeasures, getGroupParams, getVehicleTags);
    var applyGroupActionsCommand = new __WEBPACK_IMPORTED_MODULE_18__components_Pages_Vehicle_commands__["d" /* ApplyVehicleGroupActionsCommand */](this.groupEditStore.getState, groupActions, this.groupActionsErrorStore.dispatchToken, this.applyGroupActionsInProgressStore.dispatchToken);
    var vehicleUpsertCmd = new __WEBPACK_IMPORTED_MODULE_13__components_Pages_commands_UpsertCommand__["a" /* UpsertCommand */](commitEntity, this.listStore.dispatchToken, this.upsertInProgressStore.dispatchToken, this.upsertErrorStore.dispatchToken);
    var upsertVehicleController = new __WEBPACK_IMPORTED_MODULE_17__components_Pages_Vehicle_flux__["b" /* UpsertVehicleController */](polyglot, runSearch, getGeotabVehicles, getVehicleTags, commitEntity, getCurrentDivisionId, this.editStore, vehicleUpsertCmd, this.upsertErrorStore.dispatchToken, this.upsertLoadDivisionInProgressStore.dispatchToken, this.upsertLoadServiceAccountsInProgressStore.dispatchToken, this.upsertLoadGeotabVehiclesInProgressStore.dispatchToken, this.upsertLoadTagsInProgressStore.dispatchToken);
    upsertVehicleController.defaultTimezoneId = defaultTimezoneId;
    this.searchSensorsCmd = new __WEBPACK_IMPORTED_MODULE_11__components_Pages_commands_EntitySearchCommand__["a" /* SearchWithInitiatorCommand */](polyglot, __WEBPACK_IMPORTED_MODULE_6__models__["a" /* EntityType */].Sensor, runSearch, this.sensorsSearchInitiator.dispatchToken, this.toolbarErrorStore.dispatchToken);
    this.markup = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */], { path: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__routes__["d" /* routeFor */])(__WEBPACK_IMPORTED_MODULE_6__models__["a" /* EntityType */].Vehicle), render: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__components_Pages_Vehicle_VehicleRoute__["a" /* VehicleRoute */], Object.assign({ polyglot: polyglot, isAdmin: true, toolbarErrorStore: _this.toolbarErrorStore, tableTitleStore: _this.tableTitleStore, listStore: _this.listStore, selectedItemsStore: _this.selectedItemsStore, deleteObjectsStore: _this.toDeleteItemsStore, deleteObjectsCommand: deleteVehicleCommand, mapInProgressStore: _this.mapInProgressStore, showVehicleGeopositionCommand: showVehicleGeopositionCmd, alertVisibilityStore: _this.alertStore }, _this.searchConfig.searchBoxProps, {
                // group actioins
                selectGroupActionCommand: selectGroupActionCommand, showVehicleGroupActionsCommand: showVehicleGroupActionsCommand, applyGroupActionCommand: applyGroupActionsCommand, applyInProgressStore: _this.applyGroupActionsInProgressStore, applyErrorStore: _this.groupActionsErrorStore, groupEditStore: _this.groupEditStore,
                // dependency injection for upsert form
                editStore: _this.editStore, loadingDivisions: _this.upsertLoadDivisionInProgressStore, loadingServiceAccounts: _this.upsertLoadServiceAccountsInProgressStore, loadingGeotabVehicles: _this.upsertLoadGeotabVehiclesInProgressStore, loadingTags: _this.upsertLoadTagsInProgressStore, upsertInProgress: _this.upsertInProgressStore, upsertErrorStore: _this.upsertErrorStore, upsertController: upsertVehicleController, sensorsSearchCmd: _this.searchSensorsCmd, sensorsSearchInitiatorStore: _this.sensorsSearchInitiator, timezoneStore: timezoneStore }));
        } });
};

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbemitter__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbemitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fbemitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_node_polyglot__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_node_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_node_polyglot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_broadcast__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Header_Header__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Header_EntityLink__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_EntityType__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rest_Search__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__rest_Login__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__rest_Commit__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rest_user__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__rest_Geotab__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rest_Misc__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__rest_Dashboard__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__rest_GroupAction__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__rest_DeleteObjects__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__rest_GetVehiclesGeoposition__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__rest_settings__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__routes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Container__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__flux_Flag__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__flux_Error__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Pages_SensorsData_flux__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__flux_Grid_SelectedItemsActions__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Pages_SensorsData_SensorsDataRoute__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_TimeZone_TimezoneActions__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_TimeZone_TimeZoneStore__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Pages_Vehicle_flux_VehicleGeopositionStore__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Pages_ServiceAccount_AutoImportWatchActions__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Pages_VehicleMap_VehicleMapRoute__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__utils_GoogleMapLoader__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_DivisionPath_DivisionPath__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_DivisionPath_commands_ChangeCurrentDivisionCommand__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_DivisionPath_flux_CurrentDivisionStore__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_NonIsolatedPremise__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__charts_TimeSeries_flux_TimeSeriesStore__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__polyglot_languagePacks__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__login_commands_SignOutCommand__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__login_commands_configure__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__init__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__utils_Notifications_NotificationCenter__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__rest_notifications__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__rest_Misc_group_params__ = __webpack_require__(487);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//  This is an entry point into our application. The bootstrap process and initial render goes here





__webpack_require__(495);
__webpack_require__(494);










































__webpack_require__(491);
var styles = __webpack_require__(64);
var timezoneTimeoutMs = 21600000;
var autoImportTimeoutMs = 20000;
var commitHash = "72f697b\n";
var notificationPullTimeoutMs = 60000;
var CustomNavLink = function CustomNavLink(props) {
    if (props.onClick) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", Object.assign({}, props, { href: "#", onClick: props.onClick }), props.title);
    } else {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* NavLink */], Object.assign({}, props));
    }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__rest_user__["a" /* getUserInfo */])().then(function (res) {
    var isAdmin = res.IsAdministrator,
        isDivisionAware = res.IsDivisionAware,
        isIsolatedPremise = res.IsIsolatedPremise,
        defaultTimezoneId = res.DefaultTimezoneId,
        isEmailNotificationEnabled = res.IsEmailNotificationEnabled;

    var Root = void 0;
    var render = function render() {
        return __WEBPACK_IMPORTED_MODULE_1_react_dom__["render"](__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Root, null), document.getElementById('app'));
    };
    // Create Polyglot and set prefered locale.
    var polyglot = new __WEBPACK_IMPORTED_MODULE_3_node_polyglot___default.a();
    var locale = res.Locale && __WEBPACK_IMPORTED_MODULE_39__polyglot_languagePacks__["b" /* languagePacks */].has(res.Locale) ? res.Locale : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_39__polyglot_languagePacks__["a" /* getPrefLocale */])();
    var pack = __WEBPACK_IMPORTED_MODULE_39__polyglot_languagePacks__["b" /* languagePacks */].get(locale);
    polyglot.locale(locale);
    polyglot.replace(pack);
    var SubNav = function SubNav(props) {
        var pathParts = window.location.pathname.split("/");
        var currentPath = pathParts[pathParts.length - 1];
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "dropdown-menu" }, __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(props.children, function (child, idx) {
            var child_node = props.children[idx];
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: child_node.props && child_node.props.navto && child_node.props.navto.indexOf(currentPath) >= 0 ? 'active' : '', key: idx }, child);
        }));
    };

    var DashboardSubNav = function (_React$Component) {
        _inherits(DashboardSubNav, _React$Component);

        function DashboardSubNav() {
            _classCallCheck(this, DashboardSubNav);

            var _this = _possibleConstructorReturn(this, (DashboardSubNav.__proto__ || Object.getPrototypeOf(DashboardSubNav)).apply(this, arguments));

            _this.selectedItemsActions = new __WEBPACK_IMPORTED_MODULE_26__flux_Grid_SelectedItemsActions__["a" /* SelectedItemsActions */]();
            return _this;
        }

        _createClass(DashboardSubNav, [{
            key: "navigateToTimezones",
            value: function navigateToTimezones() {
                this.selectedItemsActions.selectAll(__WEBPACK_IMPORTED_MODULE_9__models_EntityType__["a" /* EntityType */].Vehicle);
                this.props.history.push('/vehicle/group-actions');
            }
        }, {
            key: "render",
            value: function render() {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SubNav, null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CustomNavLink, { to: __WEBPACK_IMPORTED_MODULE_21__routes__["a" /* homeRoute */], exact: true, navto: ['dashboard'] }, polyglot.t('nav.overview')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_Header_EntityLink__["a" /* EntityLink */], { navto: ['person'], to: '/person', type: __WEBPACK_IMPORTED_MODULE_9__models_EntityType__["a" /* EntityType */].Person }, polyglot.t('nav.user_administration')), isDivisionAware && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_Header_EntityLink__["a" /* EntityLink */], { navto: ['division'], to: '/division', type: __WEBPACK_IMPORTED_MODULE_9__models_EntityType__["a" /* EntityType */].Division }, polyglot.t('nav.fleetAdministration')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CustomNavLink, { navto: ['settings'], to: '/settings' }, polyglot.t('nav.settings_and_configuration')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CustomNavLink, { navto: ['group-actions'], title: polyglot.t('nav.timezones'), to: '/vehicle/group-actions', onClick: this.navigateToTimezones.bind(this) }, polyglot.t('nav.timezones')));
            }
        }]);

        return DashboardSubNav;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var AlarmSubNav = function (_React$Component2) {
        _inherits(AlarmSubNav, _React$Component2);

        function AlarmSubNav() {
            _classCallCheck(this, AlarmSubNav);

            var _this2 = _possibleConstructorReturn(this, (AlarmSubNav.__proto__ || Object.getPrototypeOf(AlarmSubNav)).apply(this, arguments));

            _this2.selectedItemsActions = new __WEBPACK_IMPORTED_MODULE_26__flux_Grid_SelectedItemsActions__["a" /* SelectedItemsActions */]();
            return _this2;
        }

        _createClass(AlarmSubNav, [{
            key: "navigateToAlarmsSettings",
            value: function navigateToAlarmsSettings() {
                this.selectedItemsActions.selectAll(__WEBPACK_IMPORTED_MODULE_9__models_EntityType__["a" /* EntityType */].Vehicle);
                this.props.history.push('/vehicle/group-actions');
            }
        }, {
            key: "render",
            value: function render() {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SubNav, null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CustomNavLink, { to: '/alarms', exact: true, navto: ['alarms'] }, polyglot.t('nav.overview')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CustomNavLink, { navto: ['group-actions'], title: polyglot.t('nav.configure'), to: '/vehicle/group-actions', onClick: this.navigateToAlarmsSettings.bind(this) }, polyglot.t('nav.configure')));
            }
        }]);

        return AlarmSubNav;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var VehicleSubNav = function VehicleSubNav(props) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SubNav, null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CustomNavLink, { to: '/vehicle', exact: true, navto: ['vehicle'] }, polyglot.t('nav.overview')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null));
    };
    var SensorSubNav = function SensorSubNav(props) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SubNav, null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CustomNavLink, { to: '/sensor', exact: true, navto: ['sensor', 'sensors-data'] }, polyglot.t('nav.overview')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null));
    };
    var ReportSubNav = function ReportSubNav(props) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SubNav, null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CustomNavLink, { to: '/reports', exact: true, navto: ['reports'] }, polyglot.t('nav.overview')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null));
    };
    var ReportsMessage = function ReportsMessage(props) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, polyglot.t('reports.no_reports_message'));
    };
    var googleMapLoader = new __WEBPACK_IMPORTED_MODULE_33__utils_GoogleMapLoader__["a" /* GoogleMapLoader */]();
    var vehicleGeopositionStore = new __WEBPACK_IMPORTED_MODULE_30__components_Pages_Vehicle_flux_VehicleGeopositionStore__["a" /* VehicleGeopositionStore */]();
    // Current Division
    var divisionEmitter = new __WEBPACK_IMPORTED_MODULE_2_fbemitter__["EventEmitter"]();
    var currentDivisionStore = new __WEBPACK_IMPORTED_MODULE_36__components_DivisionPath_flux_CurrentDivisionStore__["a" /* CurrentDivisionStore */]();
    // TODO: I don't like it
    var timezoneActions = new __WEBPACK_IMPORTED_MODULE_28__utils_TimeZone_TimezoneActions__["a" /* TimezoneActions */](__WEBPACK_IMPORTED_MODULE_15__rest_Misc__["a" /* getTimezones */]);
    var timezoneStore = new __WEBPACK_IMPORTED_MODULE_29__utils_TimeZone_TimeZoneStore__["a" /* TimezoneStore */]();
    // Dashboard. Instantiate configuration for Dashboard tab.
    var homeTabConfig = new __WEBPACK_IMPORTED_MODULE_42__init__["a" /* HomeTab */](polyglot, __WEBPACK_IMPORTED_MODULE_10__rest_Search__["a" /* runSearch */], __WEBPACK_IMPORTED_MODULE_16__rest_Dashboard__["a" /* getDashboard */], __WEBPACK_IMPORTED_MODULE_16__rest_Dashboard__["b" /* takeOverSensorExcess */], __WEBPACK_IMPORTED_MODULE_14__rest_Geotab__["a" /* getSensorsDataForIncident */], currentDivisionStore.getCurrentDivisionId, googleMapLoader, __WEBPACK_IMPORTED_MODULE_18__rest_DeleteObjects__["a" /* deleteObjects */]);
    var alarmTabConfig = new __WEBPACK_IMPORTED_MODULE_42__init__["b" /* AlarmTab */](polyglot, __WEBPACK_IMPORTED_MODULE_10__rest_Search__["a" /* runSearch */], __WEBPACK_IMPORTED_MODULE_16__rest_Dashboard__["a" /* getDashboard */], __WEBPACK_IMPORTED_MODULE_16__rest_Dashboard__["b" /* takeOverSensorExcess */], __WEBPACK_IMPORTED_MODULE_14__rest_Geotab__["a" /* getSensorsDataForIncident */], currentDivisionStore.getCurrentDivisionId, googleMapLoader, __WEBPACK_IMPORTED_MODULE_18__rest_DeleteObjects__["a" /* deleteObjects */]);
    // Current Division
    // Instantiate dependencies for CurrentDivisiton widget
    var changeCurrentDivisionInProgress = new __WEBPACK_IMPORTED_MODULE_23__flux_Flag__["b" /* FlagStore */]();
    var changeCurrentDivisionErrorStore = new __WEBPACK_IMPORTED_MODULE_24__flux_Error__["b" /* ErrorStore */]();
    var changeCurrentDivisionCmd = new __WEBPACK_IMPORTED_MODULE_35__components_DivisionPath_commands_ChangeCurrentDivisionCommand__["a" /* ChangeCurrentDivisionCommand */](__WEBPACK_IMPORTED_MODULE_10__rest_Search__["a" /* runSearch */], divisionEmitter, changeCurrentDivisionInProgress.dispatchToken, changeCurrentDivisionErrorStore.dispatchToken);
    // Instantiate configuration for each tab into our application
    var divisionTabConfig = new __WEBPACK_IMPORTED_MODULE_42__init__["c" /* DivisionTab */](polyglot, __WEBPACK_IMPORTED_MODULE_10__rest_Search__["a" /* runSearch */], __WEBPACK_IMPORTED_MODULE_12__rest_Commit__["a" /* commitEntity */], currentDivisionStore.getCurrentDivisionId, divisionEmitter, changeCurrentDivisionCmd);
    var personTabConfig = new __WEBPACK_IMPORTED_MODULE_42__init__["d" /* PersonTab */](polyglot, __WEBPACK_IMPORTED_MODULE_10__rest_Search__["a" /* runSearch */], __WEBPACK_IMPORTED_MODULE_12__rest_Commit__["a" /* commitEntity */], __WEBPACK_IMPORTED_MODULE_18__rest_DeleteObjects__["a" /* deleteObjects */], currentDivisionStore.getCurrentDivisionId, divisionEmitter, isAdmin);
    var serviceAccountTabConfig = new __WEBPACK_IMPORTED_MODULE_42__init__["e" /* ServiceAccountTab */](polyglot, __WEBPACK_IMPORTED_MODULE_10__rest_Search__["a" /* runSearch */], __WEBPACK_IMPORTED_MODULE_12__rest_Commit__["a" /* commitEntity */], __WEBPACK_IMPORTED_MODULE_18__rest_DeleteObjects__["a" /* deleteObjects */], currentDivisionStore.getCurrentDivisionId, divisionEmitter, isDivisionAware);
    var vehicleTabConfig = new __WEBPACK_IMPORTED_MODULE_42__init__["f" /* VehicleTab */](polyglot, timezoneStore, defaultTimezoneId, __WEBPACK_IMPORTED_MODULE_10__rest_Search__["a" /* runSearch */], __WEBPACK_IMPORTED_MODULE_12__rest_Commit__["a" /* commitEntity */], __WEBPACK_IMPORTED_MODULE_18__rest_DeleteObjects__["a" /* deleteObjects */], __WEBPACK_IMPORTED_MODULE_15__rest_Misc__["b" /* getMeasures */], __WEBPACK_IMPORTED_MODULE_45__rest_Misc_group_params__["a" /* getGroupParams */], __WEBPACK_IMPORTED_MODULE_19__rest_GetVehiclesGeoposition__["a" /* getVehiclesGeoposition */], __WEBPACK_IMPORTED_MODULE_15__rest_Misc__["c" /* getVehicleTags */], __WEBPACK_IMPORTED_MODULE_14__rest_Geotab__["b" /* getGeotabVehicles */], __WEBPACK_IMPORTED_MODULE_17__rest_GroupAction__["a" /* groupActions */], currentDivisionStore.getCurrentDivisionId, divisionEmitter, googleMapLoader);
    vehicleTabConfig.editStore.isIsolatedPremise = isIsolatedPremise;
    var sensorTabConfig = new __WEBPACK_IMPORTED_MODULE_42__init__["g" /* SensorTabConfigurator */](polyglot, __WEBPACK_IMPORTED_MODULE_10__rest_Search__["a" /* runSearch */], __WEBPACK_IMPORTED_MODULE_12__rest_Commit__["a" /* commitEntity */], __WEBPACK_IMPORTED_MODULE_18__rest_DeleteObjects__["a" /* deleteObjects */], __WEBPACK_IMPORTED_MODULE_14__rest_Geotab__["c" /* getSensorsData */], __WEBPACK_IMPORTED_MODULE_14__rest_Geotab__["d" /* getGeotabSensors */], __WEBPACK_IMPORTED_MODULE_15__rest_Misc__["b" /* getMeasures */], currentDivisionStore.getCurrentDivisionId, divisionEmitter, googleMapLoader);
    // Native brower notifications about Undefined alert levels.
    // We pull server and in case there are undefined alert levels show native browser notification
    var notificationCenter = new __WEBPACK_IMPORTED_MODULE_43__utils_Notifications_NotificationCenter__["a" /* NotificationCenter */](__WEBPACK_IMPORTED_MODULE_44__rest_notifications__["a" /* getNotifications */], notificationPullTimeoutMs);
    notificationCenter.addActionHandler('UndefinedAlertLevels', function () {
        return vehicleTabConfig.searchUndefinedLevelsCmd.execute({ SummaryCategory: 'UndefinedAlertLevels' });
    });
    // Here we are attaching listeneter to division change event.
    // When we receive this event we run dependent search in order to update the grid
    divisionEmitter.addListener('division', function () {
        var pathname = __WEBPACK_IMPORTED_MODULE_21__routes__["b" /* appNavigator */].history.location.pathname;

        switch (pathname) {
            case __WEBPACK_IMPORTED_MODULE_21__routes__["a" /* homeRoute */]:
                vehicleTabConfig.searchConfig.searchBoxProps.refresher.run();
                homeTabConfig.homeLoadDashboardCmd.execute();
                break;
            case __WEBPACK_IMPORTED_MODULE_21__routes__["c" /* alarmRoute */]:
                vehicleTabConfig.searchConfig.searchBoxProps.refresher.run();
                alarmTabConfig.homeLoadDashboardCmd.execute();
                break;
            case __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__routes__["d" /* routeFor */])(__WEBPACK_IMPORTED_MODULE_9__models_EntityType__["a" /* EntityType */].Division):
                divisionTabConfig.searchConfig.searchBoxProps.refresher.run();
                break;
            case __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__routes__["d" /* routeFor */])(__WEBPACK_IMPORTED_MODULE_9__models_EntityType__["a" /* EntityType */].Person):
                personTabConfig.searchConfig.searchBoxProps.refresher.run();
                break;
            case __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__routes__["d" /* routeFor */])(__WEBPACK_IMPORTED_MODULE_9__models_EntityType__["a" /* EntityType */].ServiceAccount):
                serviceAccountTabConfig.searchConfig.searchBoxProps.refresher.run();
                break;
            case __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__routes__["d" /* routeFor */])(__WEBPACK_IMPORTED_MODULE_9__models_EntityType__["a" /* EntityType */].Vehicle):
                vehicleTabConfig.searchConfig.searchBoxProps.refresher.run();
                break;
            case __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__routes__["d" /* routeFor */])(__WEBPACK_IMPORTED_MODULE_9__models_EntityType__["a" /* EntityType */].Sensor):
                sensorTabConfig.searchConfig.searchBoxProps.refresher.run();
                break;
        }
    });
    // Inject dependencies from other tabs
    sensorTabConfig.searchVehicleCmd.labelDispatchToken = vehicleTabConfig.tableTitleStore.dispatchToken;
    sensorTabConfig.searchVehicleCmd.refresher = vehicleTabConfig.searchConfig.searchBoxProps.refresher;
    vehicleTabConfig.searchSensorsCmd.labelDispatchToken = sensorTabConfig.tableTitleStore.dispatchToken;
    vehicleTabConfig.searchSensorsCmd.refresher = sensorTabConfig.searchConfig.searchBoxProps.refresher;
    homeTabConfig.homeSearchVehicleCmd.labelDispatchToken = vehicleTabConfig.tableTitleStore.dispatchToken;
    homeTabConfig.homeSearchVehicleCmd.refresher = vehicleTabConfig.searchConfig.searchBoxProps.refresher;
    homeTabConfig.homeSearchSensorsCmd.labelDispatchToken = sensorTabConfig.tableTitleStore.dispatchToken;
    homeTabConfig.homeSearchSensorsCmd.refresher = sensorTabConfig.searchConfig.searchBoxProps.refresher;
    homeTabConfig.vehicleCategorySearch.labelDispatchToken = vehicleTabConfig.tableTitleStore.dispatchToken;
    homeTabConfig.vehicleCategorySearch.refresher = vehicleTabConfig.searchConfig.searchBoxProps.refresher;
    // Chart
    var sensorsDataStore = new __WEBPACK_IMPORTED_MODULE_25__components_Pages_SensorsData_flux__["a" /* SensorsDataStore */]();
    var chartStore = new __WEBPACK_IMPORTED_MODULE_38__charts_TimeSeries_flux_TimeSeriesStore__["a" /* TimeSeriesStore */]();
    // Settings
    var settingsTabConfig = new __WEBPACK_IMPORTED_MODULE_42__init__["h" /* SettingsTab */](polyglot, __WEBPACK_IMPORTED_MODULE_39__polyglot_languagePacks__["b" /* languagePacks */], __WEBPACK_IMPORTED_MODULE_20__rest_settings__["a" /* getSettings */], __WEBPACK_IMPORTED_MODULE_20__rest_settings__["b" /* saveSettings */], currentDivisionStore, currentDivisionStore.getCurrentDivision, currentDivisionStore.getCurrentDivisionId, render, isEmailNotificationEnabled, isAdmin);
    // Sign out
    var signOutCmd = new __WEBPACK_IMPORTED_MODULE_40__login_commands_SignOutCommand__["a" /* SignOutCommand */](__WEBPACK_IMPORTED_MODULE_11__rest_Login__["c" /* signOut */], __WEBPACK_IMPORTED_MODULE_41__login_commands_configure__["c" /* removeAutCookies */], __WEBPACK_IMPORTED_MODULE_41__login_commands_configure__["d" /* redirectToLogin */]);
    var location = window.location;
    var isDashboard = location.pathname.indexOf('app/dashboard') > -1;
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (!currentUser || !currentUser.Username) {
        signOutCmd.execute();
    }
    // This is jsx markup for our application
    Root = function Root() {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_broadcast__["a" /* Broadcast */], { channel: "nonIsolatedPremise", value: !isIsolatedPremise }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["b" /* Router */], { history: __WEBPACK_IMPORTED_MODULE_21__routes__["b" /* appNavigator */].history }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styles.Container }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_Header_Header__["a" /* Header */], { style: { display: 'inline-block' }, polyglot: polyglot, history: __WEBPACK_IMPORTED_MODULE_21__routes__["b" /* appNavigator */].history }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_Header_EntityLink__["a" /* EntityLink */], { to: '/dashboard', subnav: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DashboardSubNav, { history: __WEBPACK_IMPORTED_MODULE_21__routes__["b" /* appNavigator */].history }), navto: ['dashboard', 'person', 'division', 'settings', 'service-account'], type: __WEBPACK_IMPORTED_MODULE_9__models_EntityType__["a" /* EntityType */].Dashboard }, polyglot.t('nav.dashboard')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_Header_EntityLink__["a" /* EntityLink */], { subnav: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AlarmSubNav, { history: __WEBPACK_IMPORTED_MODULE_21__routes__["b" /* appNavigator */].history }), to: '/alarms', navto: ['alarms'], type: __WEBPACK_IMPORTED_MODULE_9__models_EntityType__["a" /* EntityType */].Alarm }, polyglot.t('nav.alarms')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_Header_EntityLink__["a" /* EntityLink */], { to: '/vehicle', subnav: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](VehicleSubNav, { history: __WEBPACK_IMPORTED_MODULE_21__routes__["b" /* appNavigator */].history }), navto: ['vehicle'], type: __WEBPACK_IMPORTED_MODULE_9__models_EntityType__["a" /* EntityType */].Vehicle }, polyglot.t('nav.vehicle')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_Header_EntityLink__["a" /* EntityLink */], { to: '/sensor', subnav: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SensorSubNav, { history: __WEBPACK_IMPORTED_MODULE_21__routes__["b" /* appNavigator */].history }), navto: ['sensor', 'sensors-data'], type: __WEBPACK_IMPORTED_MODULE_9__models_EntityType__["a" /* EntityType */].Sensor }, polyglot.t('nav.sensor')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_Header_EntityLink__["a" /* EntityLink */], { to: '/reports', subnav: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ReportSubNav, { history: __WEBPACK_IMPORTED_MODULE_21__routes__["b" /* appNavigator */].history }), navto: ['reports'], type: __WEBPACK_IMPORTED_MODULE_9__models_EntityType__["a" /* EntityType */].Report }, polyglot.t('nav.reports')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { "aria-current": "true", href: "https://help.spartansense.com/spstools/canpimanager", target: "_blank" }, polyglot.t('nav.canpimanager')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { "aria-current": "true", href: "https://help.spartansense.com/registration", target: "_blank" }, polyglot.t('nav.registration')), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styles.Version + " hidden-xs" }, "version: ", commitHash)), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container-fluid", style: { width: '100%' } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22__Container__["a" /* Container */], { store: currentDivisionStore }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_34__components_DivisionPath_DivisionPath__["a" /* DivisionPath */], { path: null, onChange: function onChange(d) {
                return changeCurrentDivisionCmd.execute(d.id);
            }, allDivisions: null, polyglot: polyglot })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", null), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["c" /* Route */], { exact: true, path: "/", render: function render() {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* Redirect */], { to: __WEBPACK_IMPORTED_MODULE_21__routes__["a" /* homeRoute */] });
            } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["c" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_21__routes__["a" /* homeRoute */], render: function render() {
                return homeTabConfig.markup;
            } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["c" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_21__routes__["c" /* alarmRoute */], render: function render() {
                return alarmTabConfig.markup;
            } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["c" /* Route */], { path: '/reports', render: function render() {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ReportsMessage, null);
            } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_37__components_NonIsolatedPremise__["a" /* NonIsolatedPremise */], null, serviceAccountTabConfig.markup), divisionTabConfig.markup, personTabConfig.markup, vehicleTabConfig.markup, sensorTabConfig.markup, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_27__components_Pages_SensorsData_SensorsDataRoute__["a" /* SensorsDataRoute */], { polyglot: polyglot, store: sensorsDataStore, timeSeriesStore: chartStore, className: styles.MainRoute }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32__components_Pages_VehicleMap_VehicleMapRoute__["a" /* VehicleMapRoute */], { vehicleGeopositionStore: vehicleGeopositionStore }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["c" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_21__routes__["e" /* settingsRoute */], render: function render() {
                return settingsTabConfig.markup;
            } })))));
    };
    divisionEmitter.once('division', render);
    // Set current DivisionId, which server told us
    // It could be absent when we visit the app for the first time
    var lastDivisionId = res.LastDivisionId;
    changeCurrentDivisionCmd.execute(lastDivisionId);
    timezoneActions.startPullingTimezones(timezoneTimeoutMs);
    notificationCenter.start();
    // Server can be in import process and we have to show import icon.
    // Pull the server in order to update import icon.
    var saAutoImportWatchActions = new __WEBPACK_IMPORTED_MODULE_31__components_Pages_ServiceAccount_AutoImportWatchActions__["a" /* AutoImportWatchActions */](__WEBPACK_IMPORTED_MODULE_10__rest_Search__["a" /* runSearch */], function () {
        return serviceAccountTabConfig.listStore.getState().items;
    }, __WEBPACK_IMPORTED_MODULE_9__models_EntityType__["a" /* EntityType */].ServiceAccount);
    saAutoImportWatchActions.startPulling(autoImportTimeoutMs);
    var vehicleAutoImportWatchActions = new __WEBPACK_IMPORTED_MODULE_31__components_Pages_ServiceAccount_AutoImportWatchActions__["a" /* AutoImportWatchActions */](__WEBPACK_IMPORTED_MODULE_10__rest_Search__["a" /* runSearch */], function () {
        return vehicleTabConfig.listStore.getState().items;
    }, __WEBPACK_IMPORTED_MODULE_9__models_EntityType__["a" /* EntityType */].Vehicle);
    vehicleAutoImportWatchActions.startPulling(autoImportTimeoutMs);
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return extactValues; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var extactValues = function extactValues(values) {
    return values.map(function (tag) {
        if (typeof tag === 'string') return tag;
        if ((typeof tag === 'undefined' ? 'undefined' : _typeof(tag)) === 'object' && tag.customOption) return tag.label;
        throw new Error('unexpected tag type');
    });
};

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export inset */
/* unused harmony export getMaxX */
/* unused harmony export getMaxY */
/* harmony export (immutable) */ __webpack_exports__["a"] = barycentric;
/* unused harmony export inside */
/* unused harmony export point */
/* unused harmony export getRect */
/* unused harmony export getOrigin */
/* unused harmony export getParentCT */
/* unused harmony export getCT */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function inset(parent, margin) {
    return {
        x: margin.left,
        y: margin.top,
        width: parent.width - margin.left - margin.right,
        height: parent.height - margin.top - margin.bottom
    };
}
function getMaxX(frame) {
    return frame.x + frame.width;
}
function getMaxY(frame) {
    return frame.y + frame.height;
}
function barycentric(x1, x2, x) {
    return (num(x) - num(x1)) / (num(x2) - num(x1));
}
function num(x) {
    return typeof x === 'number' ? x : x.valueOf();
}
// Returns true if point `p` is inside `rect`
function inside(p, rect) {
    var x, y;
    if (p && p.constructor === Array) {
        ;

        var _p = _slicedToArray(p, 2);

        x = _p[0];
        y = _p[1];
    }if (p && p.constructor === Object) {
        ;
        x = p.x;
        y = p.y;
    }return x >= rect.x && x <= getMaxX(rect) && y >= rect.y && y <= getMaxY(rect);
}
function point(p) {
    return { x: p[0], y: p[1] };
}
// calculates SVGRect for provided SVG element
function getRect(elem) {
    var transform = getParentCT(elem);
    return transform(elem.getBBox());
}
// Get top left corner point with respect to parent's coordinate system
function getOrigin(elem) {
    var transform = getParentCT(elem);
    return transform({ x: 0, y: 0 });
}
function getParentCT(from) {
    return getCT(from, from.parentNode);
}
// idea: https://stackoverflow.com/questions/26049488/how-to-get-absolute-coordinates-of-object-inside-a-g-group
function getCT(from, to) {
    // matrix shape: https://www.w3.org/TR/SVGTiny12/coords.html#TransformMatrixDefined
    // transform = (from ViewPort to Target) * (from Source to ViewPort)
    return function (p) {
        var transform = to.getScreenCTM().inverse().multiply(from.getScreenCTM());
        p.x = transform.a * p.x + transform.c * p.y + transform.e;
        p.y = transform.b * p.x + transform.d * p.y + transform.f;
        return p;
    };
}

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Chart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tooltip__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TimeSeries__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flux_TimeSeriesActions__ = __webpack_require__(161);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var styles = __webpack_require__(408);
// This components is a container for TimeSeries and Tooltip widgets
var Chart = function (_React$Component) {
    _inherits(Chart, _React$Component);

    function Chart(props) {
        _classCallCheck(this, Chart);

        var _this = _possibleConstructorReturn(this, (Chart.__proto__ || Object.getPrototypeOf(Chart)).call(this, props));

        _this.timeSeriesActions = new __WEBPACK_IMPORTED_MODULE_3__flux_TimeSeriesActions__["a" /* TimeSeriesActions */]();
        _this.onMouseMove = function (e) {
            var lock = _this.state.lock;

            var nextLock = e.altKey ? true : false;
            if (lock !== nextLock) {
                _this.setState({ lock: nextLock });
            }
        };
        _this.handleSweepLine = function (e) {
            var _this$state = _this.state,
                lock = _this$state.lock,
                clientX = _this$state.clientX,
                clientY = _this$state.clientY;

            _this.setState({
                clientX: lock ? clientX : _this.calcTooltipX(e.clientX),
                clientY: lock ? clientY : _this.calcTooltipY(e.clientY)
            });
        };
        _this.calcTooltipX = function (sweepLineX) {
            if (_this.tooltip) {
                var gap = 10;
                var E = document.body.clientWidth;
                var width = _this.tooltip.clientWidth;

                return sweepLineX + gap + width < E ? sweepLineX + gap // put tooltip to the right side of sweepline
                : sweepLineX - width - gap; // put tooltip to the left side of sweepline
            }
            return sweepLineX;
        };
        _this.calcTooltipY = function (sweepLineY) {
            if (_this.tooltip) {
                var S = document.body.clientHeight;
                var height = _this.tooltip.clientHeight;

                var dy = S - (sweepLineY + height);
                return dy > 0 ? sweepLineY : sweepLineY + dy;
            }
        };
        // updateSize is called when React has mounted/unmounted the div container
        // at this point we can query div's size in order to inject these values to TimeSeries
        _this.updateSize = function (div) {
            if (div) {
                var clientWidth = div.clientWidth,
                    clientHeight = div.clientHeight;

                _this.setState({ width: clientWidth, height: clientHeight });
            }
        };
        _this.state = {
            // canvas size for Timeseries component
            width: undefined,
            height: undefined,
            // location of the tooltip
            clientX: undefined,
            clientY: undefined,
            lock: false
        };
        return _this;
    }

    _createClass(Chart, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                polyglot = _props.polyglot,
                dataSets = _props.dataSets,
                zoomedDataSets = _props.zoomedDataSets,
                tooltip = _props.tooltip;
            var _state = this.state,
                width = _state.width,
                height = _state.height,
                lock = _state.lock,
                clientX = _state.clientX,
                clientY = _state.clientY;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { height: 500, minWidth: 300 }, ref: this.updateSize, onMouseMove: this.onMouseMove }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__TimeSeries__["a" /* TimeSeries */], { className: lock ? styles.NoEvents : null, dataSets: dataSets, zoomedDataSets: zoomedDataSets, tooltip: tooltip, width: width, height: height, onSweepLine: this.handleSweepLine, isRangeOk: this.props.isRangeOk }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Tooltip__["a" /* Tooltip */], { polyglot: polyglot, className: lock ? styles.LockedTooltip : null, info: tooltip, left: clientX, top: clientY, elemRef: function elemRef(e) {
                    return _this2.tooltip = e;
                }, onToggle: function onToggle(seqId) {
                    return _this2.timeSeriesActions.toggleVisibility(seqId);
                }, highlight: function highlight(seqId) {
                    return _this2.timeSeriesActions.highlightSingle(seqId);
                }, normolize: function normolize() {
                    return _this2.timeSeriesActions.normalize();
                } }));
        }
    }]);

    return Chart;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Line; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_shape__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data__ = __webpack_require__(111);



// We use D3js to calculate visual properties but React to actually render SVG elemets
var Line = function Line(_ref) {
    var xScale = _ref.xScale,
        yScale = _ref.yScale,
        _ref$sequence = _ref.sequence,
        color = _ref$sequence.color,
        samples = _ref$sequence.samples,
        state = _ref$sequence.state,
        dotted = _ref$sequence.dotted;

    var getLine = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_shape__["a" /* line */])().x(function (s) {
        return xScale(s.x);
    }).y(function (s) {
        return yScale(s.y);
    });
    var opacity = state === __WEBPACK_IMPORTED_MODULE_2__Data__["a" /* SequenceState */].Dimmed ? 0.5 : 1;
    var width = state === __WEBPACK_IMPORTED_MODULE_2__Data__["a" /* SequenceState */].Highlighted ? 2 : 1;
    if (dotted) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { fill: "none", stroke: color, "stroke-dasharray": "5, 5", x1: "10", y1: "10", x2: "190", y2: "10", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: width, d: getLine(samples), opacity: opacity });
    } else {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { fill: "none", stroke: color, strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: width, d: getLine(samples), opacity: opacity });
    }
};

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SweepLine; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__d3chart__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data__ = __webpack_require__(111);



// SweepLine component which follows the user's mouse pointer
var SweepLine = function SweepLine(_ref) {
    var tooltip = _ref.tooltip,
        xScale = _ref.xScale,
        yScales = _ref.yScales,
        height = _ref.height;

    return tooltip && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g", { transform: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__d3chart__["b" /* translateX */])(xScale(tooltip.x)) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("line", { y1: 0, y2: height, x1: 0, x2: 0, stroke: "red", strokeWidth: "1.5" }), tooltip.items.filter(function (item) {
        return item.sequence.state !== __WEBPACK_IMPORTED_MODULE_2__Data__["a" /* SequenceState */].Hidden;
    }).map(function (_ref2, idx) {
        var sequence = _ref2.sequence,
            value = _ref2.value,
            dataSetId = _ref2.dataSetId;

        var y = yScales[dataSetId](value);
        return sequence.dotType === 'circle' ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("circle", { key: idx, r: "3", fill: sequence.color, cx: 0, cy: y }) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("rect", { key: idx, fill: sequence.color, x: -3, y: y - 3, width: 6, height: 6 });
    }));
};

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimeSeries; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_scale__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_utils_assert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__d3chart__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__d3chart_Axes__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__d3chart_Brush__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__d3chart_zoom__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Utils__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Line__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SweepLine__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Data__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__flux_TimeSeriesActions__ = __webpack_require__(161);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var styles = __webpack_require__(408);
var severityColors = {
    'red': '#d62728',
    'yellow': '#ffc90e'
};
// TimeSeries components manages SVG element
// Component holds:
// * A few Axes child components (dedicated X,Y axes for each DataSet)
// * Lines for each sequences
// * Sweep line
// * Brush component
var TimeSeries = function (_React$Component) {
    _inherits(TimeSeries, _React$Component);

    function TimeSeries(props) {
        _classCallCheck(this, TimeSeries);

        var _this = _possibleConstructorReturn(this, (TimeSeries.__proto__ || Object.getPrototypeOf(TimeSeries)).call(this, props));

        _this.actions = new __WEBPACK_IMPORTED_MODULE_12__flux_TimeSeriesActions__["a" /* TimeSeriesActions */]();
        _this.axisWidth = 60;
        _this.brushHeight = 100;
        _this.margin = { left: 20, top: 20, right: 20, bottom: 150 };
        _this.axisShift = function (index) {
            return _this.margin.left + (index + 1) * _this.axisWidth;
        };
        _this.onBrush = function (w, n, e, s) {
            var xScale = _this.state.xScale;

            var range = [xScale.invert(w), xScale.invert(e)];
            _this.trySetRange(range);
        };
        // Handle mouse wheel event
        // Calculates new time range of interest and updates the state
        _this.onWheel = function (e) {
            if (e.altKey) return;
            var _this$props = _this.props,
                dataSets = _this$props.dataSets,
                zoomedDataSets = _this$props.zoomedDataSets;
            var xZoomedScale = _this.state.xZoomedScale;

            var pivot = xZoomedScale.invert(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__d3chart_zoom__["a" /* getPoint */])(e, _this.canvas).x);
            var delta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__d3chart_zoom__["b" /* defaultWheelDelta */])(e);
            var extent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__Utils__["a" /* extentDataSets */])(dataSets, function (s) {
                return s.x;
            });
            var selection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__Utils__["a" /* extentDataSets */])(zoomedDataSets, function (s) {
                return s.x;
            });
            var range = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__d3chart_zoom__["c" /* scaleSelection */])(extent, selection, pivot, delta);
            _this.trySetRange(range);
        };
        _this.trySetRange = function (range) {
            if (_this.isRangeOk(range)) {
                _this.actions.setRange(range);
            }
        };
        // Handle mouse move event
        // Update the sweep line position
        _this.onMouseMove = function (e) {
            if (!_this.canvas || e.altKey) return;
            var _this$state = _this.state,
                innerHeight = _this$state.innerHeight,
                innerWidth = _this$state.innerWidth,
                xZoomedScale = _this$state.xZoomedScale;

            var p = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__d3chart_zoom__["a" /* getPoint */])(e, _this.canvas);
            var clientX = e.clientX,
                clientY = e.clientY;

            var visible = p.x >= 0 && p.x <= innerWidth && p.y >= 0 && p.y <= innerHeight;
            var t = visible ? xZoomedScale.invert(p.x) : null;
            _this.actions.setTooltipTime(t);
            var onSweepLine = _this.props.onSweepLine;

            if (onSweepLine) {
                onSweepLine({ clientX: clientX, clientY: clientY });
            }
        };
        _this.isRangeOk = function (range) {
            var isOk = _this.props.isRangeOk;

            return isOk ? isOk(range) : true;
        };
        // convert component's properties into internal state
        _this.getStateFor = function (props) {
            var allDataSets = props.dataSets,
                zoomedDataSets = props.zoomedDataSets;

            var yAxesCnt = allDataSets.length;
            var innerWidth = props.width - _this.margin.left - _this.margin.right - _this.axisWidth * yAxesCnt;
            var innerHeight = props.height - _this.margin.top - _this.margin.bottom;
            var getXScaleFor = function getXScaleFor(dataSets) {
                var xDomain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__Utils__["a" /* extentDataSets */])(dataSets, function (s) {
                    return s.x;
                });
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_scale__["a" /* scaleTime */])().rangeRound([0, innerWidth]).domain(xDomain);
            };
            var yScaleFor = function yScaleFor(dataSet, height) {
                var yDomain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__Utils__["b" /* extentDataSet */])(dataSet, function (s) {
                    return s.y;
                });
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__app_utils_assert__["c" /* isNumber */])(dataSet.minValue)) {
                    yDomain[0] = Math.min(dataSet.minValue, yDomain[0]);
                }
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_scale__["b" /* scaleLinear */])().domain(yDomain).rangeRound([height, 0]);
            };
            var brushBaseLine = props.height - 20;
            var brushTop = brushBaseLine - _this.brushHeight;
            var yScales = allDataSets.map(function (ds) {
                return yScaleFor(ds, innerHeight);
            });
            var yBrushScales = allDataSets.map(function (ds) {
                return yScaleFor(ds, _this.brushHeight);
            });
            return {
                leftMargin: _this.axisShift(allDataSets.length - 1),
                innerHeight: innerHeight,
                innerWidth: innerWidth,
                xScale: getXScaleFor(allDataSets),
                xZoomedScale: getXScaleFor(zoomedDataSets),
                yScales: yScales,
                yBrushScales: yBrushScales,
                brushTop: brushTop,
                brushBaseLine: brushBaseLine
            };
        };
        _this.state = _this.getStateFor(props);
        return _this;
    }
    // parent element are welcome to update widht and height


    _createClass(TimeSeries, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps, nextContext) {
            this.setState(this.getStateFor(nextProps));
        }
    }, {
        key: "onlyUnique",
        value: function onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                width = _props.width,
                height = _props.height,
                tooltip = _props.tooltip,
                dataSets = _props.dataSets,
                zoomedDataSets = _props.zoomedDataSets;
            var _state = this.state,
                leftMargin = _state.leftMargin,
                innerHeight = _state.innerHeight,
                innerWidth = _state.innerWidth,
                xScale = _state.xScale,
                xZoomedScale = _state.xZoomedScale,
                yScales = _state.yScales,
                yBrushScales = _state.yBrushScales,
                brushTop = _state.brushTop,
                brushBaseLine = _state.brushBaseLine;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__app_utils_assert__["b" /* assertValue */])(zoomedDataSets);
            var sweepLine = tooltip ? xZoomedScale(tooltip.x) : null;
            return zoomedDataSets.length ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg", { width: width, height: height, onWheel: this.onWheel, onMouseMove: this.onMouseMove, className: this.props.className }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g", { transform: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__d3chart__["a" /* translate */])(leftMargin, this.margin.top), ref: function ref(e) {
                    return _this2.canvas = e;
                } }, zoomedDataSets.map(function (ds, idx) {
                return ds.sequences.filter(function (seq) {
                    return seq.state !== __WEBPACK_IMPORTED_MODULE_11__Data__["a" /* SequenceState */].Hidden;
                }).map(function (seq, sIdx) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Line__["a" /* Line */], { key: "seq_" + sIdx, xScale: xZoomedScale, yScale: yScales[idx], sequence: seq });
                });
            }), zoomedDataSets.map(function (ds, idx) {
                return ds.sequences.filter(function (seq) {
                    return seq.state !== __WEBPACK_IMPORTED_MODULE_11__Data__["a" /* SequenceState */].Hidden;
                }).map(function (seq, sid) {
                    return seq.samples.filter(function (s) {
                        return s.severity;
                    }).map(function (s, i) {
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("circle", { key: idx + "_" + sid + "_" + i, fill: severityColors[s.severity], r: 5, cx: xZoomedScale(s.x), cy: yScales[idx](s.y) });
                    });
                });
            }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__SweepLine__["a" /* SweepLine */], { tooltip: tooltip, xScale: xZoomedScale, yScales: yScales, height: innerHeight })), zoomedDataSets.map(function (ds, idx) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__d3chart_Axes__["a" /* Axis */], { key: idx, transform: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__d3chart__["a" /* translate */])(_this2.axisShift(idx), _this2.margin.top), axisType: __WEBPACK_IMPORTED_MODULE_5__d3chart_Axes__["b" /* AxisType */].Left, axisScale: yScales[idx], title: ds.yAxisTitle });
            }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__d3chart_Axes__["a" /* Axis */], { transform: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__d3chart__["a" /* translate */])(leftMargin, height - this.margin.bottom), axisType: __WEBPACK_IMPORTED_MODULE_5__d3chart_Axes__["b" /* AxisType */].Bottom, axisScale: xZoomedScale }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__d3chart_Axes__["a" /* Axis */], { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(styles.Axis, styles.AxisGrid), transform: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__d3chart__["a" /* translate */])(leftMargin, brushBaseLine), axisType: __WEBPACK_IMPORTED_MODULE_5__d3chart_Axes__["b" /* AxisType */].Bottom, axisScale: xScale, tickFormat: function tickFormat() {
                    return null;
                }, tickSize: -this.brushHeight }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__d3chart_Axes__["a" /* Axis */], { transform: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__d3chart__["a" /* translate */])(leftMargin, brushBaseLine), axisType: __WEBPACK_IMPORTED_MODULE_5__d3chart_Axes__["b" /* AxisType */].Bottom, axisScale: xScale }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g", { transform: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__d3chart__["a" /* translate */])(leftMargin, brushTop), className: "brush-chart" }, dataSets.map(function (ds, idx) {
                return ds.sequences.map(function (seq, sIdx) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Line__["a" /* Line */], { key: "seq_" + sIdx, xScale: xScale, yScale: yBrushScales[idx], sequence: seq });
                });
            })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__d3chart_Brush__["a" /* Brush */], { dimension: __WEBPACK_IMPORTED_MODULE_6__d3chart_Brush__["b" /* BrushDimension */].X, transform: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__d3chart__["a" /* translate */])(leftMargin, brushTop), x0: 0, y0: 0, x1: innerWidth, y1: this.brushHeight, w: xScale(xZoomedScale.domain()[0]), e: xScale(xZoomedScale.domain()[1]), onBrush: this.onBrush })) : null;
        }
    }]);

    return TimeSeries;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
TimeSeries.defaultProps = {
    width: 900,
    height: 500
};

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_format__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Data__ = __webpack_require__(111);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var styles = __webpack_require__(966);
;
// Tooltip component for timeseries chart
// We use Polyglot to show hint which describes how to freeze tooltip in order to interact with it
// Tooltip is a grid where each row corresponds to displayed sequence of data. The structure of the table is as follows:
// [color markder with title of the sequence] --- [value] --- [show/hide checkbox]
var Tooltip = function (_React$Component) {
    _inherits(Tooltip, _React$Component);

    function Tooltip() {
        _classCallCheck(this, Tooltip);

        // this method marks sequence as highlighted
        var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).apply(this, arguments));

        _this.tryHighlight = function (seq) {
            if (seq.state === __WEBPACK_IMPORTED_MODULE_4__Data__["a" /* SequenceState */].Hidden) return;
            _this.props.highlight(seq.id);
        };
        return _this;
    }

    _createClass(Tooltip, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var tFormat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_time_format__["a" /* timeFormat */])('%Y-%m-%d %H:%M:%S');
            var vFormat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_format__["a" /* format */])(".3r");
            var _props = this.props,
                info = _props.info,
                left = _props.left,
                top = _props.top,
                elemRef = _props.elemRef;

            return info ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(styles.TooltipContainer, this.props.className), style: { left: left, top: top }, ref: elemRef }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("table", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("thead", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", { colSpan: 3 }, tFormat(info.x)))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody", null, info.items.map(function (item, idx) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", { key: idx, onMouseEnter: function onMouseEnter(e) {
                        return _this2.tryHighlight(item.sequence);
                    }, onMouseLeave: function onMouseLeave(e) {
                        return _this2.props.normolize();
                    } }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: item.sequence.dotType === 'square' ? styles.SquareIcon : styles.CircleIcon, style: { backgroundColor: item.sequence.color } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, item.sequence.title)), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, vFormat(item.value)), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "checkbox", checked: item.sequence.state !== __WEBPACK_IMPORTED_MODULE_4__Data__["a" /* SequenceState */].Hidden, onChange: function onChange(e) {
                        return _this2.props.onToggle(item.sequence.id);
                    } })));
            }), info.items.length > 1 && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: styles.Hint, colSpan: 3 }, this.props.polyglot.t('sensors_data.tooltip_hint')))))) : null;
        }
    }]);

    return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(599);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Tooltip__["a"]; });


/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Chart__ = __webpack_require__(595);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Chart__["a"]; });


/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clip */
/* unused harmony export interpolateSample */
/* unused harmony export filterDataSets */
/* harmony export (immutable) */ __webpack_exports__["a"] = extentDataSets;
/* harmony export (immutable) */ __webpack_exports__["b"] = extentDataSet;
/* unused harmony export extentStream */
/* unused harmony export translateX */
/* unused harmony export translateY */
/* unused harmony export translatePoint */
/* unused harmony export translateXY */
/* unused harmony export px */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_shim__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_shim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_shim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_array__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Geometry__ = __webpack_require__(594);




// clips sequence of data points with respect to provided time range of interest
function clip(samples, clip) {
    var bisector = bisector(function (s) {
        return s.x;
    });
    var l = bisector.left(samples, clip[0]);
    var h = bisector.right(samples, clip[1]);
    var result = samples.slice(l, h);
    if (interpolateSample) {
        if (l > 0 && clip[0] !== samples[l].x) result.splice(0, 0, interpolateSample(samples[l - 1], samples[l], clip[0]));
        if (h < samples.length && clip[1] !== samples[h].x) result.push(interpolateSample(samples[h - 1], samples[h], clip[1]));
    }
    return result;
}
function interpolateSample(s1, s2, at) {
    var interpolator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["b" /* interpolate */])(s1.y, s2.y);
    var t = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Geometry__["a" /* barycentric */])(s1.x, s2.x, at);
    return {
        x: at,
        y: interpolator(t)
    };
}
function filterDataSets(dataSets, predicate) {
    return dataSets.map(function (ds) {
        var dsCopy = Object.assign({}, ds);
        dsCopy.sequences = dsCopy.sequences.filter(predicate);
        return dsCopy;
    });
}
// calculate DataSets extent (min, max)
function extentDataSets(dataSets, accessor) {
    return extentStream(dataSets.map(function (ds) {
        return extentDataSet(ds, accessor);
    }));
}
function extentDataSet(dataSet, accessor) {
    return extentStream(dataSet.sequences.map(function (seq) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_array__["i" /* extent */])(seq.samples, accessor);
    }));
}
function extentStream(minMaxSeq) {
    var minimum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_array__["j" /* min */])(minMaxSeq, function (mm) {
        return mm[0];
    });
    var maximum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_array__["k" /* max */])(minMaxSeq, function (mm) {
        return mm[1];
    });
    return [minimum, maximum];
}
// SVG attribute utils
function translateX(x) {
    return translateXY(x, 0);
}
function translateY(y) {
    return translateXY(0, y);
}
function translatePoint(p) {
    return translateXY(p.x, p.y);
}
function translateXY(x, y) {
    return "translate(" + x + "," + y + ")";
}
function px(x) {
    return x + "px";
}

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataGridFlagValueColumn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// This column maps boolean flag to string
var DataGridFlagValueColumn = function (_React$Component) {
    _inherits(DataGridFlagValueColumn, _React$Component);

    function DataGridFlagValueColumn() {
        _classCallCheck(this, DataGridFlagValueColumn);

        return _possibleConstructorReturn(this, (DataGridFlagValueColumn.__proto__ || Object.getPrototypeOf(DataGridFlagValueColumn)).apply(this, arguments));
    }

    _createClass(DataGridFlagValueColumn, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                datum = _props.datum,
                getValue = _props.getValue,
                _props$trueTitle = _props.trueTitle,
                trueTitle = _props$trueTitle === undefined ? 'Yes' : _props$trueTitle,
                _props$falseTitle = _props.falseTitle,
                falseTitle = _props$falseTitle === undefined ? 'No' : _props$falseTitle;

            var value = getValue(datum) ? trueTitle : falseTitle;
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, value);
        }
    }]);

    return DataGridFlagValueColumn;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateRange; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datepicker__ = __webpack_require__(1150);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var datePickerStyles = __webpack_require__(971);
var styles = __webpack_require__(958);
var bootstrapStyles = __webpack_require__(186);
// DateRange component uses 3d party react-datepicker component
// The structure is simple: [react-datepicker] ––– [react-datepicker] [Apply button]
var DateRange = function (_React$Component) {
    _inherits(DateRange, _React$Component);

    function DateRange() {
        _classCallCheck(this, DateRange);

        return _possibleConstructorReturn(this, (DateRange.__proto__ || Object.getPrototypeOf(DateRange)).apply(this, arguments));
    }

    _createClass(DateRange, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                className = _props.className,
                disabled = _props.disabled,
                fromDate = _props.fromDate,
                setFromDate = _props.setFromDate,
                fromTitle = _props.fromTitle,
                toDate = _props.toDate,
                setToDate = _props.setToDate,
                toTitle = _props.toTitle,
                buttonTitle = _props.buttonTitle,
                onClick = _props.onClick,
                locale = _props.locale;

            var dpClassName = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('form-control text-center', styles.Input);
            var btnClassName = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('btn btn-default', bootstrapStyles.MarginLeft);
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(styles.DateRange, className) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_datepicker__["a" /* default */], { locale: locale, className: dpClassName, disabled: disabled, selected: fromDate, onChange: setFromDate, placeholderText: fromTitle }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, " \u2013 "), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_datepicker__["a" /* default */], { locale: locale, className: dpClassName, disabled: disabled, selected: toDate, onChange: setToDate, placeholderText: toTitle }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: btnClassName, style: { float: 'right' }, disabled: disabled || !fromDate && !toDate, onClick: onClick }, buttonTitle));
        }
    }]);

    return DateRange;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);


var styles = __webpack_require__(959);
// This components renders error messages uniformly across the app
var ErrorMessage = function ErrorMessage(_ref) {
    var className = _ref.className,
        errorMessage = _ref.errorMessage;
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("has-error", styles.ErrorMessage, className) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "control-label" }, errorMessage));
};

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Flag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_broadcast__ = __webpack_require__(208);


var Flag = function Flag(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_broadcast__["b" /* Subscriber */], { channel: props.name }, function (isSet) {
    return isSet ? props.children : null;
  });
};

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Flag__ = __webpack_require__(606);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Flag__["a"]; });


/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(163);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Modal__["a"]; });


/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NestedTypeahead; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_components_TypeaheadEnterEscWrapper__ = __webpack_require__(76);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};



// NestedTypeahead is a wrapper around 3d party react-bootstrap-typeahead component
// The are 2 important additions:
// * It allows to display nested data via indentation to reflect hierarchical structure of the data
// * It stops Enter and Esc keyDown propagation when menu is opened
var NestedTypeahead = function (_React$Component) {
    _inherits(NestedTypeahead, _React$Component);

    function NestedTypeahead(props) {
        _classCallCheck(this, NestedTypeahead);

        var _this = _possibleConstructorReturn(this, (NestedTypeahead.__proto__ || Object.getPrototypeOf(NestedTypeahead)).call(this, props));

        _this.id = function (option) {
            return option;
        };
        _this.state = {
            textInput: ''
        };
        return _this;
    }

    _createClass(NestedTypeahead, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _a = this.props,
                options = _a.options,
                selected = _a.selected,
                labelKey = _a.labelKey,
                _onChange = _a.onChange,
                rest = __rest(_a, ["options", "selected", "labelKey", "onChange"]);var textInput = this.state.textInput;

            var label = labelKey || this.id;
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__app_components_TypeaheadEnterEscWrapper__["a" /* TypeaheadEnterEscWrapper */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["Typeahead"], Object.assign({ labelKey: function labelKey(nestedOption) {
                    return label(nestedOption.option);
                }, className: this.props.className, options: options, selected: selected ? [selected] : [], onChange: function onChange(option) {
                    return _onChange(option);
                }, onInputChange: function onInputChange(text) {
                    return _this2.setState({ textInput: text });
                }, renderMenu: textInput != null && textInput !== '' ? null : function (results, menuProps) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["Menu"], Object.assign({}, menuProps), results.map(function (item, idx) {
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["MenuItem"], { key: idx, option: item, position: idx }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: { marginLeft: item.level * 10 } }, label(item.option)));
                    }));
                } }, rest)));
        }
    }]);

    return NestedTypeahead;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 610 */,
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AxisType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Axis; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var AxisType;
(function (AxisType) {
    AxisType[AxisType["Top"] = 1] = "Top";
    AxisType[AxisType["Right"] = 2] = "Right";
    AxisType[AxisType["Bottom"] = 3] = "Bottom";
    AxisType[AxisType["Left"] = 4] = "Left";
})(AxisType || (AxisType = {}));
var epsilon = 1e-6;
var Axis = function (_React$Component) {
    _inherits(Axis, _React$Component);

    function Axis() {
        _classCallCheck(this, Axis);

        return _possibleConstructorReturn(this, (Axis.__proto__ || Object.getPrototypeOf(Axis)).apply(this, arguments));
    }

    _createClass(Axis, [{
        key: "render",
        value: function render() {
            var _a = this.props,
                axisType = _a.axisType,
                axisScale = _a.axisScale,
                tickSizeInner = _a.tickSizeInner,
                tickSizeOuter = _a.tickSizeOuter,
                tickSize = _a.tickSize,
                tickPadding = _a.tickPadding,
                tickFormat = _a.tickFormat,
                gProps = __rest(_a, ["axisType", "axisScale", "tickSizeInner", "tickSizeOuter", "tickSize", "tickPadding", "tickFormat"]);
            if (typeof tickSize === 'number') {
                tickSizeInner = tickSizeOuter = tickSize;
            }
            var k = axisType === AxisType.Top || axisType === AxisType.Left ? -1 : 1;
            var transform = axisType === AxisType.Top || axisType === AxisType.Bottom ? translateX : translateY;
            var range = axisScale.range();
            var range0 = range[0] + 0.5;
            var range1 = range[range.length - 1] + 0.5;
            var d = axisType === AxisType.Left || axisType === AxisType.Right ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter;
            var spacing = Math.max(tickSizeInner, 0) + tickPadding;
            var values = axisScale.ticks();
            var format = tickFormat ? tickFormat : axisScale.tickFormat();
            var lineXY2 = _defineProperty({}, axisType === AxisType.Left || axisType === AxisType.Right ? 'x2' : 'y2', k * tickSizeInner);
            var textXY = _defineProperty({}, axisType === AxisType.Left || axisType === AxisType.Right ? 'x' : 'y', k * spacing);
            var textAnchor = axisType === AxisType.Right ? "start" : axisType === AxisType.Left ? "end" : "middle";
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g", Object.assign({ fill: "none", fontSize: "10", fontFamily: "sans-serif", textAnchor: textAnchor }, gProps), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { className: "domain", stroke: "#000", d: d }), values.map(function (d, idx) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g", { key: idx, transform: transform(axisScale(d)), className: "tick" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("line", Object.assign({}, lineXY2, { stroke: "#000" })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("text", Object.assign({ fill: "#000" }, textXY, { dy: axisType === AxisType.Top ? '0em' : axisType === AxisType.Bottom ? '0.71em' : '0.32em' }), format(d, idx)));
            }), this.props.title && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("text", { fill: "#000", textAnchor: "end", y: 6, dy: "0.71em", transform: "rotate(-90)" }, this.props.title));
        }
    }]);

    return Axis;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
Axis.defaultProps = {
    tickSizeOuter: 6,
    tickSizeInner: 6,
    tickPadding: 3
};
function translateX(x) {
    return "translate(" + x + ", 0)";
}
function translateY(y) {
    return "translate(0, " + y + ")";
}

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BrushDimension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Brush; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_utils_assert__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};



var BrushDimension;
(function (BrushDimension) {
    BrushDimension[BrushDimension["X"] = 0] = "X";
    BrushDimension[BrushDimension["Y"] = 1] = "Y";
    BrushDimension[BrushDimension["XY"] = 2] = "XY";
})(BrushDimension || (BrushDimension = {}));
var type = function type(h) {
    return { type: h };
};
var X = {
    handles: ['e', 'w'].map(type)
};
var Y = {
    handles: ['n', 's'].map(type)
};
var XY = {
    handles: ['n', 'e', 's', 'w', 'nw', 'ne', 'se', 'sw'].map(type)
};
var mapDimension = function mapDimension(dimType) {
    switch (dimType) {
        case BrushDimension.X:
            return X;
        case BrushDimension.Y:
            return Y;
        case BrushDimension.XY:
            return XY;
        default:
            throw new Error('Invalid program error');
    }
};
var cursors = {
    overlay: 'crosshair',
    selection: 'move',
    n: 'ns-resize',
    e: 'ew-resize',
    s: 'ns-resize',
    w: 'ew-resize',
    nw: 'nwse-resize',
    ne: 'nesw-resize',
    se: 'nwse-resize',
    sw: 'nesw-resize'
};
var signsX = {
    overlay: +1,
    selection: +1,
    n: null,
    e: +1,
    s: null,
    w: -1,
    nw: -1,
    ne: +1,
    se: +1,
    sw: -1
};
var signsY = {
    overlay: +1,
    selection: +1,
    n: -1,
    e: null,
    s: +1,
    w: null,
    nw: -1,
    ne: -1,
    se: +1,
    sw: +1
};
var Mode;
(function (Mode) {
    Mode[Mode["Handle"] = 0] = "Handle";
    Mode[Mode["Drag"] = 1] = "Drag";
})(Mode || (Mode = {}));
var handleSize = 6;
// This is a Rect reimplementation of d3's Brush component
// https://github.com/d3/d3-brush
var Brush = function (_React$Component) {
    _inherits(Brush, _React$Component);

    function Brush(props) {
        _classCallCheck(this, Brush);

        var _this = _possibleConstructorReturn(this, (Brush.__proto__ || Object.getPrototypeOf(Brush)).call(this, props));

        _this.onHandleMouseDown = function (e, handle) {
            return _this.handleMouseDown(e, Mode.Handle, signsX[handle.type], signsY[handle.type]);
        };
        _this.onSelectionMouseDown = function (e) {
            var dimension = _this.props.dimension;

            var signX = dimension === BrushDimension.Y ? null : signsX['selection'];
            var signY = dimension === BrushDimension.X ? null : signsY['selection'];
            _this.handleMouseDown(e, Mode.Drag, signX, signY);
        };
        _this.handleMouseDown = function (e, mode, signX, signY) {
            // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
            if (e.button) return;
            document.addEventListener('mouseup', _this.onMouseUp, true);
            document.addEventListener('mousemove', _this.onMouseMove, true);

            var _this$point = _this.point(e),
                x = _this$point.x,
                y = _this$point.y;

            _this.setState({ drag: { x: x, y: y, mode: mode, signX: signX, signY: signY } }, function () {
                return _this.raise(_this.props.onStart);
            });
        };
        _this.onMouseMove = function (evt) {
            evt.preventDefault();
            var clientX = evt.clientX,
                clientY = evt.clientY;
            var _this$state = _this.state,
                _this$state$drag = _this$state.drag,
                mode = _this$state$drag.mode,
                x = _this$state$drag.x,
                y = _this$state$drag.y,
                signX = _this$state$drag.signX,
                signY = _this$state$drag.signY,
                w = _this$state.w,
                n = _this$state.n,
                e = _this$state.e,
                s = _this$state.s;
            var _this$props = _this.props,
                dimension = _this$props.dimension,
                W = _this$props.x0,
                N = _this$props.y0,
                E = _this$props.x1,
                S = _this$props.y1;

            var _this$point2 = _this.point(evt),
                x1 = _this$point2.x,
                y1 = _this$point2.y;

            var dx = x1 - x;
            var dy = y1 - y;
            var w1 = w,
                n1 = n,
                e1 = e,
                s1 = s;
            switch (mode) {
                case Mode.Handle:
                    if (signX < 0) {
                        w1 = Math.max(W, Math.min(E, w + dx));
                        e1 = e;
                    } else if (signX > 0) {
                        e1 = Math.min(E, Math.max(W, e + dx));
                        w1 = w;
                    }
                    if (signY < 0) {
                        n1 = Math.max(N, Math.min(S, n + dy));
                        s1 = s;
                    } else if (signY > 0) {
                        s1 = Math.min(S, Math.max(N, s + dy));
                        n1 = n;
                    }
                    break;
                case Mode.Drag:
                    if (signX) {
                        dx = Math.max(W - w, Math.min(E - e, dx));
                        w1 = w + dx;
                        e1 = e + dx;
                    }
                    if (signY) {
                        dy = Math.max(N - n, Math.min(S - s));
                        n1 = n + dy;
                        s1 = s + dy;
                    }
                    break;
                default:
                    throw new Error('Not implemented');
            }
            var t = void 0;
            if (e1 < w1) {
                signX *= -1;
                t = e1;
                e1 = w1, w1 = t;
            }
            if (s1 < n1) {
                signY *= -1;
                t = s1, s1 = n1, n1 = t;
            }
            if (w !== w1 || n !== n1 || e !== e1 || s !== s1) {
                _this.setState({
                    w: w1, n: n1, e: e1, s: s1,
                    drag: {
                        mode: mode,
                        x: x1,
                        y: y1,
                        signX: signX, signY: signY
                    }
                }, function () {
                    return _this.raise(_this.props.onBrush);
                });
            }
        };
        _this.onMouseUp = function (evt) {
            document.removeEventListener('mouseup', _this.onMouseUp, true);
            document.removeEventListener('mousemove', _this.onMouseMove, true);
            _this.setState({ drag: null }, function () {
                return _this.raise(_this.props.onEnd);
            });
        };
        _this.raise = function (handler) {
            if (!handler) return;
            var _this$state2 = _this.state,
                w = _this$state2.w,
                n = _this$state2.n,
                e = _this$state2.e,
                s = _this$state2.s;

            handler(w, n, e, s);
        };
        var x0 = props.x0,
            y0 = props.y0,
            x1 = props.x1,
            y1 = props.y1,
            _props$w = props.w,
            w = _props$w === undefined ? x0 : _props$w,
            _props$n = props.n,
            n = _props$n === undefined ? y0 : _props$n,
            _props$e = props.e,
            e = _props$e === undefined ? x1 : _props$e,
            _props$s = props.s,
            s = _props$s === undefined ? y1 : _props$s;

        _this.state = {
            w: w, n: n, e: e, s: s,
            drag: null
        };
        return _this;
    }

    _createClass(Brush, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps, nextContext) {
            var w = nextProps.w,
                n = nextProps.n,
                e = nextProps.e,
                s = nextProps.s;
            var _state = this.state,
                prev_w = _state.w,
                prev_n = _state.n,
                prev_e = _state.e,
                prev_s = _state.s;

            this.setState({
                w: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__app_utils_assert__["c" /* isNumber */])(w) ? w : prev_w,
                n: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__app_utils_assert__["c" /* isNumber */])(n) ? n : prev_n,
                e: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__app_utils_assert__["c" /* isNumber */])(e) ? e : prev_e,
                s: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__app_utils_assert__["c" /* isNumber */])(s) ? s : prev_s
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _a = this.props,
                x0 = _a.x0,
                y0 = _a.y0,
                x1 = _a.x1,
                y1 = _a.y1,
                _w = _a.w,
                _n = _a.n,
                _e = _a.e,
                _s = _a.s,
                dimension = _a.dimension,
                className = _a.className,
                onStart = _a.onStart,
                onBrush = _a.onBrush,
                onEnd = _a.onEnd,
                gProps = __rest(_a, ["x0", "y0", "x1", "y1", "w", "n", "e", "s", "dimension", "className", "onStart", "onBrush", "onEnd"]);var _state2 = this.state,
                w = _state2.w,
                n = _state2.n,
                e = _state2.e,
                s = _state2.s;

            var dim = mapDimension(dimension);
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g", Object.assign({ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('brush', className), fill: "none", style: { WebkitTapHighlightColor: 'rgba(0,0,0,0)' }, pointerEvents: "all" }, gProps), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("rect", { className: "overlay", pointerEvents: "all", cursor: cursors.overlay, x: Math.min(x0, x1), y: Math.min(y0, y1), width: Math.abs(x1 - x0), height: Math.abs(y1 - y0), ref: function ref(e) {
                    return _this2.overlay = e;
                } }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("rect", { className: "selection", cursor: cursors.selection, fill: "#777", fillOpacity: 0.3, stroke: "#fff", shapeRendering: "crispEdges", x: w, y: n, width: Math.abs(e - w), height: Math.abs(s - n), onMouseDown: this.onSelectionMouseDown }), dim.handles.map(function (h, idx) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("rect", { key: idx, className: "handle handle--" + h.type, cursor: cursors[h.type], x: (h.type.endsWith('e') ? e : w) - handleSize / 2, y: (h.type.startsWith('s') ? s : n) - handleSize / 2, width: h.type === 'n' || h.type === 's' ? Math.abs(e - w) + handleSize : handleSize, height: h.type === 'w' || h.type === 'e' ? Math.abs(s - n) + handleSize : handleSize, onMouseDown: function onMouseDown(e) {
                        return _this2.onHandleMouseDown(e, h);
                    } });
            }));
        }
    }, {
        key: "point",
        value: function point(e) {
            var _props = this.props,
                x0 = _props.x0,
                y0 = _props.y0,
                x1 = _props.x1,
                y1 = _props.y1;

            var toSVGCoordinateSystem = this.overlay.getScreenCTM().inverse();

            var _mult = mult(toSVGCoordinateSystem, { x: e.clientX, y: e.clientY }),
                x = _mult.x,
                y = _mult.y;

            x = Math.max(x0, Math.min(x1, x));
            y = Math.max(y0, Math.min(y1, y));
            return { x: x, y: y };
        }
    }]);

    return Brush;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
Brush.defaultProps = {
    dimension: BrushDimension.XY
};
function mult(transform, p) {
    return {
        x: transform.a * p.x + transform.c * p.y + transform.e,
        y: transform.b * p.x + transform.d * p.y + transform.f
    };
}
// Drag feature explained
// https://stackoverflow.com/questions/30231880/setcapture-and-releasecapture-in-chrome
// https://stackoverflow.com/questions/9334084/moveable-draggable-div

/***/ }),
/* 613 */,
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getGeotabSensors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(324);


var getGeotabSensors = function getGeotabSensors(vehicleId) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* assertId */])({ vehicleId: vehicleId });
    var payload = {
        VehicleId: vehicleId,
        ExcludeRegistered: true
    };
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__client__["a" /* runAction */])('/action/GetGeotabSensors', payload);
};

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSensorsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSensorsDataForIncident; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_utils_assert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_utils_nameof__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client__ = __webpack_require__(23);



var getSensorsData = function getSensorsData(ids, timeRange) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__app_utils_assert__["d" /* assertArray */])(ids, 'expected array of ids');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__app_utils_assert__["a" /* assertTrue */])(timeRange != null && timeRange !== '', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__app_utils_nameof__["a" /* nameof */])({ timeRange: timeRange }) + " has to be a non empty string");
    var payload = {
        Ids: ids,
        TimeRange: timeRange
    };
    localStorage.setItem('sensorDataFilter', JSON.stringify(payload));
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__client__["a" /* runAction */])('/action/GetSensorsData', payload);
};
var getSensorsDataForIncident = function getSensorsDataForIncident(incidentId) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__app_utils_assert__["g" /* assertString */])(incidentId, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__app_utils_nameof__["a" /* nameof */])({ incidentId: incidentId }) + " has to be a string");
    var payload = {
        IncidentId: incidentId
    };
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__client__["a" /* runAction */])('/action/GetSensorsData', payload);
};

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getGeotabVehicles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(324);


var getGeotabVehicles = function getGeotabVehicles(serviceAccountId) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* assertId */])({ serviceAccountId: serviceAccountId });
    var payload = {
        GeotabAccountId: serviceAccountId,
        ExcludeRegistered: true
    };
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__client__["a" /* runAction */])('/action/GetGeotabVehicles', payload);
};

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Quantities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMeasures; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__(23);

var Quantities;
(function (Quantities) {
    Quantities[Quantities["SimpleQuantity"] = 1] = "SimpleQuantity";
    Quantities[Quantities["Pressure"] = 2] = "Pressure";
    Quantities[Quantities["Temperature"] = 3] = "Temperature";
    Quantities[Quantities["Speed"] = 4] = "Speed";
})(Quantities || (Quantities = {}));
var getMeasures = function getMeasures(request) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__client__["a" /* runAction */])('/action/GetMeasures', request);
};

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTimezones; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__(23);

var getTimezones = function getTimezones() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__client__["a" /* runAction */])('/action/GetTimezones', {});
};

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVehicleTags; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__(23);

var getVehicleTags = function getVehicleTags() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__client__["a" /* runAction */])('/action/GetAllVehicleTags', {});
};

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSearchName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return runSearch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_EntityType__ = __webpack_require__(54);


var getSearchName = function getSearchName(entityType) {
    switch (entityType) {
        case __WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */].Division:
            return 'Divisions';
        case __WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */].Person:
            return 'Persons';
        case __WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */].ServiceAccount:
            return 'ServiceAccounts';
        case __WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */].Vehicle:
            return 'Vehicles';
        case __WEBPACK_IMPORTED_MODULE_1__models_EntityType__["a" /* EntityType */].Sensor:
            return 'Sensors';
        default:
            throw new Error("search for entity type = " + entityType + " is not implemented");
    }
};
var runSearch = function runSearch(request) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__client__["a" /* runAction */])('/action/Search', request);
};

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export requestPersons */
var requestPersons = function requestPersons(value) {
  return Object.assign({}, value, { Name: 'Persons' });
};

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export requestSensors */
var requestSensors = function requestSensors(searchParams) {
  return Object.assign({}, searchParams, { Name: 'Sensors' });
};

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return requestServiceAccounts; });
var requestServiceAccounts = function requestServiceAccounts(value) {
  return Object.assign({}, value, { Name: 'ServiceAccounts' });
};

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return requestVehicles; });
var requestVehicles = function requestVehicles(searchParams) {
  return Object.assign({}, searchParams, { Name: 'Vehicles' });
};

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatBuilder; });
/* unused harmony export topKeys */
/* unused harmony export top */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StatBuilder = function () {
    function StatBuilder() {
        _classCallCheck(this, StatBuilder);

        this.stat = new Map();
    }

    _createClass(StatBuilder, [{
        key: 'inc',
        value: function inc() {
            var _this = this;

            for (var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++) {
                keys[_key] = arguments[_key];
            }

            keys.forEach(function (k) {
                return _this.incOne(k);
            });
        }
    }, {
        key: 'incOne',
        value: function incOne(key) {
            this.stat.set(key, (this.stat.get(key) || 0) + 1);
        }
    }]);

    return StatBuilder;
}();
var topKeys = function topKeys(stat, n) {
    return top(stat, n).map(function (kv) {
        return kv[0];
    });
};
var top = function top(stat, n) {
    if (!Number.isInteger(n)) throw new Error('n has to be an integer number');
    var entries = [].concat(_toConsumableArray(stat));
    return entries.sort(function (a, b) {
        return a[1] - b[1];
    }).slice(0, n);
};

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calcEditDistance; });
var delCost = 1;
var insCost = 1;
var replaceCost = 1;
var matchCost = 0;
var calcEditDistance = function calcEditDistance(src, dst) {
    var rows = src.length + 1;
    var columns = dst.length + 1;
    var d = init(rows, columns);
    for (var r = 1; r < rows; r++) {
        for (var c = 1; c < columns; c++) {
            var del = d[r - 1][c] + delCost;
            var ins = d[r][c - 1] + insCost;
            var match = d[r - 1][c - 1] + (src[r - 1] === dst[c - 1] ? matchCost : replaceCost);
            d[r][c] = Math.min(del, ins, match);
        }
    }
    return d[rows - 1][columns - 1];
};
var init = function init(rows, columns) {
    var matrix = new Array(rows);
    for (var r = 0; r < rows; r++) {
        matrix[r] = new Array(columns);
    }
    // replacement or insertion a symbol cost 1
    for (var _r = 0; _r < rows; _r++) {
        matrix[_r][0] = _r;
    }
    for (var c = 0; c < columns; c++) {
        matrix[0][c] = c;
    }
    return matrix;
};

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return replace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return merge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return remove; });
var getKeysToIds = function getKeysToIds(arr, key) {
    return arr.reduce(function (map, item, idx) {
        return map.set(key(item), idx);
    }, new Map());
};
var replace = function replace(arr1, arr2, key) {
    // in case there is nothing to remove, then return original array
    if (!arr2 || arr2.length === 0) return arr1;
    // in case the original array is empty retrun just empty array
    if (!arr1 || arr1.length === 0) return [];
    var keyToId = getKeysToIds(arr1, key);
    var toUpdate = arr2.filter(function (item) {
        return keyToId.has(key(item));
    });
    var result = arr1.slice(); // make a copy
    toUpdate.forEach(function (item) {
        return result[keyToId.get(key(item))] = item;
    });
    return result;
};
var merge = function merge(arr1, arr2, key) {
    if (!arr2 || arr2.length === 0) return arr1;
    if (!arr1 || arr1.length === 0) return arr2;
    var keyToId = getKeysToIds(arr1, key);
    var toAdd = [];
    var toUpdate = [];
    arr2.forEach(function (item) {
        return (keyToId.has(key(item)) ? toUpdate : toAdd).push(item);
    });
    var result = toAdd.concat(arr1);
    toUpdate.forEach(function (item) {
        return result[keyToId.get(key(item)) + toAdd.length] = item;
    });
    return result;
};
var remove = function remove(items, keys, key) {
    if (!keys || keys.length === 0) return items;
    if (!items) return [];
    if (items.length === 0) return items;
    var allKeys = new Set(items.map(key));
    if (keys.some(function (k) {
        return allKeys.has(k);
    })) {
        var keysToDelete = new Set(keys);
        return items.filter(function (item) {
            return !keysToDelete.has(key(item));
        });
    }
    return items;
};

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return removeUndefined; });
var removeUndefined = function removeUndefined(obj) {
    return Object.keys(obj).reduce(function (res, key) {
        if (obj[key] !== undefined) res[key] = obj[key];
        return res;
    }, {});
};

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calcAlignment; });
// This algorithm tries to maximize alignment score
var delCost = -1;
var insCost = -1;
var replaceCost = -1;
var matchScore = 1;
var init = function init(rows, columns) {
    // create 2D array
    var matrix = new Array(rows);
    for (var r = 0; r < rows; r++) {
        matrix[r] = new Array(columns);
    }
    // Fill base cases with zeros
    // This effectivly means we can remove or add prefix w/o penalty
    for (var _r = 0; _r < rows; _r++) {
        matrix[_r][0] = 0;
    }
    for (var c = 0; c < columns; c++) {
        matrix[0][c] = 0;
    }
    return matrix;
};
var calcAlignment = function calcAlignment(src, dst) {
    var rows = src.length + 1;
    var columns = dst.length + 1;
    var d = init(rows, columns);
    for (var r = 1; r < rows; r++) {
        for (var c = 1; c < columns; c++) {
            var del = d[r - 1][c] + delCost;
            var ins = d[r][c - 1] + insCost;
            var repl = d[r - 1][c - 1] + (src[r - 1] === dst[c - 1] ? matchScore : replaceCost);
            d[r][c] = Math.max(del, ins, repl);
        }
    }
    // Take the max score on the chart(matrix) edge (right or bottom)
    // This means that we can insert or delete suffix w/o penalty
    var edgeMax = Number.NEGATIVE_INFINITY;
    for (var _c = 0; _c < columns; _c++) {
        edgeMax = Math.max(edgeMax, d[rows - 1][_c]);
    }for (var _r2 = 0; _r2 < rows; _r2++) {
        edgeMax = Math.max(edgeMax, d[_r2][columns - 1]);
    }return edgeMax;
};

/***/ }),
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Dialog":"Dialog--1M-2z","ButtomToolbar":"ButtomToolbar--2KFeq"};

/***/ }),
/* 942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"TwoButtonDialog":"TwoButtonDialog--1d9El","Info":"Info--1eiuE","ButtomToolbar":"ButtomToolbar--35zYg"};

/***/ }),
/* 943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"DivisionPath":"DivisionPath--ED6Ry","DivisionSelector":"DivisionSelector--HGm27","Fragment":"Fragment--3eJ_S","AdminIcon":"AdminIcon--1MJRn","Current":"Current--3FhAD"};

/***/ }),
/* 944 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"NameCell":"NameCell--2zzTR","AdminIcon":"AdminIcon--21t01"};

/***/ }),
/* 945 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"EditCreateDivision":"EditCreateDivision--2NnuA"};

/***/ }),
/* 946 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SeverityRed":"SeverityRed--1Y_sf","SeverityYellow":"SeverityYellow--3jRbw","ReportTable":"ReportTable--3NbYd"};

/***/ }),
/* 947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SeverityRed":"SeverityRed--jjGzv","SeverityYellow":"SeverityYellow--22Zec","Cell":"Cell--27RvC"};

/***/ }),
/* 948 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"EditCreatePerson":"EditCreatePerson--2VYfC"};

/***/ }),
/* 949 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"UserInput":"UserInput--3lWTN"};

/***/ }),
/* 950 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"NewSensor":"NewSensor--2xQpi"};

/***/ }),
/* 951 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"VehicleCell":"VehicleCell--3LTyZ"};

/***/ }),
/* 952 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SensorsData":"SensorsData--27cSG","Container":"Container--immzl"};

/***/ }),
/* 953 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SquareIcon":"SquareIcon--12X7t","CircleIcon":"CircleIcon--apz5H","Red":"Red--yccJb","Yellow":"Yellow--ZqDM0","Table":"Table--3f_bK"};

/***/ }),
/* 954 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"NewServiceAccount":"NewServiceAccount--18drg"};

/***/ }),
/* 955 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SettingsView":"SettingsView--3CFpc"};

/***/ }),
/* 956 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SuggestList":"SuggestList--1vBiY"};

/***/ }),
/* 957 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Toolbar":"Toolbar--11LZa"};

/***/ }),
/* 958 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"DateRange":"DateRange--36LFZ","Input":"Input--2aGe9"};

/***/ }),
/* 959 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ErrorMessage":"ErrorMessage--3itUV"};

/***/ }),
/* 960 */,
/* 961 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 962 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"IdColumn":"IdColumn--tw2tE"};

/***/ }),
/* 963 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MultiselectColumn":"MultiselectColumn--14VGw","HeaderCell":"HeaderCell--2D1MB"};

/***/ }),
/* 964 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"GoogleMap":"GoogleMap--tbvzd"};

/***/ }),
/* 965 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"VehicleBatchEdit":"VehicleBatchEdit--3be4M","List":"List--2NmpS","Item":"Item--1whHV","EmptyLabel":"EmptyLabel--1hzmK","EditTags":"EditTags--3B3iV"};

/***/ }),
/* 966 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"TooltipContainer":"TooltipContainer--3Pboq","SquareIcon":"SquareIcon--1_uSu","CircleIcon":"CircleIcon--tM6PV","Hint":"Hint--3uIAx"};

/***/ }),
/* 967 */,
/* 968 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ModalBackground":"ModalBackground--1-bkm"};

/***/ }),
/* 969 */,
/* 970 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 971 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[592]);


// WEBPACK FOOTER //
// app/bundle-6e443d7.js